/** * jMiniCore System Core v 2.0 * * Last Mod Date: 2019-09-15 */

$(function () {
  console.log(jMiniCoreVersion);
  $($('.ph-app').get(0)).trigger('focus');

  // TOUCH LISTENERS
  var xyTouchStart = {
    x: -1,
    y: -1
  };
  $(document).bind('touchstart', function (event) {
    xyTouchStart = {
      x: event.originalEvent.touches[0].clientX,
      y: event.originalEvent.touches[0].clientY
    };
  });
  $('.w84domload').removeClass('w84domload');
});
$(function () {
  $('.is-text-tip').each(function (idx, el) {
    var $el = $(el),
      pcmnt = $el.data('pt-pcmnt'),
      xtraclass = $el.data('pt-xclass');
    $el.powerTip({
      xfollowMouse: true,
      xsmartPlacement: true,
      popupClass: 'text-tip ' + xtraclass,
      xmouseOnToPopup: true,
      offset: 8,
      placement: pcmnt ? pcmnt : 'sw'
    });
  });
});
$(function () {
  document.querySelectorAll("a[href^=\"#\"]").forEach(function (anchor) {
    anchor.addEventListener("click", function (ev) {
      ev.preventDefault();
      var targetElement = document.querySelector(this.getAttribute("href"));
      targetElement.scrollIntoView({
        block: "start",
        alignToTop: true,
        behavior: "smooth"
      });
    });
  });
});

/** * Check if we entered mobile mode by querying border width of element that is being modified by CSS @media-queries * * @returns {boolean} * @private */
$(function () {
  var markDesktop = "rgb(255,0,0)";
  var markTablet = "rgb(0,255,0)";
  var markMobile = "rgb(0,0,255)";
  var throttleDelay = 50;
  var throttleTimer;
  window._isInMobileMode = function () {
    var markerState = $('.page-mobile-marker').css('backgroundColor').replace(/\s/g, ''),
      isMobile = markerState === markMobile,
      isTablet = markerState === markTablet,
      isDesktop = markerState === markDesktop;
    window._isMobile = isMobile;
    window._isTablet = isTablet;
    window._isDesktop = isDesktop;
    return !isDesktop;
  };
  $(window).on('resize', function () {
    clearTimeout(throttleTimer);
    throttleTimer = setTimeout(function () {
      window._isInMobileMode();
    }, throttleDelay);
  }).on('orientationchange', function () {
    window.dispatchEvent(new Event("resize"));
  });
  window._isInMobileMode();
});
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*! jQuery Fancytree Plugin - 2.38.2 - 2022-06-30T18:24:06Z
  * https://github.com/mar10/fancytree
  * Copyright (c) 2022 Martin Wendt; Licensed MIT
 */
/*! jQuery UI - v1.13.0 - 2021-11-09
* http://jqueryui.com
* Includes: widget.js, position.js, jquery-patch.js, keycode.js, scroll-parent.js, unique-id.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

/*
	NOTE: Original jQuery UI wrapper was replaced with a simple IIFE.
	See README-Fancytree.md
*/
(function ($) {
  $.ui = $.ui || {};
  var version = $.ui.version = "1.13.0";

  /*!
   * jQuery UI Widget 1.13.0
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

  //>>label: Widget
  //>>group: Core
  //>>description: Provides a factory for creating stateful widgets with a common API.
  //>>docs: http://api.jqueryui.com/jQuery.widget/
  //>>demos: http://jqueryui.com/widget/

  var widgetUuid = 0;
  var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
  var widgetSlice = Array.prototype.slice;
  $.cleanData = function (orig) {
    return function (elems) {
      var events, elem, i;
      for (i = 0; (elem = elems[i]) != null; i++) {
        // Only trigger remove when necessary to save time
        events = $._data(elem, "events");
        if (events && events.remove) {
          $(elem).triggerHandler("remove");
        }
      }
      orig(elems);
    };
  }($.cleanData);
  $.widget = function (name, base, prototype) {
    var existingConstructor, constructor, basePrototype;

    // ProxiedPrototype allows the provided prototype to remain unmodified
    // so that it can be used as a mixin for multiple widgets (#8876)
    var proxiedPrototype = {};
    var namespace = name.split(".")[0];
    name = name.split(".")[1];
    var fullName = namespace + "-" + name;
    if (!prototype) {
      prototype = base;
      base = $.Widget;
    }
    if (Array.isArray(prototype)) {
      prototype = $.extend.apply(null, [{}].concat(prototype));
    }

    // Create selector for plugin
    $.expr.pseudos[fullName.toLowerCase()] = function (elem) {
      return !!$.data(elem, fullName);
    };
    $[namespace] = $[namespace] || {};
    existingConstructor = $[namespace][name];
    constructor = $[namespace][name] = function (options, element) {
      // Allow instantiation without "new" keyword
      if (!this._createWidget) {
        return new constructor(options, element);
      }

      // Allow instantiation without initializing for simple inheritance
      // must use "new" keyword (the code above always passes args)
      if (arguments.length) {
        this._createWidget(options, element);
      }
    };

    // Extend with the existing constructor to carry over any static properties
    $.extend(constructor, existingConstructor, {
      version: prototype.version,
      // Copy the object used to create the prototype in case we need to
      // redefine the widget later
      _proto: $.extend({}, prototype),
      // Track widgets that inherit from this widget in case this widget is
      // redefined after a widget inherits from it
      _childConstructors: []
    });
    basePrototype = new base();

    // We need to make the options hash a property directly on the new instance
    // otherwise we'll modify the options hash on the prototype that we're
    // inheriting from
    basePrototype.options = $.widget.extend({}, basePrototype.options);
    $.each(prototype, function (prop, value) {
      if (typeof value !== "function") {
        proxiedPrototype[prop] = value;
        return;
      }
      proxiedPrototype[prop] = function () {
        function _super() {
          return base.prototype[prop].apply(this, arguments);
        }
        function _superApply(args) {
          return base.prototype[prop].apply(this, args);
        }
        return function () {
          var __super = this._super;
          var __superApply = this._superApply;
          var returnValue;
          this._super = _super;
          this._superApply = _superApply;
          returnValue = value.apply(this, arguments);
          this._super = __super;
          this._superApply = __superApply;
          return returnValue;
        };
      }();
    });
    constructor.prototype = $.widget.extend(basePrototype, {
      // TODO: remove support for widgetEventPrefix
      // always use the name + a colon as the prefix, e.g., draggable:start
      // don't prefix for widgets that aren't DOM-based
      widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
    }, proxiedPrototype, {
      constructor: constructor,
      namespace: namespace,
      widgetName: name,
      widgetFullName: fullName
    });

    // If this widget is being redefined then we need to find all widgets that
    // are inheriting from it and redefine all of them so that they inherit from
    // the new version of this widget. We're essentially trying to replace one
    // level in the prototype chain.
    if (existingConstructor) {
      $.each(existingConstructor._childConstructors, function (i, child) {
        var childPrototype = child.prototype;

        // Redefine the child widget using the same prototype that was
        // originally used, but inherit from the new version of the base
        $.widget(childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto);
      });

      // Remove the list of existing child constructors from the old constructor
      // so the old child constructors can be garbage collected
      delete existingConstructor._childConstructors;
    } else {
      base._childConstructors.push(constructor);
    }
    $.widget.bridge(name, constructor);
    return constructor;
  };
  $.widget.extend = function (target) {
    var input = widgetSlice.call(arguments, 1);
    var inputIndex = 0;
    var inputLength = input.length;
    var key;
    var value;
    for (; inputIndex < inputLength; inputIndex++) {
      for (key in input[inputIndex]) {
        value = input[inputIndex][key];
        if (widgetHasOwnProperty.call(input[inputIndex], key) && value !== undefined) {
          // Clone objects
          if ($.isPlainObject(value)) {
            target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) :
            // Don't extend strings, arrays, etc. with objects
            $.widget.extend({}, value);

            // Copy everything else by reference
          } else {
            target[key] = value;
          }
        }
      }
    }
    return target;
  };
  $.widget.bridge = function (name, object) {
    var fullName = object.prototype.widgetFullName || name;
    $.fn[name] = function (options) {
      var isMethodCall = typeof options === "string";
      var args = widgetSlice.call(arguments, 1);
      var returnValue = this;
      if (isMethodCall) {
        // If this is an empty collection, we need to have the instance method
        // return undefined instead of the jQuery instance
        if (!this.length && options === "instance") {
          returnValue = undefined;
        } else {
          this.each(function () {
            var methodValue;
            var instance = $.data(this, fullName);
            if (options === "instance") {
              returnValue = instance;
              return false;
            }
            if (!instance) {
              return $.error("cannot call methods on " + name + " prior to initialization; " + "attempted to call method '" + options + "'");
            }
            if (typeof instance[options] !== "function" || options.charAt(0) === "_") {
              return $.error("no such method '" + options + "' for " + name + " widget instance");
            }
            methodValue = instance[options].apply(instance, args);
            if (methodValue !== instance && methodValue !== undefined) {
              returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
              return false;
            }
          });
        }
      } else {
        // Allow multiple hashes to be passed on init
        if (args.length) {
          options = $.widget.extend.apply(null, [options].concat(args));
        }
        this.each(function () {
          var instance = $.data(this, fullName);
          if (instance) {
            instance.option(options || {});
            if (instance._init) {
              instance._init();
            }
          } else {
            $.data(this, fullName, new object(options, this));
          }
        });
      }
      return returnValue;
    };
  };
  $.Widget = function /* options, element */ () {};
  $.Widget._childConstructors = [];
  $.Widget.prototype = {
    widgetName: "widget",
    widgetEventPrefix: "",
    defaultElement: "<div>",
    options: {
      classes: {},
      disabled: false,
      // Callbacks
      create: null
    },
    _createWidget: function _createWidget(options, element) {
      element = $(element || this.defaultElement || this)[0];
      this.element = $(element);
      this.uuid = widgetUuid++;
      this.eventNamespace = "." + this.widgetName + this.uuid;
      this.bindings = $();
      this.hoverable = $();
      this.focusable = $();
      this.classesElementLookup = {};
      if (element !== this) {
        $.data(element, this.widgetFullName, this);
        this._on(true, this.element, {
          remove: function remove(event) {
            if (event.target === element) {
              this.destroy();
            }
          }
        });
        this.document = $(element.style ?
        // Element within the document
        element.ownerDocument :
        // Element is window or document
        element.document || element);
        this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
      }
      this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options);
      this._create();
      if (this.options.disabled) {
        this._setOptionDisabled(this.options.disabled);
      }
      this._trigger("create", null, this._getCreateEventData());
      this._init();
    },
    _getCreateOptions: function _getCreateOptions() {
      return {};
    },
    _getCreateEventData: $.noop,
    _create: $.noop,
    _init: $.noop,
    destroy: function destroy() {
      var that = this;
      this._destroy();
      $.each(this.classesElementLookup, function (key, value) {
        that._removeClass(value, key);
      });

      // We can probably remove the unbind calls in 2.0
      // all event bindings should go through this._on()
      this.element.off(this.eventNamespace).removeData(this.widgetFullName);
      this.widget().off(this.eventNamespace).removeAttr("aria-disabled");

      // Clean up events and states
      this.bindings.off(this.eventNamespace);
    },
    _destroy: $.noop,
    widget: function widget() {
      return this.element;
    },
    option: function option(key, value) {
      var options = key;
      var parts;
      var curOption;
      var i;
      if (arguments.length === 0) {
        // Don't return a reference to the internal hash
        return $.widget.extend({}, this.options);
      }
      if (typeof key === "string") {
        // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
        options = {};
        parts = key.split(".");
        key = parts.shift();
        if (parts.length) {
          curOption = options[key] = $.widget.extend({}, this.options[key]);
          for (i = 0; i < parts.length - 1; i++) {
            curOption[parts[i]] = curOption[parts[i]] || {};
            curOption = curOption[parts[i]];
          }
          key = parts.pop();
          if (arguments.length === 1) {
            return curOption[key] === undefined ? null : curOption[key];
          }
          curOption[key] = value;
        } else {
          if (arguments.length === 1) {
            return this.options[key] === undefined ? null : this.options[key];
          }
          options[key] = value;
        }
      }
      this._setOptions(options);
      return this;
    },
    _setOptions: function _setOptions(options) {
      var key;
      for (key in options) {
        this._setOption(key, options[key]);
      }
      return this;
    },
    _setOption: function _setOption(key, value) {
      if (key === "classes") {
        this._setOptionClasses(value);
      }
      this.options[key] = value;
      if (key === "disabled") {
        this._setOptionDisabled(value);
      }
      return this;
    },
    _setOptionClasses: function _setOptionClasses(value) {
      var classKey, elements, currentElements;
      for (classKey in value) {
        currentElements = this.classesElementLookup[classKey];
        if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) {
          continue;
        }

        // We are doing this to create a new jQuery object because the _removeClass() call
        // on the next line is going to destroy the reference to the current elements being
        // tracked. We need to save a copy of this collection so that we can add the new classes
        // below.
        elements = $(currentElements.get());
        this._removeClass(currentElements, classKey);

        // We don't use _addClass() here, because that uses this.options.classes
        // for generating the string of classes. We want to use the value passed in from
        // _setOption(), this is the new value of the classes option which was passed to
        // _setOption(). We pass this value directly to _classes().
        elements.addClass(this._classes({
          element: elements,
          keys: classKey,
          classes: value,
          add: true
        }));
      }
    },
    _setOptionDisabled: function _setOptionDisabled(value) {
      this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!value);

      // If the widget is becoming disabled, then nothing is interactive
      if (value) {
        this._removeClass(this.hoverable, null, "ui-state-hover");
        this._removeClass(this.focusable, null, "ui-state-focus");
      }
    },
    enable: function enable() {
      return this._setOptions({
        disabled: false
      });
    },
    disable: function disable() {
      return this._setOptions({
        disabled: true
      });
    },
    _classes: function _classes(options) {
      var full = [];
      var that = this;
      options = $.extend({
        element: this.element,
        classes: this.options.classes || {}
      }, options);
      function bindRemoveEvent() {
        options.element.each(function (_, element) {
          var isTracked = $.map(that.classesElementLookup, function (elements) {
            return elements;
          }).some(function (elements) {
            return elements.is(element);
          });
          if (!isTracked) {
            that._on($(element), {
              remove: "_untrackClassesElement"
            });
          }
        });
      }
      function processClassString(classes, checkOption) {
        var current, i;
        for (i = 0; i < classes.length; i++) {
          current = that.classesElementLookup[classes[i]] || $();
          if (options.add) {
            bindRemoveEvent();
            current = $($.uniqueSort(current.get().concat(options.element.get())));
          } else {
            current = $(current.not(options.element).get());
          }
          that.classesElementLookup[classes[i]] = current;
          full.push(classes[i]);
          if (checkOption && options.classes[classes[i]]) {
            full.push(options.classes[classes[i]]);
          }
        }
      }
      if (options.keys) {
        processClassString(options.keys.match(/\S+/g) || [], true);
      }
      if (options.extra) {
        processClassString(options.extra.match(/\S+/g) || []);
      }
      return full.join(" ");
    },
    _untrackClassesElement: function _untrackClassesElement(event) {
      var that = this;
      $.each(that.classesElementLookup, function (key, value) {
        if ($.inArray(event.target, value) !== -1) {
          that.classesElementLookup[key] = $(value.not(event.target).get());
        }
      });
      this._off($(event.target));
    },
    _removeClass: function _removeClass(element, keys, extra) {
      return this._toggleClass(element, keys, extra, false);
    },
    _addClass: function _addClass(element, keys, extra) {
      return this._toggleClass(element, keys, extra, true);
    },
    _toggleClass: function _toggleClass(element, keys, extra, add) {
      add = typeof add === "boolean" ? add : extra;
      var shift = typeof element === "string" || element === null,
        options = {
          extra: shift ? keys : extra,
          keys: shift ? element : keys,
          element: shift ? this.element : element,
          add: add
        };
      options.element.toggleClass(this._classes(options), add);
      return this;
    },
    _on: function _on(suppressDisabledCheck, element, handlers) {
      var delegateElement;
      var instance = this;

      // No suppressDisabledCheck flag, shuffle arguments
      if (typeof suppressDisabledCheck !== "boolean") {
        handlers = element;
        element = suppressDisabledCheck;
        suppressDisabledCheck = false;
      }

      // No element argument, shuffle and use this.element
      if (!handlers) {
        handlers = element;
        element = this.element;
        delegateElement = this.widget();
      } else {
        element = delegateElement = $(element);
        this.bindings = this.bindings.add(element);
      }
      $.each(handlers, function (event, handler) {
        function handlerProxy() {
          // Allow widgets to customize the disabled handling
          // - disabled as an array instead of boolean
          // - disabled class as method for disabling individual parts
          if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) {
            return;
          }
          return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
        }

        // Copy the guid so direct unbinding works
        if (typeof handler !== "string") {
          handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
        }
        var match = event.match(/^([\w:-]*)\s*(.*)$/);
        var eventName = match[1] + instance.eventNamespace;
        var selector = match[2];
        if (selector) {
          delegateElement.on(eventName, selector, handlerProxy);
        } else {
          element.on(eventName, handlerProxy);
        }
      });
    },
    _off: function _off(element, eventName) {
      eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
      element.off(eventName);

      // Clear the stack to avoid memory leaks (#10056)
      this.bindings = $(this.bindings.not(element).get());
      this.focusable = $(this.focusable.not(element).get());
      this.hoverable = $(this.hoverable.not(element).get());
    },
    _delay: function _delay(handler, delay) {
      function handlerProxy() {
        return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
      }
      var instance = this;
      return setTimeout(handlerProxy, delay || 0);
    },
    _hoverable: function _hoverable(element) {
      this.hoverable = this.hoverable.add(element);
      this._on(element, {
        mouseenter: function mouseenter(event) {
          this._addClass($(event.currentTarget), null, "ui-state-hover");
        },
        mouseleave: function mouseleave(event) {
          this._removeClass($(event.currentTarget), null, "ui-state-hover");
        }
      });
    },
    _focusable: function _focusable(element) {
      this.focusable = this.focusable.add(element);
      this._on(element, {
        focusin: function focusin(event) {
          this._addClass($(event.currentTarget), null, "ui-state-focus");
        },
        focusout: function focusout(event) {
          this._removeClass($(event.currentTarget), null, "ui-state-focus");
        }
      });
    },
    _trigger: function _trigger(type, event, data) {
      var prop, orig;
      var callback = this.options[type];
      data = data || {};
      event = $.Event(event);
      event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();

      // The original event may come from any element
      // so we need to reset the target on the new event
      event.target = this.element[0];

      // Copy original event properties over to the new event
      orig = event.originalEvent;
      if (orig) {
        for (prop in orig) {
          if (!(prop in event)) {
            event[prop] = orig[prop];
          }
        }
      }
      this.element.trigger(event, data);
      return !(typeof callback === "function" && callback.apply(this.element[0], [event].concat(data)) === false || event.isDefaultPrevented());
    }
  };
  $.each({
    show: "fadeIn",
    hide: "fadeOut"
  }, function (method, defaultEffect) {
    $.Widget.prototype["_" + method] = function (element, options, callback) {
      if (typeof options === "string") {
        options = {
          effect: options
        };
      }
      var hasOptions;
      var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
      options = options || {};
      if (typeof options === "number") {
        options = {
          duration: options
        };
      } else if (options === true) {
        options = {};
      }
      hasOptions = !$.isEmptyObject(options);
      options.complete = callback;
      if (options.delay) {
        element.delay(options.delay);
      }
      if (hasOptions && $.effects && $.effects.effect[effectName]) {
        element[method](options);
      } else if (effectName !== method && element[effectName]) {
        element[effectName](options.duration, options.easing, callback);
      } else {
        element.queue(function (next) {
          $(this)[method]();
          if (callback) {
            callback.call(element[0]);
          }
          next();
        });
      }
    };
  });
  var widget = $.widget;

  /*!
   * jQuery UI Position 1.13.0
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/position/
   */

  //>>label: Position
  //>>group: Core
  //>>description: Positions elements relative to other elements.
  //>>docs: http://api.jqueryui.com/position/
  //>>demos: http://jqueryui.com/position/

  (function () {
    var cachedScrollbarWidth,
      max = Math.max,
      abs = Math.abs,
      rhorizontal = /left|center|right/,
      rvertical = /top|center|bottom/,
      roffset = /[\+\-]\d+(\.[\d]+)?%?/,
      rposition = /^\w+/,
      rpercent = /%$/,
      _position = $.fn.position;
    function getOffsets(offsets, width, height) {
      return [parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1), parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)];
    }
    function parseCss(element, property) {
      return parseInt($.css(element, property), 10) || 0;
    }
    function isWindow(obj) {
      return obj != null && obj === obj.window;
    }
    function getDimensions(elem) {
      var raw = elem[0];
      if (raw.nodeType === 9) {
        return {
          width: elem.width(),
          height: elem.height(),
          offset: {
            top: 0,
            left: 0
          }
        };
      }
      if (isWindow(raw)) {
        return {
          width: elem.width(),
          height: elem.height(),
          offset: {
            top: elem.scrollTop(),
            left: elem.scrollLeft()
          }
        };
      }
      if (raw.preventDefault) {
        return {
          width: 0,
          height: 0,
          offset: {
            top: raw.pageY,
            left: raw.pageX
          }
        };
      }
      return {
        width: elem.outerWidth(),
        height: elem.outerHeight(),
        offset: elem.offset()
      };
    }
    $.position = {
      scrollbarWidth: function scrollbarWidth() {
        if (cachedScrollbarWidth !== undefined) {
          return cachedScrollbarWidth;
        }
        var w1,
          w2,
          div = $("<div style=" + "'display:block;position:absolute;width:200px;height:200px;overflow:hidden;'>" + "<div style='height:300px;width:auto;'></div></div>"),
          innerDiv = div.children()[0];
        $("body").append(div);
        w1 = innerDiv.offsetWidth;
        div.css("overflow", "scroll");
        w2 = innerDiv.offsetWidth;
        if (w1 === w2) {
          w2 = div[0].clientWidth;
        }
        div.remove();
        return cachedScrollbarWidth = w1 - w2;
      },
      getScrollInfo: function getScrollInfo(within) {
        var overflowX = within.isWindow || within.isDocument ? "" : within.element.css("overflow-x"),
          overflowY = within.isWindow || within.isDocument ? "" : within.element.css("overflow-y"),
          hasOverflowX = overflowX === "scroll" || overflowX === "auto" && within.width < within.element[0].scrollWidth,
          hasOverflowY = overflowY === "scroll" || overflowY === "auto" && within.height < within.element[0].scrollHeight;
        return {
          width: hasOverflowY ? $.position.scrollbarWidth() : 0,
          height: hasOverflowX ? $.position.scrollbarWidth() : 0
        };
      },
      getWithinInfo: function getWithinInfo(element) {
        var withinElement = $(element || window),
          isElemWindow = isWindow(withinElement[0]),
          isDocument = !!withinElement[0] && withinElement[0].nodeType === 9,
          hasOffset = !isElemWindow && !isDocument;
        return {
          element: withinElement,
          isWindow: isElemWindow,
          isDocument: isDocument,
          offset: hasOffset ? $(element).offset() : {
            left: 0,
            top: 0
          },
          scrollLeft: withinElement.scrollLeft(),
          scrollTop: withinElement.scrollTop(),
          width: withinElement.outerWidth(),
          height: withinElement.outerHeight()
        };
      }
    };
    $.fn.position = function (options) {
      if (!options || !options.of) {
        return _position.apply(this, arguments);
      }

      // Make a copy, we don't want to modify arguments
      options = $.extend({}, options);
      var atOffset,
        targetWidth,
        targetHeight,
        targetOffset,
        basePosition,
        dimensions,
        // Make sure string options are treated as CSS selectors
        target = typeof options.of === "string" ? $(document).find(options.of) : $(options.of),
        within = $.position.getWithinInfo(options.within),
        scrollInfo = $.position.getScrollInfo(within),
        collision = (options.collision || "flip").split(" "),
        offsets = {};
      dimensions = getDimensions(target);
      if (target[0].preventDefault) {
        // Force left top to allow flipping
        options.at = "left top";
      }
      targetWidth = dimensions.width;
      targetHeight = dimensions.height;
      targetOffset = dimensions.offset;

      // Clone to reuse original targetOffset later
      basePosition = $.extend({}, targetOffset);

      // Force my and at to have valid horizontal and vertical positions
      // if a value is missing or invalid, it will be converted to center
      $.each(["my", "at"], function () {
        var pos = (options[this] || "").split(" "),
          horizontalOffset,
          verticalOffset;
        if (pos.length === 1) {
          pos = rhorizontal.test(pos[0]) ? pos.concat(["center"]) : rvertical.test(pos[0]) ? ["center"].concat(pos) : ["center", "center"];
        }
        pos[0] = rhorizontal.test(pos[0]) ? pos[0] : "center";
        pos[1] = rvertical.test(pos[1]) ? pos[1] : "center";

        // Calculate offsets
        horizontalOffset = roffset.exec(pos[0]);
        verticalOffset = roffset.exec(pos[1]);
        offsets[this] = [horizontalOffset ? horizontalOffset[0] : 0, verticalOffset ? verticalOffset[0] : 0];

        // Reduce to just the positions without the offsets
        options[this] = [rposition.exec(pos[0])[0], rposition.exec(pos[1])[0]];
      });

      // Normalize collision option
      if (collision.length === 1) {
        collision[1] = collision[0];
      }
      if (options.at[0] === "right") {
        basePosition.left += targetWidth;
      } else if (options.at[0] === "center") {
        basePosition.left += targetWidth / 2;
      }
      if (options.at[1] === "bottom") {
        basePosition.top += targetHeight;
      } else if (options.at[1] === "center") {
        basePosition.top += targetHeight / 2;
      }
      atOffset = getOffsets(offsets.at, targetWidth, targetHeight);
      basePosition.left += atOffset[0];
      basePosition.top += atOffset[1];
      return this.each(function () {
        var collisionPosition,
          using,
          elem = $(this),
          elemWidth = elem.outerWidth(),
          elemHeight = elem.outerHeight(),
          marginLeft = parseCss(this, "marginLeft"),
          marginTop = parseCss(this, "marginTop"),
          collisionWidth = elemWidth + marginLeft + parseCss(this, "marginRight") + scrollInfo.width,
          collisionHeight = elemHeight + marginTop + parseCss(this, "marginBottom") + scrollInfo.height,
          position = $.extend({}, basePosition),
          myOffset = getOffsets(offsets.my, elem.outerWidth(), elem.outerHeight());
        if (options.my[0] === "right") {
          position.left -= elemWidth;
        } else if (options.my[0] === "center") {
          position.left -= elemWidth / 2;
        }
        if (options.my[1] === "bottom") {
          position.top -= elemHeight;
        } else if (options.my[1] === "center") {
          position.top -= elemHeight / 2;
        }
        position.left += myOffset[0];
        position.top += myOffset[1];
        collisionPosition = {
          marginLeft: marginLeft,
          marginTop: marginTop
        };
        $.each(["left", "top"], function (i, dir) {
          if ($.ui.position[collision[i]]) {
            $.ui.position[collision[i]][dir](position, {
              targetWidth: targetWidth,
              targetHeight: targetHeight,
              elemWidth: elemWidth,
              elemHeight: elemHeight,
              collisionPosition: collisionPosition,
              collisionWidth: collisionWidth,
              collisionHeight: collisionHeight,
              offset: [atOffset[0] + myOffset[0], atOffset[1] + myOffset[1]],
              my: options.my,
              at: options.at,
              within: within,
              elem: elem
            });
          }
        });
        if (options.using) {
          // Adds feedback as second argument to using callback, if present
          using = function using(props) {
            var left = targetOffset.left - position.left,
              right = left + targetWidth - elemWidth,
              top = targetOffset.top - position.top,
              bottom = top + targetHeight - elemHeight,
              feedback = {
                target: {
                  element: target,
                  left: targetOffset.left,
                  top: targetOffset.top,
                  width: targetWidth,
                  height: targetHeight
                },
                element: {
                  element: elem,
                  left: position.left,
                  top: position.top,
                  width: elemWidth,
                  height: elemHeight
                },
                horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
              };
            if (targetWidth < elemWidth && abs(left + right) < targetWidth) {
              feedback.horizontal = "center";
            }
            if (targetHeight < elemHeight && abs(top + bottom) < targetHeight) {
              feedback.vertical = "middle";
            }
            if (max(abs(left), abs(right)) > max(abs(top), abs(bottom))) {
              feedback.important = "horizontal";
            } else {
              feedback.important = "vertical";
            }
            options.using.call(this, props, feedback);
          };
        }
        elem.offset($.extend(position, {
          using: using
        }));
      });
    };
    $.ui.position = {
      fit: {
        left: function left(position, data) {
          var within = data.within,
            withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
            outerWidth = within.width,
            collisionPosLeft = position.left - data.collisionPosition.marginLeft,
            overLeft = withinOffset - collisionPosLeft,
            overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
            newOverRight;

          // Element is wider than within
          if (data.collisionWidth > outerWidth) {
            // Element is initially over the left side of within
            if (overLeft > 0 && overRight <= 0) {
              newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
              position.left += overLeft - newOverRight;

              // Element is initially over right side of within
            } else if (overRight > 0 && overLeft <= 0) {
              position.left = withinOffset;

              // Element is initially over both left and right sides of within
            } else {
              if (overLeft > overRight) {
                position.left = withinOffset + outerWidth - data.collisionWidth;
              } else {
                position.left = withinOffset;
              }
            }

            // Too far left -> align with left edge
          } else if (overLeft > 0) {
            position.left += overLeft;

            // Too far right -> align with right edge
          } else if (overRight > 0) {
            position.left -= overRight;

            // Adjust based on position and margin
          } else {
            position.left = max(position.left - collisionPosLeft, position.left);
          }
        },
        top: function top(position, data) {
          var within = data.within,
            withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
            outerHeight = data.within.height,
            collisionPosTop = position.top - data.collisionPosition.marginTop,
            overTop = withinOffset - collisionPosTop,
            overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
            newOverBottom;

          // Element is taller than within
          if (data.collisionHeight > outerHeight) {
            // Element is initially over the top of within
            if (overTop > 0 && overBottom <= 0) {
              newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
              position.top += overTop - newOverBottom;

              // Element is initially over bottom of within
            } else if (overBottom > 0 && overTop <= 0) {
              position.top = withinOffset;

              // Element is initially over both top and bottom of within
            } else {
              if (overTop > overBottom) {
                position.top = withinOffset + outerHeight - data.collisionHeight;
              } else {
                position.top = withinOffset;
              }
            }

            // Too far up -> align with top
          } else if (overTop > 0) {
            position.top += overTop;

            // Too far down -> align with bottom edge
          } else if (overBottom > 0) {
            position.top -= overBottom;

            // Adjust based on position and margin
          } else {
            position.top = max(position.top - collisionPosTop, position.top);
          }
        }
      },
      flip: {
        left: function left(position, data) {
          var within = data.within,
            withinOffset = within.offset.left + within.scrollLeft,
            outerWidth = within.width,
            offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
            collisionPosLeft = position.left - data.collisionPosition.marginLeft,
            overLeft = collisionPosLeft - offsetLeft,
            overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
            myOffset = data.my[0] === "left" ? -data.elemWidth : data.my[0] === "right" ? data.elemWidth : 0,
            atOffset = data.at[0] === "left" ? data.targetWidth : data.at[0] === "right" ? -data.targetWidth : 0,
            offset = -2 * data.offset[0],
            newOverRight,
            newOverLeft;
          if (overLeft < 0) {
            newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
            if (newOverRight < 0 || newOverRight < abs(overLeft)) {
              position.left += myOffset + atOffset + offset;
            }
          } else if (overRight > 0) {
            newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
            if (newOverLeft > 0 || abs(newOverLeft) < overRight) {
              position.left += myOffset + atOffset + offset;
            }
          }
        },
        top: function top(position, data) {
          var within = data.within,
            withinOffset = within.offset.top + within.scrollTop,
            outerHeight = within.height,
            offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
            collisionPosTop = position.top - data.collisionPosition.marginTop,
            overTop = collisionPosTop - offsetTop,
            overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
            top = data.my[1] === "top",
            myOffset = top ? -data.elemHeight : data.my[1] === "bottom" ? data.elemHeight : 0,
            atOffset = data.at[1] === "top" ? data.targetHeight : data.at[1] === "bottom" ? -data.targetHeight : 0,
            offset = -2 * data.offset[1],
            newOverTop,
            newOverBottom;
          if (overTop < 0) {
            newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
            if (newOverBottom < 0 || newOverBottom < abs(overTop)) {
              position.top += myOffset + atOffset + offset;
            }
          } else if (overBottom > 0) {
            newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
            if (newOverTop > 0 || abs(newOverTop) < overBottom) {
              position.top += myOffset + atOffset + offset;
            }
          }
        }
      },
      flipfit: {
        left: function left() {
          $.ui.position.flip.left.apply(this, arguments);
          $.ui.position.fit.left.apply(this, arguments);
        },
        top: function top() {
          $.ui.position.flip.top.apply(this, arguments);
          $.ui.position.fit.top.apply(this, arguments);
        }
      }
    };
  })();
  var position = $.ui.position;

  /*!
   * jQuery UI Support for jQuery core 1.8.x and newer 1.13.0
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   */

  //>>label: jQuery 1.8+ Support
  //>>group: Core
  //>>description: Support version 1.8.x and newer of jQuery core

  // Support: jQuery 1.9.x or older
  // $.expr[ ":" ] is deprecated.
  if (!$.expr.pseudos) {
    $.expr.pseudos = $.expr[":"];
  }

  // Support: jQuery 1.11.x or older
  // $.unique has been renamed to $.uniqueSort
  if (!$.uniqueSort) {
    $.uniqueSort = $.unique;
  }

  // Support: jQuery 2.2.x or older.
  // This method has been defined in jQuery 3.0.0.
  // Code from https://github.com/jquery/jquery/blob/e539bac79e666bba95bba86d690b4e609dca2286/src/selector/escapeSelector.js
  if (!$.escapeSelector) {
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    var fcssescape = function fcssescape(ch, asCodePoint) {
      if (asCodePoint) {
        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
        if (ch === "\0") {
          return "\uFFFD";
        }

        // Control characters and (dependent upon position) numbers get escaped as code points
        return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
      }

      // Other potentially-special ASCII characters get backslash-escaped
      return "\\" + ch;
    };
    $.escapeSelector = function (sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };
  }

  // Support: jQuery 3.4.x or older
  // These methods have been defined in jQuery 3.5.0.
  if (!$.fn.even || !$.fn.odd) {
    $.fn.extend({
      even: function even() {
        return this.filter(function (i) {
          return i % 2 === 0;
        });
      },
      odd: function odd() {
        return this.filter(function (i) {
          return i % 2 === 1;
        });
      }
    });
  }
  ;
  /*!
   * jQuery UI Keycode 1.13.0
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

  //>>label: Keycode
  //>>group: Core
  //>>description: Provide keycodes as keynames
  //>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/

  var keycode = $.ui.keyCode = {
    BACKSPACE: 8,
    COMMA: 188,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    LEFT: 37,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SPACE: 32,
    TAB: 9,
    UP: 38
  };

  /*!
   * jQuery UI Scroll Parent 1.13.0
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

  //>>label: scrollParent
  //>>group: Core
  //>>description: Get the closest ancestor element that is scrollable.
  //>>docs: http://api.jqueryui.com/scrollParent/

  var scrollParent = $.fn.scrollParent = function (includeHidden) {
    var position = this.css("position"),
      excludeStaticParent = position === "absolute",
      overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
      scrollParent = this.parents().filter(function () {
        var parent = $(this);
        if (excludeStaticParent && parent.css("position") === "static") {
          return false;
        }
        return overflowRegex.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
      }).eq(0);
    return position === "fixed" || !scrollParent.length ? $(this[0].ownerDocument || document) : scrollParent;
  };

  /*!
   * jQuery UI Unique ID 1.13.0
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   */

  //>>label: uniqueId
  //>>group: Core
  //>>description: Functions to generate and remove uniqueId's
  //>>docs: http://api.jqueryui.com/uniqueId/

  var uniqueId = $.fn.extend({
    uniqueId: function () {
      var uuid = 0;
      return function () {
        return this.each(function () {
          if (!this.id) {
            this.id = "ui-id-" + ++uuid;
          }
        });
      };
    }(),
    removeUniqueId: function removeUniqueId() {
      return this.each(function () {
        if (/^ui-id-\d+$/.test(this.id)) {
          $(this).removeAttr("id");
        }
      });
    }
  });

  // NOTE: Original jQuery UI wrapper was replaced. See README-Fancytree.md
  // }));
})(jQuery);
(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["jquery"], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
    // Node/CommonJS
    module.exports = factory(require("jquery"));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  /*! Fancytree Core */ /*!
                        * jquery.fancytree.js
                        * Tree view control with support for lazy loading and much more.
                        * https://github.com/mar10/fancytree/
                        *
                        * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                        * Released under the MIT license
                        * https://github.com/mar10/fancytree/wiki/LicenseInfo
                        *
                        * @version 2.38.2
                        * @date 2022-06-30T18:24:06Z
                        */

  /** Core Fancytree module.
   */

  // UMD wrapper for the Fancytree core module
  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree.ui-deps"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree.ui-deps");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    // prevent duplicate loading
    if ($.ui && $.ui.fancytree) {
      $.ui.fancytree.warn("Fancytree: ignored duplicate include");
      return;
    }

    /******************************************************************************
     * Private functions and variables
     */

    var i,
      attr,
      FT = null,
      // initialized below
      TEST_IMG = new RegExp(/\.|\//),
      // strings are considered image urls if they contain '.' or '/'
      REX_HTML = /[&<>"'/]/g,
      // Escape those characters
      REX_TOOLTIP = /[<>"'/]/g,
      // Don't escape `&` in tooltips
      RECURSIVE_REQUEST_ERROR = "$recursive_request",
      INVALID_REQUEST_TARGET_ERROR = "$request_target_invalid",
      ENTITY_MAP = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;"
      },
      IGNORE_KEYCODES = {
        16: true,
        17: true,
        18: true
      },
      SPECIAL_KEYCODES = {
        8: "backspace",
        9: "tab",
        10: "return",
        13: "return",
        // 16: null, 17: null, 18: null,  // ignore shift, ctrl, alt
        19: "pause",
        20: "capslock",
        27: "esc",
        32: "space",
        33: "pageup",
        34: "pagedown",
        35: "end",
        36: "home",
        37: "left",
        38: "up",
        39: "right",
        40: "down",
        45: "insert",
        46: "del",
        59: ";",
        61: "=",
        // 91: null, 93: null,  // ignore left and right meta
        96: "0",
        97: "1",
        98: "2",
        99: "3",
        100: "4",
        101: "5",
        102: "6",
        103: "7",
        104: "8",
        105: "9",
        106: "*",
        107: "+",
        109: "-",
        110: ".",
        111: "/",
        112: "f1",
        113: "f2",
        114: "f3",
        115: "f4",
        116: "f5",
        117: "f6",
        118: "f7",
        119: "f8",
        120: "f9",
        121: "f10",
        122: "f11",
        123: "f12",
        144: "numlock",
        145: "scroll",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'"
      },
      MODIFIERS = {
        16: "shift",
        17: "ctrl",
        18: "alt",
        91: "meta",
        93: "meta"
      },
      MOUSE_BUTTONS = {
        0: "",
        1: "left",
        2: "middle",
        3: "right"
      },
      // Boolean attributes that can be set with equivalent class names in the LI tags
      // Note: v2.23: checkbox and hideCheckbox are *not* in this list
      CLASS_ATTRS = "active expanded focus folder lazy radiogroup selected unselectable unselectableIgnore".split(" "),
      CLASS_ATTR_MAP = {},
      // Top-level Fancytree attributes, that can be set by dict
      TREE_ATTRS = "columns types".split(" "),
      // TREE_ATTR_MAP = {},
      // Top-level FancytreeNode attributes, that can be set by dict
      NODE_ATTRS = "checkbox expanded extraClasses folder icon iconTooltip key lazy partsel radiogroup refKey selected statusNodeType title tooltip type unselectable unselectableIgnore unselectableStatus".split(" "),
      NODE_ATTR_MAP = {},
      // Mapping of lowercase -> real name (because HTML5 data-... attribute only supports lowercase)
      NODE_ATTR_LOWERCASE_MAP = {},
      // Attribute names that should NOT be added to node.data
      NONE_NODE_DATA_MAP = {
        active: true,
        children: true,
        data: true,
        focus: true
      };
    for (i = 0; i < CLASS_ATTRS.length; i++) {
      CLASS_ATTR_MAP[CLASS_ATTRS[i]] = true;
    }
    for (i = 0; i < NODE_ATTRS.length; i++) {
      attr = NODE_ATTRS[i];
      NODE_ATTR_MAP[attr] = true;
      if (attr !== attr.toLowerCase()) {
        NODE_ATTR_LOWERCASE_MAP[attr.toLowerCase()] = attr;
      }
    }
    // for(i=0; i<TREE_ATTRS.length; i++) {
    // 	TREE_ATTR_MAP[TREE_ATTRS[i]] = true;
    // }

    function _assert(cond, msg) {
      // TODO: see qunit.js extractStacktrace()
      if (!cond) {
        msg = msg ? ": " + msg : "";
        msg = "Fancytree assertion failed" + msg;

        // consoleApply("assert", [!!cond, msg]);

        // #1041: Raised exceptions may not be visible in the browser
        // console if inside promise chains, so we also print directly:
        $.ui.fancytree.error(msg);

        // Throw exception:
        $.error(msg);
      }
    }
    function _hasProp(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    }

    /* Replacement for the deprecated `jQuery.isFunction()`. */
    function _isFunction(obj) {
      return typeof obj === "function";
    }

    /* Replacement for the deprecated `jQuery.trim()`. */
    function _trim(text) {
      return text == null ? "" : text.trim();
    }

    /* Replacement for the deprecated `jQuery.isArray()`. */
    var _isArray = Array.isArray;
    _assert($.ui, "Fancytree requires jQuery UI (http://jqueryui.com)");
    function consoleApply(method, args) {
      var i,
        s,
        fn = window.console ? window.console[method] : null;
      if (fn) {
        try {
          fn.apply(window.console, args);
        } catch (e) {
          // IE 8?
          s = "";
          for (i = 0; i < args.length; i++) {
            s += args[i];
          }
          fn(s);
        }
      }
    }

    /* support: IE8 Polyfil for Date.now() */
    if (!Date.now) {
      Date.now = function now() {
        return new Date().getTime();
      };
    }

    /*Return true if x is a FancytreeNode.*/
    function _isNode(x) {
      return !!(x.tree && x.statusNodeType !== undefined);
    }

    /** Return true if dotted version string is equal or higher than requested version.
     *
     * See http://jsfiddle.net/mar10/FjSAN/
     */
    function isVersionAtLeast(dottedVersion, major, minor, patch) {
      var i,
        v,
        t,
        verParts = $.map(_trim(dottedVersion).split("."), function (e) {
          return parseInt(e, 10);
        }),
        testParts = $.map(Array.prototype.slice.call(arguments, 1), function (e) {
          return parseInt(e, 10);
        });
      for (i = 0; i < testParts.length; i++) {
        v = verParts[i] || 0;
        t = testParts[i] || 0;
        if (v !== t) {
          return v > t;
        }
      }
      return true;
    }

    /**
     * Deep-merge a list of objects (but replace array-type options).
     *
     * jQuery's $.extend(true, ...) method does a deep merge, that also merges Arrays.
     * This variant is used to merge extension defaults with user options, and should
     * merge objects, but override arrays (for example the `triggerStart: [...]` option
     * of ext-edit). Also `null` values are copied over and not skipped.
     *
     * See issue #876
     *
     * Example:
     * _simpleDeepMerge({}, o1, o2);
     */
    function _simpleDeepMerge() {
      var options,
        name,
        src,
        copy,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length;

      // Handle case when target is a string or something (possible in deep copy)
      if (_typeof(target) !== "object" && !_isFunction(target)) {
        target = {};
      }
      if (i === length) {
        throw Error("need at least two args");
      }
      for (; i < length; i++) {
        // Only deal with non-null/undefined values
        if ((options = arguments[i]) != null) {
          // Extend the base object
          for (name in options) {
            if (_hasProp(options, name)) {
              src = target[name];
              copy = options[name];
              // Prevent never-ending loop
              if (target === copy) {
                continue;
              }
              // Recurse if we're merging plain objects
              // (NOTE: unlike $.extend, we don't merge arrays, but replace them)
              if (copy && $.isPlainObject(copy)) {
                clone = src && $.isPlainObject(src) ? src : {};
                // Never move original objects, clone them
                target[name] = _simpleDeepMerge(clone, copy);
                // Don't bring in undefined values
              } else if (copy !== undefined) {
                target[name] = copy;
              }
            }
          }
        }
      }
      // Return the modified object
      return target;
    }

    /** Return a wrapper that calls sub.methodName() and exposes
     *  this             : tree
     *  this._local      : tree.ext.EXTNAME
     *  this._super      : base.methodName.call()
     *  this._superApply : base.methodName.apply()
     */
    function _makeVirtualFunction(methodName, tree, base, extension, extName) {
      // $.ui.fancytree.debug("_makeVirtualFunction", methodName, tree, base, extension, extName);
      // if(rexTestSuper && !rexTestSuper.test(func)){
      //     // extension.methodName() doesn't call _super(), so no wrapper required
      //     return func;
      // }
      // Use an immediate function as closure
      var proxy = function () {
        var prevFunc = tree[methodName],
          // org. tree method or prev. proxy
          baseFunc = extension[methodName],
          //
          _local = tree.ext[extName],
          _super = function _super() {
            return prevFunc.apply(tree, arguments);
          },
          _superApply = function _superApply(args) {
            return prevFunc.apply(tree, args);
          };

        // Return the wrapper function
        return function () {
          var prevLocal = tree._local,
            prevSuper = tree._super,
            prevSuperApply = tree._superApply;
          try {
            tree._local = _local;
            tree._super = _super;
            tree._superApply = _superApply;
            return baseFunc.apply(tree, arguments);
          } finally {
            tree._local = prevLocal;
            tree._super = prevSuper;
            tree._superApply = prevSuperApply;
          }
        };
      }(); // end of Immediate Function
      return proxy;
    }

    /**
     * Subclass `base` by creating proxy functions
     */
    function _subclassObject(tree, base, extension, extName) {
      // $.ui.fancytree.debug("_subclassObject", tree, base, extension, extName);
      for (var attrName in extension) {
        if (typeof extension[attrName] === "function") {
          if (typeof tree[attrName] === "function") {
            // override existing method
            tree[attrName] = _makeVirtualFunction(attrName, tree, base, extension, extName);
          } else if (attrName.charAt(0) === "_") {
            // Create private methods in tree.ext.EXTENSION namespace
            tree.ext[extName][attrName] = _makeVirtualFunction(attrName, tree, base, extension, extName);
          } else {
            $.error("Could not override tree." + attrName + ". Use prefix '_' to create tree." + extName + "._" + attrName);
          }
        } else {
          // Create member variables in tree.ext.EXTENSION namespace
          if (attrName !== "options") {
            tree.ext[extName][attrName] = extension[attrName];
          }
        }
      }
    }
    function _getResolvedPromise(context, argArray) {
      if (context === undefined) {
        return $.Deferred(function () {
          this.resolve();
        }).promise();
      }
      return $.Deferred(function () {
        this.resolveWith(context, argArray);
      }).promise();
    }
    function _getRejectedPromise(context, argArray) {
      if (context === undefined) {
        return $.Deferred(function () {
          this.reject();
        }).promise();
      }
      return $.Deferred(function () {
        this.rejectWith(context, argArray);
      }).promise();
    }
    function _makeResolveFunc(deferred, context) {
      return function () {
        deferred.resolveWith(context);
      };
    }
    function _getElementDataAsDict($el) {
      // Evaluate 'data-NAME' attributes with special treatment for 'data-json'.
      var d = $.extend({}, $el.data()),
        json = d.json;
      delete d.fancytree; // added to container by widget factory (old jQuery UI)
      delete d.uiFancytree; // added to container by widget factory

      if (json) {
        delete d.json;
        // <li data-json='...'> is already returned as object (http://api.jquery.com/data/#data-html5)
        d = $.extend(d, json);
      }
      return d;
    }
    function _escapeTooltip(s) {
      return ("" + s).replace(REX_TOOLTIP, function (s) {
        return ENTITY_MAP[s];
      });
    }

    // TODO: use currying
    function _makeNodeTitleMatcher(s) {
      s = s.toLowerCase();
      return function (node) {
        return node.title.toLowerCase().indexOf(s) >= 0;
      };
    }
    function _makeNodeTitleStartMatcher(s) {
      var reMatch = new RegExp("^" + s, "i");
      return function (node) {
        return reMatch.test(node.title);
      };
    }

    /******************************************************************************
     * FancytreeNode
     */

    /**
     * Creates a new FancytreeNode
     *
     * @class FancytreeNode
     * @classdesc A FancytreeNode represents the hierarchical data model and operations.
     *
     * @param {FancytreeNode} parent
     * @param {NodeData} obj
     *
     * @property {Fancytree} tree The tree instance
     * @property {FancytreeNode} parent The parent node
     * @property {string} key Node id (must be unique inside the tree)
     * @property {string} title Display name (may contain HTML)
     * @property {object} data Contains all extra data that was passed on node creation
     * @property {FancytreeNode[] | null | undefined} children Array of child nodes.<br>
     *     For lazy nodes, null or undefined means 'not yet loaded'. Use an empty array
     *     to define a node that has no children.
     * @property {boolean} expanded Use isExpanded(), setExpanded() to access this property.
     * @property {string} extraClasses Additional CSS classes, added to the node's `<span>`.<br>
     *     Note: use `node.add/remove/toggleClass()` to modify.
     * @property {boolean} folder Folder nodes have different default icons and click behavior.<br>
     *     Note: Also non-folders may have children.
     * @property {string} statusNodeType null for standard nodes. Otherwise type of special system node: 'error', 'loading', 'nodata', or 'paging'.
     * @property {boolean} lazy True if this node is loaded on demand, i.e. on first expansion.
     * @property {boolean} selected Use isSelected(), setSelected() to access this property.
     * @property {string} tooltip Alternative description used as hover popup
     * @property {string} iconTooltip Description used as hover popup for icon. @since 2.27
     * @property {string} type Node type, used with tree.types map. @since 2.27
     */
    function FancytreeNode(parent, obj) {
      var i, l, name, cl;
      this.parent = parent;
      this.tree = parent.tree;
      this.ul = null;
      this.li = null; // <li id='key' ftnode=this> tag
      this.statusNodeType = null; // if this is a temp. node to display the status of its parent
      this._isLoading = false; // if this node itself is loading
      this._error = null; // {message: '...'} if a load error occurred
      this.data = {};

      // TODO: merge this code with node.toDict()
      // copy attributes from obj object
      for (i = 0, l = NODE_ATTRS.length; i < l; i++) {
        name = NODE_ATTRS[i];
        this[name] = obj[name];
      }
      // unselectableIgnore and unselectableStatus imply unselectable
      if (this.unselectableIgnore != null || this.unselectableStatus != null) {
        this.unselectable = true;
      }
      if (obj.hideCheckbox) {
        $.error("'hideCheckbox' node option was removed in v2.23.0: use 'checkbox: false'");
      }
      // node.data += obj.data
      if (obj.data) {
        $.extend(this.data, obj.data);
      }
      // Copy all other attributes to this.data.NAME
      for (name in obj) {
        if (!NODE_ATTR_MAP[name] && (this.tree.options.copyFunctionsToData || !_isFunction(obj[name])) && !NONE_NODE_DATA_MAP[name]) {
          // node.data.NAME = obj.NAME
          this.data[name] = obj[name];
        }
      }

      // Fix missing key
      if (this.key == null) {
        // test for null OR undefined
        if (this.tree.options.defaultKey) {
          this.key = "" + this.tree.options.defaultKey(this);
          _assert(this.key, "defaultKey() must return a unique key");
        } else {
          this.key = "_" + FT._nextNodeKey++;
        }
      } else {
        this.key = "" + this.key; // Convert to string (#217)
      }

      // Fix tree.activeNode
      // TODO: not elegant: we use obj.active as marker to set tree.activeNode
      // when loading from a dictionary.
      if (obj.active) {
        _assert(this.tree.activeNode === null, "only one active node allowed");
        this.tree.activeNode = this;
      }
      if (obj.selected) {
        // #186
        this.tree.lastSelectedNode = this;
      }
      // TODO: handle obj.focus = true

      // Create child nodes
      cl = obj.children;
      if (cl) {
        if (cl.length) {
          this._setChildren(cl);
        } else {
          // if an empty array was passed for a lazy node, keep it, in order to mark it 'loaded'
          this.children = this.lazy ? [] : null;
        }
      } else {
        this.children = null;
      }
      // Add to key/ref map (except for root node)
      //	if( parent ) {
      this.tree._callHook("treeRegisterNode", this.tree, true, this);
      //	}
    }

    FancytreeNode.prototype = /** @lends FancytreeNode# */{
      /* Return the direct child FancytreeNode with a given key, index. */
      _findDirectChild: function _findDirectChild(ptr) {
        var i,
          l,
          cl = this.children;
        if (cl) {
          if (typeof ptr === "string") {
            for (i = 0, l = cl.length; i < l; i++) {
              if (cl[i].key === ptr) {
                return cl[i];
              }
            }
          } else if (typeof ptr === "number") {
            return this.children[ptr];
          } else if (ptr.parent === this) {
            return ptr;
          }
        }
        return null;
      },
      // TODO: activate()
      // TODO: activateSilently()
      /* Internal helper called in recursive addChildren sequence.*/
      _setChildren: function _setChildren(children) {
        _assert(children && (!this.children || this.children.length === 0), "only init supported");
        this.children = [];
        for (var i = 0, l = children.length; i < l; i++) {
          this.children.push(new FancytreeNode(this, children[i]));
        }
        this.tree._callHook("treeStructureChanged", this.tree, "setChildren");
      },
      /**
       * Append (or insert) a list of child nodes.
       *
       * @param {NodeData[]} children array of child node definitions (also single child accepted)
       * @param {FancytreeNode | string | Integer} [insertBefore] child node (or key or index of such).
       *     If omitted, the new children are appended.
       * @returns {FancytreeNode} first child added
       *
       * @see FancytreeNode#applyPatch
       */
      addChildren: function addChildren(children, insertBefore) {
        var i,
          l,
          pos,
          origFirstChild = this.getFirstChild(),
          origLastChild = this.getLastChild(),
          firstNode = null,
          nodeList = [];
        if ($.isPlainObject(children)) {
          children = [children];
        }
        if (!this.children) {
          this.children = [];
        }
        for (i = 0, l = children.length; i < l; i++) {
          nodeList.push(new FancytreeNode(this, children[i]));
        }
        firstNode = nodeList[0];
        if (insertBefore == null) {
          this.children = this.children.concat(nodeList);
        } else {
          // Returns null if insertBefore is not a direct child:
          insertBefore = this._findDirectChild(insertBefore);
          pos = $.inArray(insertBefore, this.children);
          _assert(pos >= 0, "insertBefore must be an existing child");
          // insert nodeList after children[pos]
          this.children.splice.apply(this.children, [pos, 0].concat(nodeList));
        }
        if (origFirstChild && !insertBefore) {
          // #708: Fast path -- don't render every child of root, just the new ones!
          // #723, #729: but only if it's appended to an existing child list
          for (i = 0, l = nodeList.length; i < l; i++) {
            nodeList[i].render(); // New nodes were never rendered before
          }
          // Adjust classes where status may have changed
          // Has a first child
          if (origFirstChild !== this.getFirstChild()) {
            // Different first child -- recompute classes
            origFirstChild.renderStatus();
          }
          if (origLastChild !== this.getLastChild()) {
            // Different last child -- recompute classes
            origLastChild.renderStatus();
          }
        } else if (!this.parent || this.parent.ul || this.tr) {
          // render if the parent was rendered (or this is a root node)
          this.render();
        }
        if (this.tree.options.selectMode === 3) {
          this.fixSelection3FromEndNodes();
        }
        this.triggerModifyChild("add", nodeList.length === 1 ? nodeList[0] : null);
        return firstNode;
      },
      /**
       * Add class to node's span tag and to .extraClasses.
       *
       * @param {string} className class name
       *
       * @since 2.17
       */
      addClass: function addClass(className) {
        return this.toggleClass(className, true);
      },
      /**
       * Append or prepend a node, or append a child node.
       *
       * This a convenience function that calls addChildren()
       *
       * @param {NodeData} node node definition
       * @param {string} [mode=child] 'before', 'after', 'firstChild', or 'child' ('over' is a synonym for 'child')
       * @returns {FancytreeNode} new node
       */
      addNode: function addNode(node, mode) {
        if (mode === undefined || mode === "over") {
          mode = "child";
        }
        switch (mode) {
          case "after":
            return this.getParent().addChildren(node, this.getNextSibling());
          case "before":
            return this.getParent().addChildren(node, this);
          case "firstChild":
            // Insert before the first child if any
            var insertBefore = this.children ? this.children[0] : null;
            return this.addChildren(node, insertBefore);
          case "child":
          case "over":
            return this.addChildren(node);
        }
        _assert(false, "Invalid mode: " + mode);
      },
      /**Add child status nodes that indicate 'More...', etc.
       *
       * This also maintains the node's `partload` property.
       * @param {boolean|object} node optional node definition. Pass `false` to remove all paging nodes.
       * @param {string} [mode='child'] 'child'|firstChild'
       * @since 2.15
       */
      addPagingNode: function addPagingNode(node, mode) {
        var i, n;
        mode = mode || "child";
        if (node === false) {
          for (i = this.children.length - 1; i >= 0; i--) {
            n = this.children[i];
            if (n.statusNodeType === "paging") {
              this.removeChild(n);
            }
          }
          this.partload = false;
          return;
        }
        node = $.extend({
          title: this.tree.options.strings.moreData,
          statusNodeType: "paging",
          icon: false
        }, node);
        this.partload = true;
        return this.addNode(node, mode);
      },
      /**
       * Append new node after this.
       *
       * This a convenience function that calls addNode(node, 'after')
       *
       * @param {NodeData} node node definition
       * @returns {FancytreeNode} new node
       */
      appendSibling: function appendSibling(node) {
        return this.addNode(node, "after");
      },
      /**
       * (experimental) Apply a modification (or navigation) operation.
       *
       * @param {string} cmd
       * @param {object} [opts]
       * @see Fancytree#applyCommand
       * @since 2.32
       */
      applyCommand: function applyCommand(cmd, opts) {
        return this.tree.applyCommand(cmd, this, opts);
      },
      /**
       * Modify existing child nodes.
       *
       * @param {NodePatch} patch
       * @returns {$.Promise}
       * @see FancytreeNode#addChildren
       */
      applyPatch: function applyPatch(patch) {
        // patch [key, null] means 'remove'
        if (patch === null) {
          this.remove();
          return _getResolvedPromise(this);
        }
        // TODO: make sure that root node is not collapsed or modified
        // copy (most) attributes to node.ATTR or node.data.ATTR
        var name,
          promise,
          v,
          IGNORE_MAP = {
            children: true,
            expanded: true,
            parent: true
          }; // TODO: should be global

        for (name in patch) {
          if (_hasProp(patch, name)) {
            v = patch[name];
            if (!IGNORE_MAP[name] && !_isFunction(v)) {
              if (NODE_ATTR_MAP[name]) {
                this[name] = v;
              } else {
                this.data[name] = v;
              }
            }
          }
        }
        // Remove and/or create children
        if (_hasProp(patch, "children")) {
          this.removeChildren();
          if (patch.children) {
            // only if not null and not empty list
            // TODO: addChildren instead?
            this._setChildren(patch.children);
          }
          // TODO: how can we APPEND or INSERT child nodes?
        }

        if (this.isVisible()) {
          this.renderTitle();
          this.renderStatus();
        }
        // Expand collapse (final step, since this may be async)
        if (_hasProp(patch, "expanded")) {
          promise = this.setExpanded(patch.expanded);
        } else {
          promise = _getResolvedPromise(this);
        }
        return promise;
      },
      /** Collapse all sibling nodes.
       * @returns {$.Promise}
       */
      collapseSiblings: function collapseSiblings() {
        return this.tree._callHook("nodeCollapseSiblings", this);
      },
      /** Copy this node as sibling or child of `node`.
       *
       * @param {FancytreeNode} node source node
       * @param {string} [mode=child] 'before' | 'after' | 'child'
       * @param {Function} [map] callback function(NodeData, FancytreeNode) that could modify the new node
       * @returns {FancytreeNode} new
       */
      copyTo: function copyTo(node, mode, map) {
        return node.addNode(this.toDict(true, map), mode);
      },
      /** Count direct and indirect children.
       *
       * @param {boolean} [deep=true] pass 'false' to only count direct children
       * @returns {int} number of child nodes
       */
      countChildren: function countChildren(deep) {
        var cl = this.children,
          i,
          l,
          n;
        if (!cl) {
          return 0;
        }
        n = cl.length;
        if (deep !== false) {
          for (i = 0, l = n; i < l; i++) {
            n += cl[i].countChildren();
          }
        }
        return n;
      },
      // TODO: deactivate()
      /** Write to browser console if debugLevel >= 4 (prepending node info)
       *
       * @param {*} msg string or object or array of such
       */
      debug: function debug(msg) {
        if (this.tree.options.debugLevel >= 4) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("log", arguments);
        }
      },
      /** Deprecated.
       * @deprecated since 2014-02-16. Use resetLazy() instead.
       */
      discard: function discard() {
        this.warn("FancytreeNode.discard() is deprecated since 2014-02-16. Use .resetLazy() instead.");
        return this.resetLazy();
      },
      /** Remove DOM elements for all descendents. May be called on .collapse event
       * to keep the DOM small.
       * @param {boolean} [includeSelf=false]
       */
      discardMarkup: function discardMarkup(includeSelf) {
        var fn = includeSelf ? "nodeRemoveMarkup" : "nodeRemoveChildMarkup";
        this.tree._callHook(fn, this);
      },
      /** Write error to browser console if debugLevel >= 1 (prepending tree info)
       *
       * @param {*} msg string or object or array of such
       */
      error: function error(msg) {
        if (this.tree.options.debugLevel >= 1) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("error", arguments);
        }
      },
      /**Find all nodes that match condition (excluding self).
       *
       * @param {string | function(node)} match title string to search for, or a
       *     callback function that returns `true` if a node is matched.
       * @returns {FancytreeNode[]} array of nodes (may be empty)
       */
      findAll: function findAll(match) {
        match = _isFunction(match) ? match : _makeNodeTitleMatcher(match);
        var res = [];
        this.visit(function (n) {
          if (match(n)) {
            res.push(n);
          }
        });
        return res;
      },
      /**Find first node that matches condition (excluding self).
       *
       * @param {string | function(node)} match title string to search for, or a
       *     callback function that returns `true` if a node is matched.
       * @returns {FancytreeNode} matching node or null
       * @see FancytreeNode#findAll
       */
      findFirst: function findFirst(match) {
        match = _isFunction(match) ? match : _makeNodeTitleMatcher(match);
        var res = null;
        this.visit(function (n) {
          if (match(n)) {
            res = n;
            return false;
          }
        });
        return res;
      },
      /** Find a node relative to self.
       *
       * @param {number|string} where The keyCode that would normally trigger this move,
       *		or a keyword ('down', 'first', 'last', 'left', 'parent', 'right', 'up').
       * @returns {FancytreeNode}
       * @since v2.31
       */
      findRelatedNode: function findRelatedNode(where, includeHidden) {
        return this.tree.findRelatedNode(this, where, includeHidden);
      },
      /* Apply selection state (internal use only) */
      _changeSelectStatusAttrs: function _changeSelectStatusAttrs(state) {
        var changed = false,
          opts = this.tree.options,
          unselectable = FT.evalOption("unselectable", this, this, opts, false),
          unselectableStatus = FT.evalOption("unselectableStatus", this, this, opts, undefined);
        if (unselectable && unselectableStatus != null) {
          state = unselectableStatus;
        }
        switch (state) {
          case false:
            changed = this.selected || this.partsel;
            this.selected = false;
            this.partsel = false;
            break;
          case true:
            changed = !this.selected || !this.partsel;
            this.selected = true;
            this.partsel = true;
            break;
          case undefined:
            changed = this.selected || !this.partsel;
            this.selected = false;
            this.partsel = true;
            break;
          default:
            _assert(false, "invalid state: " + state);
        }
        // this.debug("fixSelection3AfterLoad() _changeSelectStatusAttrs()", state, changed);
        if (changed) {
          this.renderStatus();
        }
        return changed;
      },
      /**
       * Fix selection status, after this node was (de)selected in multi-hier mode.
       * This includes (de)selecting all children.
       */
      fixSelection3AfterClick: function fixSelection3AfterClick(callOpts) {
        var flag = this.isSelected();

        // this.debug("fixSelection3AfterClick()");

        this.visit(function (node) {
          node._changeSelectStatusAttrs(flag);
          if (node.radiogroup) {
            // #931: don't (de)select this branch
            return "skip";
          }
        });
        this.fixSelection3FromEndNodes(callOpts);
      },
      /**
       * Fix selection status for multi-hier mode.
       * Only end-nodes are considered to update the descendants branch and parents.
       * Should be called after this node has loaded new children or after
       * children have been modified using the API.
       */
      fixSelection3FromEndNodes: function fixSelection3FromEndNodes(callOpts) {
        var opts = this.tree.options;

        // this.debug("fixSelection3FromEndNodes()");
        _assert(opts.selectMode === 3, "expected selectMode 3");

        // Visit all end nodes and adjust their parent's `selected` and `partsel`
        // attributes. Return selection state true, false, or undefined.
        function _walk(node) {
          var i,
            l,
            child,
            s,
            state,
            allSelected,
            someSelected,
            unselIgnore,
            unselState,
            children = node.children;
          if (children && children.length) {
            // check all children recursively
            allSelected = true;
            someSelected = false;
            for (i = 0, l = children.length; i < l; i++) {
              child = children[i];
              // the selection state of a node is not relevant; we need the end-nodes
              s = _walk(child);
              // if( !child.unselectableIgnore ) {
              unselIgnore = FT.evalOption("unselectableIgnore", child, child, opts, false);
              if (!unselIgnore) {
                if (s !== false) {
                  someSelected = true;
                }
                if (s !== true) {
                  allSelected = false;
                }
              }
            }
            // eslint-disable-next-line no-nested-ternary
            state = allSelected ? true : someSelected ? undefined : false;
          } else {
            // This is an end-node: simply report the status
            unselState = FT.evalOption("unselectableStatus", node, node, opts, undefined);
            state = unselState == null ? !!node.selected : !!unselState;
          }
          // #939: Keep a `partsel` flag that was explicitly set on a lazy node
          if (node.partsel && !node.selected && node.lazy && node.children == null) {
            state = undefined;
          }
          node._changeSelectStatusAttrs(state);
          return state;
        }
        _walk(this);

        // Update parent's state
        this.visitParents(function (node) {
          var i,
            l,
            child,
            state,
            unselIgnore,
            unselState,
            children = node.children,
            allSelected = true,
            someSelected = false;
          for (i = 0, l = children.length; i < l; i++) {
            child = children[i];
            unselIgnore = FT.evalOption("unselectableIgnore", child, child, opts, false);
            if (!unselIgnore) {
              unselState = FT.evalOption("unselectableStatus", child, child, opts, undefined);
              state = unselState == null ? !!child.selected : !!unselState;
              // When fixing the parents, we trust the sibling status (i.e.
              // we don't recurse)
              if (state || child.partsel) {
                someSelected = true;
              }
              if (!state) {
                allSelected = false;
              }
            }
          }
          // eslint-disable-next-line no-nested-ternary
          state = allSelected ? true : someSelected ? undefined : false;
          node._changeSelectStatusAttrs(state);
        });
      },
      // TODO: focus()
      /**
       * Update node data. If dict contains 'children', then also replace
       * the hole sub tree.
       * @param {NodeData} dict
       *
       * @see FancytreeNode#addChildren
       * @see FancytreeNode#applyPatch
       */
      fromDict: function fromDict(dict) {
        // copy all other attributes to this.data.xxx
        for (var name in dict) {
          if (NODE_ATTR_MAP[name]) {
            // node.NAME = dict.NAME
            this[name] = dict[name];
          } else if (name === "data") {
            // node.data += dict.data
            $.extend(this.data, dict.data);
          } else if (!_isFunction(dict[name]) && !NONE_NODE_DATA_MAP[name]) {
            // node.data.NAME = dict.NAME
            this.data[name] = dict[name];
          }
        }
        if (dict.children) {
          // recursively set children and render
          this.removeChildren();
          this.addChildren(dict.children);
        }
        this.renderTitle();
        /*
        var children = dict.children;
        if(children === undefined){
        	this.data = $.extend(this.data, dict);
        	this.render();
        	return;
        }
        dict = $.extend({}, dict);
        dict.children = undefined;
        this.data = $.extend(this.data, dict);
        this.removeChildren();
        this.addChild(children);
        */
      },

      /** Return the list of child nodes (undefined for unexpanded lazy nodes).
       * @returns {FancytreeNode[] | undefined}
       */
      getChildren: function getChildren() {
        if (this.hasChildren() === undefined) {
          // TODO: only required for lazy nodes?
          return undefined; // Lazy node: unloaded, currently loading, or load error
        }

        return this.children;
      },
      /** Return the first child node or null.
       * @returns {FancytreeNode | null}
       */
      getFirstChild: function getFirstChild() {
        return this.children ? this.children[0] : null;
      },
      /** Return the 0-based child index.
       * @returns {int}
       */
      getIndex: function getIndex() {
        // return this.parent.children.indexOf(this);
        return $.inArray(this, this.parent.children); // indexOf doesn't work in IE7
      },

      /** Return the hierarchical child index (1-based, e.g. '3.2.4').
       * @param {string} [separator="."]
       * @param {int} [digits=1]
       * @returns {string}
       */
      getIndexHier: function getIndexHier(separator, digits) {
        separator = separator || ".";
        var s,
          res = [];
        $.each(this.getParentList(false, true), function (i, o) {
          s = "" + (o.getIndex() + 1);
          if (digits) {
            // prepend leading zeroes
            s = ("0000000" + s).substr(-digits);
          }
          res.push(s);
        });
        return res.join(separator);
      },
      /** Return the parent keys separated by options.keyPathSeparator, e.g. "/id_1/id_17/id_32".
       *
       * (Unlike `node.getPath()`, this method prepends a "/" and inverts the first argument.)
       *
       * @see FancytreeNode#getPath
       * @param {boolean} [excludeSelf=false]
       * @returns {string}
       */
      getKeyPath: function getKeyPath(excludeSelf) {
        var sep = this.tree.options.keyPathSeparator;
        return sep + this.getPath(!excludeSelf, "key", sep);
      },
      /** Return the last child of this node or null.
       * @returns {FancytreeNode | null}
       */
      getLastChild: function getLastChild() {
        return this.children ? this.children[this.children.length - 1] : null;
      },
      /** Return node depth. 0: System root node, 1: visible top-level node, 2: first sub-level, ... .
       * @returns {int}
       */
      getLevel: function getLevel() {
        var level = 0,
          dtn = this.parent;
        while (dtn) {
          level++;
          dtn = dtn.parent;
        }
        return level;
      },
      /** Return the successor node (under the same parent) or null.
       * @returns {FancytreeNode | null}
       */
      getNextSibling: function getNextSibling() {
        // TODO: use indexOf, if available: (not in IE6)
        if (this.parent) {
          var i,
            l,
            ac = this.parent.children;
          for (i = 0, l = ac.length - 1; i < l; i++) {
            // up to length-2, so next(last) = null
            if (ac[i] === this) {
              return ac[i + 1];
            }
          }
        }
        return null;
      },
      /** Return the parent node (null for the system root node).
       * @returns {FancytreeNode | null}
       */
      getParent: function getParent() {
        // TODO: return null for top-level nodes?
        return this.parent;
      },
      /** Return an array of all parent nodes (top-down).
       * @param {boolean} [includeRoot=false] Include the invisible system root node.
       * @param {boolean} [includeSelf=false] Include the node itself.
       * @returns {FancytreeNode[]}
       */
      getParentList: function getParentList(includeRoot, includeSelf) {
        var l = [],
          dtn = includeSelf ? this : this.parent;
        while (dtn) {
          if (includeRoot || dtn.parent) {
            l.unshift(dtn);
          }
          dtn = dtn.parent;
        }
        return l;
      },
      /** Return a string representing the hierachical node path, e.g. "a/b/c".
       * @param {boolean} [includeSelf=true]
       * @param {string | function} [part="title"] node property name or callback
       * @param {string} [separator="/"]
       * @returns {string}
       * @since v2.31
       */
      getPath: function getPath(includeSelf, part, separator) {
        includeSelf = includeSelf !== false;
        part = part || "title";
        separator = separator || "/";
        var val,
          path = [],
          isFunc = _isFunction(part);
        this.visitParents(function (n) {
          if (n.parent) {
            val = isFunc ? part(n) : n[part];
            path.unshift(val);
          }
        }, includeSelf);
        return path.join(separator);
      },
      /** Return the predecessor node (under the same parent) or null.
       * @returns {FancytreeNode | null}
       */
      getPrevSibling: function getPrevSibling() {
        if (this.parent) {
          var i,
            l,
            ac = this.parent.children;
          for (i = 1, l = ac.length; i < l; i++) {
            // start with 1, so prev(first) = null
            if (ac[i] === this) {
              return ac[i - 1];
            }
          }
        }
        return null;
      },
      /**
       * Return an array of selected descendant nodes.
       * @param {boolean} [stopOnParents=false] only return the topmost selected
       *     node (useful with selectMode 3)
       * @returns {FancytreeNode[]}
       */
      getSelectedNodes: function getSelectedNodes(stopOnParents) {
        var nodeList = [];
        this.visit(function (node) {
          if (node.selected) {
            nodeList.push(node);
            if (stopOnParents === true) {
              return "skip"; // stop processing this branch
            }
          }
        });

        return nodeList;
      },
      /** Return true if node has children. Return undefined if not sure, i.e. the node is lazy and not yet loaded).
       * @returns {boolean | undefined}
       */
      hasChildren: function hasChildren() {
        if (this.lazy) {
          if (this.children == null) {
            // null or undefined: Not yet loaded
            return undefined;
          } else if (this.children.length === 0) {
            // Loaded, but response was empty
            return false;
          } else if (this.children.length === 1 && this.children[0].isStatusNode()) {
            // Currently loading or load error
            return undefined;
          }
          return true;
        }
        return !!(this.children && this.children.length);
      },
      /**
       * Return true if node has `className` defined in .extraClasses.
       *
       * @param {string} className class name (separate multiple classes by space)
       * @returns {boolean}
       *
       * @since 2.32
       */
      hasClass: function hasClass(className) {
        return (" " + (this.extraClasses || "") + " ").indexOf(" " + className + " ") >= 0;
      },
      /** Return true if node has keyboard focus.
       * @returns {boolean}
       */
      hasFocus: function hasFocus() {
        return this.tree.hasFocus() && this.tree.focusNode === this;
      },
      /** Write to browser console if debugLevel >= 3 (prepending node info)
       *
       * @param {*} msg string or object or array of such
       */
      info: function info(msg) {
        if (this.tree.options.debugLevel >= 3) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("info", arguments);
        }
      },
      /** Return true if node is active (see also FancytreeNode#isSelected).
       * @returns {boolean}
       */
      isActive: function isActive() {
        return this.tree.activeNode === this;
      },
      /** Return true if node is vertically below `otherNode`, i.e. rendered in a subsequent row.
       * @param {FancytreeNode} otherNode
       * @returns {boolean}
       * @since 2.28
       */
      isBelowOf: function isBelowOf(otherNode) {
        return this.getIndexHier(".", 5) > otherNode.getIndexHier(".", 5);
      },
      /** Return true if node is a direct child of otherNode.
       * @param {FancytreeNode} otherNode
       * @returns {boolean}
       */
      isChildOf: function isChildOf(otherNode) {
        return this.parent && this.parent === otherNode;
      },
      /** Return true, if node is a direct or indirect sub node of otherNode.
       * @param {FancytreeNode} otherNode
       * @returns {boolean}
       */
      isDescendantOf: function isDescendantOf(otherNode) {
        if (!otherNode || otherNode.tree !== this.tree) {
          return false;
        }
        var p = this.parent;
        while (p) {
          if (p === otherNode) {
            return true;
          }
          if (p === p.parent) {
            $.error("Recursive parent link: " + p);
          }
          p = p.parent;
        }
        return false;
      },
      /** Return true if node is expanded.
       * @returns {boolean}
       */
      isExpanded: function isExpanded() {
        return !!this.expanded;
      },
      /** Return true if node is the first node of its parent's children.
       * @returns {boolean}
       */
      isFirstSibling: function isFirstSibling() {
        var p = this.parent;
        return !p || p.children[0] === this;
      },
      /** Return true if node is a folder, i.e. has the node.folder attribute set.
       * @returns {boolean}
       */
      isFolder: function isFolder() {
        return !!this.folder;
      },
      /** Return true if node is the last node of its parent's children.
       * @returns {boolean}
       */
      isLastSibling: function isLastSibling() {
        var p = this.parent;
        return !p || p.children[p.children.length - 1] === this;
      },
      /** Return true if node is lazy (even if data was already loaded)
       * @returns {boolean}
       */
      isLazy: function isLazy() {
        return !!this.lazy;
      },
      /** Return true if node is lazy and loaded. For non-lazy nodes always return true.
       * @returns {boolean}
       */
      isLoaded: function isLoaded() {
        return !this.lazy || this.hasChildren() !== undefined; // Also checks if the only child is a status node
      },

      /** Return true if children are currently beeing loaded, i.e. a Ajax request is pending.
       * @returns {boolean}
       */
      isLoading: function isLoading() {
        return !!this._isLoading;
      },
      /*
       * @deprecated since v2.4.0:  Use isRootNode() instead
       */
      isRoot: function isRoot() {
        return this.isRootNode();
      },
      /** Return true if node is partially selected (tri-state).
       * @returns {boolean}
       * @since 2.23
       */
      isPartsel: function isPartsel() {
        return !this.selected && !!this.partsel;
      },
      /** (experimental) Return true if this is partially loaded.
       * @returns {boolean}
       * @since 2.15
       */
      isPartload: function isPartload() {
        return !!this.partload;
      },
      /** Return true if this is the (invisible) system root node.
       * @returns {boolean}
       * @since 2.4
       */
      isRootNode: function isRootNode() {
        return this.tree.rootNode === this;
      },
      /** Return true if node is selected, i.e. has a checkmark set (see also FancytreeNode#isActive).
       * @returns {boolean}
       */
      isSelected: function isSelected() {
        return !!this.selected;
      },
      /** Return true if this node is a temporarily generated system node like
       * 'loading', 'paging', or 'error' (node.statusNodeType contains the type).
       * @returns {boolean}
       */
      isStatusNode: function isStatusNode() {
        return !!this.statusNodeType;
      },
      /** Return true if this node is a status node of type 'paging'.
       * @returns {boolean}
       * @since 2.15
       */
      isPagingNode: function isPagingNode() {
        return this.statusNodeType === "paging";
      },
      /** Return true if this a top level node, i.e. a direct child of the (invisible) system root node.
       * @returns {boolean}
       * @since 2.4
       */
      isTopLevel: function isTopLevel() {
        return this.tree.rootNode === this.parent;
      },
      /** Return true if node is lazy and not yet loaded. For non-lazy nodes always return false.
       * @returns {boolean}
       */
      isUndefined: function isUndefined() {
        return this.hasChildren() === undefined; // also checks if the only child is a status node
      },

      /** Return true if all parent nodes are expanded. Note: this does not check
       * whether the node is scrolled into the visible part of the screen.
       * @returns {boolean}
       */
      isVisible: function isVisible() {
        var i,
          l,
          n,
          hasFilter = this.tree.enableFilter,
          parents = this.getParentList(false, false);

        // TODO: check $(n.span).is(":visible")
        // i.e. return false for nodes (but not parents) that are hidden
        // by a filter
        if (hasFilter && !this.match && !this.subMatchCount) {
          // this.debug( "isVisible: HIDDEN (" + hasFilter + ", " + this.match + ", " + this.match + ")" );
          return false;
        }
        for (i = 0, l = parents.length; i < l; i++) {
          n = parents[i];
          if (!n.expanded) {
            // this.debug("isVisible: HIDDEN (parent collapsed)");
            return false;
          }
          // if (hasFilter && !n.match && !n.subMatchCount) {
          // 	this.debug("isVisible: HIDDEN (" + hasFilter + ", " + this.match + ", " + this.match + ")");
          // 	return false;
          // }
        }
        // this.debug("isVisible: VISIBLE");
        return true;
      },
      /** Deprecated.
       * @deprecated since 2014-02-16: use load() instead.
       */
      lazyLoad: function lazyLoad(discard) {
        $.error("FancytreeNode.lazyLoad() is deprecated since 2014-02-16. Use .load() instead.");
      },
      /**
       * Load all children of a lazy node if neccessary. The <i>expanded</i> state is maintained.
       * @param {boolean} [forceReload=false] Pass true to discard any existing nodes before. Otherwise this method does nothing if the node was already loaded.
       * @returns {$.Promise}
       */
      load: function load(forceReload) {
        var res,
          source,
          self = this,
          wasExpanded = this.isExpanded();
        _assert(this.isLazy(), "load() requires a lazy node");
        // _assert( forceReload || this.isUndefined(), "Pass forceReload=true to re-load a lazy node" );
        if (!forceReload && !this.isUndefined()) {
          return _getResolvedPromise(this);
        }
        if (this.isLoaded()) {
          this.resetLazy(); // also collapses
        }
        // This method is also called by setExpanded() and loadKeyPath(), so we
        // have to avoid recursion.
        source = this.tree._triggerNodeEvent("lazyLoad", this);
        if (source === false) {
          // #69
          return _getResolvedPromise(this);
        }
        _assert(typeof source !== "boolean", "lazyLoad event must return source in data.result");
        res = this.tree._callHook("nodeLoadChildren", this, source);
        if (wasExpanded) {
          this.expanded = true;
          res.always(function () {
            self.render();
          });
        } else {
          res.always(function () {
            self.renderStatus(); // fix expander icon to 'loaded'
          });
        }

        return res;
      },
      /** Expand all parents and optionally scroll into visible area as neccessary.
       * Promise is resolved, when lazy loading and animations are done.
       * @param {object} [opts] passed to `setExpanded()`.
       *     Defaults to {noAnimation: false, noEvents: false, scrollIntoView: true}
       * @returns {$.Promise}
       */
      makeVisible: function makeVisible(opts) {
        var i,
          self = this,
          deferreds = [],
          dfd = new $.Deferred(),
          parents = this.getParentList(false, false),
          len = parents.length,
          effects = !(opts && opts.noAnimation === true),
          scroll = !(opts && opts.scrollIntoView === false);

        // Expand bottom-up, so only the top node is animated
        for (i = len - 1; i >= 0; i--) {
          // self.debug("pushexpand" + parents[i]);
          deferreds.push(parents[i].setExpanded(true, opts));
        }
        $.when.apply($, deferreds).done(function () {
          // All expands have finished
          // self.debug("expand DONE", scroll);
          if (scroll) {
            self.scrollIntoView(effects).done(function () {
              // self.debug("scroll DONE");
              dfd.resolve();
            });
          } else {
            dfd.resolve();
          }
        });
        return dfd.promise();
      },
      /** Move this node to targetNode.
       *  @param {FancytreeNode} targetNode
       *  @param {string} mode <pre>
       *      'child': append this node as last child of targetNode.
       *               This is the default. To be compatble with the D'n'd
       *               hitMode, we also accept 'over'.
       *      'firstChild': add this node as first child of targetNode.
       *      'before': add this node as sibling before targetNode.
       *      'after': add this node as sibling after targetNode.</pre>
       *  @param {function} [map] optional callback(FancytreeNode) to allow modifcations
       */
      moveTo: function moveTo(targetNode, mode, map) {
        if (mode === undefined || mode === "over") {
          mode = "child";
        } else if (mode === "firstChild") {
          if (targetNode.children && targetNode.children.length) {
            mode = "before";
            targetNode = targetNode.children[0];
          } else {
            mode = "child";
          }
        }
        var pos,
          tree = this.tree,
          prevParent = this.parent,
          targetParent = mode === "child" ? targetNode : targetNode.parent;
        if (this === targetNode) {
          return;
        } else if (!this.parent) {
          $.error("Cannot move system root");
        } else if (targetParent.isDescendantOf(this)) {
          $.error("Cannot move a node to its own descendant");
        }
        if (targetParent !== prevParent) {
          prevParent.triggerModifyChild("remove", this);
        }
        // Unlink this node from current parent
        if (this.parent.children.length === 1) {
          if (this.parent === targetParent) {
            return; // #258
          }

          this.parent.children = this.parent.lazy ? [] : null;
          this.parent.expanded = false;
        } else {
          pos = $.inArray(this, this.parent.children);
          _assert(pos >= 0, "invalid source parent");
          this.parent.children.splice(pos, 1);
        }
        // Remove from source DOM parent
        // if(this.parent.ul){
        // 	this.parent.ul.removeChild(this.li);
        // }

        // Insert this node to target parent's child list
        this.parent = targetParent;
        if (targetParent.hasChildren()) {
          switch (mode) {
            case "child":
              // Append to existing target children
              targetParent.children.push(this);
              break;
            case "before":
              // Insert this node before target node
              pos = $.inArray(targetNode, targetParent.children);
              _assert(pos >= 0, "invalid target parent");
              targetParent.children.splice(pos, 0, this);
              break;
            case "after":
              // Insert this node after target node
              pos = $.inArray(targetNode, targetParent.children);
              _assert(pos >= 0, "invalid target parent");
              targetParent.children.splice(pos + 1, 0, this);
              break;
            default:
              $.error("Invalid mode " + mode);
          }
        } else {
          targetParent.children = [this];
        }
        // Parent has no <ul> tag yet:
        // if( !targetParent.ul ) {
        // 	// This is the parent's first child: create UL tag
        // 	// (Hidden, because it will be
        // 	targetParent.ul = document.createElement("ul");
        // 	targetParent.ul.style.display = "none";
        // 	targetParent.li.appendChild(targetParent.ul);
        // }
        // // Issue 319: Add to target DOM parent (only if node was already rendered(expanded))
        // if(this.li){
        // 	targetParent.ul.appendChild(this.li);
        // }

        // Let caller modify the nodes
        if (map) {
          targetNode.visit(map, true);
        }
        if (targetParent === prevParent) {
          targetParent.triggerModifyChild("move", this);
        } else {
          // prevParent.triggerModifyChild("remove", this);
          targetParent.triggerModifyChild("add", this);
        }
        // Handle cross-tree moves
        if (tree !== targetNode.tree) {
          // Fix node.tree for all source nodes
          // 	_assert(false, "Cross-tree move is not yet implemented.");
          this.warn("Cross-tree moveTo is experimental!");
          this.visit(function (n) {
            // TODO: fix selection state and activation, ...
            n.tree = targetNode.tree;
          }, true);
        }

        // A collaposed node won't re-render children, so we have to remove it manually
        // if( !targetParent.expanded ){
        //   prevParent.ul.removeChild(this.li);
        // }
        tree._callHook("treeStructureChanged", tree, "moveTo");

        // Update HTML markup
        if (!prevParent.isDescendantOf(targetParent)) {
          prevParent.render();
        }
        if (!targetParent.isDescendantOf(prevParent) && targetParent !== prevParent) {
          targetParent.render();
        }
        // TODO: fix selection state
        // TODO: fix active state

        /*
        var tree = this.tree;
        var opts = tree.options;
        var pers = tree.persistence;
        	// Always expand, if it's below minExpandLevel
        // tree.logDebug ("%s._addChildNode(%o), l=%o", this, ftnode, ftnode.getLevel());
        if ( opts.minExpandLevel >= ftnode.getLevel() ) {
        	// tree.logDebug ("Force expand for %o", ftnode);
        	this.bExpanded = true;
        }
        	// In multi-hier mode, update the parents selection state
        // DT issue #82: only if not initializing, because the children may not exist yet
        // if( !ftnode.data.isStatusNode() && opts.selectMode==3 && !isInitializing )
        // 	ftnode._fixSelectionState();
        	// In multi-hier mode, update the parents selection state
        if( ftnode.bSelected && opts.selectMode==3 ) {
        	var p = this;
        	while( p ) {
        		if( !p.hasSubSel )
        			p._setSubSel(true);
        		p = p.parent;
        	}
        }
        // render this node and the new child
        if ( tree.bEnableUpdate )
        	this.render();
        return ftnode;
        */
      },

      /** Set focus relative to this node and optionally activate.
       *
       * 'left' collapses the node if it is expanded, or move to the parent
       * otherwise.
       * 'right' expands the node if it is collapsed, or move to the first
       * child otherwise.
       *
       * @param {string|number} where 'down', 'first', 'last', 'left', 'parent', 'right', or 'up'.
       *   (Alternatively the keyCode that would normally trigger this move,
       *   e.g. `$.ui.keyCode.LEFT` = 'left'.
       * @param {boolean} [activate=true]
       * @returns {$.Promise}
       */
      navigate: function navigate(where, activate) {
        var node,
          KC = $.ui.keyCode;

        // Handle optional expand/collapse action for LEFT/RIGHT
        switch (where) {
          case "left":
          case KC.LEFT:
            if (this.expanded) {
              return this.setExpanded(false);
            }
            break;
          case "right":
          case KC.RIGHT:
            if (!this.expanded && (this.children || this.lazy)) {
              return this.setExpanded();
            }
            break;
        }
        // Otherwise activate or focus the related node
        node = this.findRelatedNode(where);
        if (node) {
          // setFocus/setActive will scroll later (if autoScroll is specified)
          try {
            node.makeVisible({
              scrollIntoView: false
            });
          } catch (e) {} // #272
          if (activate === false) {
            node.setFocus();
            return _getResolvedPromise();
          }
          return node.setActive();
        }
        this.warn("Could not find related node '" + where + "'.");
        return _getResolvedPromise();
      },
      /**
       * Remove this node (not allowed for system root).
       */
      remove: function remove() {
        return this.parent.removeChild(this);
      },
      /**
       * Remove childNode from list of direct children.
       * @param {FancytreeNode} childNode
       */
      removeChild: function removeChild(childNode) {
        return this.tree._callHook("nodeRemoveChild", this, childNode);
      },
      /**
       * Remove all child nodes and descendents. This converts the node into a leaf.<br>
       * If this was a lazy node, it is still considered 'loaded'; call node.resetLazy()
       * in order to trigger lazyLoad on next expand.
       */
      removeChildren: function removeChildren() {
        return this.tree._callHook("nodeRemoveChildren", this);
      },
      /**
       * Remove class from node's span tag and .extraClasses.
       *
       * @param {string} className class name
       *
       * @since 2.17
       */
      removeClass: function removeClass(className) {
        return this.toggleClass(className, false);
      },
      /**
       * This method renders and updates all HTML markup that is required
       * to display this node in its current state.<br>
       * Note:
       * <ul>
       * <li>It should only be neccessary to call this method after the node object
       *     was modified by direct access to its properties, because the common
       *     API methods (node.setTitle(), moveTo(), addChildren(), remove(), ...)
       *     already handle this.
       * <li> {@link FancytreeNode#renderTitle} and {@link FancytreeNode#renderStatus}
       *     are implied. If changes are more local, calling only renderTitle() or
       *     renderStatus() may be sufficient and faster.
       * </ul>
       *
       * @param {boolean} [force=false] re-render, even if html markup was already created
       * @param {boolean} [deep=false] also render all descendants, even if parent is collapsed
       */
      render: function render(force, deep) {
        return this.tree._callHook("nodeRender", this, force, deep);
      },
      /** Create HTML markup for the node's outer `<span>` (expander, checkbox, icon, and title).
       * Implies {@link FancytreeNode#renderStatus}.
       * @see Fancytree_Hooks#nodeRenderTitle
       */
      renderTitle: function renderTitle() {
        return this.tree._callHook("nodeRenderTitle", this);
      },
      /** Update element's CSS classes according to node state.
       * @see Fancytree_Hooks#nodeRenderStatus
       */
      renderStatus: function renderStatus() {
        return this.tree._callHook("nodeRenderStatus", this);
      },
      /**
       * (experimental) Replace this node with `source`.
       * (Currently only available for paging nodes.)
       * @param {NodeData[]} source List of child node definitions
       * @since 2.15
       */
      replaceWith: function replaceWith(source) {
        var res,
          parent = this.parent,
          pos = $.inArray(this, parent.children),
          self = this;
        _assert(this.isPagingNode(), "replaceWith() currently requires a paging status node");
        res = this.tree._callHook("nodeLoadChildren", this, source);
        res.done(function (data) {
          // New nodes are currently children of `this`.
          var children = self.children;
          // Prepend newly loaded child nodes to `this`
          // Move new children after self
          for (i = 0; i < children.length; i++) {
            children[i].parent = parent;
          }
          parent.children.splice.apply(parent.children, [pos + 1, 0].concat(children));

          // Remove self
          self.children = null;
          self.remove();
          // Redraw new nodes
          parent.render();
          // TODO: set node.partload = false if this was tha last paging node?
          // parent.addPagingNode(false);
        }).fail(function () {
          self.setExpanded();
        });
        return res;
        // $.error("Not implemented: replaceWith()");
      },

      /**
       * Remove all children, collapse, and set the lazy-flag, so that the lazyLoad
       * event is triggered on next expand.
       */
      resetLazy: function resetLazy() {
        this.removeChildren();
        this.expanded = false;
        this.lazy = true;
        this.children = undefined;
        this.renderStatus();
      },
      /** Schedule activity for delayed execution (cancel any pending request).
       *  scheduleAction('cancel') will only cancel a pending request (if any).
       * @param {string} mode
       * @param {number} ms
       */
      scheduleAction: function scheduleAction(mode, ms) {
        if (this.tree.timer) {
          clearTimeout(this.tree.timer);
          this.tree.debug("clearTimeout(%o)", this.tree.timer);
        }
        this.tree.timer = null;
        var self = this; // required for closures
        switch (mode) {
          case "cancel":
            // Simply made sure that timer was cleared
            break;
          case "expand":
            this.tree.timer = setTimeout(function () {
              self.tree.debug("setTimeout: trigger expand");
              self.setExpanded(true);
            }, ms);
            break;
          case "activate":
            this.tree.timer = setTimeout(function () {
              self.tree.debug("setTimeout: trigger activate");
              self.setActive(true);
            }, ms);
            break;
          default:
            $.error("Invalid mode " + mode);
        }
        // this.tree.debug("setTimeout(%s, %s): %s", mode, ms, this.tree.timer);
      },

      /**
       *
       * @param {boolean | PlainObject} [effects=false] animation options.
       * @param {object} [options=null] {topNode: null, effects: ..., parent: ...} this node will remain visible in
       *     any case, even if `this` is outside the scroll pane.
       * @returns {$.Promise}
       */
      scrollIntoView: function scrollIntoView(effects, options) {
        if (options !== undefined && _isNode(options)) {
          throw Error("scrollIntoView() with 'topNode' option is deprecated since 2014-05-08. Use 'options.topNode' instead.");
        }
        // The scroll parent is typically the plain tree's <UL> container.
        // For ext-table, we choose the nearest parent that has `position: relative`
        // and `overflow` set.
        // (This default can be overridden by the local or global `scrollParent` option.)
        var opts = $.extend({
            effects: effects === true ? {
              duration: 200,
              queue: false
            } : effects,
            scrollOfs: this.tree.options.scrollOfs,
            scrollParent: this.tree.options.scrollParent,
            topNode: null
          }, options),
          $scrollParent = opts.scrollParent,
          $container = this.tree.$container,
          overflowY = $container.css("overflow-y");
        if (!$scrollParent) {
          if (this.tree.tbody) {
            $scrollParent = $container.scrollParent();
          } else if (overflowY === "scroll" || overflowY === "auto") {
            $scrollParent = $container;
          } else {
            // #922 plain tree in a non-fixed-sized UL scrolls inside its parent
            $scrollParent = $container.scrollParent();
          }
        } else if (!$scrollParent.jquery) {
          // Make sure we have a jQuery object
          $scrollParent = $($scrollParent);
        }
        if ($scrollParent[0] === document || $scrollParent[0] === document.body) {
          // `document` may be returned by $().scrollParent(), if nothing is found,
          // but would not work: (see #894)
          this.debug("scrollIntoView(): normalizing scrollParent to 'window':", $scrollParent[0]);
          $scrollParent = $(window);
        }
        // eslint-disable-next-line one-var
        var topNodeY,
          nodeY,
          horzScrollbarHeight,
          containerOffsetTop,
          dfd = new $.Deferred(),
          self = this,
          nodeHeight = $(this.span).height(),
          topOfs = opts.scrollOfs.top || 0,
          bottomOfs = opts.scrollOfs.bottom || 0,
          containerHeight = $scrollParent.height(),
          scrollTop = $scrollParent.scrollTop(),
          $animateTarget = $scrollParent,
          isParentWindow = $scrollParent[0] === window,
          topNode = opts.topNode || null,
          newScrollTop = null;

        // this.debug("scrollIntoView(), scrollTop=" + scrollTop, opts.scrollOfs);
        // _assert($(this.span).is(":visible"), "scrollIntoView node is invisible"); // otherwise we cannot calc offsets
        if (this.isRootNode() || !this.isVisible()) {
          // We cannot calc offsets for hidden elements
          this.info("scrollIntoView(): node is invisible.");
          return _getResolvedPromise();
        }
        if (isParentWindow) {
          nodeY = $(this.span).offset().top;
          topNodeY = topNode && topNode.span ? $(topNode.span).offset().top : 0;
          $animateTarget = $("html,body");
        } else {
          _assert($scrollParent[0] !== document && $scrollParent[0] !== document.body, "scrollParent should be a simple element or `window`, not document or body.");
          containerOffsetTop = $scrollParent.offset().top;
          nodeY = $(this.span).offset().top - containerOffsetTop + scrollTop; // relative to scroll parent
          topNodeY = topNode ? $(topNode.span).offset().top - containerOffsetTop + scrollTop : 0;
          horzScrollbarHeight = Math.max(0, $scrollParent.innerHeight() - $scrollParent[0].clientHeight);
          containerHeight -= horzScrollbarHeight;
        }

        // this.debug("    scrollIntoView(), nodeY=" + nodeY + ", containerHeight=" + containerHeight);
        if (nodeY < scrollTop + topOfs) {
          // Node is above visible container area
          newScrollTop = nodeY - topOfs;
          // this.debug("    scrollIntoView(), UPPER newScrollTop=" + newScrollTop);
        } else if (nodeY + nodeHeight > scrollTop + containerHeight - bottomOfs) {
          newScrollTop = nodeY + nodeHeight - containerHeight + bottomOfs;
          // this.debug("    scrollIntoView(), LOWER newScrollTop=" + newScrollTop);
          // If a topNode was passed, make sure that it is never scrolled
          // outside the upper border
          if (topNode) {
            _assert(topNode.isRootNode() || topNode.isVisible(), "topNode must be visible");
            if (topNodeY < newScrollTop) {
              newScrollTop = topNodeY - topOfs;
              // this.debug("    scrollIntoView(), TOP newScrollTop=" + newScrollTop);
            }
          }
        }

        if (newScrollTop === null) {
          dfd.resolveWith(this);
        } else {
          // this.debug("    scrollIntoView(), SET newScrollTop=" + newScrollTop);
          if (opts.effects) {
            opts.effects.complete = function () {
              dfd.resolveWith(self);
            };
            $animateTarget.stop(true).animate({
              scrollTop: newScrollTop
            }, opts.effects);
          } else {
            $animateTarget[0].scrollTop = newScrollTop;
            dfd.resolveWith(this);
          }
        }
        return dfd.promise();
      },
      /**Activate this node.
       *
       * The `cell` option requires the ext-table and ext-ariagrid extensions.
       *
       * @param {boolean} [flag=true] pass false to deactivate
       * @param {object} [opts] additional options. Defaults to {noEvents: false, noFocus: false, cell: null}
       * @returns {$.Promise}
       */
      setActive: function setActive(flag, opts) {
        return this.tree._callHook("nodeSetActive", this, flag, opts);
      },
      /**Expand or collapse this node. Promise is resolved, when lazy loading and animations are done.
       * @param {boolean} [flag=true] pass false to collapse
       * @param {object} [opts] additional options. Defaults to {noAnimation: false, noEvents: false}
       * @returns {$.Promise}
       */
      setExpanded: function setExpanded(flag, opts) {
        return this.tree._callHook("nodeSetExpanded", this, flag, opts);
      },
      /**Set keyboard focus to this node.
       * @param {boolean} [flag=true] pass false to blur
       * @see Fancytree#setFocus
       */
      setFocus: function setFocus(flag) {
        return this.tree._callHook("nodeSetFocus", this, flag);
      },
      /**Select this node, i.e. check the checkbox.
       * @param {boolean} [flag=true] pass false to deselect
       * @param {object} [opts] additional options. Defaults to {noEvents: false, p
       *     propagateDown: null, propagateUp: null, callback: null }
       */
      setSelected: function setSelected(flag, opts) {
        return this.tree._callHook("nodeSetSelected", this, flag, opts);
      },
      /**Mark a lazy node as 'error', 'loading', 'nodata', or 'ok'.
       * @param {string} status 'error'|'loading'|'nodata'|'ok'
       * @param {string} [message]
       * @param {string} [details]
       */
      setStatus: function setStatus(status, message, details) {
        return this.tree._callHook("nodeSetStatus", this, status, message, details);
      },
      /**Rename this node.
       * @param {string} title
       */
      setTitle: function setTitle(title) {
        this.title = title;
        this.renderTitle();
        this.triggerModify("rename");
      },
      /**Sort child list by title.
       * @param {function} [cmp] custom compare function(a, b) that returns -1, 0, or 1 (defaults to sort by title).
       * @param {boolean} [deep=false] pass true to sort all descendant nodes
       */
      sortChildren: function sortChildren(cmp, deep) {
        var i,
          l,
          cl = this.children;
        if (!cl) {
          return;
        }
        cmp = cmp || function (a, b) {
          var x = a.title.toLowerCase(),
            y = b.title.toLowerCase();

          // eslint-disable-next-line no-nested-ternary
          return x === y ? 0 : x > y ? 1 : -1;
        };
        cl.sort(cmp);
        if (deep) {
          for (i = 0, l = cl.length; i < l; i++) {
            if (cl[i].children) {
              cl[i].sortChildren(cmp, "$norender$");
            }
          }
        }
        if (deep !== "$norender$") {
          this.render();
        }
        this.triggerModifyChild("sort");
      },
      /** Convert node (or whole branch) into a plain object.
       *
       * The result is compatible with node.addChildren().
       *
       * @param {boolean} [recursive=false] include child nodes
       * @param {function} [callback] callback(dict, node) is called for every node, in order to allow modifications.
       *     Return `false` to ignore this node or `"skip"` to include this node without its children.
       * @returns {NodeData}
       */
      toDict: function toDict(recursive, callback) {
        var i,
          l,
          node,
          res,
          dict = {},
          self = this;
        $.each(NODE_ATTRS, function (i, a) {
          if (self[a] || self[a] === false) {
            dict[a] = self[a];
          }
        });
        if (!$.isEmptyObject(this.data)) {
          dict.data = $.extend({}, this.data);
          if ($.isEmptyObject(dict.data)) {
            delete dict.data;
          }
        }
        if (callback) {
          res = callback(dict, self);
          if (res === false) {
            return false; // Don't include this node nor its children
          }

          if (res === "skip") {
            recursive = false; // Include this node, but not the children
          }
        }

        if (recursive) {
          if (_isArray(this.children)) {
            dict.children = [];
            for (i = 0, l = this.children.length; i < l; i++) {
              node = this.children[i];
              if (!node.isStatusNode()) {
                res = node.toDict(true, callback);
                if (res !== false) {
                  dict.children.push(res);
                }
              }
            }
          }
        }
        return dict;
      },
      /**
       * Set, clear, or toggle class of node's span tag and .extraClasses.
       *
       * @param {string} className class name (separate multiple classes by space)
       * @param {boolean} [flag] true/false to add/remove class. If omitted, class is toggled.
       * @returns {boolean} true if a class was added
       *
       * @since 2.17
       */
      toggleClass: function toggleClass(value, flag) {
        var className,
          hasClass,
          rnotwhite = /\S+/g,
          classNames = value.match(rnotwhite) || [],
          i = 0,
          wasAdded = false,
          statusElem = this[this.tree.statusClassPropName],
          curClasses = " " + (this.extraClasses || "") + " ";

        // this.info("toggleClass('" + value + "', " + flag + ")", curClasses);
        // Modify DOM element directly if it already exists
        if (statusElem) {
          $(statusElem).toggleClass(value, flag);
        }
        // Modify node.extraClasses to make this change persistent
        // Toggle if flag was not passed
        while (className = classNames[i++]) {
          hasClass = curClasses.indexOf(" " + className + " ") >= 0;
          flag = flag === undefined ? !hasClass : !!flag;
          if (flag) {
            if (!hasClass) {
              curClasses += className + " ";
              wasAdded = true;
            }
          } else {
            while (curClasses.indexOf(" " + className + " ") > -1) {
              curClasses = curClasses.replace(" " + className + " ", " ");
            }
          }
        }
        this.extraClasses = _trim(curClasses);
        // this.info("-> toggleClass('" + value + "', " + flag + "): '" + this.extraClasses + "'");
        return wasAdded;
      },
      /** Flip expanded status. */
      toggleExpanded: function toggleExpanded() {
        return this.tree._callHook("nodeToggleExpanded", this);
      },
      /** Flip selection status. */
      toggleSelected: function toggleSelected() {
        return this.tree._callHook("nodeToggleSelected", this);
      },
      toString: function toString() {
        return "FancytreeNode@" + this.key + "[title='" + this.title + "']";
        // return "<FancytreeNode(#" + this.key + ", '" + this.title + "')>";
      },

      /**
       * Trigger `modifyChild` event on a parent to signal that a child was modified.
       * @param {string} operation Type of change: 'add', 'remove', 'rename', 'move', 'data', ...
       * @param {FancytreeNode} [childNode]
       * @param {object} [extra]
       */
      triggerModifyChild: function triggerModifyChild(operation, childNode, extra) {
        var data,
          modifyChild = this.tree.options.modifyChild;
        if (modifyChild) {
          if (childNode && childNode.parent !== this) {
            $.error("childNode " + childNode + " is not a child of " + this);
          }
          data = {
            node: this,
            tree: this.tree,
            operation: operation,
            childNode: childNode || null
          };
          if (extra) {
            $.extend(data, extra);
          }
          modifyChild({
            type: "modifyChild"
          }, data);
        }
      },
      /**
       * Trigger `modifyChild` event on node.parent(!).
       * @param {string} operation Type of change: 'add', 'remove', 'rename', 'move', 'data', ...
       * @param {object} [extra]
       */
      triggerModify: function triggerModify(operation, extra) {
        this.parent.triggerModifyChild(operation, this, extra);
      },
      /** Call fn(node) for all child nodes in hierarchical order (depth-first).<br>
       * Stop iteration, if fn() returns false. Skip current branch, if fn() returns "skip".<br>
       * Return false if iteration was stopped.
       *
       * @param {function} fn the callback function.
       *     Return false to stop iteration, return "skip" to skip this node and
       *     its children only.
       * @param {boolean} [includeSelf=false]
       * @returns {boolean}
       */
      visit: function visit(fn, includeSelf) {
        var i,
          l,
          res = true,
          children = this.children;
        if (includeSelf === true) {
          res = fn(this);
          if (res === false || res === "skip") {
            return res;
          }
        }
        if (children) {
          for (i = 0, l = children.length; i < l; i++) {
            res = children[i].visit(fn, true);
            if (res === false) {
              break;
            }
          }
        }
        return res;
      },
      /** Call fn(node) for all child nodes and recursively load lazy children.<br>
       * <b>Note:</b> If you need this method, you probably should consider to review
       * your architecture! Recursivley loading nodes is a perfect way for lazy
       * programmers to flood the server with requests ;-)
       *
       * @param {function} [fn] optional callback function.
       *     Return false to stop iteration, return "skip" to skip this node and
       *     its children only.
       * @param {boolean} [includeSelf=false]
       * @returns {$.Promise}
       * @since 2.4
       */
      visitAndLoad: function visitAndLoad(fn, includeSelf, _recursion) {
        var dfd,
          res,
          loaders,
          node = this;

        // node.debug("visitAndLoad");
        if (fn && includeSelf === true) {
          res = fn(node);
          if (res === false || res === "skip") {
            return _recursion ? res : _getResolvedPromise();
          }
        }
        if (!node.children && !node.lazy) {
          return _getResolvedPromise();
        }
        dfd = new $.Deferred();
        loaders = [];
        // node.debug("load()...");
        node.load().done(function () {
          // node.debug("load()... done.");
          for (var i = 0, l = node.children.length; i < l; i++) {
            res = node.children[i].visitAndLoad(fn, true, true);
            if (res === false) {
              dfd.reject();
              break;
            } else if (res !== "skip") {
              loaders.push(res); // Add promise to the list
            }
          }

          $.when.apply(this, loaders).then(function () {
            dfd.resolve();
          });
        });
        return dfd.promise();
      },
      /** Call fn(node) for all parent nodes, bottom-up, including invisible system root.<br>
       * Stop iteration, if fn() returns false.<br>
       * Return false if iteration was stopped.
       *
       * @param {function} fn the callback function.
       *     Return false to stop iteration, return "skip" to skip this node and children only.
       * @param {boolean} [includeSelf=false]
       * @returns {boolean}
       */
      visitParents: function visitParents(fn, includeSelf) {
        // Visit parent nodes (bottom up)
        if (includeSelf && fn(this) === false) {
          return false;
        }
        var p = this.parent;
        while (p) {
          if (fn(p) === false) {
            return false;
          }
          p = p.parent;
        }
        return true;
      },
      /** Call fn(node) for all sibling nodes.<br>
       * Stop iteration, if fn() returns false.<br>
       * Return false if iteration was stopped.
       *
       * @param {function} fn the callback function.
       *     Return false to stop iteration.
       * @param {boolean} [includeSelf=false]
       * @returns {boolean}
       */
      visitSiblings: function visitSiblings(fn, includeSelf) {
        var i,
          l,
          n,
          ac = this.parent.children;
        for (i = 0, l = ac.length; i < l; i++) {
          n = ac[i];
          if (includeSelf || n !== this) {
            if (fn(n) === false) {
              return false;
            }
          }
        }
        return true;
      },
      /** Write warning to browser console if debugLevel >= 2 (prepending node info)
       *
       * @param {*} msg string or object or array of such
       */
      warn: function warn(msg) {
        if (this.tree.options.debugLevel >= 2) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("warn", arguments);
        }
      }
    };

    /******************************************************************************
     * Fancytree
     */
    /**
     * Construct a new tree object.
     *
     * @class Fancytree
     * @classdesc The controller behind a fancytree.
     * This class also contains 'hook methods': see {@link Fancytree_Hooks}.
     *
     * @param {Widget} widget
     *
     * @property {string} _id Automatically generated unique tree instance ID, e.g. "1".
     * @property {string} _ns Automatically generated unique tree namespace, e.g. ".fancytree-1".
     * @property {FancytreeNode} activeNode Currently active node or null.
     * @property {string} ariaPropName Property name of FancytreeNode that contains the element which will receive the aria attributes.
     *     Typically "li", but "tr" for table extension.
     * @property {jQueryObject} $container Outer `<ul>` element (or `<table>` element for ext-table).
     * @property {jQueryObject} $div A jQuery object containing the element used to instantiate the tree widget (`widget.element`)
     * @property {object|array} columns Recommended place to store shared column meta data. @since 2.27
     * @property {object} data Metadata, i.e. properties that may be passed to `source` in addition to a children array.
     * @property {object} ext Hash of all active plugin instances.
     * @property {FancytreeNode} focusNode Currently focused node or null.
     * @property {FancytreeNode} lastSelectedNode Used to implement selectMode 1 (single select)
     * @property {string} nodeContainerAttrName Property name of FancytreeNode that contains the outer element of single nodes.
     *     Typically "li", but "tr" for table extension.
     * @property {FancytreeOptions} options Current options, i.e. default options + options passed to constructor.
     * @property {FancytreeNode} rootNode Invisible system root node.
     * @property {string} statusClassPropName Property name of FancytreeNode that contains the element which will receive the status classes.
     *     Typically "span", but "tr" for table extension.
     * @property {object} types Map for shared type specific meta data, used with node.type attribute. @since 2.27
     * @property {object} viewport See ext-vieport. @since v2.31
     * @property {object} widget Base widget instance.
     */
    function Fancytree(widget) {
      this.widget = widget;
      this.$div = widget.element;
      this.options = widget.options;
      if (this.options) {
        if (this.options.lazyload !== undefined) {
          $.error("The 'lazyload' event is deprecated since 2014-02-25. Use 'lazyLoad' (with uppercase L) instead.");
        }
        if (this.options.loaderror !== undefined) {
          $.error("The 'loaderror' event was renamed since 2014-07-03. Use 'loadError' (with uppercase E) instead.");
        }
        if (this.options.fx !== undefined) {
          $.error("The 'fx' option was replaced by 'toggleEffect' since 2014-11-30.");
        }
        if (this.options.removeNode !== undefined) {
          $.error("The 'removeNode' event was replaced by 'modifyChild' since 2.20 (2016-09-10).");
        }
      }
      this.ext = {}; // Active extension instances
      this.types = {};
      this.columns = {};
      // allow to init tree.data.foo from <div data-foo=''>
      this.data = _getElementDataAsDict(this.$div);
      // TODO: use widget.uuid instead?
      this._id = "" + (this.options.treeId || $.ui.fancytree._nextId++);
      // TODO: use widget.eventNamespace instead?
      this._ns = ".fancytree-" + this._id; // append for namespaced events
      this.activeNode = null;
      this.focusNode = null;
      this._hasFocus = null;
      this._tempCache = {};
      this._lastMousedownNode = null;
      this._enableUpdate = true;
      this.lastSelectedNode = null;
      this.systemFocusElement = null;
      this.lastQuicksearchTerm = "";
      this.lastQuicksearchTime = 0;
      this.viewport = null; // ext-grid

      this.statusClassPropName = "span";
      this.ariaPropName = "li";
      this.nodeContainerAttrName = "li";

      // Remove previous markup if any
      this.$div.find(">ul.fancytree-container").remove();

      // Create a node without parent.
      var fakeParent = {
          tree: this
        },
        $ul;
      this.rootNode = new FancytreeNode(fakeParent, {
        title: "root",
        key: "root_" + this._id,
        children: null,
        expanded: true
      });
      this.rootNode.parent = null;

      // Create root markup
      $ul = $("<ul>", {
        id: "ft-id-" + this._id,
        "class": "ui-fancytree fancytree-container fancytree-plain"
      }).appendTo(this.$div);
      this.$container = $ul;
      this.rootNode.ul = $ul[0];
      if (this.options.debugLevel == null) {
        this.options.debugLevel = FT.debugLevel;
      }
      // // Add container to the TAB chain
      // // See http://www.w3.org/TR/wai-aria-practices/#focus_activedescendant
      // // #577: Allow to set tabindex to "0", "-1" and ""
      // this.$container.attr("tabindex", this.options.tabindex);

      // if( this.options.rtl ) {
      // 	this.$container.attr("DIR", "RTL").addClass("fancytree-rtl");
      // // }else{
      // //	this.$container.attr("DIR", null).removeClass("fancytree-rtl");
      // }
      // if(this.options.aria){
      // 	this.$container.attr("role", "tree");
      // 	if( this.options.selectMode !== 1 ) {
      // 		this.$container.attr("aria-multiselectable", true);
      // 	}
      // }
    }

    Fancytree.prototype = /** @lends Fancytree# */{
      /* Return a context object that can be re-used for _callHook().
       * @param {Fancytree | FancytreeNode | EventData} obj
       * @param {Event} originalEvent
       * @param {Object} extra
       * @returns {EventData}
       */
      _makeHookContext: function _makeHookContext(obj, originalEvent, extra) {
        var ctx, tree;
        if (obj.node !== undefined) {
          // obj is already a context object
          if (originalEvent && obj.originalEvent !== originalEvent) {
            $.error("invalid args");
          }
          ctx = obj;
        } else if (obj.tree) {
          // obj is a FancytreeNode
          tree = obj.tree;
          ctx = {
            node: obj,
            tree: tree,
            widget: tree.widget,
            options: tree.widget.options,
            originalEvent: originalEvent,
            typeInfo: tree.types[obj.type] || {}
          };
        } else if (obj.widget) {
          // obj is a Fancytree
          ctx = {
            node: null,
            tree: obj,
            widget: obj.widget,
            options: obj.widget.options,
            originalEvent: originalEvent
          };
        } else {
          $.error("invalid args");
        }
        if (extra) {
          $.extend(ctx, extra);
        }
        return ctx;
      },
      /* Trigger a hook function: funcName(ctx, [...]).
       *
       * @param {string} funcName
       * @param {Fancytree|FancytreeNode|EventData} contextObject
       * @param {any}  [_extraArgs] optional additional arguments
       * @returns {any}
       */
      _callHook: function _callHook(funcName, contextObject, _extraArgs) {
        var ctx = this._makeHookContext(contextObject),
          fn = this[funcName],
          args = Array.prototype.slice.call(arguments, 2);
        if (!_isFunction(fn)) {
          $.error("_callHook('" + funcName + "') is not a function");
        }
        args.unshift(ctx);
        // this.debug("_hook", funcName, ctx.node && ctx.node.toString() || ctx.tree.toString(), args);
        return fn.apply(this, args);
      },
      _setExpiringValue: function _setExpiringValue(key, value, ms) {
        this._tempCache[key] = {
          value: value,
          expire: Date.now() + (+ms || 50)
        };
      },
      _getExpiringValue: function _getExpiringValue(key) {
        var entry = this._tempCache[key];
        if (entry && entry.expire > Date.now()) {
          return entry.value;
        }
        delete this._tempCache[key];
        return null;
      },
      /* Check if this tree has extension `name` enabled.
       *
       * @param {string} name name of the required extension
       */
      _usesExtension: function _usesExtension(name) {
        return $.inArray(name, this.options.extensions) >= 0;
      },
      /* Check if current extensions dependencies are met and throw an error if not.
       *
       * This method may be called inside the `treeInit` hook for custom extensions.
       *
       * @param {string} name name of the required extension
       * @param {boolean} [required=true] pass `false` if the extension is optional, but we want to check for order if it is present
       * @param {boolean} [before] `true` if `name` must be included before this, `false` otherwise (use `null` if order doesn't matter)
       * @param {string} [message] optional error message (defaults to a descriptve error message)
       */
      _requireExtension: function _requireExtension(name, required, before, message) {
        if (before != null) {
          before = !!before;
        }
        var thisName = this._local.name,
          extList = this.options.extensions,
          isBefore = $.inArray(name, extList) < $.inArray(thisName, extList),
          isMissing = required && this.ext[name] == null,
          badOrder = !isMissing && before != null && before !== isBefore;
        _assert(thisName && thisName !== name, "invalid or same name '" + thisName + "' (require yourself?)");
        if (isMissing || badOrder) {
          if (!message) {
            if (isMissing || required) {
              message = "'" + thisName + "' extension requires '" + name + "'";
              if (badOrder) {
                message += " to be registered " + (before ? "before" : "after") + " itself";
              }
            } else {
              message = "If used together, `" + name + "` must be registered " + (before ? "before" : "after") + " `" + thisName + "`";
            }
          }
          $.error(message);
          return false;
        }
        return true;
      },
      /** Activate node with a given key and fire focus and activate events.
       *
       * A previously activated node will be deactivated.
       * If activeVisible option is set, all parents will be expanded as necessary.
       * Pass key = false, to deactivate the current node only.
       * @param {string} key
       * @param {object} [opts] additional options. Defaults to {noEvents: false, noFocus: false}
       * @returns {FancytreeNode} activated node (null, if not found)
       */
      activateKey: function activateKey(key, opts) {
        var node = this.getNodeByKey(key);
        if (node) {
          node.setActive(true, opts);
        } else if (this.activeNode) {
          this.activeNode.setActive(false, opts);
        }
        return node;
      },
      /** (experimental) Add child status nodes that indicate 'More...', ....
       * @param {boolean|object} node optional node definition. Pass `false` to remove all paging nodes.
       * @param {string} [mode='append'] 'child'|firstChild'
       * @since 2.15
       */
      addPagingNode: function addPagingNode(node, mode) {
        return this.rootNode.addPagingNode(node, mode);
      },
      /**
       * (experimental) Apply a modification (or navigation) operation.
       *
       * Valid commands:
       *   - 'moveUp', 'moveDown'
       *   - 'indent', 'outdent'
       *   - 'remove'
       *   - 'edit', 'addChild', 'addSibling': (reqires ext-edit extension)
       *   - 'cut', 'copy', 'paste': (use an internal singleton 'clipboard')
       *   - 'down', 'first', 'last', 'left', 'parent', 'right', 'up': navigate
       *
       * @param {string} cmd
       * @param {FancytreeNode} [node=active_node]
       * @param {object} [opts] Currently unused
       *
       * @since 2.32
       */
      applyCommand: function applyCommand(cmd, node, opts_) {
        var
        // clipboard,
        refNode;
        // opts = $.extend(
        // 	{ setActive: true, clipboard: CLIPBOARD },
        // 	opts_
        // );

        node = node || this.getActiveNode();
        // clipboard = opts.clipboard;

        switch (cmd) {
          // Sorting and indentation:
          case "moveUp":
            refNode = node.getPrevSibling();
            if (refNode) {
              node.moveTo(refNode, "before");
              node.setActive();
            }
            break;
          case "moveDown":
            refNode = node.getNextSibling();
            if (refNode) {
              node.moveTo(refNode, "after");
              node.setActive();
            }
            break;
          case "indent":
            refNode = node.getPrevSibling();
            if (refNode) {
              node.moveTo(refNode, "child");
              refNode.setExpanded();
              node.setActive();
            }
            break;
          case "outdent":
            if (!node.isTopLevel()) {
              node.moveTo(node.getParent(), "after");
              node.setActive();
            }
            break;
          // Remove:
          case "remove":
            refNode = node.getPrevSibling() || node.getParent();
            node.remove();
            if (refNode) {
              refNode.setActive();
            }
            break;
          // Add, edit (requires ext-edit):
          case "addChild":
            node.editCreateNode("child", "");
            break;
          case "addSibling":
            node.editCreateNode("after", "");
            break;
          case "rename":
            node.editStart();
            break;
          // Simple clipboard simulation:
          // case "cut":
          // 	clipboard = { mode: cmd, data: node };
          // 	break;
          // case "copy":
          // 	clipboard = {
          // 		mode: cmd,
          // 		data: node.toDict(function(d, n) {
          // 			delete d.key;
          // 		}),
          // 	};
          // 	break;
          // case "clear":
          // 	clipboard = null;
          // 	break;
          // case "paste":
          // 	if (clipboard.mode === "cut") {
          // 		// refNode = node.getPrevSibling();
          // 		clipboard.data.moveTo(node, "child");
          // 		clipboard.data.setActive();
          // 	} else if (clipboard.mode === "copy") {
          // 		node.addChildren(clipboard.data).setActive();
          // 	}
          // 	break;
          // Navigation commands:
          case "down":
          case "first":
          case "last":
          case "left":
          case "parent":
          case "right":
          case "up":
            return node.navigate(cmd);
          default:
            $.error("Unhandled command: '" + cmd + "'");
        }
      },
      /** (experimental) Modify existing data model.
       *
       * @param {Array} patchList array of [key, NodePatch] arrays
       * @returns {$.Promise} resolved, when all patches have been applied
       * @see TreePatch
       */
      applyPatch: function applyPatch(patchList) {
        var dfd,
          i,
          p2,
          key,
          patch,
          node,
          patchCount = patchList.length,
          deferredList = [];
        for (i = 0; i < patchCount; i++) {
          p2 = patchList[i];
          _assert(p2.length === 2, "patchList must be an array of length-2-arrays");
          key = p2[0];
          patch = p2[1];
          node = key === null ? this.rootNode : this.getNodeByKey(key);
          if (node) {
            dfd = new $.Deferred();
            deferredList.push(dfd);
            node.applyPatch(patch).always(_makeResolveFunc(dfd, node));
          } else {
            this.warn("could not find node with key '" + key + "'");
          }
        }
        // Return a promise that is resolved, when ALL patches were applied
        return $.when.apply($, deferredList).promise();
      },
      /* TODO: implement in dnd extension
      cancelDrag: function() {
      		var dd = $.ui.ddmanager.current;
      		if(dd){
      			dd.cancel();
      		}
      	},
      */
      /** Remove all nodes.
       * @since 2.14
       */
      clear: function clear(source) {
        this._callHook("treeClear", this);
      },
      /** Return the number of nodes.
       * @returns {integer}
       */
      count: function count() {
        return this.rootNode.countChildren();
      },
      /** Write to browser console if debugLevel >= 4 (prepending tree name)
       *
       * @param {*} msg string or object or array of such
       */
      debug: function debug(msg) {
        if (this.options.debugLevel >= 4) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("log", arguments);
        }
      },
      /** Destroy this widget, restore previous markup and cleanup resources.
       *
       * @since 2.34
       */
      destroy: function destroy() {
        this.widget.destroy();
      },
      /** Enable (or disable) the tree control.
       *
       * @param {boolean} [flag=true] pass false to disable
       * @since 2.30
       */
      enable: function enable(flag) {
        if (flag === false) {
          this.widget.disable();
        } else {
          this.widget.enable();
        }
      },
      /** Temporarily suppress rendering to improve performance on bulk-updates.
       *
       * @param {boolean} flag
       * @returns {boolean} previous status
       * @since 2.19
       */
      enableUpdate: function enableUpdate(flag) {
        flag = flag !== false;
        if (!!this._enableUpdate === !!flag) {
          return flag;
        }
        this._enableUpdate = flag;
        if (flag) {
          this.debug("enableUpdate(true): redraw "); //, this._dirtyRoots);
          this._callHook("treeStructureChanged", this, "enableUpdate");
          this.render();
        } else {
          // 	this._dirtyRoots = null;
          this.debug("enableUpdate(false)...");
        }
        return !flag; // return previous value
      },

      /** Write error to browser console if debugLevel >= 1 (prepending tree info)
       *
       * @param {*} msg string or object or array of such
       */
      error: function error(msg) {
        if (this.options.debugLevel >= 1) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("error", arguments);
        }
      },
      /** Expand (or collapse) all parent nodes.
       *
       * This convenience method uses `tree.visit()` and `tree.setExpanded()`
       * internally.
       *
       * @param {boolean} [flag=true] pass false to collapse
       * @param {object} [opts] passed to setExpanded()
       * @since 2.30
       */
      expandAll: function expandAll(flag, opts) {
        var prev = this.enableUpdate(false);
        flag = flag !== false;
        this.visit(function (node) {
          if (node.hasChildren() !== false && node.isExpanded() !== flag) {
            node.setExpanded(flag, opts);
          }
        });
        this.enableUpdate(prev);
      },
      /**Find all nodes that matches condition.
       *
       * @param {string | function(node)} match title string to search for, or a
       *     callback function that returns `true` if a node is matched.
       * @returns {FancytreeNode[]} array of nodes (may be empty)
       * @see FancytreeNode#findAll
       * @since 2.12
       */
      findAll: function findAll(match) {
        return this.rootNode.findAll(match);
      },
      /**Find first node that matches condition.
       *
       * @param {string | function(node)} match title string to search for, or a
       *     callback function that returns `true` if a node is matched.
       * @returns {FancytreeNode} matching node or null
       * @see FancytreeNode#findFirst
       * @since 2.12
       */
      findFirst: function findFirst(match) {
        return this.rootNode.findFirst(match);
      },
      /** Find the next visible node that starts with `match`, starting at `startNode`
       * and wrap-around at the end.
       *
       * @param {string|function} match
       * @param {FancytreeNode} [startNode] defaults to first node
       * @returns {FancytreeNode} matching node or null
       */
      findNextNode: function findNextNode(match, startNode) {
        //, visibleOnly) {
        var res = null,
          firstNode = this.getFirstChild();
        match = typeof match === "string" ? _makeNodeTitleStartMatcher(match) : match;
        startNode = startNode || firstNode;
        function _checkNode(n) {
          // console.log("_check " + n)
          if (match(n)) {
            res = n;
          }
          if (res || n === startNode) {
            return false;
          }
        }
        this.visitRows(_checkNode, {
          start: startNode,
          includeSelf: false
        });
        // Wrap around search
        if (!res && startNode !== firstNode) {
          this.visitRows(_checkNode, {
            start: firstNode,
            includeSelf: true
          });
        }
        return res;
      },
      /** Find a node relative to another node.
       *
       * @param {FancytreeNode} node
       * @param {string|number} where 'down', 'first', 'last', 'left', 'parent', 'right', or 'up'.
       *   (Alternatively the keyCode that would normally trigger this move,
       *   e.g. `$.ui.keyCode.LEFT` = 'left'.
       * @param {boolean} [includeHidden=false] Not yet implemented
       * @returns {FancytreeNode|null}
       * @since v2.31
       */
      findRelatedNode: function findRelatedNode(node, where, includeHidden) {
        var res = null,
          KC = $.ui.keyCode;
        switch (where) {
          case "parent":
          case KC.BACKSPACE:
            if (node.parent && node.parent.parent) {
              res = node.parent;
            }
            break;
          case "first":
          case KC.HOME:
            // First visible node
            this.visit(function (n) {
              if (n.isVisible()) {
                res = n;
                return false;
              }
            });
            break;
          case "last":
          case KC.END:
            this.visit(function (n) {
              // last visible node
              if (n.isVisible()) {
                res = n;
              }
            });
            break;
          case "left":
          case KC.LEFT:
            if (node.expanded) {
              node.setExpanded(false);
            } else if (node.parent && node.parent.parent) {
              res = node.parent;
            }
            break;
          case "right":
          case KC.RIGHT:
            if (!node.expanded && (node.children || node.lazy)) {
              node.setExpanded();
              res = node;
            } else if (node.children && node.children.length) {
              res = node.children[0];
            }
            break;
          case "up":
          case KC.UP:
            this.visitRows(function (n) {
              res = n;
              return false;
            }, {
              start: node,
              reverse: true,
              includeSelf: false
            });
            break;
          case "down":
          case KC.DOWN:
            this.visitRows(function (n) {
              res = n;
              return false;
            }, {
              start: node,
              includeSelf: false
            });
            break;
          default:
            this.tree.warn("Unknown relation '" + where + "'.");
        }
        return res;
      },
      // TODO: fromDict
      /**
       * Generate INPUT elements that can be submitted with html forms.
       *
       * In selectMode 3 only the topmost selected nodes are considered, unless
       * `opts.stopOnParents: false` is passed.
       *
       * @example
       * // Generate input elements for active and selected nodes
       * tree.generateFormElements();
       * // Generate input elements selected nodes, using a custom `name` attribute
       * tree.generateFormElements("cust_sel", false);
       * // Generate input elements using a custom filter
       * tree.generateFormElements(true, true, { filter: function(node) {
       *     return node.isSelected() && node.data.yes;
       * }});
       *
       * @param {boolean | string} [selected=true] Pass false to disable, pass a string to override the field name (default: 'ft_ID[]')
       * @param {boolean | string} [active=true] Pass false to disable, pass a string to override the field name (default: 'ft_ID_active')
       * @param {object} [opts] default { filter: null, stopOnParents: true }
       */
      generateFormElements: function generateFormElements(selected, active, opts) {
        opts = opts || {};
        var nodeList,
          selectedName = typeof selected === "string" ? selected : "ft_" + this._id + "[]",
          activeName = typeof active === "string" ? active : "ft_" + this._id + "_active",
          id = "fancytree_result_" + this._id,
          $result = $("#" + id),
          stopOnParents = this.options.selectMode === 3 && opts.stopOnParents !== false;
        if ($result.length) {
          $result.empty();
        } else {
          $result = $("<div>", {
            id: id
          }).hide().insertAfter(this.$container);
        }
        if (active !== false && this.activeNode) {
          $result.append($("<input>", {
            type: "radio",
            name: activeName,
            value: this.activeNode.key,
            checked: true
          }));
        }
        function _appender(node) {
          $result.append($("<input>", {
            type: "checkbox",
            name: selectedName,
            value: node.key,
            checked: true
          }));
        }
        if (opts.filter) {
          this.visit(function (node) {
            var res = opts.filter(node);
            if (res === "skip") {
              return res;
            }
            if (res !== false) {
              _appender(node);
            }
          });
        } else if (selected !== false) {
          nodeList = this.getSelectedNodes(stopOnParents);
          $.each(nodeList, function (idx, node) {
            _appender(node);
          });
        }
      },
      /**
       * Return the currently active node or null.
       * @returns {FancytreeNode}
       */
      getActiveNode: function getActiveNode() {
        return this.activeNode;
      },
      /** Return the first top level node if any (not the invisible root node).
       * @returns {FancytreeNode | null}
       */
      getFirstChild: function getFirstChild() {
        return this.rootNode.getFirstChild();
      },
      /**
       * Return node that has keyboard focus or null.
       * @returns {FancytreeNode}
       */
      getFocusNode: function getFocusNode() {
        return this.focusNode;
      },
      /**
       * Return current option value.
       * (Note: this is the preferred variant of `$().fancytree("option", "KEY")`)
       *
       * @param {string} name option name (may contain '.')
       * @returns {any}
       */
      getOption: function getOption(optionName) {
        return this.widget.option(optionName);
      },
      /**
       * Return node with a given key or null if not found.
       *
       * @param {string} key
       * @param {FancytreeNode} [searchRoot] only search below this node
       * @returns {FancytreeNode | null}
       */
      getNodeByKey: function getNodeByKey(key, searchRoot) {
        // Search the DOM by element ID (assuming this is faster than traversing all nodes).
        var el, match;
        // TODO: use tree.keyMap if available
        // TODO: check opts.generateIds === true
        if (!searchRoot) {
          el = document.getElementById(this.options.idPrefix + key);
          if (el) {
            return el.ftnode ? el.ftnode : null;
          }
        }
        // Not found in the DOM, but still may be in an unrendered part of tree
        searchRoot = searchRoot || this.rootNode;
        match = null;
        key = "" + key; // Convert to string (#1005)
        searchRoot.visit(function (node) {
          if (node.key === key) {
            match = node;
            return false; // Stop iteration
          }
        }, true);
        return match;
      },
      /** Return the invisible system root node.
       * @returns {FancytreeNode}
       */
      getRootNode: function getRootNode() {
        return this.rootNode;
      },
      /**
       * Return an array of selected nodes.
       *
       * Note: you cannot send this result via Ajax directly. Instead the
       * node object need to be converted to plain objects, for example
       * by using `$.map()` and `node.toDict()`.
       * @param {boolean} [stopOnParents=false] only return the topmost selected
       *     node (useful with selectMode 3)
       * @returns {FancytreeNode[]}
       */
      getSelectedNodes: function getSelectedNodes(stopOnParents) {
        return this.rootNode.getSelectedNodes(stopOnParents);
      },
      /** Return true if the tree control has keyboard focus
       * @returns {boolean}
       */
      hasFocus: function hasFocus() {
        // var ae = document.activeElement,
        // 	hasFocus = !!(
        // 		ae && $(ae).closest(".fancytree-container").length
        // 	);

        // if (hasFocus !== !!this._hasFocus) {
        // 	this.warn(
        // 		"hasFocus(): fix inconsistent container state, now: " +
        // 			hasFocus
        // 	);
        // 	this._hasFocus = hasFocus;
        // 	this.$container.toggleClass("fancytree-treefocus", hasFocus);
        // }
        // return hasFocus;
        return !!this._hasFocus;
      },
      /** Write to browser console if debugLevel >= 3 (prepending tree name)
       * @param {*} msg string or object or array of such
       */
      info: function info(msg) {
        if (this.options.debugLevel >= 3) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("info", arguments);
        }
      },
      /** Return true if any node is currently beeing loaded, i.e. a Ajax request is pending.
       * @returns {boolean}
       * @since 2.32
       */
      isLoading: function isLoading() {
        var res = false;
        this.rootNode.visit(function (n) {
          // also visit rootNode
          if (n._isLoading || n._requestId) {
            res = true;
            return false;
          }
        }, true);
        return res;
      },
      /*
      TODO: isInitializing: function() {
      	return ( this.phase=="init" || this.phase=="postInit" );
      },
      TODO: isReloading: function() {
      	return ( this.phase=="init" || this.phase=="postInit" ) && this.options.persist && this.persistence.cookiesFound;
      },
      TODO: isUserEvent: function() {
      	return ( this.phase=="userEvent" );
      },
      */

      /**
       * Make sure that a node with a given ID is loaded, by traversing - and
       * loading - its parents. This method is meant for lazy hierarchies.
       * A callback is executed for every node as we go.
       * @example
       * // Resolve using node.key:
       * tree.loadKeyPath("/_3/_23/_26/_27", function(node, status){
       *   if(status === "loaded") {
       *     console.log("loaded intermediate node " + node);
       *   }else if(status === "ok") {
       *     node.activate();
       *   }
       * });
       * // Use deferred promise:
       * tree.loadKeyPath("/_3/_23/_26/_27").progress(function(data){
       *   if(data.status === "loaded") {
       *     console.log("loaded intermediate node " + data.node);
       *   }else if(data.status === "ok") {
       *     node.activate();
       *   }
       * }).done(function(){
       *    ...
       * });
       * // Custom path segment resolver:
       * tree.loadKeyPath("/321/431/21/2", {
       *   matchKey: function(node, key){
       *     return node.data.refKey === key;
       *   },
       *   callback: function(node, status){
       *     if(status === "loaded") {
       *       console.log("loaded intermediate node " + node);
       *     }else if(status === "ok") {
       *       node.activate();
       *     }
       *   }
       * });
       * @param {string | string[]} keyPathList one or more key paths (e.g. '/3/2_1/7')
       * @param {function | object} optsOrCallback callback(node, status) is called for every visited node ('loading', 'loaded', 'ok', 'error').
       *     Pass an object to define custom key matchers for the path segments: {callback: function, matchKey: function}.
       * @returns {$.Promise}
       */
      loadKeyPath: function loadKeyPath(keyPathList, optsOrCallback) {
        var callback,
          i,
          path,
          self = this,
          dfd = new $.Deferred(),
          parent = this.getRootNode(),
          sep = this.options.keyPathSeparator,
          pathSegList = [],
          opts = $.extend({}, optsOrCallback);

        // Prepare options
        if (typeof optsOrCallback === "function") {
          callback = optsOrCallback;
        } else if (optsOrCallback && optsOrCallback.callback) {
          callback = optsOrCallback.callback;
        }
        opts.callback = function (ctx, node, status) {
          if (callback) {
            callback.call(ctx, node, status);
          }
          dfd.notifyWith(ctx, [{
            node: node,
            status: status
          }]);
        };
        if (opts.matchKey == null) {
          opts.matchKey = function (node, key) {
            return node.key === key;
          };
        }
        // Convert array of path strings to array of segment arrays
        if (!_isArray(keyPathList)) {
          keyPathList = [keyPathList];
        }
        for (i = 0; i < keyPathList.length; i++) {
          path = keyPathList[i];
          // strip leading slash
          if (path.charAt(0) === sep) {
            path = path.substr(1);
          }
          // segListMap[path] = { parent: parent, segList: path.split(sep) };
          pathSegList.push(path.split(sep));
          // targetList.push({ parent: parent, segList: path.split(sep)/* , path: path*/});
        }
        // The timeout forces async behavior always (even if nodes are all loaded)
        // This way a potential progress() event will fire.
        setTimeout(function () {
          self._loadKeyPathImpl(dfd, opts, parent, pathSegList).done(function () {
            dfd.resolve();
          });
        }, 0);
        return dfd.promise();
      },
      /*
       * Resolve a list of paths, relative to one parent node.
       */
      _loadKeyPathImpl: function _loadKeyPathImpl(dfd, opts, parent, pathSegList) {
        var deferredList,
          i,
          key,
          node,
          nodeKey,
          remain,
          remainMap,
          tmpParent,
          segList,
          subDfd,
          self = this;
        function __findChild(parent, key) {
          // console.log("__findChild", key, parent);
          var i,
            l,
            cl = parent.children;
          if (cl) {
            for (i = 0, l = cl.length; i < l; i++) {
              if (opts.matchKey(cl[i], key)) {
                return cl[i];
              }
            }
          }
          return null;
        }

        // console.log("_loadKeyPathImpl, parent=", parent, ", pathSegList=", pathSegList);

        // Pass 1:
        // Handle all path segments for nodes that are already loaded.
        // Collect distinct top-most lazy nodes in a map.
        // Note that we can use node.key to de-dupe entries, even if a custom matcher would
        // look for other node attributes.
        // map[node.key] => {node: node, pathList: [list of remaining rest-paths]}
        remainMap = {};
        for (i = 0; i < pathSegList.length; i++) {
          segList = pathSegList[i];
          // target = targetList[i];

          // Traverse and pop path segments (i.e. keys), until we hit a lazy, unloaded node
          tmpParent = parent;
          while (segList.length) {
            key = segList.shift();
            node = __findChild(tmpParent, key);
            if (!node) {
              this.warn("loadKeyPath: key not found: " + key + " (parent: " + tmpParent + ")");
              opts.callback(this, key, "error");
              break;
            } else if (segList.length === 0) {
              opts.callback(this, node, "ok");
              break;
            } else if (!node.lazy || node.hasChildren() !== undefined) {
              opts.callback(this, node, "loaded");
              tmpParent = node;
            } else {
              opts.callback(this, node, "loaded");
              key = node.key; //target.segList.join(sep);
              if (remainMap[key]) {
                remainMap[key].pathSegList.push(segList);
              } else {
                remainMap[key] = {
                  parent: node,
                  pathSegList: [segList]
                };
              }
              break;
            }
          }
        }
        // console.log("_loadKeyPathImpl AFTER pass 1, remainMap=", remainMap);

        // Now load all lazy nodes and continue iteration for remaining paths
        deferredList = [];

        // Avoid jshint warning 'Don't make functions within a loop.':
        function __lazyload(dfd, parent, pathSegList) {
          // console.log("__lazyload", parent, "pathSegList=", pathSegList);
          opts.callback(self, parent, "loading");
          parent.load().done(function () {
            self._loadKeyPathImpl.call(self, dfd, opts, parent, pathSegList).always(_makeResolveFunc(dfd, self));
          }).fail(function (errMsg) {
            self.warn("loadKeyPath: error loading lazy " + parent);
            opts.callback(self, node, "error");
            dfd.rejectWith(self);
          });
        }
        // remainMap contains parent nodes, each with a list of relative sub-paths.
        // We start loading all of them now, and pass the the list to each loader.
        for (nodeKey in remainMap) {
          if (_hasProp(remainMap, nodeKey)) {
            remain = remainMap[nodeKey];
            // console.log("for(): remain=", remain, "remainMap=", remainMap);
            // key = remain.segList.shift();
            // node = __findChild(remain.parent, key);
            // if (node == null) {  // #576
            // 	// Issue #576, refactored for v2.27:
            // 	// The root cause was, that sometimes the wrong parent was used here
            // 	// to find the next segment.
            // 	// Falling back to getNodeByKey() was a hack that no longer works if a custom
            // 	// matcher is used, because we cannot assume that a single segment-key is unique
            // 	// throughout the tree.
            // 	self.error("loadKeyPath: error loading child by key '" + key + "' (parent: " + target.parent + ")", target);
            // 	// 	node = self.getNodeByKey(key);
            // 	continue;
            // }
            subDfd = new $.Deferred();
            deferredList.push(subDfd);
            __lazyload(subDfd, remain.parent, remain.pathSegList);
          }
        }
        // Return a promise that is resolved, when ALL paths were loaded
        return $.when.apply($, deferredList).promise();
      },
      /** Re-fire beforeActivate, activate, and (optional) focus events.
       * Calling this method in the `init` event, will activate the node that
       * was marked 'active' in the source data, and optionally set the keyboard
       * focus.
       * @param [setFocus=false]
       */
      reactivate: function reactivate(setFocus) {
        var res,
          node = this.activeNode;
        if (!node) {
          return _getResolvedPromise();
        }
        this.activeNode = null; // Force re-activating
        res = node.setActive(true, {
          noFocus: true
        });
        if (setFocus) {
          node.setFocus();
        }
        return res;
      },
      /** Reload tree from source and return a promise.
       * @param [source] optional new source (defaults to initial source data)
       * @returns {$.Promise}
       */
      reload: function reload(source) {
        this._callHook("treeClear", this);
        return this._callHook("treeLoad", this, source);
      },
      /**Render tree (i.e. create DOM elements for all top-level nodes).
       * @param {boolean} [force=false] create DOM elemnts, even if parent is collapsed
       * @param {boolean} [deep=false]
       */
      render: function render(force, deep) {
        return this.rootNode.render(force, deep);
      },
      /**(De)select all nodes.
       * @param {boolean} [flag=true]
       * @since 2.28
       */
      selectAll: function selectAll(flag) {
        this.visit(function (node) {
          node.setSelected(flag);
        });
      },
      // TODO: selectKey: function(key, select)
      // TODO: serializeArray: function(stopOnParents)
      /**
       * @param {boolean} [flag=true]
       */
      setFocus: function setFocus(flag) {
        return this._callHook("treeSetFocus", this, flag);
      },
      /**
       * Set current option value.
       * (Note: this is the preferred variant of `$().fancytree("option", "KEY", VALUE)`)
       * @param {string} name option name (may contain '.')
       * @param {any} new value
       */
      setOption: function setOption(optionName, value) {
        return this.widget.option(optionName, value);
      },
      /**
       * Call console.time() when in debug mode (verbose >= 4).
       *
       * @param {string} label
       */
      debugTime: function debugTime(label) {
        if (this.options.debugLevel >= 4) {
          window.console.time(this + " - " + label);
        }
      },
      /**
       * Call console.timeEnd() when in debug mode (verbose >= 4).
       *
       * @param {string} label
       */
      debugTimeEnd: function debugTimeEnd(label) {
        if (this.options.debugLevel >= 4) {
          window.console.timeEnd(this + " - " + label);
        }
      },
      /**
       * Return all nodes as nested list of {@link NodeData}.
       *
       * @param {boolean} [includeRoot=false] Returns the hidden system root node (and its children)
       * @param {function} [callback] callback(dict, node) is called for every node, in order to allow modifications.
       *     Return `false` to ignore this node or "skip" to include this node without its children.
       * @returns {Array | object}
       * @see FancytreeNode#toDict
       */
      toDict: function toDict(includeRoot, callback) {
        var res = this.rootNode.toDict(true, callback);
        return includeRoot ? res : res.children;
      },
      /* Implicitly called for string conversions.
       * @returns {string}
       */
      toString: function toString() {
        return "Fancytree@" + this._id;
        // return "<Fancytree(#" + this._id + ")>";
      },

      /* _trigger a widget event with additional node ctx.
       * @see EventData
       */
      _triggerNodeEvent: function _triggerNodeEvent(type, node, originalEvent, extra) {
        // this.debug("_trigger(" + type + "): '" + ctx.node.title + "'", ctx);
        var ctx = this._makeHookContext(node, originalEvent, extra),
          res = this.widget._trigger(type, originalEvent, ctx);
        if (res !== false && ctx.result !== undefined) {
          return ctx.result;
        }
        return res;
      },
      /* _trigger a widget event with additional tree data. */
      _triggerTreeEvent: function _triggerTreeEvent(type, originalEvent, extra) {
        // this.debug("_trigger(" + type + ")", ctx);
        var ctx = this._makeHookContext(this, originalEvent, extra),
          res = this.widget._trigger(type, originalEvent, ctx);
        if (res !== false && ctx.result !== undefined) {
          return ctx.result;
        }
        return res;
      },
      /** Call fn(node) for all nodes in hierarchical order (depth-first).
       *
       * @param {function} fn the callback function.
       *     Return false to stop iteration, return "skip" to skip this node and children only.
       * @returns {boolean} false, if the iterator was stopped.
       */
      visit: function visit(fn) {
        return this.rootNode.visit(fn, false);
      },
      /** Call fn(node) for all nodes in vertical order, top down (or bottom up).<br>
       * Stop iteration, if fn() returns false.<br>
       * Return false if iteration was stopped.
       *
       * @param {function} fn the callback function.
       *     Return false to stop iteration, return "skip" to skip this node and children only.
       * @param {object} [options]
       *     Defaults:
       *     {start: First top node, reverse: false, includeSelf: true, includeHidden: false}
       * @returns {boolean} false if iteration was cancelled
       * @since 2.28
       */
      visitRows: function visitRows(fn, opts) {
        if (!this.rootNode.hasChildren()) {
          return false;
        }
        if (opts && opts.reverse) {
          delete opts.reverse;
          return this._visitRowsUp(fn, opts);
        }
        opts = opts || {};
        var i,
          nextIdx,
          parent,
          res,
          siblings,
          siblingOfs = 0,
          skipFirstNode = opts.includeSelf === false,
          includeHidden = !!opts.includeHidden,
          checkFilter = !includeHidden && this.enableFilter,
          node = opts.start || this.rootNode.children[0];
        parent = node.parent;
        while (parent) {
          // visit siblings
          siblings = parent.children;
          nextIdx = siblings.indexOf(node) + siblingOfs;
          _assert(nextIdx >= 0, "Could not find " + node + " in parent's children: " + parent);
          for (i = nextIdx; i < siblings.length; i++) {
            node = siblings[i];
            if (checkFilter && !node.match && !node.subMatchCount) {
              continue;
            }
            if (!skipFirstNode && fn(node) === false) {
              return false;
            }
            skipFirstNode = false;
            // Dive into node's child nodes
            if (node.children && node.children.length && (includeHidden || node.expanded)) {
              // Disable warning: Functions declared within loops referencing an outer
              // scoped variable may lead to confusing semantics:
              /*jshint -W083 */
              res = node.visit(function (n) {
                if (checkFilter && !n.match && !n.subMatchCount) {
                  return "skip";
                }
                if (fn(n) === false) {
                  return false;
                }
                if (!includeHidden && n.children && !n.expanded) {
                  return "skip";
                }
              }, false);
              /*jshint +W083 */
              if (res === false) {
                return false;
              }
            }
          }
          // Visit parent nodes (bottom up)
          node = parent;
          parent = parent.parent;
          siblingOfs = 1; //
        }

        return true;
      },
      /* Call fn(node) for all nodes in vertical order, bottom up.
       */
      _visitRowsUp: function _visitRowsUp(fn, opts) {
        var children,
          idx,
          parent,
          includeHidden = !!opts.includeHidden,
          node = opts.start || this.rootNode.children[0];
        while (true) {
          parent = node.parent;
          children = parent.children;
          if (children[0] === node) {
            // If this is already the first sibling, goto parent
            node = parent;
            if (!node.parent) {
              break; // first node of the tree
            }

            children = parent.children;
          } else {
            // Otherwise, goto prev. sibling
            idx = children.indexOf(node);
            node = children[idx - 1];
            // If the prev. sibling has children, follow down to last descendant
            while (
            // See: https://github.com/eslint/eslint/issues/11302
            // eslint-disable-next-line no-unmodified-loop-condition
            (includeHidden || node.expanded) && node.children && node.children.length) {
              children = node.children;
              parent = node;
              node = children[children.length - 1];
            }
          }
          // Skip invisible
          if (!includeHidden && !node.isVisible()) {
            continue;
          }
          if (fn(node) === false) {
            return false;
          }
        }
      },
      /** Write warning to browser console if debugLevel >= 2 (prepending tree info)
       *
       * @param {*} msg string or object or array of such
       */
      warn: function warn(msg) {
        if (this.options.debugLevel >= 2) {
          Array.prototype.unshift.call(arguments, this.toString());
          consoleApply("warn", arguments);
        }
      }
    };

    /**
     * These additional methods of the {@link Fancytree} class are 'hook functions'
     * that can be used and overloaded by extensions.
     *
     * @see [writing extensions](https://github.com/mar10/fancytree/wiki/TutorialExtensions)
     * @mixin Fancytree_Hooks
     */
    $.extend(Fancytree.prototype, /** @lends Fancytree_Hooks# */
    {
      /** Default handling for mouse click events.
       *
       * @param {EventData} ctx
       */
      nodeClick: function nodeClick(ctx) {
        var activate,
          expand,
          // event = ctx.originalEvent,
          targetType = ctx.targetType,
          node = ctx.node;

        // this.debug("ftnode.onClick(" + event.type + "): ftnode:" + this + ", button:" + event.button + ", which: " + event.which, ctx);
        // TODO: use switch
        // TODO: make sure clicks on embedded <input> doesn't steal focus (see table sample)
        if (targetType === "expander") {
          if (node.isLoading()) {
            // #495: we probably got a click event while a lazy load is pending.
            // The 'expanded' state is not yet set, so 'toggle' would expand
            // and trigger lazyLoad again.
            // It would be better to allow to collapse/expand the status node
            // while loading (instead of ignoring), but that would require some
            // more work.
            node.debug("Got 2nd click while loading: ignored");
            return;
          }
          // Clicking the expander icon always expands/collapses
          this._callHook("nodeToggleExpanded", ctx);
        } else if (targetType === "checkbox") {
          // Clicking the checkbox always (de)selects
          this._callHook("nodeToggleSelected", ctx);
          if (ctx.options.focusOnSelect) {
            // #358
            this._callHook("nodeSetFocus", ctx, true);
          }
        } else {
          // Honor `clickFolderMode` for
          expand = false;
          activate = true;
          if (node.folder) {
            switch (ctx.options.clickFolderMode) {
              case 2:
                // expand only
                expand = true;
                activate = false;
                break;
              case 3:
                // expand and activate
                activate = true;
                expand = true; //!node.isExpanded();
                break;
              // else 1 or 4: just activate
            }
          }

          if (activate) {
            this.nodeSetFocus(ctx);
            this._callHook("nodeSetActive", ctx, true);
          }
          if (expand) {
            if (!activate) {
              // this._callHook("nodeSetFocus", ctx);
            }
            if (ctx.options.clickFolderMode === 3) this._callHook("nodeSetExpanded", ctx, true);else this._callHook("nodeToggleExpanded", ctx);
          }
        }
        // Make sure that clicks stop, otherwise <a href='#'> jumps to the top
        // if(event.target.localName === "a" && event.target.className === "fancytree-title"){
        // 	event.preventDefault();
        // }
        // TODO: return promise?
      },

      /** Collapse all other  children of same parent.
       *
       * @param {EventData} ctx
       * @param {object} callOpts
       */
      nodeCollapseSiblings: function nodeCollapseSiblings(ctx, callOpts) {
        // TODO: return promise?
        var ac,
          i,
          l,
          node = ctx.node;
        if (node.parent) {
          ac = node.parent.children;
          for (i = 0, l = ac.length; i < l; i++) {
            if (ac[i] !== node && ac[i].expanded) {
              this._callHook("nodeSetExpanded", ac[i], false, callOpts);
            }
          }
        }
      },
      /** Default handling for mouse douleclick events.
       * @param {EventData} ctx
       */
      nodeDblclick: function nodeDblclick(ctx) {
        // TODO: return promise?
        if (ctx.targetType === "title" && ctx.options.clickFolderMode === 4) {
          // this.nodeSetFocus(ctx);
          // this._callHook("nodeSetActive", ctx, true);
          this._callHook("nodeToggleExpanded", ctx);
        }
        // TODO: prevent text selection on dblclicks
        if (ctx.targetType === "title") {
          ctx.originalEvent.preventDefault();
        }
      },
      /** Default handling for mouse keydown events.
       *
       * NOTE: this may be called with node == null if tree (but no node) has focus.
       * @param {EventData} ctx
       */
      nodeKeydown: function nodeKeydown(ctx) {
        // TODO: return promise?
        var matchNode,
          stamp,
          _res,
          focusNode,
          event = ctx.originalEvent,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          which = event.which,
          // #909: Use event.key, to get unicode characters.
          // We can't use `/\w/.test(key)`, because that would
          // only detect plain ascii alpha-numerics. But we still need
          // to ignore modifier-only, whitespace, cursor-keys, etc.
          key = event.key || String.fromCharCode(which),
          specialModifiers = !!(event.altKey || event.ctrlKey || event.metaKey),
          isAlnum = !MODIFIERS[which] && !SPECIAL_KEYCODES[which] && !specialModifiers,
          $target = $(event.target),
          handled = true,
          activate = !(event.ctrlKey || !opts.autoActivate);

        // (node || FT).debug("ftnode.nodeKeydown(" + event.type + "): ftnode:" + this + ", charCode:" + event.charCode + ", keyCode: " + event.keyCode + ", which: " + event.which);
        // FT.debug( "eventToString(): " + FT.eventToString(event) + ", key='" + key + "', isAlnum: " + isAlnum );

        // Set focus to active (or first node) if no other node has the focus yet
        if (!node) {
          focusNode = this.getActiveNode() || this.getFirstChild();
          if (focusNode) {
            focusNode.setFocus();
            node = ctx.node = this.focusNode;
            node.debug("Keydown force focus on active node");
          }
        }
        if (opts.quicksearch && isAlnum && !$target.is(":input:enabled")) {
          // Allow to search for longer streaks if typed in quickly
          stamp = Date.now();
          if (stamp - tree.lastQuicksearchTime > 500) {
            tree.lastQuicksearchTerm = "";
          }
          tree.lastQuicksearchTime = stamp;
          tree.lastQuicksearchTerm += key;
          // tree.debug("quicksearch find", tree.lastQuicksearchTerm);
          matchNode = tree.findNextNode(tree.lastQuicksearchTerm, tree.getActiveNode());
          if (matchNode) {
            matchNode.setActive();
          }
          event.preventDefault();
          return;
        }
        switch (FT.eventToString(event)) {
          case "+":
          case "=":
            // 187: '+' @ Chrome, Safari
            tree.nodeSetExpanded(ctx, true);
            break;
          case "-":
            tree.nodeSetExpanded(ctx, false);
            break;
          case "space":
            if (node.isPagingNode()) {
              tree._triggerNodeEvent("clickPaging", ctx, event);
            } else if (FT.evalOption("checkbox", node, node, opts, false)) {
              // #768
              tree.nodeToggleSelected(ctx);
            } else {
              tree.nodeSetActive(ctx, true);
            }
            break;
          case "return":
            tree.nodeSetActive(ctx, true);
            break;
          case "home":
          case "end":
          case "backspace":
          case "left":
          case "right":
          case "up":
          case "down":
            _res = node.navigate(event.which, activate);
            break;
          default:
            handled = false;
        }
        if (handled) {
          event.preventDefault();
        }
      },
      // /** Default handling for mouse keypress events. */
      // nodeKeypress: function(ctx) {
      //     var event = ctx.originalEvent;
      // },

      // /** Trigger lazyLoad event (async). */
      // nodeLazyLoad: function(ctx) {
      //     var node = ctx.node;
      //     if(this._triggerNodeEvent())
      // },
      /** Load child nodes (async).
       *
       * @param {EventData} ctx
       * @param {object[]|object|string|$.Promise|function} source
       * @returns {$.Promise} The deferred will be resolved as soon as the (ajax)
       *     data was rendered.
       */
      nodeLoadChildren: function nodeLoadChildren(ctx, source) {
        var ajax,
          delay,
          ajaxDfd = null,
          resultDfd,
          isAsync = true,
          tree = ctx.tree,
          node = ctx.node,
          nodePrevParent = node.parent,
          tag = "nodeLoadChildren",
          requestId = Date.now();

        // `source` is a callback: use the returned result instead:
        if (_isFunction(source)) {
          source = source.call(tree, {
            type: "source"
          }, ctx);
          _assert(!_isFunction(source), "source callback must not return another function");
        }
        // `source` is already a promise:
        if (_isFunction(source.then)) {
          // _assert(_isFunction(source.always), "Expected jQuery?");
          ajaxDfd = source;
        } else if (source.url) {
          // `source` is an Ajax options object
          ajax = $.extend({}, ctx.options.ajax, source);
          if (ajax.debugDelay) {
            // Simulate a slow server
            delay = ajax.debugDelay;
            delete ajax.debugDelay; // remove debug option
            if (_isArray(delay)) {
              // random delay range [min..max]
              delay = delay[0] + Math.random() * (delay[1] - delay[0]);
            }
            node.warn("nodeLoadChildren waiting debugDelay " + Math.round(delay) + " ms ...");
            ajaxDfd = $.Deferred(function (ajaxDfd) {
              setTimeout(function () {
                $.ajax(ajax).done(function () {
                  ajaxDfd.resolveWith(this, arguments);
                }).fail(function () {
                  ajaxDfd.rejectWith(this, arguments);
                });
              }, delay);
            });
          } else {
            ajaxDfd = $.ajax(ajax);
          }
        } else if ($.isPlainObject(source) || _isArray(source)) {
          // `source` is already a constant dict or list, but we convert
          // to a thenable for unified processing.
          // 2020-01-03: refactored.
          // `ajaxDfd = $.when(source)` would do the trick, but the returned
          // promise will resolve async, which broke some tests and
          // would probably also break current implementations out there.
          // So we mock-up a thenable that resolves synchronously:
          ajaxDfd = {
            then: function then(resolve, reject) {
              resolve(source, null, null);
            }
          };
          isAsync = false;
        } else {
          $.error("Invalid source type: " + source);
        }

        // Check for overlapping requests
        if (node._requestId) {
          node.warn("Recursive load request #" + requestId + " while #" + node._requestId + " is pending.");
          node._requestId = requestId;
          // 	node.debug("Send load request #" + requestId);
        }

        if (isAsync) {
          tree.debugTime(tag);
          tree.nodeSetStatus(ctx, "loading");
        }

        // The async Ajax request has now started...
        // Defer the deferred:
        // we want to be able to reject invalid responses, even if
        // the raw HTTP Ajax XHR resolved as Ok.
        // We use the ajaxDfd.then() syntax here, which is compatible with
        // jQuery and ECMA6.
        // However resultDfd is a jQuery deferred, which is currently the
        // expected result type of nodeLoadChildren()
        resultDfd = new $.Deferred();
        ajaxDfd.then(function (data, textStatus, jqXHR) {
          // ajaxDfd was resolved, but we reject or resolve resultDfd
          // depending on the response data
          var errorObj, res;
          if ((source.dataType === "json" || source.dataType === "jsonp") && typeof data === "string") {
            $.error("Ajax request returned a string (did you get the JSON dataType wrong?).");
          }
          if (node._requestId && node._requestId > requestId) {
            // The expected request time stamp is later than `requestId`
            // (which was kept as as closure variable to this handler function)
            // node.warn("Ignored load response for obsolete request #" + requestId + " (expected #" + node._requestId + ")");
            resultDfd.rejectWith(this, [RECURSIVE_REQUEST_ERROR]);
            return;
            // } else {
            // 	node.debug("Response returned for load request #" + requestId);
          }

          if (node.parent === null && nodePrevParent !== null) {
            resultDfd.rejectWith(this, [INVALID_REQUEST_TARGET_ERROR]);
            return;
          }
          // Allow to adjust the received response data in the `postProcess` event.
          if (ctx.options.postProcess) {
            // The handler may either
            //   - modify `ctx.response` in-place (and leave `ctx.result` undefined)
            //     => res = undefined
            //   - return a replacement in `ctx.result`
            //     => res = <new data>
            //   If res contains an `error` property, an error status is displayed
            try {
              res = tree._triggerNodeEvent("postProcess", ctx, ctx.originalEvent, {
                response: data,
                error: null,
                dataType: source.dataType
              });
              if (res.error) {
                tree.warn("postProcess returned error:", res);
              }
            } catch (e) {
              res = {
                error: e,
                message: "" + e,
                details: "postProcess failed"
              };
            }
            if (res.error) {
              // Either postProcess failed with an exception, or the returned
              // result object has an 'error' property attached:
              errorObj = $.isPlainObject(res.error) ? res.error : {
                message: res.error
              };
              errorObj = tree._makeHookContext(node, null, errorObj);
              resultDfd.rejectWith(this, [errorObj]);
              return;
            }
            if (_isArray(res) || $.isPlainObject(res) && _isArray(res.children)) {
              // Use `ctx.result` if valid
              // (otherwise use existing data, which may have been modified in-place)
              data = res;
            }
          } else if (data && _hasProp(data, "d") && ctx.options.enableAspx) {
            // Process ASPX WebMethod JSON object inside "d" property
            // (only if no postProcess event was defined)
            if (ctx.options.enableAspx === 42) {
              tree.warn("The default for enableAspx will change to `false` in the fututure. " + "Pass `enableAspx: true` or implement postProcess to silence this warning.");
            }
            data = typeof data.d === "string" ? $.parseJSON(data.d) : data.d;
          }
          resultDfd.resolveWith(this, [data]);
        }, function (jqXHR, textStatus, errorThrown) {
          // ajaxDfd was rejected, so we reject resultDfd as well
          var errorObj = tree._makeHookContext(node, null, {
            error: jqXHR,
            args: Array.prototype.slice.call(arguments),
            message: errorThrown,
            details: jqXHR.status + ": " + errorThrown
          });
          resultDfd.rejectWith(this, [errorObj]);
        });

        // The async Ajax request has now started.
        // resultDfd will be resolved/rejected after the response arrived,
        // was postProcessed, and checked.
        // Now we implement the UI update and add the data to the tree.
        // We also return this promise to the caller.
        resultDfd.done(function (data) {
          tree.nodeSetStatus(ctx, "ok");
          var children, metaData, noDataRes;
          if ($.isPlainObject(data)) {
            // We got {foo: 'abc', children: [...]}
            // Copy extra properties to tree.data.foo
            _assert(node.isRootNode(), "source may only be an object for root nodes (expecting an array of child objects otherwise)");
            _assert(_isArray(data.children), "if an object is passed as source, it must contain a 'children' array (all other properties are added to 'tree.data')");
            metaData = data;
            children = data.children;
            delete metaData.children;
            // Copy some attributes to tree.data
            $.each(TREE_ATTRS, function (i, attr) {
              if (metaData[attr] !== undefined) {
                tree[attr] = metaData[attr];
                delete metaData[attr];
              }
            });
            // Copy all other attributes to tree.data.NAME
            $.extend(tree.data, metaData);
          } else {
            children = data;
          }
          _assert(_isArray(children), "expected array of children");
          node._setChildren(children);
          if (tree.options.nodata && children.length === 0) {
            if (_isFunction(tree.options.nodata)) {
              noDataRes = tree.options.nodata.call(tree, {
                type: "nodata"
              }, ctx);
            } else if (tree.options.nodata === true && node.isRootNode()) {
              noDataRes = tree.options.strings.noData;
            } else if (typeof tree.options.nodata === "string" && node.isRootNode()) {
              noDataRes = tree.options.nodata;
            }
            if (noDataRes) {
              node.setStatus("nodata", noDataRes);
            }
          }
          // trigger fancytreeloadchildren
          tree._triggerNodeEvent("loadChildren", node);
        }).fail(function (error) {
          var ctxErr;
          if (error === RECURSIVE_REQUEST_ERROR) {
            node.warn("Ignored response for obsolete load request #" + requestId + " (expected #" + node._requestId + ")");
            return;
          } else if (error === INVALID_REQUEST_TARGET_ERROR) {
            node.warn("Lazy parent node was removed while loading: discarding response.");
            return;
          } else if (error.node && error.error && error.message) {
            // error is already a context object
            ctxErr = error;
          } else {
            ctxErr = tree._makeHookContext(node, null, {
              error: error,
              // it can be jqXHR or any custom error
              args: Array.prototype.slice.call(arguments),
              message: error ? error.message || error.toString() : ""
            });
            if (ctxErr.message === "[object Object]") {
              ctxErr.message = "";
            }
          }
          node.warn("Load children failed (" + ctxErr.message + ")", ctxErr);
          if (tree._triggerNodeEvent("loadError", ctxErr, null) !== false) {
            tree.nodeSetStatus(ctx, "error", ctxErr.message, ctxErr.details);
          }
        }).always(function () {
          node._requestId = null;
          if (isAsync) {
            tree.debugTimeEnd(tag);
          }
        });
        return resultDfd.promise();
      },
      /** [Not Implemented]  */
      nodeLoadKeyPath: function nodeLoadKeyPath(ctx, keyPathList) {
        // TODO: implement and improve
        // http://code.google.com/p/dynatree/issues/detail?id=222
      },
      /**
       * Remove a single direct child of ctx.node.
       * @param {EventData} ctx
       * @param {FancytreeNode} childNode dircect child of ctx.node
       */
      nodeRemoveChild: function nodeRemoveChild(ctx, childNode) {
        var idx,
          node = ctx.node,
          // opts = ctx.options,
          subCtx = $.extend({}, ctx, {
            node: childNode
          }),
          children = node.children;

        // FT.debug("nodeRemoveChild()", node.toString(), childNode.toString());

        if (children.length === 1) {
          _assert(childNode === children[0], "invalid single child");
          return this.nodeRemoveChildren(ctx);
        }
        if (this.activeNode && (childNode === this.activeNode || this.activeNode.isDescendantOf(childNode))) {
          this.activeNode.setActive(false); // TODO: don't fire events
        }

        if (this.focusNode && (childNode === this.focusNode || this.focusNode.isDescendantOf(childNode))) {
          this.focusNode = null;
        }
        // TODO: persist must take care to clear select and expand cookies
        this.nodeRemoveMarkup(subCtx);
        this.nodeRemoveChildren(subCtx);
        idx = $.inArray(childNode, children);
        _assert(idx >= 0, "invalid child");
        // Notify listeners
        node.triggerModifyChild("remove", childNode);
        // Unlink to support GC
        childNode.visit(function (n) {
          n.parent = null;
        }, true);
        this._callHook("treeRegisterNode", this, false, childNode);
        // remove from child list
        children.splice(idx, 1);
      },
      /**Remove HTML markup for all descendents of ctx.node.
       * @param {EventData} ctx
       */
      nodeRemoveChildMarkup: function nodeRemoveChildMarkup(ctx) {
        var node = ctx.node;

        // FT.debug("nodeRemoveChildMarkup()", node.toString());
        // TODO: Unlink attr.ftnode to support GC
        if (node.ul) {
          if (node.isRootNode()) {
            $(node.ul).empty();
          } else {
            $(node.ul).remove();
            node.ul = null;
          }
          node.visit(function (n) {
            n.li = n.ul = null;
          });
        }
      },
      /**Remove all descendants of ctx.node.
       * @param {EventData} ctx
       */
      nodeRemoveChildren: function nodeRemoveChildren(ctx) {
        var
          //subCtx,
          tree = ctx.tree,
          node = ctx.node,
          children = node.children;
        // opts = ctx.options;

        // FT.debug("nodeRemoveChildren()", node.toString());
        if (!children) {
          return;
        }
        if (this.activeNode && this.activeNode.isDescendantOf(node)) {
          this.activeNode.setActive(false); // TODO: don't fire events
        }

        if (this.focusNode && this.focusNode.isDescendantOf(node)) {
          this.focusNode = null;
        }
        // TODO: persist must take care to clear select and expand cookies
        this.nodeRemoveChildMarkup(ctx);
        // Unlink children to support GC
        // TODO: also delete this.children (not possible using visit())
        // subCtx = $.extend({}, ctx);
        node.triggerModifyChild("remove", null);
        node.visit(function (n) {
          n.parent = null;
          tree._callHook("treeRegisterNode", tree, false, n);
        });
        if (node.lazy) {
          // 'undefined' would be interpreted as 'not yet loaded' for lazy nodes
          node.children = [];
        } else {
          node.children = null;
        }
        if (!node.isRootNode()) {
          node.expanded = false; // #449, #459
        }

        this.nodeRenderStatus(ctx);
      },
      /**Remove HTML markup for ctx.node and all its descendents.
       * @param {EventData} ctx
       */
      nodeRemoveMarkup: function nodeRemoveMarkup(ctx) {
        var node = ctx.node;
        // FT.debug("nodeRemoveMarkup()", node.toString());
        // TODO: Unlink attr.ftnode to support GC
        if (node.li) {
          $(node.li).remove();
          node.li = null;
        }
        this.nodeRemoveChildMarkup(ctx);
      },
      /**
       * Create `<li><span>..</span> .. </li>` tags for this node.
       *
       * This method takes care that all HTML markup is created that is required
       * to display this node in its current state.
       *
       * Call this method to create new nodes, or after the strucuture
       * was changed (e.g. after moving this node or adding/removing children)
       * nodeRenderTitle() and nodeRenderStatus() are implied.
       *
       * ```html
       * <li id='KEY' ftnode=NODE>
       *     <span class='fancytree-node fancytree-expanded fancytree-has-children fancytree-lastsib fancytree-exp-el fancytree-ico-e'>
       *         <span class="fancytree-expander"></span>
       *         <span class="fancytree-checkbox"></span> // only present in checkbox mode
       *         <span class="fancytree-icon"></span>
       *         <a href="#" class="fancytree-title"> Node 1 </a>
       *     </span>
       *     <ul> // only present if node has children
       *         <li id='KEY' ftnode=NODE> child1 ... </li>
       *         <li id='KEY' ftnode=NODE> child2 ... </li>
       *     </ul>
       * </li>
       * ```
       *
       * @param {EventData} ctx
       * @param {boolean} [force=false] re-render, even if html markup was already created
       * @param {boolean} [deep=false] also render all descendants, even if parent is collapsed
       * @param {boolean} [collapsed=false] force root node to be collapsed, so we can apply animated expand later
       */
      nodeRender: function nodeRender(ctx, force, deep, collapsed, _recursive) {
        /* This method must take care of all cases where the current data mode
         * (i.e. node hierarchy) does not match the current markup.
         *
         * - node was not yet rendered:
         *   create markup
         * - node was rendered: exit fast
         * - children have been added
         * - children have been removed
         */
        var childLI,
          childNode1,
          childNode2,
          i,
          l,
          next,
          subCtx,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          aria = opts.aria,
          firstTime = false,
          parent = node.parent,
          isRootNode = !parent,
          children = node.children,
          successorLi = null;
        // FT.debug("nodeRender(" + !!force + ", " + !!deep + ")", node.toString());

        if (tree._enableUpdate === false) {
          // tree.debug("no render", tree._enableUpdate);
          return;
        }
        if (!isRootNode && !parent.ul) {
          // Calling node.collapse on a deep, unrendered node
          return;
        }
        _assert(isRootNode || parent.ul, "parent UL must exist");

        // Render the node
        if (!isRootNode) {
          // Discard markup on force-mode, or if it is not linked to parent <ul>
          if (node.li && (force || node.li.parentNode !== node.parent.ul)) {
            if (node.li.parentNode === node.parent.ul) {
              // #486: store following node, so we can insert the new markup there later
              successorLi = node.li.nextSibling;
            } else {
              // May happen, when a top-level node was dropped over another
              this.debug("Unlinking " + node + " (must be child of " + node.parent + ")");
            }
            //	            this.debug("nodeRemoveMarkup...");
            this.nodeRemoveMarkup(ctx);
          }
          // Create <li><span /> </li>
          // node.debug("render...");
          if (node.li) {
            // this.nodeRenderTitle(ctx);
            this.nodeRenderStatus(ctx);
          } else {
            // node.debug("render... really");
            firstTime = true;
            node.li = document.createElement("li");
            node.li.ftnode = node;
            if (node.key && opts.generateIds) {
              node.li.id = opts.idPrefix + node.key;
            }
            node.span = document.createElement("span");
            node.span.className = "fancytree-node";
            if (aria && !node.tr) {
              $(node.li).attr("role", "treeitem");
            }
            node.li.appendChild(node.span);

            // Create inner HTML for the <span> (expander, checkbox, icon, and title)
            this.nodeRenderTitle(ctx);

            // Allow tweaking and binding, after node was created for the first time
            if (opts.createNode) {
              opts.createNode.call(tree, {
                type: "createNode"
              }, ctx);
            }
          }
          // Allow tweaking after node state was rendered
          if (opts.renderNode) {
            opts.renderNode.call(tree, {
              type: "renderNode"
            }, ctx);
          }
        }

        // Visit child nodes
        if (children) {
          if (isRootNode || node.expanded || deep === true) {
            // Create a UL to hold the children
            if (!node.ul) {
              node.ul = document.createElement("ul");
              if (collapsed === true && !_recursive || !node.expanded) {
                // hide top UL, so we can use an animation to show it later
                node.ul.style.display = "none";
              }
              if (aria) {
                $(node.ul).attr("role", "group");
              }
              if (node.li) {
                // issue #67
                node.li.appendChild(node.ul);
              } else {
                node.tree.$div.append(node.ul);
              }
            }
            // Add child markup
            for (i = 0, l = children.length; i < l; i++) {
              subCtx = $.extend({}, ctx, {
                node: children[i]
              });
              this.nodeRender(subCtx, force, deep, false, true);
            }
            // Remove <li> if nodes have moved to another parent
            childLI = node.ul.firstChild;
            while (childLI) {
              childNode2 = childLI.ftnode;
              if (childNode2 && childNode2.parent !== node) {
                node.debug("_fixParent: remove missing " + childNode2, childLI);
                next = childLI.nextSibling;
                childLI.parentNode.removeChild(childLI);
                childLI = next;
              } else {
                childLI = childLI.nextSibling;
              }
            }
            // Make sure, that <li> order matches node.children order.
            childLI = node.ul.firstChild;
            for (i = 0, l = children.length - 1; i < l; i++) {
              childNode1 = children[i];
              childNode2 = childLI.ftnode;
              if (childNode1 === childNode2) {
                childLI = childLI.nextSibling;
              } else {
                // node.debug("_fixOrder: mismatch at index " + i + ": " + childNode1 + " != " + childNode2);
                node.ul.insertBefore(childNode1.li, childNode2.li);
              }
            }
          }
        } else {
          // No children: remove markup if any
          if (node.ul) {
            // alert("remove child markup for " + node);
            this.warn("remove child markup for " + node);
            this.nodeRemoveChildMarkup(ctx);
          }
        }
        if (!isRootNode) {
          // Update element classes according to node state
          // this.nodeRenderStatus(ctx);
          // Finally add the whole structure to the DOM, so the browser can render
          if (firstTime) {
            // #486: successorLi is set, if we re-rendered (i.e. discarded)
            // existing markup, which  we want to insert at the same position.
            // (null is equivalent to append)
            // 		parent.ul.appendChild(node.li);
            parent.ul.insertBefore(node.li, successorLi);
          }
        }
      },
      /** Create HTML inside the node's outer `<span>` (i.e. expander, checkbox,
       * icon, and title).
       *
       * nodeRenderStatus() is implied.
       * @param {EventData} ctx
       * @param {string} [title] optinal new title
       */
      nodeRenderTitle: function nodeRenderTitle(ctx, title) {
        // set node connector images, links and text
        var checkbox,
          className,
          icon,
          nodeTitle,
          role,
          tabindex,
          tooltip,
          iconTooltip,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          aria = opts.aria,
          level = node.getLevel(),
          ares = [];
        if (title !== undefined) {
          node.title = title;
        }
        if (!node.span || tree._enableUpdate === false) {
          // Silently bail out if node was not rendered yet, assuming
          // node.render() will be called as the node becomes visible
          return;
        }
        // Connector (expanded, expandable or simple)
        role = aria && node.hasChildren() !== false ? " role='button'" : "";
        if (level < opts.minExpandLevel) {
          if (!node.lazy) {
            node.expanded = true;
          }
          if (level > 1) {
            ares.push("<span " + role + " class='fancytree-expander fancytree-expander-fixed'></span>");
          }
          // .. else (i.e. for root level) skip expander/connector alltogether
        } else {
          ares.push("<span " + role + " class='fancytree-expander'></span>");
        }
        // Checkbox mode
        checkbox = FT.evalOption("checkbox", node, node, opts, false);
        if (checkbox && !node.isStatusNode()) {
          role = aria ? " role='checkbox'" : "";
          className = "fancytree-checkbox";
          if (checkbox === "radio" || node.parent && node.parent.radiogroup) {
            className += " fancytree-radio";
          }
          ares.push("<span " + role + " class='" + className + "'></span>");
        }
        // Folder or doctype icon
        if (node.data.iconClass !== undefined) {
          // 2015-11-16
          // Handle / warn about backward compatibility
          if (node.icon) {
            $.error("'iconClass' node option is deprecated since v2.14.0: use 'icon' only instead");
          } else {
            node.warn("'iconClass' node option is deprecated since v2.14.0: use 'icon' instead");
            node.icon = node.data.iconClass;
          }
        }
        // If opts.icon is a callback and returns something other than undefined, use that
        // else if node.icon is a boolean or string, use that
        // else if opts.icon is a boolean or string, use that
        // else show standard icon (which may be different for folders or documents)
        icon = FT.evalOption("icon", node, node, opts, true);
        // if( typeof icon !== "boolean" ) {
        // 	// icon is defined, but not true/false: must be a string
        // 	icon = "" + icon;
        // }
        if (icon !== false) {
          role = aria ? " role='presentation'" : "";
          iconTooltip = FT.evalOption("iconTooltip", node, node, opts, null);
          iconTooltip = iconTooltip ? " title='" + _escapeTooltip(iconTooltip) + "'" : "";
          if (typeof icon === "string") {
            if (TEST_IMG.test(icon)) {
              // node.icon is an image url. Prepend imagePath
              icon = icon.charAt(0) === "/" ? icon : (opts.imagePath || "") + icon;
              ares.push("<img src='" + icon + "' class='fancytree-icon'" + iconTooltip + " alt='' />");
            } else {
              ares.push("<span " + role + " class='fancytree-custom-icon " + icon + "'" + iconTooltip + "></span>");
            }
          } else if (icon.text) {
            ares.push("<span " + role + " class='fancytree-custom-icon " + (icon.addClass || "") + "'" + iconTooltip + ">" + FT.escapeHtml(icon.text) + "</span>");
          } else if (icon.html) {
            ares.push("<span " + role + " class='fancytree-custom-icon " + (icon.addClass || "") + "'" + iconTooltip + ">" + icon.html + "</span>");
          } else {
            // standard icon: theme css will take care of this
            ares.push("<span " + role + " class='fancytree-icon'" + iconTooltip + "></span>");
          }
        }
        // Node title
        nodeTitle = "";
        if (opts.renderTitle) {
          nodeTitle = opts.renderTitle.call(tree, {
            type: "renderTitle"
          }, ctx) || "";
        }
        if (!nodeTitle) {
          tooltip = FT.evalOption("tooltip", node, node, opts, null);
          if (tooltip === true) {
            tooltip = node.title;
          }
          // if( node.tooltip ) {
          // 	tooltip = node.tooltip;
          // } else if ( opts.tooltip ) {
          // 	tooltip = opts.tooltip === true ? node.title : opts.tooltip.call(tree, node);
          // }
          tooltip = tooltip ? " title='" + _escapeTooltip(tooltip) + "'" : "";
          tabindex = opts.titlesTabbable ? " tabindex='0'" : "";
          nodeTitle = "<span class='fancytree-title'" + tooltip + tabindex + ">" + (opts.escapeTitles ? FT.escapeHtml(node.title) : node.title) + "</span>";
        }
        ares.push(nodeTitle);
        // Note: this will trigger focusout, if node had the focus
        //$(node.span).html(ares.join("")); // it will cleanup the jQuery data currently associated with SPAN (if any), but it executes more slowly
        node.span.innerHTML = ares.join("");
        // Update CSS classes
        this.nodeRenderStatus(ctx);
        if (opts.enhanceTitle) {
          ctx.$title = $(">span.fancytree-title", node.span);
          nodeTitle = opts.enhanceTitle.call(tree, {
            type: "enhanceTitle"
          }, ctx) || "";
        }
      },
      /** Update element classes according to node state.
       * @param {EventData} ctx
       */
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        // Set classes for current status
        var $ariaElem,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          // 	nodeContainer = node[tree.nodeContainerAttrName],
          hasChildren = node.hasChildren(),
          isLastSib = node.isLastSibling(),
          aria = opts.aria,
          cn = opts._classNames,
          cnList = [],
          statusElem = node[tree.statusClassPropName];
        if (!statusElem || tree._enableUpdate === false) {
          // if this function is called for an unrendered node, ignore it (will be updated on nect render anyway)
          return;
        }
        if (aria) {
          $ariaElem = $(node.tr || node.li);
        }
        // Build a list of class names that we will add to the node <span>
        cnList.push(cn.node);
        if (tree.activeNode === node) {
          cnList.push(cn.active);
          // 		$(">span.fancytree-title", statusElem).attr("tabindex", "0");
          // 		tree.$container.removeAttr("tabindex");
          // }else{
          // 		$(">span.fancytree-title", statusElem).removeAttr("tabindex");
          // 		tree.$container.attr("tabindex", "0");
        }

        if (tree.focusNode === node) {
          cnList.push(cn.focused);
        }
        if (node.expanded) {
          cnList.push(cn.expanded);
        }
        if (aria) {
          if (hasChildren === false) {
            $ariaElem.removeAttr("aria-expanded");
          } else {
            $ariaElem.attr("aria-expanded", Boolean(node.expanded));
          }
        }
        if (node.folder) {
          cnList.push(cn.folder);
        }
        if (hasChildren !== false) {
          cnList.push(cn.hasChildren);
        }
        // TODO: required?
        if (isLastSib) {
          cnList.push(cn.lastsib);
        }
        if (node.lazy && node.children == null) {
          cnList.push(cn.lazy);
        }
        if (node.partload) {
          cnList.push(cn.partload);
        }
        if (node.partsel) {
          cnList.push(cn.partsel);
        }
        if (FT.evalOption("unselectable", node, node, opts, false)) {
          cnList.push(cn.unselectable);
        }
        if (node._isLoading) {
          cnList.push(cn.loading);
        }
        if (node._error) {
          cnList.push(cn.error);
        }
        if (node.statusNodeType) {
          cnList.push(cn.statusNodePrefix + node.statusNodeType);
        }
        if (node.selected) {
          cnList.push(cn.selected);
          if (aria) {
            $ariaElem.attr("aria-selected", true);
          }
        } else if (aria) {
          $ariaElem.attr("aria-selected", false);
        }
        if (node.extraClasses) {
          cnList.push(node.extraClasses);
        }
        // IE6 doesn't correctly evaluate multiple class names,
        // so we create combined class names that can be used in the CSS
        if (hasChildren === false) {
          cnList.push(cn.combinedExpanderPrefix + "n" + (isLastSib ? "l" : ""));
        } else {
          cnList.push(cn.combinedExpanderPrefix + (node.expanded ? "e" : "c") + (node.lazy && node.children == null ? "d" : "") + (isLastSib ? "l" : ""));
        }
        cnList.push(cn.combinedIconPrefix + (node.expanded ? "e" : "c") + (node.folder ? "f" : ""));
        // node.span.className = cnList.join(" ");
        statusElem.className = cnList.join(" ");

        // TODO: we should not set this in the <span> tag also, if we set it here:
        // Maybe most (all) of the classes should be set in LI instead of SPAN?
        if (node.li) {
          // #719: we have to consider that there may be already other classes:
          $(node.li).toggleClass(cn.lastsib, isLastSib);
        }
      },
      /** Activate node.
       * flag defaults to true.
       * If flag is true, the node is activated (must be a synchronous operation)
       * If flag is false, the node is deactivated (must be a synchronous operation)
       * @param {EventData} ctx
       * @param {boolean} [flag=true]
       * @param {object} [opts] additional options. Defaults to {noEvents: false, noFocus: false}
       * @returns {$.Promise}
       */
      nodeSetActive: function nodeSetActive(ctx, flag, callOpts) {
        // Handle user click / [space] / [enter], according to clickFolderMode.
        callOpts = callOpts || {};
        var subCtx,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          noEvents = callOpts.noEvents === true,
          noFocus = callOpts.noFocus === true,
          scroll = callOpts.scrollIntoView !== false,
          isActive = node === tree.activeNode;

        // flag defaults to true
        flag = flag !== false;
        // node.debug("nodeSetActive", flag);

        if (isActive === flag) {
          // Nothing to do
          return _getResolvedPromise(node);
        }
        // #1042: don't scroll between mousedown/-up when clicking an embedded link
        if (scroll && ctx.originalEvent && $(ctx.originalEvent.target).is("a,:checkbox")) {
          node.info("Not scrolling while clicking an embedded link.");
          scroll = false;
        }
        if (flag && !noEvents && this._triggerNodeEvent("beforeActivate", node, ctx.originalEvent) === false) {
          // Callback returned false
          return _getRejectedPromise(node, ["rejected"]);
        }
        if (flag) {
          if (tree.activeNode) {
            _assert(tree.activeNode !== node, "node was active (inconsistency)");
            subCtx = $.extend({}, ctx, {
              node: tree.activeNode
            });
            tree.nodeSetActive(subCtx, false);
            _assert(tree.activeNode === null, "deactivate was out of sync?");
          }
          if (opts.activeVisible) {
            // If no focus is set (noFocus: true) and there is no focused node, this node is made visible.
            // scroll = noFocus && tree.focusNode == null;
            // #863: scroll by default (unless `scrollIntoView: false` was passed)
            node.makeVisible({
              scrollIntoView: scroll
            });
          }
          tree.activeNode = node;
          tree.nodeRenderStatus(ctx);
          if (!noFocus) {
            tree.nodeSetFocus(ctx);
          }
          if (!noEvents) {
            tree._triggerNodeEvent("activate", node, ctx.originalEvent);
          }
        } else {
          _assert(tree.activeNode === node, "node was not active (inconsistency)");
          tree.activeNode = null;
          this.nodeRenderStatus(ctx);
          if (!noEvents) {
            ctx.tree._triggerNodeEvent("deactivate", node, ctx.originalEvent);
          }
        }
        return _getResolvedPromise(node);
      },
      /** Expand or collapse node, return Deferred.promise.
       *
       * @param {EventData} ctx
       * @param {boolean} [flag=true]
       * @param {object} [opts] additional options. Defaults to `{noAnimation: false, noEvents: false}`
       * @returns {$.Promise} The deferred will be resolved as soon as the (lazy)
       *     data was retrieved, rendered, and the expand animation finished.
       */
      nodeSetExpanded: function nodeSetExpanded(ctx, flag, callOpts) {
        callOpts = callOpts || {};
        var _afterLoad,
          dfd,
          i,
          l,
          parents,
          prevAC,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          noAnimation = callOpts.noAnimation === true,
          noEvents = callOpts.noEvents === true;

        // flag defaults to true
        flag = flag !== false;

        // node.debug("nodeSetExpanded(" + flag + ")");

        if ($(node.li).hasClass(opts._classNames.animating)) {
          node.warn("setExpanded(" + flag + ") while animating: ignored.");
          return _getRejectedPromise(node, ["recursion"]);
        }
        if (node.expanded && flag || !node.expanded && !flag) {
          // Nothing to do
          // node.debug("nodeSetExpanded(" + flag + "): nothing to do");
          return _getResolvedPromise(node);
        } else if (flag && !node.lazy && !node.hasChildren()) {
          // Prevent expanding of empty nodes
          // return _getRejectedPromise(node, ["empty"]);
          return _getResolvedPromise(node);
        } else if (!flag && node.getLevel() < opts.minExpandLevel) {
          // Prevent collapsing locked levels
          return _getRejectedPromise(node, ["locked"]);
        } else if (!noEvents && this._triggerNodeEvent("beforeExpand", node, ctx.originalEvent) === false) {
          // Callback returned false
          return _getRejectedPromise(node, ["rejected"]);
        }
        // If this node inside a collpased node, no animation and scrolling is needed
        if (!noAnimation && !node.isVisible()) {
          noAnimation = callOpts.noAnimation = true;
        }
        dfd = new $.Deferred();

        // Auto-collapse mode: collapse all siblings
        if (flag && !node.expanded && opts.autoCollapse) {
          parents = node.getParentList(false, true);
          prevAC = opts.autoCollapse;
          try {
            opts.autoCollapse = false;
            for (i = 0, l = parents.length; i < l; i++) {
              // TODO: should return promise?
              this._callHook("nodeCollapseSiblings", parents[i], callOpts);
            }
          } finally {
            opts.autoCollapse = prevAC;
          }
        }
        // Trigger expand/collapse after expanding
        dfd.done(function () {
          var lastChild = node.getLastChild();
          if (flag && opts.autoScroll && !noAnimation && lastChild && tree._enableUpdate) {
            // Scroll down to last child, but keep current node visible
            lastChild.scrollIntoView(true, {
              topNode: node
            }).always(function () {
              if (!noEvents) {
                ctx.tree._triggerNodeEvent(flag ? "expand" : "collapse", ctx);
              }
            });
          } else {
            if (!noEvents) {
              ctx.tree._triggerNodeEvent(flag ? "expand" : "collapse", ctx);
            }
          }
        });
        // vvv Code below is executed after loading finished:
        _afterLoad = function _afterLoad(callback) {
          var cn = opts._classNames,
            isVisible,
            isExpanded,
            effect = opts.toggleEffect;
          node.expanded = flag;
          tree._callHook("treeStructureChanged", ctx, flag ? "expand" : "collapse");
          // Create required markup, but make sure the top UL is hidden, so we
          // can animate later
          tree._callHook("nodeRender", ctx, false, false, true);

          // Hide children, if node is collapsed
          if (node.ul) {
            isVisible = node.ul.style.display !== "none";
            isExpanded = !!node.expanded;
            if (isVisible === isExpanded) {
              node.warn("nodeSetExpanded: UL.style.display already set");
            } else if (!effect || noAnimation) {
              node.ul.style.display = node.expanded || !parent ? "" : "none";
            } else {
              // The UI toggle() effect works with the ext-wide extension,
              // while jQuery.animate() has problems when the title span
              // has position: absolute.
              // Since jQuery UI 1.12, the blind effect requires the parent
              // element to have 'position: relative'.
              // See #716, #717
              $(node.li).addClass(cn.animating); // #717

              if (_isFunction($(node.ul)[effect.effect])) {
                // tree.debug( "use jquery." + effect.effect + " method" );
                $(node.ul)[effect.effect]({
                  duration: effect.duration,
                  always: function always() {
                    // node.debug("fancytree-animating end: " + node.li.className);
                    $(this).removeClass(cn.animating); // #716
                    $(node.li).removeClass(cn.animating); // #717
                    callback();
                  }
                });
              } else {
                // The UI toggle() effect works with the ext-wide extension,
                // while jQuery.animate() has problems when the title span
                // has positon: absolute.
                // Since jQuery UI 1.12, the blind effect requires the parent
                // element to have 'position: relative'.
                // See #716, #717
                // tree.debug("use specified effect (" + effect.effect + ") with the jqueryui.toggle method");

                // try to stop an animation that might be already in progress
                $(node.ul).stop(true, true); //< does not work after resetLazy has been called for a node whose animation wasn't complete and effect was "blind"

                // dirty fix to remove a defunct animation (effect: "blind") after resetLazy has been called
                $(node.ul).parent().find(".ui-effects-placeholder").remove();
                $(node.ul).toggle(effect.effect, effect.options, effect.duration, function () {
                  // node.debug("fancytree-animating end: " + node.li.className);
                  $(this).removeClass(cn.animating); // #716
                  $(node.li).removeClass(cn.animating); // #717
                  callback();
                });
              }
              return;
            }
          }
          callback();
        };
        // ^^^ Code above is executed after loading finshed.

        // Load lazy nodes, if any. Then continue with _afterLoad()
        if (flag && node.lazy && node.hasChildren() === undefined) {
          // node.debug("nodeSetExpanded: load start...");
          node.load().done(function () {
            // node.debug("nodeSetExpanded: load done");
            if (dfd.notifyWith) {
              // requires jQuery 1.6+
              dfd.notifyWith(node, ["loaded"]);
            }
            _afterLoad(function () {
              dfd.resolveWith(node);
            });
          }).fail(function (errMsg) {
            _afterLoad(function () {
              dfd.rejectWith(node, ["load failed (" + errMsg + ")"]);
            });
          });
          /*
          var source = tree._triggerNodeEvent("lazyLoad", node, ctx.originalEvent);
          _assert(typeof source !== "boolean", "lazyLoad event must return source in data.result");
          node.debug("nodeSetExpanded: load start...");
          this._callHook("nodeLoadChildren", ctx, source).done(function(){
          	node.debug("nodeSetExpanded: load done");
          	if(dfd.notifyWith){ // requires jQuery 1.6+
          		dfd.notifyWith(node, ["loaded"]);
          	}
          	_afterLoad.call(tree);
          }).fail(function(errMsg){
          	dfd.rejectWith(node, ["load failed (" + errMsg + ")"]);
          });
          */
        } else {
          _afterLoad(function () {
            dfd.resolveWith(node);
          });
        }
        // node.debug("nodeSetExpanded: returns");
        return dfd.promise();
      },
      /** Focus or blur this node.
       * @param {EventData} ctx
       * @param {boolean} [flag=true]
       */
      nodeSetFocus: function nodeSetFocus(ctx, flag) {
        // ctx.node.debug("nodeSetFocus(" + flag + ")");
        var ctx2,
          tree = ctx.tree,
          node = ctx.node,
          opts = tree.options,
          // et = ctx.originalEvent && ctx.originalEvent.type,
          isInput = ctx.originalEvent ? $(ctx.originalEvent.target).is(":input") : false;
        flag = flag !== false;

        // (node || tree).debug("nodeSetFocus(" + flag + "), event: " + et + ", isInput: "+ isInput);
        // Blur previous node if any
        if (tree.focusNode) {
          if (tree.focusNode === node && flag) {
            // node.debug("nodeSetFocus(" + flag + "): nothing to do");
            return;
          }
          ctx2 = $.extend({}, ctx, {
            node: tree.focusNode
          });
          tree.focusNode = null;
          this._triggerNodeEvent("blur", ctx2);
          this._callHook("nodeRenderStatus", ctx2);
        }
        // Set focus to container and node
        if (flag) {
          if (!this.hasFocus()) {
            node.debug("nodeSetFocus: forcing container focus");
            this._callHook("treeSetFocus", ctx, true, {
              calledByNode: true
            });
          }
          node.makeVisible({
            scrollIntoView: false
          });
          tree.focusNode = node;
          if (opts.titlesTabbable) {
            if (!isInput) {
              // #621
              $(node.span).find(".fancytree-title").focus();
            }
          }
          if (opts.aria) {
            // Set active descendant to node's span ID (create one, if needed)
            $(tree.$container).attr("aria-activedescendant", $(node.tr || node.li).uniqueId().attr("id"));
            // "ftal_" + opts.idPrefix + node.key);
          }
          // $(node.span).find(".fancytree-title").focus();
          this._triggerNodeEvent("focus", ctx);

          // determine if we have focus on or inside tree container
          var hasFancytreeFocus = document.activeElement === tree.$container.get(0) || $(document.activeElement, tree.$container).length >= 1;
          if (!hasFancytreeFocus) {
            // We cannot set KB focus to a node, so use the tree container
            // #563, #570: IE scrolls on every call to .focus(), if the container
            // is partially outside the viewport. So do it only, when absolutely
            // necessary.
            $(tree.$container).focus();
          }

          // if( opts.autoActivate ){
          // 	tree.nodeSetActive(ctx, true);
          // }
          if (opts.autoScroll) {
            node.scrollIntoView();
          }
          this._callHook("nodeRenderStatus", ctx);
        }
      },
      /** (De)Select node, return new status (sync).
       *
       * @param {EventData} ctx
       * @param {boolean} [flag=true]
       * @param {object} [opts] additional options. Defaults to {noEvents: false,
       *     propagateDown: null, propagateUp: null,
       *     callback: null,
       *     }
       * @returns {boolean} previous status
       */
      nodeSetSelected: function nodeSetSelected(ctx, flag, callOpts) {
        callOpts = callOpts || {};
        var node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options,
          noEvents = callOpts.noEvents === true,
          parent = node.parent;

        // flag defaults to true
        flag = flag !== false;

        // node.debug("nodeSetSelected(" + flag + ")", ctx);

        // Cannot (de)select unselectable nodes directly (only by propagation or
        // by setting the `.selected` property)
        if (FT.evalOption("unselectable", node, node, opts, false)) {
          return;
        }

        // Remember the user's intent, in case down -> up propagation prevents
        // applying it to node.selected
        node._lastSelectIntent = flag; // Confusing use of '!'

        // Nothing to do?
        if (!!node.selected === flag) {
          if (opts.selectMode === 3 && node.partsel && !flag) {
            // If propagation prevented selecting this node last time, we still
            // want to allow to apply setSelected(false) now
          } else {
            return flag;
          }
        }
        if (!noEvents && this._triggerNodeEvent("beforeSelect", node, ctx.originalEvent) === false) {
          return !!node.selected;
        }
        if (flag && opts.selectMode === 1) {
          // single selection mode (we don't uncheck all tree nodes, for performance reasons)
          if (tree.lastSelectedNode) {
            tree.lastSelectedNode.setSelected(false);
          }
          node.selected = flag;
        } else if (opts.selectMode === 3 && parent && !parent.radiogroup && !node.radiogroup) {
          // multi-hierarchical selection mode
          node.selected = flag;
          node.fixSelection3AfterClick(callOpts);
        } else if (parent && parent.radiogroup) {
          node.visitSiblings(function (n) {
            n._changeSelectStatusAttrs(flag && n === node);
          }, true);
        } else {
          // default: selectMode: 2, multi selection mode
          node.selected = flag;
        }
        this.nodeRenderStatus(ctx);
        tree.lastSelectedNode = flag ? node : null;
        if (!noEvents) {
          tree._triggerNodeEvent("select", ctx);
        }
      },
      /** Show node status (ok, loading, error, nodata) using styles and a dummy child node.
       *
       * @param {EventData} ctx
       * @param status
       * @param message
       * @param details
       * @since 2.3
       */
      nodeSetStatus: function nodeSetStatus(ctx, status, message, details) {
        var node = ctx.node,
          tree = ctx.tree;
        function _clearStatusNode() {
          // Remove dedicated dummy node, if any
          var firstChild = node.children ? node.children[0] : null;
          if (firstChild && firstChild.isStatusNode()) {
            try {
              // I've seen exceptions here with loadKeyPath...
              if (node.ul) {
                node.ul.removeChild(firstChild.li);
                firstChild.li = null; // avoid leaks (DT issue 215)
              }
            } catch (e) {}
            if (node.children.length === 1) {
              node.children = [];
            } else {
              node.children.shift();
            }
            tree._callHook("treeStructureChanged", ctx, "clearStatusNode");
          }
        }
        function _setStatusNode(data, type) {
          // Create/modify the dedicated dummy node for 'loading...' or
          // 'error!' status. (only called for direct child of the invisible
          // system root)
          var firstChild = node.children ? node.children[0] : null;
          if (firstChild && firstChild.isStatusNode()) {
            $.extend(firstChild, data);
            firstChild.statusNodeType = type;
            tree._callHook("nodeRenderTitle", firstChild);
          } else {
            node._setChildren([data]);
            tree._callHook("treeStructureChanged", ctx, "setStatusNode");
            node.children[0].statusNodeType = type;
            tree.render();
          }
          return node.children[0];
        }
        switch (status) {
          case "ok":
            _clearStatusNode();
            node._isLoading = false;
            node._error = null;
            node.renderStatus();
            break;
          case "loading":
            if (!node.parent) {
              _setStatusNode({
                title: tree.options.strings.loading + (message ? " (" + message + ")" : ""),
                // icon: true,  // needed for 'loding' icon
                checkbox: false,
                tooltip: details
              }, status);
            }
            node._isLoading = true;
            node._error = null;
            node.renderStatus();
            break;
          case "error":
            _setStatusNode({
              title: tree.options.strings.loadError + (message ? " (" + message + ")" : ""),
              // icon: false,
              checkbox: false,
              tooltip: details
            }, status);
            node._isLoading = false;
            node._error = {
              message: message,
              details: details
            };
            node.renderStatus();
            break;
          case "nodata":
            _setStatusNode({
              title: message || tree.options.strings.noData,
              // icon: false,
              checkbox: false,
              tooltip: details
            }, status);
            node._isLoading = false;
            node._error = null;
            node.renderStatus();
            break;
          default:
            $.error("invalid node status " + status);
        }
      },
      /**
       *
       * @param {EventData} ctx
       */
      nodeToggleExpanded: function nodeToggleExpanded(ctx) {
        return this.nodeSetExpanded(ctx, !ctx.node.expanded);
      },
      /**
       * @param {EventData} ctx
       */
      nodeToggleSelected: function nodeToggleSelected(ctx) {
        var node = ctx.node,
          flag = !node.selected;

        // In selectMode: 3 this node may be unselected+partsel, even if
        // setSelected(true) was called before, due to `unselectable` children.
        // In this case, we now toggle as `setSelected(false)`
        if (node.partsel && !node.selected && node._lastSelectIntent === true) {
          flag = false;
          node.selected = true; // so it is not considered 'nothing to do'
        }

        node._lastSelectIntent = flag;
        return this.nodeSetSelected(ctx, flag);
      },
      /** Remove all nodes.
       * @param {EventData} ctx
       */
      treeClear: function treeClear(ctx) {
        var tree = ctx.tree;
        tree.activeNode = null;
        tree.focusNode = null;
        tree.$div.find(">ul.fancytree-container").empty();
        // TODO: call destructors and remove reference loops
        tree.rootNode.children = null;
        tree._callHook("treeStructureChanged", ctx, "clear");
      },
      /** Widget was created (called only once, even it re-initialized).
       * @param {EventData} ctx
       */
      treeCreate: function treeCreate(ctx) {},
      /** Widget was destroyed.
       * @param {EventData} ctx
       */
      treeDestroy: function treeDestroy(ctx) {
        this.$div.find(">ul.fancytree-container").remove();
        if (this.$source) {
          this.$source.removeClass("fancytree-helper-hidden");
        }
      },
      /** Widget was (re-)initialized.
       * @param {EventData} ctx
       */
      treeInit: function treeInit(ctx) {
        var tree = ctx.tree,
          opts = tree.options;

        //this.debug("Fancytree.treeInit()");
        // Add container to the TAB chain
        // See http://www.w3.org/TR/wai-aria-practices/#focus_activedescendant
        // #577: Allow to set tabindex to "0", "-1" and ""
        tree.$container.attr("tabindex", opts.tabindex);

        // Copy some attributes to tree.data
        $.each(TREE_ATTRS, function (i, attr) {
          if (opts[attr] !== undefined) {
            tree.info("Move option " + attr + " to tree");
            tree[attr] = opts[attr];
            delete opts[attr];
          }
        });
        if (opts.checkboxAutoHide) {
          tree.$container.addClass("fancytree-checkbox-auto-hide");
        }
        if (opts.rtl) {
          tree.$container.attr("DIR", "RTL").addClass("fancytree-rtl");
        } else {
          tree.$container.removeAttr("DIR").removeClass("fancytree-rtl");
        }
        if (opts.aria) {
          tree.$container.attr("role", "tree");
          if (opts.selectMode !== 1) {
            tree.$container.attr("aria-multiselectable", true);
          }
        }
        this.treeLoad(ctx);
      },
      /** Parse Fancytree from source, as configured in the options.
       * @param {EventData} ctx
       * @param {object} [source] optional new source (use last data otherwise)
       */
      treeLoad: function treeLoad(ctx, source) {
        var metaData,
          type,
          $ul,
          tree = ctx.tree,
          $container = ctx.widget.element,
          dfd,
          // calling context for root node
          rootCtx = $.extend({}, ctx, {
            node: this.rootNode
          });
        if (tree.rootNode.children) {
          this.treeClear(ctx);
        }
        source = source || this.options.source;
        if (!source) {
          type = $container.data("type") || "html";
          switch (type) {
            case "html":
              // There should be an embedded `<ul>` with initial nodes,
              // but another `<ul class='fancytree-container'>` is appended
              // to the tree's <div> on startup anyway.
              $ul = $container.find(">ul").not(".fancytree-container").first();
              if ($ul.length) {
                $ul.addClass("ui-fancytree-source fancytree-helper-hidden");
                source = $.ui.fancytree.parseHtml($ul);
                // allow to init tree.data.foo from <ul data-foo=''>
                this.data = $.extend(this.data, _getElementDataAsDict($ul));
              } else {
                FT.warn("No `source` option was passed and container does not contain `<ul>`: assuming `source: []`.");
                source = [];
              }
              break;
            case "json":
              source = $.parseJSON($container.text());
              // $container already contains the <ul>, but we remove the plain (json) text
              // $container.empty();
              $container.contents().filter(function () {
                return this.nodeType === 3;
              }).remove();
              if ($.isPlainObject(source)) {
                // We got {foo: 'abc', children: [...]}
                _assert(_isArray(source.children), "if an object is passed as source, it must contain a 'children' array (all other properties are added to 'tree.data')");
                metaData = source;
                source = source.children;
                delete metaData.children;
                // Copy some attributes to tree.data
                $.each(TREE_ATTRS, function (i, attr) {
                  if (metaData[attr] !== undefined) {
                    tree[attr] = metaData[attr];
                    delete metaData[attr];
                  }
                });
                // Copy extra properties to tree.data.foo
                $.extend(tree.data, metaData);
              }
              break;
            default:
              $.error("Invalid data-type: " + type);
          }
        } else if (typeof source === "string") {
          // TODO: source is an element ID
          $.error("Not implemented");
        }

        // preInit is fired when the widget markup is created, but nodes
        // not yet loaded
        tree._triggerTreeEvent("preInit", null);

        // Trigger fancytreeinit after nodes have been loaded
        dfd = this.nodeLoadChildren(rootCtx, source).done(function () {
          tree._callHook("treeStructureChanged", ctx, "loadChildren");
          tree.render();
          if (ctx.options.selectMode === 3) {
            tree.rootNode.fixSelection3FromEndNodes();
          }
          if (tree.activeNode && tree.options.activeVisible) {
            tree.activeNode.makeVisible();
          }
          tree._triggerTreeEvent("init", null, {
            status: true
          });
        }).fail(function () {
          tree.render();
          tree._triggerTreeEvent("init", null, {
            status: false
          });
        });
        return dfd;
      },
      /** Node was inserted into or removed from the tree.
       * @param {EventData} ctx
       * @param {boolean} add
       * @param {FancytreeNode} node
       */
      treeRegisterNode: function treeRegisterNode(ctx, add, node) {
        ctx.tree._callHook("treeStructureChanged", ctx, add ? "addNode" : "removeNode");
      },
      /** Widget got focus.
       * @param {EventData} ctx
       * @param {boolean} [flag=true]
       */
      treeSetFocus: function treeSetFocus(ctx, flag, callOpts) {
        var targetNode;
        flag = flag !== false;

        // this.debug("treeSetFocus(" + flag + "), callOpts: ", callOpts, this.hasFocus());
        // this.debug("    focusNode: " + this.focusNode);
        // this.debug("    activeNode: " + this.activeNode);
        if (flag !== this.hasFocus()) {
          this._hasFocus = flag;
          if (!flag && this.focusNode) {
            // Node also looses focus if widget blurs
            this.focusNode.setFocus(false);
          } else if (flag && (!callOpts || !callOpts.calledByNode)) {
            $(this.$container).focus();
          }
          this.$container.toggleClass("fancytree-treefocus", flag);
          this._triggerTreeEvent(flag ? "focusTree" : "blurTree");
          if (flag && !this.activeNode) {
            // #712: Use last mousedowned node ('click' event fires after focusin)
            targetNode = this._lastMousedownNode || this.getFirstChild();
            if (targetNode) {
              targetNode.setFocus();
            }
          }
        }
      },
      /** Widget option was set using `$().fancytree("option", "KEY", VALUE)`.
       *
       * Note: `key` may reference a nested option, e.g. 'dnd5.scroll'.
       * In this case `value`contains the complete, modified `dnd5` option hash.
       * We can check for changed values like
       *     if( value.scroll !== tree.options.dnd5.scroll ) {...}
       *
       * @param {EventData} ctx
       * @param {string} key option name
       * @param {any} value option value
       */
      treeSetOption: function treeSetOption(ctx, key, value) {
        var tree = ctx.tree,
          callDefault = true,
          callCreate = false,
          callRender = false;
        switch (key) {
          case "aria":
          case "checkbox":
          case "icon":
          case "minExpandLevel":
          case "tabindex":
            // tree._callHook("treeCreate", tree);
            callCreate = true;
            callRender = true;
            break;
          case "checkboxAutoHide":
            tree.$container.toggleClass("fancytree-checkbox-auto-hide", !!value);
            break;
          case "escapeTitles":
          case "tooltip":
            callRender = true;
            break;
          case "rtl":
            if (value === false) {
              tree.$container.removeAttr("DIR").removeClass("fancytree-rtl");
            } else {
              tree.$container.attr("DIR", "RTL").addClass("fancytree-rtl");
            }
            callRender = true;
            break;
          case "source":
            callDefault = false;
            tree._callHook("treeLoad", tree, value);
            callRender = true;
            break;
        }
        tree.debug("set option " + key + "=" + value + " <" + _typeof(value) + ">");
        if (callDefault) {
          if (this.widget._super) {
            // jQuery UI 1.9+
            this.widget._super.call(this.widget, key, value);
          } else {
            // jQuery UI <= 1.8, we have to manually invoke the _setOption method from the base widget
            $.Widget.prototype._setOption.call(this.widget, key, value);
          }
        }
        if (callCreate) {
          tree._callHook("treeCreate", tree);
        }
        if (callRender) {
          tree.render(true, false); // force, not-deep
        }
      },

      /** A Node was added, removed, moved, or it's visibility changed.
       * @param {EventData} ctx
       */
      treeStructureChanged: function treeStructureChanged(ctx, type) {}
    });

    /*******************************************************************************
     * jQuery UI widget boilerplate
     */

    /**
     * The plugin (derrived from [jQuery.Widget](http://api.jqueryui.com/jQuery.widget/)).
     *
     * **Note:**
     * These methods implement the standard jQuery UI widget API.
     * It is recommended to use methods of the {Fancytree} instance instead
     *
     * @example
     * // DEPRECATED: Access jQuery UI widget methods and members:
     * var tree = $("#tree").fancytree("getTree");
     * var node = $("#tree").fancytree("getActiveNode");
     *
     * // RECOMMENDED: Use the Fancytree object API
     * var tree = $.ui.fancytree.getTree("#tree");
     * var node = tree.getActiveNode();
     *
     * // or you may already have stored the tree instance upon creation:
     * import {createTree, version} from 'jquery.fancytree'
     * const tree = createTree('#tree', { ... });
     * var node = tree.getActiveNode();
     *
     * @see {Fancytree_Static#getTree}
     * @deprecated Use methods of the {Fancytree} instance instead
     * @mixin Fancytree_Widget
     */

    $.widget("ui.fancytree", /** @lends Fancytree_Widget# */
    {
      /**These options will be used as defaults
       * @type {FancytreeOptions}
       */
      options: {
        activeVisible: true,
        ajax: {
          type: "GET",
          cache: false,
          // false: Append random '_' argument to the request url to prevent caching.
          // timeout: 0, // >0: Make sure we get an ajax error if server is unreachable
          dataType: "json" // Expect json format and pass json object to callbacks.
        },

        aria: true,
        autoActivate: true,
        autoCollapse: false,
        autoScroll: false,
        checkbox: false,
        clickFolderMode: 4,
        copyFunctionsToData: false,
        debugLevel: null,
        // 0..4 (null: use global setting $.ui.fancytree.debugLevel)
        disabled: false,
        // TODO: required anymore?
        enableAspx: 42,
        // TODO: this is truethy, but distinguishable from true: default will change to false in the future
        escapeTitles: false,
        extensions: [],
        focusOnSelect: false,
        generateIds: false,
        icon: true,
        idPrefix: "ft_",
        keyboard: true,
        keyPathSeparator: "/",
        minExpandLevel: 1,
        nodata: true,
        // (bool, string, or callback) display message, when no data available
        quicksearch: false,
        rtl: false,
        scrollOfs: {
          top: 0,
          bottom: 0
        },
        scrollParent: null,
        selectMode: 2,
        strings: {
          loading: "Loading...",
          // &#8230; would be escaped when escapeTitles is true
          loadError: "Load error!",
          moreData: "More...",
          noData: "No data."
        },
        tabindex: "0",
        titlesTabbable: false,
        toggleEffect: {
          effect: "slideToggle",
          duration: 200
        },
        //< "toggle" or "slideToggle" to use jQuery instead of jQueryUI for toggleEffect animation
        tooltip: false,
        treeId: null,
        _classNames: {
          active: "fancytree-active",
          animating: "fancytree-animating",
          combinedExpanderPrefix: "fancytree-exp-",
          combinedIconPrefix: "fancytree-ico-",
          error: "fancytree-error",
          expanded: "fancytree-expanded",
          focused: "fancytree-focused",
          folder: "fancytree-folder",
          hasChildren: "fancytree-has-children",
          lastsib: "fancytree-lastsib",
          lazy: "fancytree-lazy",
          loading: "fancytree-loading",
          node: "fancytree-node",
          partload: "fancytree-partload",
          partsel: "fancytree-partsel",
          radio: "fancytree-radio",
          selected: "fancytree-selected",
          statusNodePrefix: "fancytree-statusnode-",
          unselectable: "fancytree-unselectable"
        },
        // events
        lazyLoad: null,
        postProcess: null
      },
      _deprecationWarning: function _deprecationWarning(name) {
        var tree = this.tree;
        if (tree && tree.options.debugLevel >= 3) {
          tree.warn("$().fancytree('" + name + "') is deprecated (see https://wwwendt.de/tech/fancytree/doc/jsdoc/Fancytree_Widget.html");
        }
      },
      /* Set up the widget, Called on first $().fancytree() */
      _create: function _create() {
        this.tree = new Fancytree(this);
        this.$source = this.source || this.element.data("type") === "json" ? this.element : this.element.find(">ul").first();
        // Subclass Fancytree instance with all enabled extensions
        var extension,
          extName,
          i,
          opts = this.options,
          extensions = opts.extensions,
          base = this.tree;
        for (i = 0; i < extensions.length; i++) {
          extName = extensions[i];
          extension = $.ui.fancytree._extensions[extName];
          if (!extension) {
            $.error("Could not apply extension '" + extName + "' (it is not registered, did you forget to include it?)");
          }
          // Add extension options as tree.options.EXTENSION
          // 	_assert(!this.tree.options[extName], "Extension name must not exist as option name: " + extName);

          // console.info("extend " + extName, extension.options, this.tree.options[extName])
          // issue #876: we want to replace custom array-options, not merge them
          this.tree.options[extName] = _simpleDeepMerge({}, extension.options, this.tree.options[extName]);
          // this.tree.options[extName] = $.extend(true, {}, extension.options, this.tree.options[extName]);

          // console.info("extend " + extName + " =>", this.tree.options[extName])
          // console.info("extend " + extName + " org default =>", extension.options)

          // Add a namespace tree.ext.EXTENSION, to hold instance data
          _assert(this.tree.ext[extName] === undefined, "Extension name must not exist as Fancytree.ext attribute: '" + extName + "'");
          // this.tree[extName] = extension;
          this.tree.ext[extName] = {};
          // Subclass Fancytree methods using proxies.
          _subclassObject(this.tree, base, extension, extName);
          // current extension becomes base for the next extension
          base = extension;
        }
        //
        if (opts.icons !== undefined) {
          // 2015-11-16
          if (opts.icon === true) {
            this.tree.warn("'icons' tree option is deprecated since v2.14.0: use 'icon' instead");
            opts.icon = opts.icons;
          } else {
            $.error("'icons' tree option is deprecated since v2.14.0: use 'icon' only instead");
          }
        }
        if (opts.iconClass !== undefined) {
          // 2015-11-16
          if (opts.icon) {
            $.error("'iconClass' tree option is deprecated since v2.14.0: use 'icon' only instead");
          } else {
            this.tree.warn("'iconClass' tree option is deprecated since v2.14.0: use 'icon' instead");
            opts.icon = opts.iconClass;
          }
        }
        if (opts.tabbable !== undefined) {
          // 2016-04-04
          opts.tabindex = opts.tabbable ? "0" : "-1";
          this.tree.warn("'tabbable' tree option is deprecated since v2.17.0: use 'tabindex='" + opts.tabindex + "' instead");
        }
        //
        this.tree._callHook("treeCreate", this.tree);
        // Note: 'fancytreecreate' event is fired by widget base class
        //        this.tree._triggerTreeEvent("create");
      },

      /* Called on every $().fancytree() */
      _init: function _init() {
        this.tree._callHook("treeInit", this.tree);
        // TODO: currently we call bind after treeInit, because treeInit
        // might change tree.$container.
        // It would be better, to move event binding into hooks altogether
        this._bind();
      },
      /* Use the _setOption method to respond to changes to options. */
      _setOption: function _setOption(key, value) {
        return this.tree._callHook("treeSetOption", this.tree, key, value);
      },
      /** Use the destroy method to clean up any modifications your widget has made to the DOM */
      _destroy: function _destroy() {
        this._unbind();
        this.tree._callHook("treeDestroy", this.tree);
        // In jQuery UI 1.8, you must invoke the destroy method from the base widget
        // $.Widget.prototype.destroy.call(this);
        // TODO: delete tree and nodes to make garbage collect easier?
        // TODO: In jQuery UI 1.9 and above, you would define _destroy instead of destroy and not call the base method
      },

      // -------------------------------------------------------------------------

      /* Remove all event handlers for our namespace */
      _unbind: function _unbind() {
        var ns = this.tree._ns;
        this.element.off(ns);
        this.tree.$container.off(ns);
        $(document).off(ns);
      },
      /* Add mouse and kyboard handlers to the container */
      _bind: function _bind() {
        var self = this,
          opts = this.options,
          tree = this.tree,
          ns = tree._ns;
        // selstartEvent = ( $.support.selectstart ? "selectstart" : "mousedown" )

        // Remove all previuous handlers for this tree
        this._unbind();

        //alert("keydown" + ns + "foc=" + tree.hasFocus() + tree.$container);
        // tree.debug("bind events; container: ", tree.$container);
        tree.$container.on("focusin" + ns + " focusout" + ns, function (event) {
          var node = FT.getNode(event),
            flag = event.type === "focusin";
          if (!flag && node && $(event.target).is("a")) {
            // #764
            node.debug("Ignored focusout on embedded <a> element.");
            return;
          }
          // tree.treeOnFocusInOut.call(tree, event);
          // tree.debug("Tree container got event " + event.type, node, event, FT.getEventTarget(event));
          if (flag) {
            if (tree._getExpiringValue("focusin")) {
              // #789: IE 11 may send duplicate focusin events
              tree.debug("Ignored double focusin.");
              return;
            }
            tree._setExpiringValue("focusin", true, 50);
            if (!node) {
              // #789: IE 11 may send focusin before mousdown(?)
              node = tree._getExpiringValue("mouseDownNode");
              if (node) {
                tree.debug("Reconstruct mouse target for focusin from recent event.");
              }
            }
          }
          if (node) {
            // For example clicking into an <input> that is part of a node
            tree._callHook("nodeSetFocus", tree._makeHookContext(node, event), flag);
          } else {
            if (tree.tbody && $(event.target).parents("table.fancytree-container > thead").length) {
              // #767: ignore events in the table's header
              tree.debug("Ignore focus event outside table body.", event);
            } else {
              tree._callHook("treeSetFocus", tree, flag);
            }
          }
        }).on("selectstart" + ns, "span.fancytree-title", function (event) {
          // prevent mouse-drags to select text ranges
          // tree.debug("<span title> got event " + event.type);
          event.preventDefault();
        }).on("keydown" + ns, function (event) {
          // TODO: also bind keyup and keypress
          // tree.debug("got event " + event.type + ", hasFocus:" + tree.hasFocus());
          // if(opts.disabled || opts.keyboard === false || !tree.hasFocus() ){
          if (opts.disabled || opts.keyboard === false) {
            return true;
          }
          var res,
            node = tree.focusNode,
            // node may be null
            ctx = tree._makeHookContext(node || tree, event),
            prevPhase = tree.phase;
          try {
            tree.phase = "userEvent";
            // If a 'fancytreekeydown' handler returns false, skip the default
            // handling (implemented by tree.nodeKeydown()).
            if (node) {
              res = tree._triggerNodeEvent("keydown", node, event);
            } else {
              res = tree._triggerTreeEvent("keydown", event);
            }
            if (res === "preventNav") {
              res = true; // prevent keyboard navigation, but don't prevent default handling of embedded input controls
            } else if (res !== false) {
              res = tree._callHook("nodeKeydown", ctx);
            }
            return res;
          } finally {
            tree.phase = prevPhase;
          }
        }).on("mousedown" + ns, function (event) {
          var et = FT.getEventTarget(event);
          // self.tree.debug("event(" + event.type + "): node: ", et.node);
          // #712: Store the clicked node, so we can use it when we get a focusin event
          //       ('click' event fires after focusin)
          // tree.debug("event(" + event.type + "): node: ", et.node);
          tree._lastMousedownNode = et ? et.node : null;
          // #789: Store the node also for a short period, so we can use it
          // in a *resulting* focusin event
          tree._setExpiringValue("mouseDownNode", tree._lastMousedownNode);
        }).on("click" + ns + " dblclick" + ns, function (event) {
          if (opts.disabled) {
            return true;
          }
          var ctx,
            et = FT.getEventTarget(event),
            node = et.node,
            tree = self.tree,
            prevPhase = tree.phase;

          // self.tree.debug("event(" + event.type + "): node: ", node);
          if (!node) {
            return true; // Allow bubbling of other events
          }

          ctx = tree._makeHookContext(node, event);
          // self.tree.debug("event(" + event.type + "): node: ", node);
          try {
            tree.phase = "userEvent";
            switch (event.type) {
              case "click":
                ctx.targetType = et.type;
                if (node.isPagingNode()) {
                  return tree._triggerNodeEvent("clickPaging", ctx, event) === true;
                }
                return tree._triggerNodeEvent("click", ctx, event) === false ? false : tree._callHook("nodeClick", ctx);
              case "dblclick":
                ctx.targetType = et.type;
                return tree._triggerNodeEvent("dblclick", ctx, event) === false ? false : tree._callHook("nodeDblclick", ctx);
            }
          } finally {
            tree.phase = prevPhase;
          }
        });
      },
      /** Return the active node or null.
       * @returns {FancytreeNode}
       * @deprecated Use methods of the Fancytree instance instead (<a href="Fancytree_Widget.html">example above</a>).
       */
      getActiveNode: function getActiveNode() {
        this._deprecationWarning("getActiveNode");
        return this.tree.activeNode;
      },
      /** Return the matching node or null.
       * @param {string} key
       * @returns {FancytreeNode}
       * @deprecated Use methods of the Fancytree instance instead (<a href="Fancytree_Widget.html">example above</a>).
       */
      getNodeByKey: function getNodeByKey(key) {
        this._deprecationWarning("getNodeByKey");
        return this.tree.getNodeByKey(key);
      },
      /** Return the invisible system root node.
       * @returns {FancytreeNode}
       * @deprecated Use methods of the Fancytree instance instead (<a href="Fancytree_Widget.html">example above</a>).
       */
      getRootNode: function getRootNode() {
        this._deprecationWarning("getRootNode");
        return this.tree.rootNode;
      },
      /** Return the current tree instance.
       * @returns {Fancytree}
       * @deprecated Use `$.ui.fancytree.getTree()` instead (<a href="Fancytree_Widget.html">example above</a>).
       */
      getTree: function getTree() {
        this._deprecationWarning("getTree");
        return this.tree;
      }
    });

    // $.ui.fancytree was created by the widget factory. Create a local shortcut:
    FT = $.ui.fancytree;

    /**
     * Static members in the `$.ui.fancytree` namespace.
     * This properties and methods can be accessed without instantiating a concrete
     * Fancytree instance.
     *
     * @example
     * // Access static members:
     * var node = $.ui.fancytree.getNode(element);
     * alert($.ui.fancytree.version);
     *
     * @mixin Fancytree_Static
     */
    $.extend($.ui.fancytree, /** @lends Fancytree_Static# */
    {
      /** Version number `"MAJOR.MINOR.PATCH"`
       * @type {string} */
      version: "2.38.2",
      // Set to semver by 'grunt release'
      /** @type {string}
       * @description `"production" for release builds` */
      buildType: "production",
      // Set to 'production' by 'grunt build'
      /** @type {int}
       * @description 0: silent .. 5: verbose (default: 3 for release builds). */
      debugLevel: 3,
      // Set to 3 by 'grunt build'
      // Used by $.ui.fancytree.debug() and as default for tree.options.debugLevel

      _nextId: 1,
      _nextNodeKey: 1,
      _extensions: {},
      // focusTree: null,

      /** Expose class object as `$.ui.fancytree._FancytreeClass`.
       * Useful to extend `$.ui.fancytree._FancytreeClass.prototype`.
       * @type {Fancytree}
       */
      _FancytreeClass: Fancytree,
      /** Expose class object as $.ui.fancytree._FancytreeNodeClass
       * Useful to extend `$.ui.fancytree._FancytreeNodeClass.prototype`.
       * @type {FancytreeNode}
       */
      _FancytreeNodeClass: FancytreeNode,
      /* Feature checks to provide backwards compatibility */
      jquerySupports: {
        // http://jqueryui.com/upgrade-guide/1.9/#deprecated-offset-option-merged-into-my-and-at
        positionMyOfs: isVersionAtLeast($.ui.version, 1, 9)
      },
      /** Throw an error if condition fails (debug method).
       * @param {boolean} cond
       * @param {string} msg
       */
      assert: function assert(cond, msg) {
        return _assert(cond, msg);
      },
      /** Create a new Fancytree instance on a target element.
       *
       * @param {Element | jQueryObject | string} el Target DOM element or selector
       * @param {FancytreeOptions} [opts] Fancytree options
       * @returns {Fancytree} new tree instance
       * @example
       * var tree = $.ui.fancytree.createTree("#tree", {
       *     source: {url: "my/webservice"}
       * }); // Create tree for this matching element
       *
       * @since 2.25
       */
      createTree: function createTree(el, opts) {
        var $tree = $(el).fancytree(opts);
        return FT.getTree($tree);
      },
      /** Return a function that executes *fn* at most every *timeout* ms.
       * @param {integer} timeout
       * @param {function} fn
       * @param {boolean} [invokeAsap=false]
       * @param {any} [ctx]
       */
      debounce: function debounce(timeout, fn, invokeAsap, ctx) {
        var timer;
        if (arguments.length === 3 && typeof invokeAsap !== "boolean") {
          ctx = invokeAsap;
          invokeAsap = false;
        }
        return function () {
          var args = arguments;
          ctx = ctx || this;
          // eslint-disable-next-line no-unused-expressions
          invokeAsap && !timer && fn.apply(ctx, args);
          clearTimeout(timer);
          timer = setTimeout(function () {
            // eslint-disable-next-line no-unused-expressions
            invokeAsap || fn.apply(ctx, args);
            timer = null;
          }, timeout);
        };
      },
      /** Write message to console if debugLevel >= 4
       * @param {string} msg
       */
      debug: function debug(msg) {
        if ($.ui.fancytree.debugLevel >= 4) {
          consoleApply("log", arguments);
        }
      },
      /** Write error message to console if debugLevel >= 1.
       * @param {string} msg
       */
      error: function error(msg) {
        if ($.ui.fancytree.debugLevel >= 1) {
          consoleApply("error", arguments);
        }
      },
      /** Convert `<`, `>`, `&`, `"`, `'`, and `/` to the equivalent entities.
       *
       * @param {string} s
       * @returns {string}
       */
      escapeHtml: function escapeHtml(s) {
        return ("" + s).replace(REX_HTML, function (s) {
          return ENTITY_MAP[s];
        });
      },
      /** Make jQuery.position() arguments backwards compatible, i.e. if
       * jQuery UI version <= 1.8, convert
       *   { my: "left+3 center", at: "left bottom", of: $target }
       * to
       *   { my: "left center", at: "left bottom", of: $target, offset: "3  0" }
       *
       * See http://jqueryui.com/upgrade-guide/1.9/#deprecated-offset-option-merged-into-my-and-at
       * and http://jsfiddle.net/mar10/6xtu9a4e/
       *
       * @param {object} opts
       * @returns {object} the (potentially modified) original opts hash object
       */
      fixPositionOptions: function fixPositionOptions(opts) {
        if (opts.offset || ("" + opts.my + opts.at).indexOf("%") >= 0) {
          $.error("expected new position syntax (but '%' is not supported)");
        }
        if (!$.ui.fancytree.jquerySupports.positionMyOfs) {
          var
            // parse 'left+3 center' into ['left+3 center', 'left', '+3', 'center', undefined]
            myParts = /(\w+)([+-]?\d+)?\s+(\w+)([+-]?\d+)?/.exec(opts.my),
            atParts = /(\w+)([+-]?\d+)?\s+(\w+)([+-]?\d+)?/.exec(opts.at),
            // convert to numbers
            dx = (myParts[2] ? +myParts[2] : 0) + (atParts[2] ? +atParts[2] : 0),
            dy = (myParts[4] ? +myParts[4] : 0) + (atParts[4] ? +atParts[4] : 0);
          opts = $.extend({}, opts, {
            // make a copy and overwrite
            my: myParts[1] + " " + myParts[3],
            at: atParts[1] + " " + atParts[3]
          });
          if (dx || dy) {
            opts.offset = "" + dx + " " + dy;
          }
        }
        return opts;
      },
      /** Return a {node: FancytreeNode, type: TYPE} object for a mouse event.
       *
       * @param {Event} event Mouse event, e.g. click, ...
       * @returns {object} Return a {node: FancytreeNode, type: TYPE} object
       *     TYPE: 'title' | 'prefix' | 'expander' | 'checkbox' | 'icon' | undefined
       */
      getEventTarget: function getEventTarget(event) {
        var $target,
          tree,
          tcn = event && event.target ? event.target.className : "",
          res = {
            node: this.getNode(event.target),
            type: undefined
          };
        // We use a fast version of $(res.node).hasClass()
        // See http://jsperf.com/test-for-classname/2
        if (/\bfancytree-title\b/.test(tcn)) {
          res.type = "title";
        } else if (/\bfancytree-expander\b/.test(tcn)) {
          res.type = res.node.hasChildren() === false ? "prefix" : "expander";
          // }else if( /\bfancytree-checkbox\b/.test(tcn) || /\bfancytree-radio\b/.test(tcn) ){
        } else if (/\bfancytree-checkbox\b/.test(tcn)) {
          res.type = "checkbox";
        } else if (/\bfancytree(-custom)?-icon\b/.test(tcn)) {
          res.type = "icon";
        } else if (/\bfancytree-node\b/.test(tcn)) {
          // Somewhere near the title
          res.type = "title";
        } else if (event && event.target) {
          $target = $(event.target);
          if ($target.is("ul[role=group]")) {
            // #nnn: Clicking right to a node may hit the surrounding UL
            tree = res.node && res.node.tree;
            (tree || FT).debug("Ignoring click on outer UL.");
            res.node = null;
          } else if ($target.closest(".fancytree-title").length) {
            // #228: clicking an embedded element inside a title
            res.type = "title";
          } else if ($target.closest(".fancytree-checkbox").length) {
            // E.g. <svg> inside checkbox span
            res.type = "checkbox";
          } else if ($target.closest(".fancytree-expander").length) {
            res.type = "expander";
          }
        }
        return res;
      },
      /** Return a string describing the affected node region for a mouse event.
       *
       * @param {Event} event Mouse event, e.g. click, mousemove, ...
       * @returns {string} 'title' | 'prefix' | 'expander' | 'checkbox' | 'icon' | undefined
       */
      getEventTargetType: function getEventTargetType(event) {
        return this.getEventTarget(event).type;
      },
      /** Return a FancytreeNode instance from element, event, or jQuery object.
       *
       * @param {Element | jQueryObject | Event} el
       * @returns {FancytreeNode} matching node or null
       */
      getNode: function getNode(el) {
        if (el instanceof FancytreeNode) {
          return el; // el already was a FancytreeNode
        } else if (el instanceof $) {
          el = el[0]; // el was a jQuery object: use the DOM element
        } else if (el.originalEvent !== undefined) {
          el = el.target; // el was an Event
        }

        while (el) {
          if (el.ftnode) {
            return el.ftnode;
          }
          el = el.parentNode;
        }
        return null;
      },
      /** Return a Fancytree instance, from element, index, event, or jQueryObject.
       *
       * @param {Element | jQueryObject | Event | integer | string} [el]
       * @returns {Fancytree} matching tree or null
       * @example
       * $.ui.fancytree.getTree();  // Get first Fancytree instance on page
       * $.ui.fancytree.getTree(1);  // Get second Fancytree instance on page
       * $.ui.fancytree.getTree(event);  // Get tree for this mouse- or keyboard event
       * $.ui.fancytree.getTree("foo");  // Get tree for this `opts.treeId`
       * $.ui.fancytree.getTree("#tree");  // Get tree for this matching element
       *
       * @since 2.13
       */
      getTree: function getTree(el) {
        var widget,
          orgEl = el;
        if (el instanceof Fancytree) {
          return el; // el already was a Fancytree
        }

        if (el === undefined) {
          el = 0; // get first tree
        }

        if (typeof el === "number") {
          el = $(".fancytree-container").eq(el); // el was an integer: return nth instance
        } else if (typeof el === "string") {
          // `el` may be a treeId or a selector:
          el = $("#ft-id-" + orgEl).eq(0);
          if (!el.length) {
            el = $(orgEl).eq(0); // el was a selector: use first match
          }
        } else if (el instanceof Element || el instanceof HTMLDocument) {
          el = $(el);
        } else if (el instanceof $) {
          el = el.eq(0); // el was a jQuery object: use the first
        } else if (el.originalEvent !== undefined) {
          el = $(el.target); // el was an Event
        }
        // el is a jQuery object wit one element here
        el = el.closest(":ui-fancytree");
        widget = el.data("ui-fancytree") || el.data("fancytree"); // the latter is required by jQuery <= 1.8
        return widget ? widget.tree : null;
      },
      /** Return an option value that has a default, but may be overridden by a
       * callback or a node instance attribute.
       *
       * Evaluation sequence:
       *
       * If `tree.options.<optionName>` is a callback that returns something, use that.
       * Else if `node.<optionName>` is defined, use that.
       * Else if `tree.options.<optionName>` is a value, use that.
       * Else use `defaultValue`.
       *
       * @param {string} optionName name of the option property (on node and tree)
       * @param {FancytreeNode} node passed to the callback
       * @param {object} nodeObject where to look for the local option property, e.g. `node` or `node.data`
       * @param {object} treeOption where to look for the tree option, e.g. `tree.options` or `tree.options.dnd5`
       * @param {any} [defaultValue]
       * @returns {any}
       *
       * @example
       * // Check for node.foo, tree,options.foo(), and tree.options.foo:
       * $.ui.fancytree.evalOption("foo", node, node, tree.options);
       * // Check for node.data.bar, tree,options.qux.bar(), and tree.options.qux.bar:
       * $.ui.fancytree.evalOption("bar", node, node.data, tree.options.qux);
       *
       * @since 2.22
       */
      evalOption: function evalOption(optionName, node, nodeObject, treeOptions, defaultValue) {
        var ctx,
          res,
          tree = node.tree,
          treeOpt = treeOptions[optionName],
          nodeOpt = nodeObject[optionName];
        if (_isFunction(treeOpt)) {
          ctx = {
            node: node,
            tree: tree,
            widget: tree.widget,
            options: tree.widget.options,
            typeInfo: tree.types[node.type] || {}
          };
          res = treeOpt.call(tree, {
            type: optionName
          }, ctx);
          if (res == null) {
            res = nodeOpt;
          }
        } else {
          res = nodeOpt == null ? treeOpt : nodeOpt;
        }
        if (res == null) {
          res = defaultValue; // no option set at all: return default
        }

        return res;
      },
      /** Set expander, checkbox, or node icon, supporting string and object format.
       *
       * @param {Element | jQueryObject} span
       * @param {string} baseClass
       * @param {string | object} icon
       * @since 2.27
       */
      setSpanIcon: function setSpanIcon(span, baseClass, icon) {
        var $span = $(span);
        if (typeof icon === "string") {
          $span.attr("class", baseClass + " " + icon);
        } else {
          // support object syntax: { text: ligature, addClasse: classname }
          if (icon.text) {
            $span.text("" + icon.text);
          } else if (icon.html) {
            span.innerHTML = icon.html;
          }
          $span.attr("class", baseClass + " " + (icon.addClass || ""));
        }
      },
      /** Convert a keydown or mouse event to a canonical string like 'ctrl+a',
       * 'ctrl+shift+f2', 'shift+leftdblclick'.
       *
       * This is especially handy for switch-statements in event handlers.
       *
       * @param {event}
       * @returns {string}
       *
       * @example
      	switch( $.ui.fancytree.eventToString(event) ) {
      	case "-":
      		tree.nodeSetExpanded(ctx, false);
      		break;
      	case "shift+return":
      		tree.nodeSetActive(ctx, true);
      		break;
      	case "down":
      		res = node.navigate(event.which, activate);
      		break;
      	default:
      		handled = false;
      }
      if( handled ){
      	event.preventDefault();
      }
      */
      eventToString: function eventToString(event) {
        // Poor-man's hotkeys. See here for a complete implementation:
        //   https://github.com/jeresig/jquery.hotkeys
        var which = event.which,
          et = event.type,
          s = [];
        if (event.altKey) {
          s.push("alt");
        }
        if (event.ctrlKey) {
          s.push("ctrl");
        }
        if (event.metaKey) {
          s.push("meta");
        }
        if (event.shiftKey) {
          s.push("shift");
        }
        if (et === "click" || et === "dblclick") {
          s.push(MOUSE_BUTTONS[event.button] + et);
        } else if (et === "wheel") {
          s.push(et);
        } else if (!IGNORE_KEYCODES[which]) {
          s.push(SPECIAL_KEYCODES[which] || String.fromCharCode(which).toLowerCase());
        }
        return s.join("+");
      },
      /** Write message to console if debugLevel >= 3
       * @param {string} msg
       */
      info: function info(msg) {
        if ($.ui.fancytree.debugLevel >= 3) {
          consoleApply("info", arguments);
        }
      },
      /* @deprecated: use eventToString(event) instead.
       */
      keyEventToString: function keyEventToString(event) {
        this.warn("keyEventToString() is deprecated: use eventToString()");
        return this.eventToString(event);
      },
      /** Return a wrapped handler method, that provides `this._super`.
       *
       * @example
      	// Implement `opts.createNode` event to add the 'draggable' attribute
      	$.ui.fancytree.overrideMethod(ctx.options, "createNode", function(event, data) {
      		// Default processing if any
      		this._super.apply(this, arguments);
      		// Add 'draggable' attribute
      		data.node.span.draggable = true;
      	});
       *
       * @param {object} instance
       * @param {string} methodName
       * @param {function} handler
       * @param {object} [context] optional context
       */
      overrideMethod: function overrideMethod(instance, methodName, handler, context) {
        var prevSuper,
          _super = instance[methodName] || $.noop;
        instance[methodName] = function () {
          var self = context || this;
          try {
            prevSuper = self._super;
            self._super = _super;
            return handler.apply(self, arguments);
          } finally {
            self._super = prevSuper;
          }
        };
      },
      /**
       * Parse tree data from HTML <ul> markup
       *
       * @param {jQueryObject} $ul
       * @returns {NodeData[]}
       */
      parseHtml: function parseHtml($ul) {
        var classes,
          className,
          extraClasses,
          i,
          iPos,
          l,
          tmp,
          tmp2,
          $children = $ul.find(">li"),
          children = [];
        $children.each(function () {
          var allData,
            lowerCaseAttr,
            $li = $(this),
            $liSpan = $li.find(">span", this).first(),
            $liA = $liSpan.length ? null : $li.find(">a").first(),
            d = {
              tooltip: null,
              data: {}
            };
          if ($liSpan.length) {
            d.title = $liSpan.html();
          } else if ($liA && $liA.length) {
            // If a <li><a> tag is specified, use it literally and extract href/target.
            d.title = $liA.html();
            d.data.href = $liA.attr("href");
            d.data.target = $liA.attr("target");
            d.tooltip = $liA.attr("title");
          } else {
            // If only a <li> tag is specified, use the trimmed string up to
            // the next child <ul> tag.
            d.title = $li.html();
            iPos = d.title.search(/<ul/i);
            if (iPos >= 0) {
              d.title = d.title.substring(0, iPos);
            }
          }
          d.title = _trim(d.title);

          // Make sure all fields exist
          for (i = 0, l = CLASS_ATTRS.length; i < l; i++) {
            d[CLASS_ATTRS[i]] = undefined;
          }
          // Initialize to `true`, if class is set and collect extraClasses
          classes = this.className.split(" ");
          extraClasses = [];
          for (i = 0, l = classes.length; i < l; i++) {
            className = classes[i];
            if (CLASS_ATTR_MAP[className]) {
              d[className] = true;
            } else {
              extraClasses.push(className);
            }
          }
          d.extraClasses = extraClasses.join(" ");

          // Parse node options from ID, title and class attributes
          tmp = $li.attr("title");
          if (tmp) {
            d.tooltip = tmp; // overrides <a title='...'>
          }

          tmp = $li.attr("id");
          if (tmp) {
            d.key = tmp;
          }
          // Translate hideCheckbox -> checkbox:false
          if ($li.attr("hideCheckbox")) {
            d.checkbox = false;
          }
          // Add <li data-NAME='...'> as node.data.NAME
          allData = _getElementDataAsDict($li);
          if (allData && !$.isEmptyObject(allData)) {
            // #507: convert data-hidecheckbox (lower case) to hideCheckbox
            for (lowerCaseAttr in NODE_ATTR_LOWERCASE_MAP) {
              if (_hasProp(allData, lowerCaseAttr)) {
                allData[NODE_ATTR_LOWERCASE_MAP[lowerCaseAttr]] = allData[lowerCaseAttr];
                delete allData[lowerCaseAttr];
              }
            }
            // #56: Allow to set special node.attributes from data-...
            for (i = 0, l = NODE_ATTRS.length; i < l; i++) {
              tmp = NODE_ATTRS[i];
              tmp2 = allData[tmp];
              if (tmp2 != null) {
                delete allData[tmp];
                d[tmp] = tmp2;
              }
            }
            // All other data-... goes to node.data...
            $.extend(d.data, allData);
          }
          // Recursive reading of child nodes, if LI tag contains an UL tag
          $ul = $li.find(">ul").first();
          if ($ul.length) {
            d.children = $.ui.fancytree.parseHtml($ul);
          } else {
            d.children = d.lazy ? undefined : null;
          }
          children.push(d);
          // FT.debug("parse ", d, children);
        });

        return children;
      },
      /** Add Fancytree extension definition to the list of globally available extensions.
       *
       * @param {object} definition
       */
      registerExtension: function registerExtension(definition) {
        _assert(definition.name != null, "extensions must have a `name` property.");
        _assert(definition.version != null, "extensions must have a `version` property.");
        $.ui.fancytree._extensions[definition.name] = definition;
      },
      /** Replacement for the deprecated `jQuery.trim()`.
       *
       * @param {string} text
       */
      trim: _trim,
      /** Inverse of escapeHtml().
       *
       * @param {string} s
       * @returns {string}
       */
      unescapeHtml: function unescapeHtml(s) {
        var e = document.createElement("div");
        e.innerHTML = s;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
      },
      /** Write warning message to console if debugLevel >= 2.
       * @param {string} msg
       */
      warn: function warn(msg) {
        if ($.ui.fancytree.debugLevel >= 2) {
          consoleApply("warn", arguments);
        }
      }
    });

    // Value returned by `require('jquery.fancytree')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.childcounter.js' */ // Extending Fancytree
  // ===================
  //
  // See also the [live demo](https://wwWendt.de/tech/fancytree/demo/sample-ext-childcounter.html) of this code.
  //
  // Every extension should have a comment header containing some information
  // about the author, copyright and licensing. Also a pointer to the latest
  // source code.
  // Prefix with `/*!` so the comment is not removed by the minifier.

  /*!
   * jquery.fancytree.childcounter.js
   *
   * Add a child counter bubble to tree nodes.
   * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
   *
   * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
   *
   * Released under the MIT license
   * https://github.com/mar10/fancytree/wiki/LicenseInfo
   *
   * @version 2.38.2
   * @date 2022-06-30T18:24:06Z
   */

  // To keep the global namespace clean, we wrap everything in a closure.
  // The UMD wrapper pattern defines the dependencies on jQuery and the
  // Fancytree core module, and makes sure that we can use the `require()`
  // syntax with package loaders.

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    // Consider to use [strict mode](http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/)
    "use strict";

    // The [coding guidelines](http://contribute.jquery.org/style-guide/js/)
    // require jshint /eslint compliance.
    // But for this sample, we want to allow unused variables for demonstration purpose.

    /*eslint-disable no-unused-vars */

    // Adding methods
    // --------------

    // New member functions can be added to the `Fancytree` class.
    // This function will be available for every tree instance:
    //
    //     var tree = $.ui.fancytree.getTree("#tree");
    //     tree.countSelected(false);
    $.ui.fancytree._FancytreeClass.prototype.countSelected = function (topOnly) {
      var tree = this,
        treeOptions = tree.options;
      return tree.getSelectedNodes(topOnly).length;
    };

    // The `FancytreeNode` class can also be easily extended. This would be called
    // like
    //     node.updateCounters();
    //
    // It is also good practice to add a docstring comment.
    /**
     * [ext-childcounter] Update counter badges for `node` and its parents.
     * May be called in the `loadChildren` event, to update parents of lazy loaded
     * nodes.
     * @alias FancytreeNode#updateCounters
     * @requires jquery.fancytree.childcounters.js
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.updateCounters = function () {
      var node = this,
        $badge = $("span.fancytree-childcounter", node.span),
        extOpts = node.tree.options.childcounter,
        count = node.countChildren(extOpts.deep);
      node.data.childCounter = count;
      if ((count || !extOpts.hideZeros) && (!node.isExpanded() || !extOpts.hideExpanded)) {
        if (!$badge.length) {
          $badge = $("<span class='fancytree-childcounter'/>").appendTo($("span.fancytree-icon,span.fancytree-custom-icon", node.span));
        }
        $badge.text(count);
      } else {
        $badge.remove();
      }
      if (extOpts.deep && !node.isTopLevel() && !node.isRootNode()) {
        node.parent.updateCounters();
      }
    };

    // Finally, we can extend the widget API and create functions that are called
    // like so:
    //
    //     $("#tree").fancytree("widgetMethod1", "abc");

    $.ui.fancytree.prototype.widgetMethod1 = function (arg1) {
      var tree = this.tree;
      return arg1;
    };

    // Register a Fancytree extension
    // ------------------------------
    // A full blown extension, extension is available for all trees and can be
    // enabled like so (see also the [live demo](https://wwWendt.de/tech/fancytree/demo/sample-ext-childcounter.html)):
    //
    //    <script src="../src/jquery.fancytree.js"></script>
    //    <script src="../src/jquery.fancytree.childcounter.js"></script>
    //    ...
    //
    //     $("#tree").fancytree({
    //         extensions: ["childcounter"],
    //         childcounter: {
    //             hideExpanded: true
    //         },
    //         ...
    //     });
    //

    /* 'childcounter' extension */
    $.ui.fancytree.registerExtension({
      // Every extension must be registered by a unique name.
      name: "childcounter",
      // Version information should be compliant with [semver](http://semver.org)
      version: "2.38.2",
      // Extension specific options and their defaults.
      // This options will be available as `tree.options.childcounter.hideExpanded`

      options: {
        deep: true,
        hideZeros: true,
        hideExpanded: false
      },
      // Attributes other than `options` (or functions) can be defined here, and
      // will be added to the tree.ext.EXTNAME namespace, in this case `tree.ext.childcounter.foo`.
      // They can also be accessed as `this._local.foo` from within the extension
      // methods.
      foo: 42,
      // Local functions are prefixed with an underscore '_'.
      // Callable as `this._local._appendCounter()`.

      _appendCounter: function _appendCounter(bar) {
        var tree = this;
      },
      // **Override virtual methods for this extension.**
      //
      // Fancytree implements a number of 'hook methods', prefixed by 'node...' or 'tree...'.
      // with a `ctx` argument (see [EventData](https://wwWendt.de/tech/fancytree/doc/jsdoc/global.html#EventData)
      // for details) and an extended calling context:<br>
      // `this`       : the Fancytree instance<br>
      // `this._local`: the namespace that contains extension attributes and private methods (same as this.ext.EXTNAME)<br>
      // `this._super`: the virtual function that was overridden (member of previous extension or Fancytree)
      //
      // See also the [complete list of available hook functions](https://wwWendt.de/tech/fancytree/doc/jsdoc/Fancytree_Hooks.html).

      /* Init */
      // `treeInit` is triggered when a tree is initalized. We can set up classes or
      // bind event handlers here...
      treeInit: function treeInit(ctx) {
        var tree = this,
          // same as ctx.tree,
          opts = ctx.options,
          extOpts = ctx.options.childcounter;
        // Optionally check for dependencies with other extensions
        /* this._requireExtension("glyph", false, false); */
        // Call the base implementation
        this._superApply(arguments);
        // Add a class to the tree container
        this.$container.addClass("fancytree-ext-childcounter");
      },
      // Destroy this tree instance (we only call the default implementation, so
      // this method could as well be omitted).

      treeDestroy: function treeDestroy(ctx) {
        this._superApply(arguments);
      },
      // Overload the `renderTitle` hook, to append a counter badge
      nodeRenderTitle: function nodeRenderTitle(ctx, title) {
        var node = ctx.node,
          extOpts = ctx.options.childcounter,
          count = node.data.childCounter == null ? node.countChildren(extOpts.deep) : +node.data.childCounter;
        // Let the base implementation render the title
        // We use `_super()` instead of `_superApply()` here, since it is a little bit
        // more performant when called often
        this._super(ctx, title);
        // Append a counter badge
        if ((count || !extOpts.hideZeros) && (!node.isExpanded() || !extOpts.hideExpanded)) {
          $("span.fancytree-icon,span.fancytree-custom-icon", node.span).append($("<span class='fancytree-childcounter'/>").text(count));
        }
      },
      // Overload the `setExpanded` hook, so the counters are updated
      nodeSetExpanded: function nodeSetExpanded(ctx, flag, callOpts) {
        var tree = ctx.tree,
          node = ctx.node;
        // Let the base implementation expand/collapse the node, then redraw the title
        // after the animation has finished
        return this._superApply(arguments).always(function () {
          tree.nodeRenderTitle(ctx);
        });
      }

      // End of extension definition
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.clones.js' */ /*!
                                                *
                                                * jquery.fancytree.clones.js
                                                * Support faster lookup of nodes by key and shared ref-ids.
                                                * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                                *
                                                * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                                *
                                                * Released under the MIT license
                                                * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                                *
                                                * @version 2.38.2
                                                * @date 2022-06-30T18:24:06Z
                                                */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /*******************************************************************************
     * Private functions and variables
     */
    var _assert = $.ui.fancytree.assert;

    /* Return first occurrence of member from array. */
    function _removeArrayMember(arr, elem) {
      // TODO: use Array.indexOf for IE >= 9
      var i;
      for (i = arr.length - 1; i >= 0; i--) {
        if (arr[i] === elem) {
          arr.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    /**
     * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
     *
     * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
     * @see http://github.com/garycourt/murmurhash-js
     * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
     * @see http://sites.google.com/site/murmurhash/
     *
     * @param {string} key ASCII only
     * @param {boolean} [asString=false]
     * @param {number} seed Positive integer only
     * @return {number} 32-bit positive integer hash
     */
    function hashMurmur3(key, asString, seed) {
      /*eslint-disable no-bitwise */
      var h1b,
        k1,
        remainder = key.length & 3,
        bytes = key.length - remainder,
        h1 = seed,
        c1 = 0xcc9e2d51,
        c2 = 0x1b873593,
        i = 0;
      while (i < bytes) {
        k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(++i) & 0xff) << 8 | (key.charCodeAt(++i) & 0xff) << 16 | (key.charCodeAt(++i) & 0xff) << 24;
        ++i;
        k1 = (k1 & 0xffff) * c1 + (((k1 >>> 16) * c1 & 0xffff) << 16) & 0xffffffff;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = (k1 & 0xffff) * c2 + (((k1 >>> 16) * c2 & 0xffff) << 16) & 0xffffffff;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1b = (h1 & 0xffff) * 5 + (((h1 >>> 16) * 5 & 0xffff) << 16) & 0xffffffff;
        h1 = (h1b & 0xffff) + 0x6b64 + (((h1b >>> 16) + 0xe654 & 0xffff) << 16);
      }
      k1 = 0;
      switch (remainder) {
        case 3:
          k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
        // fall through
        case 2:
          k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
        // fall through
        case 1:
          k1 ^= key.charCodeAt(i) & 0xff;
          k1 = (k1 & 0xffff) * c1 + (((k1 >>> 16) * c1 & 0xffff) << 16) & 0xffffffff;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = (k1 & 0xffff) * c2 + (((k1 >>> 16) * c2 & 0xffff) << 16) & 0xffffffff;
          h1 ^= k1;
      }
      h1 ^= key.length;
      h1 ^= h1 >>> 16;
      h1 = (h1 & 0xffff) * 0x85ebca6b + (((h1 >>> 16) * 0x85ebca6b & 0xffff) << 16) & 0xffffffff;
      h1 ^= h1 >>> 13;
      h1 = (h1 & 0xffff) * 0xc2b2ae35 + (((h1 >>> 16) * 0xc2b2ae35 & 0xffff) << 16) & 0xffffffff;
      h1 ^= h1 >>> 16;
      if (asString) {
        // Convert to 8 digit hex string
        return ("0000000" + (h1 >>> 0).toString(16)).substr(-8);
      }
      return h1 >>> 0;
      /*eslint-enable no-bitwise */
    }

    /*
     * Return a unique key for node by calculating the hash of the parents refKey-list.
     */
    function calcUniqueKey(node) {
      var key,
        h1,
        path = $.map(node.getParentList(false, true), function (e) {
          return e.refKey || e.key;
        });
      path = path.join("/");
      // 32-bit has a high probability of collisions, so we pump up to 64-bit
      // https://security.stackexchange.com/q/209882/207588

      h1 = hashMurmur3(path, true);
      key = "id_" + h1 + hashMurmur3(h1 + path, true);
      return key;
    }

    /**
     * [ext-clones] Return a list of clone-nodes (i.e. same refKey) or null.
     * @param {boolean} [includeSelf=false]
     * @returns {FancytreeNode[] | null}
     *
     * @alias FancytreeNode#getCloneList
     * @requires jquery.fancytree.clones.js
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.getCloneList = function (includeSelf) {
      var key,
        tree = this.tree,
        refList = tree.refMap[this.refKey] || null,
        keyMap = tree.keyMap;
      if (refList) {
        key = this.key;
        // Convert key list to node list
        if (includeSelf) {
          refList = $.map(refList, function (val) {
            return keyMap[val];
          });
        } else {
          refList = $.map(refList, function (val) {
            return val === key ? null : keyMap[val];
          });
          if (refList.length < 1) {
            refList = null;
          }
        }
      }
      return refList;
    };

    /**
     * [ext-clones] Return true if this node has at least another clone with same refKey.
     * @returns {boolean}
     *
     * @alias FancytreeNode#isClone
     * @requires jquery.fancytree.clones.js
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.isClone = function () {
      var refKey = this.refKey || null,
        refList = refKey && this.tree.refMap[refKey] || null;
      return !!(refList && refList.length > 1);
    };

    /**
     * [ext-clones] Update key and/or refKey for an existing node.
     * @param {string} key
     * @param {string} refKey
     * @returns {boolean}
     *
     * @alias FancytreeNode#reRegister
     * @requires jquery.fancytree.clones.js
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.reRegister = function (key, refKey) {
      key = key == null ? null : "" + key;
      refKey = refKey == null ? null : "" + refKey;
      // this.debug("reRegister", key, refKey);

      var tree = this.tree,
        prevKey = this.key,
        prevRefKey = this.refKey,
        keyMap = tree.keyMap,
        refMap = tree.refMap,
        refList = refMap[prevRefKey] || null,
        //		curCloneKeys = refList ? node.getCloneList(true),
        modified = false;

      // Key has changed: update all references
      if (key != null && key !== this.key) {
        if (keyMap[key]) {
          $.error("[ext-clones] reRegister(" + key + "): already exists: " + this);
        }
        // Update keyMap
        delete keyMap[prevKey];
        keyMap[key] = this;
        // Update refMap
        if (refList) {
          refMap[prevRefKey] = $.map(refList, function (e) {
            return e === prevKey ? key : e;
          });
        }
        this.key = key;
        modified = true;
      }

      // refKey has changed
      if (refKey != null && refKey !== this.refKey) {
        // Remove previous refKeys
        if (refList) {
          if (refList.length === 1) {
            delete refMap[prevRefKey];
          } else {
            refMap[prevRefKey] = $.map(refList, function (e) {
              return e === prevKey ? null : e;
            });
          }
        }
        // Add refKey
        if (refMap[refKey]) {
          refMap[refKey].append(key);
        } else {
          refMap[refKey] = [this.key];
        }
        this.refKey = refKey;
        modified = true;
      }
      return modified;
    };

    /**
     * [ext-clones] Define a refKey for an existing node.
     * @param {string} refKey
     * @returns {boolean}
     *
     * @alias FancytreeNode#setRefKey
     * @requires jquery.fancytree.clones.js
     * @since 2.16
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.setRefKey = function (refKey) {
      return this.reRegister(null, refKey);
    };

    /**
     * [ext-clones] Return all nodes with a given refKey (null if not found).
     * @param {string} refKey
     * @param {FancytreeNode} [rootNode] optionally restrict results to descendants of this node
     * @returns {FancytreeNode[] | null}
     * @alias Fancytree#getNodesByRef
     * @requires jquery.fancytree.clones.js
     */
    $.ui.fancytree._FancytreeClass.prototype.getNodesByRef = function (refKey, rootNode) {
      var keyMap = this.keyMap,
        refList = this.refMap[refKey] || null;
      if (refList) {
        // Convert key list to node list
        if (rootNode) {
          refList = $.map(refList, function (val) {
            var node = keyMap[val];
            return node.isDescendantOf(rootNode) ? node : null;
          });
        } else {
          refList = $.map(refList, function (val) {
            return keyMap[val];
          });
        }
        if (refList.length < 1) {
          refList = null;
        }
      }
      return refList;
    };

    /**
     * [ext-clones] Replace a refKey with a new one.
     * @param {string} oldRefKey
     * @param {string} newRefKey
     * @alias Fancytree#changeRefKey
     * @requires jquery.fancytree.clones.js
     */
    $.ui.fancytree._FancytreeClass.prototype.changeRefKey = function (oldRefKey, newRefKey) {
      var i,
        node,
        keyMap = this.keyMap,
        refList = this.refMap[oldRefKey] || null;
      if (refList) {
        for (i = 0; i < refList.length; i++) {
          node = keyMap[refList[i]];
          node.refKey = newRefKey;
        }
        delete this.refMap[oldRefKey];
        this.refMap[newRefKey] = refList;
      }
    };

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "clones",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        highlightActiveClones: true,
        // set 'fancytree-active-clone' on active clones and all peers
        highlightClones: false // set 'fancytree-clone' class on any node that has at least one clone
      },

      treeCreate: function treeCreate(ctx) {
        this._superApply(arguments);
        ctx.tree.refMap = {};
        ctx.tree.keyMap = {};
      },
      treeInit: function treeInit(ctx) {
        this.$container.addClass("fancytree-ext-clones");
        _assert(ctx.options.defaultKey == null);
        // Generate unique / reproducible default keys
        ctx.options.defaultKey = function (node) {
          return calcUniqueKey(node);
        };
        // The default implementation loads initial data
        this._superApply(arguments);
      },
      treeClear: function treeClear(ctx) {
        ctx.tree.refMap = {};
        ctx.tree.keyMap = {};
        return this._superApply(arguments);
      },
      treeRegisterNode: function treeRegisterNode(ctx, add, node) {
        var refList,
          len,
          tree = ctx.tree,
          keyMap = tree.keyMap,
          refMap = tree.refMap,
          key = node.key,
          refKey = node && node.refKey != null ? "" + node.refKey : null;

        //		ctx.tree.debug("clones.treeRegisterNode", add, node);

        if (node.isStatusNode()) {
          return this._super(ctx, add, node);
        }
        if (add) {
          if (keyMap[node.key] != null) {
            var other = keyMap[node.key],
              msg = "clones.treeRegisterNode: duplicate key '" + node.key + "': /" + node.getPath(true) + " => " + other.getPath(true);
            // Sometimes this exception is not visible in the console,
            // so we also write it:
            tree.error(msg);
            $.error(msg);
          }
          keyMap[key] = node;
          if (refKey) {
            refList = refMap[refKey];
            if (refList) {
              refList.push(key);
              if (refList.length === 2 && ctx.options.clones.highlightClones) {
                // Mark peer node, if it just became a clone (no need to
                // mark current node, since it will be rendered later anyway)
                keyMap[refList[0]].renderStatus();
              }
            } else {
              refMap[refKey] = [key];
            }
            // node.debug("clones.treeRegisterNode: add clone =>", refMap[refKey]);
          }
        } else {
          if (keyMap[key] == null) {
            $.error("clones.treeRegisterNode: node.key not registered: " + node.key);
          }
          delete keyMap[key];
          if (refKey) {
            refList = refMap[refKey];
            // node.debug("clones.treeRegisterNode: remove clone BEFORE =>", refMap[refKey]);
            if (refList) {
              len = refList.length;
              if (len <= 1) {
                _assert(len === 1);
                _assert(refList[0] === key);
                delete refMap[refKey];
              } else {
                _removeArrayMember(refList, key);
                // Unmark peer node, if this was the only clone
                if (len === 2 && ctx.options.clones.highlightClones) {
                  //							node.debug("clones.treeRegisterNode: last =>", node.getCloneList());
                  keyMap[refList[0]].renderStatus();
                }
              }
              // node.debug("clones.treeRegisterNode: remove clone =>", refMap[refKey]);
            }
          }
        }

        return this._super(ctx, add, node);
      },
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        var $span,
          res,
          node = ctx.node;
        res = this._super(ctx);
        if (ctx.options.clones.highlightClones) {
          $span = $(node[ctx.tree.statusClassPropName]);
          // Only if span already exists
          if ($span.length && node.isClone()) {
            //				node.debug("clones.nodeRenderStatus: ", ctx.options.clones.highlightClones);
            $span.addClass("fancytree-clone");
          }
        }
        return res;
      },
      nodeSetActive: function nodeSetActive(ctx, flag, callOpts) {
        var res,
          scpn = ctx.tree.statusClassPropName,
          node = ctx.node;
        res = this._superApply(arguments);
        if (ctx.options.clones.highlightActiveClones && node.isClone()) {
          $.each(node.getCloneList(true), function (idx, n) {
            // n.debug("clones.nodeSetActive: ", flag !== false);
            $(n[scpn]).toggleClass("fancytree-active-clone", flag !== false);
          });
        }
        return res;
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.dnd5.js' */ /*!
                                              * jquery.fancytree.dnd5.js
                                              *
                                              * Drag-and-drop support (native HTML5).
                                              * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                              *
                                              * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                              *
                                              * Released under the MIT license
                                              * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                              *
                                              * @version 2.38.2
                                              * @date 2022-06-30T18:24:06Z
                                              */

  /*
   #TODO
  	Compatiblity when dragging between *separate* windows:
  
  		   Drag from Chrome   Edge    FF    IE11    Safari
  	  To Chrome      ok       ok      ok    NO      ?
  		 Edge        ok       ok      ok    NO      ?
  		 FF          ok       ok      ok    NO      ?
  		 IE 11       ok       ok      ok    ok      ?
  		 Safari      ?        ?       ?     ?       ok
  
   */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /******************************************************************************
     * Private functions and variables
     */
    var FT = $.ui.fancytree,
      isMac = /Mac/.test(navigator.platform),
      classDragSource = "fancytree-drag-source",
      classDragRemove = "fancytree-drag-remove",
      classDropAccept = "fancytree-drop-accept",
      classDropAfter = "fancytree-drop-after",
      classDropBefore = "fancytree-drop-before",
      classDropOver = "fancytree-drop-over",
      classDropReject = "fancytree-drop-reject",
      classDropTarget = "fancytree-drop-target",
      nodeMimeType = "application/x-fancytree-node",
      $dropMarker = null,
      $dragImage,
      $extraHelper,
      SOURCE_NODE = null,
      SOURCE_NODE_LIST = null,
      $sourceList = null,
      DRAG_ENTER_RESPONSE = null,
      // SESSION_DATA = null, // plain object passed to events as `data`
      SUGGESTED_DROP_EFFECT = null,
      REQUESTED_DROP_EFFECT = null,
      REQUESTED_EFFECT_ALLOWED = null,
      LAST_HIT_MODE = null,
      DRAG_OVER_STAMP = null; // Time when a node entered the 'over' hitmode

    /* */
    function _clearGlobals() {
      DRAG_ENTER_RESPONSE = null;
      DRAG_OVER_STAMP = null;
      REQUESTED_DROP_EFFECT = null;
      REQUESTED_EFFECT_ALLOWED = null;
      SUGGESTED_DROP_EFFECT = null;
      SOURCE_NODE = null;
      SOURCE_NODE_LIST = null;
      if ($sourceList) {
        $sourceList.removeClass(classDragSource + " " + classDragRemove);
      }
      $sourceList = null;
      if ($dropMarker) {
        $dropMarker.hide();
      }
      // Take this badge off of me - I can't use it anymore:
      if ($extraHelper) {
        $extraHelper.remove();
        $extraHelper = null;
      }
    }

    /* Convert number to string and prepend +/-; return empty string for 0.*/
    function offsetString(n) {
      // eslint-disable-next-line no-nested-ternary
      return n === 0 ? "" : n > 0 ? "+" + n : "" + n;
    }

    /* Convert a dragEnter() or dragOver() response to a canonical form.
     * Return false or plain object
     * @param {string|object|boolean} r
     * @return {object|false}
     */
    function normalizeDragEnterResponse(r) {
      var res;
      if (!r) {
        return false;
      }
      if ($.isPlainObject(r)) {
        res = {
          over: !!r.over,
          before: !!r.before,
          after: !!r.after
        };
      } else if (Array.isArray(r)) {
        res = {
          over: $.inArray("over", r) >= 0,
          before: $.inArray("before", r) >= 0,
          after: $.inArray("after", r) >= 0
        };
      } else {
        res = {
          over: r === true || r === "over",
          before: r === true || r === "before",
          after: r === true || r === "after"
        };
      }
      if (Object.keys(res).length === 0) {
        return false;
      }
      // if( Object.keys(res).length === 1 ) {
      // 	res.unique = res[0];
      // }
      return res;
    }

    /* Convert a dataTransfer.effectAllowed to a canonical form.
     * Return false or plain object
     * @param {string|boolean} r
     * @return {object|false}
     */
    // function normalizeEffectAllowed(r) {
    // 	if (!r || r === "none") {
    // 		return false;
    // 	}
    // 	var all = r === "all",
    // 		res = {
    // 			copy: all || /copy/i.test(r),
    // 			link: all || /link/i.test(r),
    // 			move: all || /move/i.test(r),
    // 		};

    // 	return res;
    // }

    /* Implement auto scrolling when drag cursor is in top/bottom area of scroll parent. */
    function autoScroll(tree, event) {
      var spOfs,
        scrollTop,
        delta,
        dndOpts = tree.options.dnd5,
        sp = tree.$scrollParent[0],
        sensitivity = dndOpts.scrollSensitivity,
        speed = dndOpts.scrollSpeed,
        scrolled = 0;
      if (sp !== document && sp.tagName !== "HTML") {
        spOfs = tree.$scrollParent.offset();
        scrollTop = sp.scrollTop;
        if (spOfs.top + sp.offsetHeight - event.pageY < sensitivity) {
          delta = sp.scrollHeight - tree.$scrollParent.innerHeight() - scrollTop;
          // console.log ("sp.offsetHeight: " + sp.offsetHeight
          // 	+ ", spOfs.top: " + spOfs.top
          // 	+ ", scrollTop: " + scrollTop
          // 	+ ", innerHeight: " + tree.$scrollParent.innerHeight()
          // 	+ ", scrollHeight: " + sp.scrollHeight
          // 	+ ", delta: " + delta
          // 	);
          if (delta > 0) {
            sp.scrollTop = scrolled = scrollTop + speed;
          }
        } else if (scrollTop > 0 && event.pageY - spOfs.top < sensitivity) {
          sp.scrollTop = scrolled = scrollTop - speed;
        }
      } else {
        scrollTop = $(document).scrollTop();
        if (scrollTop > 0 && event.pageY - scrollTop < sensitivity) {
          scrolled = scrollTop - speed;
          $(document).scrollTop(scrolled);
        } else if ($(window).height() - (event.pageY - scrollTop) < sensitivity) {
          scrolled = scrollTop + speed;
          $(document).scrollTop(scrolled);
        }
      }
      if (scrolled) {
        tree.debug("autoScroll: " + scrolled + "px");
      }
      return scrolled;
    }

    /* Guess dropEffect from modifier keys.
     * Using rules suggested here:
     *     https://ux.stackexchange.com/a/83769
     * @returns
     *     'copy', 'link', 'move', or 'none'
     */
    function evalEffectModifiers(tree, event, effectDefault) {
      var res = effectDefault;
      if (isMac) {
        if (event.metaKey && event.altKey) {
          // Mac: [Control] + [Option]
          res = "link";
        } else if (event.ctrlKey) {
          // Chrome on Mac: [Control]
          res = "link";
        } else if (event.metaKey) {
          // Mac: [Command]
          res = "move";
        } else if (event.altKey) {
          // Mac: [Option]
          res = "copy";
        }
      } else {
        if (event.ctrlKey) {
          // Windows: [Ctrl]
          res = "copy";
        } else if (event.shiftKey) {
          // Windows: [Shift]
          res = "move";
        } else if (event.altKey) {
          // Windows: [Alt]
          res = "link";
        }
      }
      if (res !== SUGGESTED_DROP_EFFECT) {
        tree.info("evalEffectModifiers: " + event.type + " - evalEffectModifiers(): " + SUGGESTED_DROP_EFFECT + " -> " + res);
      }
      SUGGESTED_DROP_EFFECT = res;
      // tree.debug("evalEffectModifiers: " + res);
      return res;
    }
    /*
     * Check if the previous callback (dragEnter, dragOver, ...) has changed
     * the `data` object and apply those settings.
     *
     * Safari:
     *     It seems that `dataTransfer.dropEffect` can only be set on dragStart, and will remain
     *     even if the cursor changes when [Alt] or [Ctrl] are pressed (?)
     * Using rules suggested here:
     *     https://ux.stackexchange.com/a/83769
     * @returns
     *     'copy', 'link', 'move', or 'none'
     */
    function prepareDropEffectCallback(event, data) {
      var tree = data.tree,
        dataTransfer = data.dataTransfer;
      if (event.type === "dragstart") {
        data.effectAllowed = tree.options.dnd5.effectAllowed;
        data.dropEffect = tree.options.dnd5.dropEffectDefault;
      } else {
        data.effectAllowed = REQUESTED_EFFECT_ALLOWED;
        data.dropEffect = REQUESTED_DROP_EFFECT;
      }
      data.dropEffectSuggested = evalEffectModifiers(tree, event, tree.options.dnd5.dropEffectDefault);
      data.isMove = data.dropEffect === "move";
      data.files = dataTransfer.files || [];

      // if (REQUESTED_EFFECT_ALLOWED !== dataTransfer.effectAllowed) {
      // 	tree.warn(
      // 		"prepareDropEffectCallback(" +
      // 			event.type +
      // 			"): dataTransfer.effectAllowed changed from " +
      // 			REQUESTED_EFFECT_ALLOWED +
      // 			" -> " +
      // 			dataTransfer.effectAllowed
      // 	);
      // }
      // if (REQUESTED_DROP_EFFECT !== dataTransfer.dropEffect) {
      // 	tree.warn(
      // 		"prepareDropEffectCallback(" +
      // 			event.type +
      // 			"): dataTransfer.dropEffect changed from requested " +
      // 			REQUESTED_DROP_EFFECT +
      // 			" to " +
      // 			dataTransfer.dropEffect
      // 	);
      // }
    }

    function applyDropEffectCallback(event, data, allowDrop) {
      var tree = data.tree,
        dataTransfer = data.dataTransfer;
      if (event.type !== "dragstart" && REQUESTED_EFFECT_ALLOWED !== data.effectAllowed) {
        tree.warn("effectAllowed should only be changed in dragstart event: " + event.type + ": data.effectAllowed changed from " + REQUESTED_EFFECT_ALLOWED + " -> " + data.effectAllowed);
      }
      if (allowDrop === false) {
        tree.info("applyDropEffectCallback: allowDrop === false");
        data.effectAllowed = "none";
        data.dropEffect = "none";
      }
      // if (REQUESTED_DROP_EFFECT !== data.dropEffect) {
      // 	tree.debug(
      // 		"applyDropEffectCallback(" +
      // 			event.type +
      // 			"): data.dropEffect changed from previous " +
      // 			REQUESTED_DROP_EFFECT +
      // 			" to " +
      // 			data.dropEffect
      // 	);
      // }

      data.isMove = data.dropEffect === "move";
      // data.isMove = data.dropEffectSuggested === "move";

      // `effectAllowed` must only be defined in dragstart event, so we
      // store it in a global variable for reference
      if (event.type === "dragstart") {
        REQUESTED_EFFECT_ALLOWED = data.effectAllowed;
        REQUESTED_DROP_EFFECT = data.dropEffect;
      }

      // if (REQUESTED_DROP_EFFECT !== dataTransfer.dropEffect) {
      // 	data.tree.info(
      // 		"applyDropEffectCallback(" +
      // 			event.type +
      // 			"): dataTransfer.dropEffect changed from " +
      // 			REQUESTED_DROP_EFFECT +
      // 			" -> " +
      // 			dataTransfer.dropEffect
      // 	);
      // }
      dataTransfer.effectAllowed = REQUESTED_EFFECT_ALLOWED;
      dataTransfer.dropEffect = REQUESTED_DROP_EFFECT;

      // tree.debug(
      // 	"applyDropEffectCallback(" +
      // 		event.type +
      // 		"): set " +
      // 		dataTransfer.dropEffect +
      // 		"/" +
      // 		dataTransfer.effectAllowed
      // );
      // if (REQUESTED_DROP_EFFECT !== dataTransfer.dropEffect) {
      // 	data.tree.warn(
      // 		"applyDropEffectCallback(" +
      // 			event.type +
      // 			"): could not set dataTransfer.dropEffect to " +
      // 			REQUESTED_DROP_EFFECT +
      // 			": got " +
      // 			dataTransfer.dropEffect
      // 	);
      // }
      return REQUESTED_DROP_EFFECT;
    }

    /* Handle dragover event (fired every x ms) on valid drop targets.
     *
     * - Auto-scroll when cursor is in border regions
     * - Apply restrictioan like 'preventVoidMoves'
     * - Calculate hit mode
     * - Calculate drop effect
     * - Trigger dragOver() callback to let user modify hit mode and drop effect
     * - Adjust the drop marker accordingly
     *
     * @returns hitMode
     */
    function handleDragOver(event, data) {
      // Implement auto-scrolling
      if (data.options.dnd5.scroll) {
        autoScroll(data.tree, event);
      }
      // Bail out with previous response if we get an invalid dragover
      if (!data.node) {
        data.tree.warn("Ignored dragover for non-node"); //, event, data);
        return LAST_HIT_MODE;
      }
      var markerOffsetX,
        nodeOfs,
        pos,
        relPosY,
        hitMode = null,
        tree = data.tree,
        options = tree.options,
        dndOpts = options.dnd5,
        targetNode = data.node,
        sourceNode = data.otherNode,
        markerAt = "center",
        $target = $(targetNode.span),
        $targetTitle = $target.find("span.fancytree-title");
      if (DRAG_ENTER_RESPONSE === false) {
        tree.debug("Ignored dragover, since dragenter returned false.");
        return false;
      } else if (typeof DRAG_ENTER_RESPONSE === "string") {
        $.error("assert failed: dragenter returned string");
      }
      // Calculate hitMode from relative cursor position.
      nodeOfs = $target.offset();
      relPosY = (event.pageY - nodeOfs.top) / $target.height();
      if (event.pageY === undefined) {
        tree.warn("event.pageY is undefined: see issue #1013.");
      }
      if (DRAG_ENTER_RESPONSE.after && relPosY > 0.75) {
        hitMode = "after";
      } else if (!DRAG_ENTER_RESPONSE.over && DRAG_ENTER_RESPONSE.after && relPosY > 0.5) {
        hitMode = "after";
      } else if (DRAG_ENTER_RESPONSE.before && relPosY <= 0.25) {
        hitMode = "before";
      } else if (!DRAG_ENTER_RESPONSE.over && DRAG_ENTER_RESPONSE.before && relPosY <= 0.5) {
        hitMode = "before";
      } else if (DRAG_ENTER_RESPONSE.over) {
        hitMode = "over";
      }
      // Prevent no-ops like 'before source node'
      // TODO: these are no-ops when moving nodes, but not in copy mode
      if (dndOpts.preventVoidMoves && data.dropEffect === "move") {
        if (targetNode === sourceNode) {
          targetNode.debug("Drop over source node prevented.");
          hitMode = null;
        } else if (hitMode === "before" && sourceNode && targetNode === sourceNode.getNextSibling()) {
          targetNode.debug("Drop after source node prevented.");
          hitMode = null;
        } else if (hitMode === "after" && sourceNode && targetNode === sourceNode.getPrevSibling()) {
          targetNode.debug("Drop before source node prevented.");
          hitMode = null;
        } else if (hitMode === "over" && sourceNode && sourceNode.parent === targetNode && sourceNode.isLastSibling()) {
          targetNode.debug("Drop last child over own parent prevented.");
          hitMode = null;
        }
      }
      // Let callback modify the calculated hitMode
      data.hitMode = hitMode;
      if (hitMode && dndOpts.dragOver) {
        prepareDropEffectCallback(event, data);
        dndOpts.dragOver(targetNode, data);
        var allowDrop = !!hitMode;
        applyDropEffectCallback(event, data, allowDrop);
        hitMode = data.hitMode;
      }
      LAST_HIT_MODE = hitMode;
      //
      if (hitMode === "after" || hitMode === "before" || hitMode === "over") {
        markerOffsetX = dndOpts.dropMarkerOffsetX || 0;
        switch (hitMode) {
          case "before":
            markerAt = "top";
            markerOffsetX += dndOpts.dropMarkerInsertOffsetX || 0;
            break;
          case "after":
            markerAt = "bottom";
            markerOffsetX += dndOpts.dropMarkerInsertOffsetX || 0;
            break;
        }
        pos = {
          my: "left" + offsetString(markerOffsetX) + " center",
          at: "left " + markerAt,
          of: $targetTitle
        };
        if (options.rtl) {
          pos.my = "right" + offsetString(-markerOffsetX) + " center";
          pos.at = "right " + markerAt;
          // console.log("rtl", pos);
        }

        $dropMarker.toggleClass(classDropAfter, hitMode === "after").toggleClass(classDropOver, hitMode === "over").toggleClass(classDropBefore, hitMode === "before").show().position(FT.fixPositionOptions(pos));
      } else {
        $dropMarker.hide();
        // console.log("hide dropmarker")
      }

      $(targetNode.span).toggleClass(classDropTarget, hitMode === "after" || hitMode === "before" || hitMode === "over").toggleClass(classDropAfter, hitMode === "after").toggleClass(classDropBefore, hitMode === "before").toggleClass(classDropAccept, hitMode === "over").toggleClass(classDropReject, hitMode === false);
      return hitMode;
    }

    /*
     * Handle dragstart drag dragend events on the container
     */
    function onDragEvent(event) {
      var json,
        tree = this,
        dndOpts = tree.options.dnd5,
        node = FT.getNode(event),
        dataTransfer = event.dataTransfer || event.originalEvent.dataTransfer,
        data = {
          tree: tree,
          node: node,
          options: tree.options,
          originalEvent: event.originalEvent,
          widget: tree.widget,
          dataTransfer: dataTransfer,
          useDefaultImage: true,
          dropEffect: undefined,
          dropEffectSuggested: undefined,
          effectAllowed: undefined,
          // set by dragstart
          files: undefined,
          // only for drop events
          isCancelled: undefined,
          // set by dragend
          isMove: undefined
        };
      switch (event.type) {
        case "dragstart":
          if (!node) {
            tree.info("Ignored dragstart on a non-node.");
            return false;
          }
          // Store current source node in different formats
          SOURCE_NODE = node;

          // Also optionally store selected nodes
          if (dndOpts.multiSource === false) {
            SOURCE_NODE_LIST = [node];
          } else if (dndOpts.multiSource === true) {
            if (node.isSelected()) {
              SOURCE_NODE_LIST = tree.getSelectedNodes();
            } else {
              SOURCE_NODE_LIST = [node];
            }
          } else {
            SOURCE_NODE_LIST = dndOpts.multiSource(node, data);
          }
          // Cache as array of jQuery objects for faster access:
          $sourceList = $($.map(SOURCE_NODE_LIST, function (n) {
            return n.span;
          }));
          // Set visual feedback
          $sourceList.addClass(classDragSource);

          // Set payload
          // Note:
          // Transfer data is only accessible on dragstart and drop!
          // For all other events the formats and kinds in the drag
          // data store list of items representing dragged data can be
          // enumerated, but the data itself is unavailable and no new
          // data can be added.
          var nodeData = node.toDict(true, dndOpts.sourceCopyHook);
          nodeData.treeId = node.tree._id;
          json = JSON.stringify(nodeData);
          try {
            dataTransfer.setData(nodeMimeType, json);
            dataTransfer.setData("text/html", $(node.span).html());
            dataTransfer.setData("text/plain", node.title);
          } catch (ex) {
            // IE only accepts 'text' type
            tree.warn("Could not set data (IE only accepts 'text') - " + ex);
          }
          // We always need to set the 'text' type if we want to drag
          // Because IE 11 only accepts this single type.
          // If we pass JSON here, IE can can access all node properties,
          // even when the source lives in another window. (D'n'd inside
          // the same window will always work.)
          // The drawback is, that in this case ALL browsers will see
          // the JSON representation as 'text', so dragging
          // to a text field will insert the JSON string instead of
          // the node title.
          if (dndOpts.setTextTypeJson) {
            dataTransfer.setData("text", json);
          } else {
            dataTransfer.setData("text", node.title);
          }

          // Set the allowed drag modes (combinations of move, copy, and link)
          // (effectAllowed can only be set in the dragstart event.)
          // This can be overridden in the dragStart() callback
          prepareDropEffectCallback(event, data);

          // Let user cancel or modify above settings
          // Realize potential changes by previous callback
          if (dndOpts.dragStart(node, data) === false) {
            // Cancel dragging
            // dataTransfer.dropEffect = "none";
            _clearGlobals();
            return false;
          }
          applyDropEffectCallback(event, data);

          // Unless user set `data.useDefaultImage` to false in dragStart,
          // generata a default drag image now:
          $extraHelper = null;
          if (data.useDefaultImage) {
            // Set the title as drag image (otherwise it would contain the expander)
            $dragImage = $(node.span).find(".fancytree-title");
            if (SOURCE_NODE_LIST && SOURCE_NODE_LIST.length > 1) {
              // Add a counter badge to node title if dragging more than one node.
              // We want this, because the element that is used as drag image
              // must be *visible* in the DOM, so we cannot create some hidden
              // custom markup.
              // See https://kryogenix.org/code/browser/custom-drag-image.html
              // Also, since IE 11 and Edge don't support setDragImage() alltogether,
              // it gives som feedback to the user.
              // The badge will be removed later on drag end.
              $extraHelper = $("<span class='fancytree-childcounter'/>").text("+" + (SOURCE_NODE_LIST.length - 1)).appendTo($dragImage);
            }
            if (dataTransfer.setDragImage) {
              // IE 11 and Edge do not support this
              dataTransfer.setDragImage($dragImage[0], -10, -10);
            }
          }
          return true;
        case "drag":
          // Called every few milliseconds (no matter if the
          // cursor is over a valid drop target)
          // data.tree.info("drag", SOURCE_NODE)
          prepareDropEffectCallback(event, data);
          dndOpts.dragDrag(node, data);
          applyDropEffectCallback(event, data);
          $sourceList.toggleClass(classDragRemove, data.isMove);
          break;
        case "dragend":
          // Called at the end of a d'n'd process (after drop)
          // Note caveat: If drop removed the dragged source element,
          // we may not get this event, since the target does not exist
          // anymore
          prepareDropEffectCallback(event, data);
          _clearGlobals();
          data.isCancelled = !LAST_HIT_MODE;
          dndOpts.dragEnd(node, data, !LAST_HIT_MODE);
          // applyDropEffectCallback(event, data);
          break;
      }
    }
    /*
     * Handle dragenter dragover dragleave drop events on the container
     */
    function onDropEvent(event) {
      var json,
        allowAutoExpand,
        nodeData,
        isSourceFtNode,
        r,
        res,
        tree = this,
        dndOpts = tree.options.dnd5,
        allowDrop = null,
        node = FT.getNode(event),
        dataTransfer = event.dataTransfer || event.originalEvent.dataTransfer,
        data = {
          tree: tree,
          node: node,
          options: tree.options,
          originalEvent: event.originalEvent,
          widget: tree.widget,
          hitMode: DRAG_ENTER_RESPONSE,
          dataTransfer: dataTransfer,
          otherNode: SOURCE_NODE || null,
          otherNodeList: SOURCE_NODE_LIST || null,
          otherNodeData: null,
          // set by drop event
          useDefaultImage: true,
          dropEffect: undefined,
          dropEffectSuggested: undefined,
          effectAllowed: undefined,
          // set by dragstart
          files: null,
          // list of File objects (may be [])
          isCancelled: undefined,
          // set by drop event
          isMove: undefined
        };

      // data.isMove = dropEffect === "move";

      switch (event.type) {
        case "dragenter":
          // The dragenter event is fired when a dragged element or
          // text selection enters a valid drop target.

          DRAG_OVER_STAMP = null;
          if (!node) {
            // Sometimes we get dragenter for the container element
            tree.debug("Ignore non-node " + event.type + ": " + event.target.tagName + "." + event.target.className);
            DRAG_ENTER_RESPONSE = false;
            break;
          }
          $(node.span).addClass(classDropOver).removeClass(classDropAccept + " " + classDropReject);

          // Data is only readable in the dragstart and drop event,
          // but we can check for the type:
          isSourceFtNode = $.inArray(nodeMimeType, dataTransfer.types) >= 0;
          if (dndOpts.preventNonNodes && !isSourceFtNode) {
            node.debug("Reject dropping a non-node.");
            DRAG_ENTER_RESPONSE = false;
            break;
          } else if (dndOpts.preventForeignNodes && (!SOURCE_NODE || SOURCE_NODE.tree !== node.tree)) {
            node.debug("Reject dropping a foreign node.");
            DRAG_ENTER_RESPONSE = false;
            break;
          } else if (dndOpts.preventSameParent && data.otherNode && data.otherNode.tree === node.tree && node.parent === data.otherNode.parent) {
            node.debug("Reject dropping as sibling (same parent).");
            DRAG_ENTER_RESPONSE = false;
            break;
          } else if (dndOpts.preventRecursion && data.otherNode && data.otherNode.tree === node.tree && node.isDescendantOf(data.otherNode)) {
            node.debug("Reject dropping below own ancestor.");
            DRAG_ENTER_RESPONSE = false;
            break;
          } else if (dndOpts.preventLazyParents && !node.isLoaded()) {
            node.warn("Drop over unloaded target node prevented.");
            DRAG_ENTER_RESPONSE = false;
            break;
          }
          $dropMarker.show();

          // Call dragEnter() to figure out if (and where) dropping is allowed
          prepareDropEffectCallback(event, data);
          r = dndOpts.dragEnter(node, data);
          res = normalizeDragEnterResponse(r);
          // alert("res:" + JSON.stringify(res))
          DRAG_ENTER_RESPONSE = res;
          allowDrop = res && (res.over || res.before || res.after);
          applyDropEffectCallback(event, data, allowDrop);
          break;
        case "dragover":
          if (!node) {
            tree.debug("Ignore non-node " + event.type + ": " + event.target.tagName + "." + event.target.className);
            break;
          }
          // The dragover event is fired when an element or text
          // selection is being dragged over a valid drop target
          // (every few hundred milliseconds).
          // tree.debug(
          // 	event.type +
          // 		": dropEffect: " +
          // 		dataTransfer.dropEffect
          // );
          prepareDropEffectCallback(event, data);
          LAST_HIT_MODE = handleDragOver(event, data);

          // The flag controls the preventDefault() below:
          allowDrop = !!LAST_HIT_MODE;
          allowAutoExpand = LAST_HIT_MODE === "over" || LAST_HIT_MODE === false;
          if (allowAutoExpand && !node.expanded && node.hasChildren() !== false) {
            if (!DRAG_OVER_STAMP) {
              DRAG_OVER_STAMP = Date.now();
            } else if (dndOpts.autoExpandMS && Date.now() - DRAG_OVER_STAMP > dndOpts.autoExpandMS && !node.isLoading() && (!dndOpts.dragExpand || dndOpts.dragExpand(node, data) !== false)) {
              node.setExpanded();
            }
          } else {
            DRAG_OVER_STAMP = null;
          }
          break;
        case "dragleave":
          // NOTE: dragleave is fired AFTER the dragenter event of the
          // FOLLOWING element.
          if (!node) {
            tree.debug("Ignore non-node " + event.type + ": " + event.target.tagName + "." + event.target.className);
            break;
          }
          if (!$(node.span).hasClass(classDropOver)) {
            node.debug("Ignore dragleave (multi).");
            break;
          }
          $(node.span).removeClass(classDropOver + " " + classDropAccept + " " + classDropReject);
          node.scheduleAction("cancel");
          dndOpts.dragLeave(node, data);
          $dropMarker.hide();
          break;
        case "drop":
          // Data is only readable in the (dragstart and) drop event:

          if ($.inArray(nodeMimeType, dataTransfer.types) >= 0) {
            nodeData = dataTransfer.getData(nodeMimeType);
            tree.info(event.type + ": getData('application/x-fancytree-node'): '" + nodeData + "'");
          }
          if (!nodeData) {
            // 1. Source is not a Fancytree node, or
            // 2. If the FT mime type was set, but returns '', this
            //    is probably IE 11 (which only supports 'text')
            nodeData = dataTransfer.getData("text");
            tree.info(event.type + ": getData('text'): '" + nodeData + "'");
          }
          if (nodeData) {
            try {
              // 'text' type may contain JSON if IE is involved
              // and setTextTypeJson option was set
              json = JSON.parse(nodeData);
              if (json.title !== undefined) {
                data.otherNodeData = json;
              }
            } catch (ex) {
              // assume 'text' type contains plain text, so `otherNodeData`
              // should not be set
            }
          }
          tree.debug(event.type + ": nodeData: '" + nodeData + "', otherNodeData: ", data.otherNodeData);
          $(node.span).removeClass(classDropOver + " " + classDropAccept + " " + classDropReject);

          // Let user implement the actual drop operation
          data.hitMode = LAST_HIT_MODE;
          prepareDropEffectCallback(event, data, !LAST_HIT_MODE);
          data.isCancelled = !LAST_HIT_MODE;
          var orgSourceElem = SOURCE_NODE && SOURCE_NODE.span,
            orgSourceTree = SOURCE_NODE && SOURCE_NODE.tree;
          dndOpts.dragDrop(node, data);
          // applyDropEffectCallback(event, data);

          // Prevent browser's default drop handling, i.e. open as link, ...
          event.preventDefault();
          if (orgSourceElem && !document.body.contains(orgSourceElem)) {
            // The drop handler removed the original drag source from
            // the DOM, so the dragend event will probaly not fire.
            if (orgSourceTree === tree) {
              tree.debug("Drop handler removed source element: generating dragEnd.");
              dndOpts.dragEnd(SOURCE_NODE, data);
            } else {
              tree.warn("Drop handler removed source element: dragend event may be lost.");
            }
          }
          _clearGlobals();
          break;
      }
      // Dnd API madness: we must PREVENT default handling to enable dropping
      if (allowDrop) {
        event.preventDefault();
        return false;
      }
    }

    /** [ext-dnd5] Return a Fancytree instance, from element, index, event, or jQueryObject.
     *
     * @returns {FancytreeNode[]} List of nodes (empty if no drag operation)
     * @example
     * $.ui.fancytree.getDragNodeList();
     *
     * @alias Fancytree_Static#getDragNodeList
     * @requires jquery.fancytree.dnd5.js
     * @since 2.31
     */
    $.ui.fancytree.getDragNodeList = function () {
      return SOURCE_NODE_LIST || [];
    };

    /** [ext-dnd5] Return the FancytreeNode that is currently being dragged.
     *
     * If multiple nodes are dragged, only the first is returned.
     *
     * @returns {FancytreeNode | null} dragged nodes or null if no drag operation
     * @example
     * $.ui.fancytree.getDragNode();
     *
     * @alias Fancytree_Static#getDragNode
     * @requires jquery.fancytree.dnd5.js
     * @since 2.31
     */
    $.ui.fancytree.getDragNode = function () {
      return SOURCE_NODE;
    };

    /******************************************************************************
     *
     */

    $.ui.fancytree.registerExtension({
      name: "dnd5",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        autoExpandMS: 1500,
        // Expand nodes after n milliseconds of hovering
        dropMarkerInsertOffsetX: -16,
        // Additional offset for drop-marker with hitMode = "before"/"after"
        dropMarkerOffsetX: -24,
        // Absolute position offset for .fancytree-drop-marker relatively to ..fancytree-title (icon/img near a node accepting drop)
        // #1021 `document.body` is not available yet
        dropMarkerParent: "body",
        // Root Container used for drop marker (could be a shadow root)
        multiSource: false,
        // true: Drag multiple (i.e. selected) nodes. Also a callback() is allowed
        effectAllowed: "all",
        // Restrict the possible cursor shapes and modifier operations (can also be set in the dragStart event)
        // dropEffect: "auto", // 'copy'|'link'|'move'|'auto'(calculate from `effectAllowed`+modifier keys) or callback(node, data) that returns such string.
        dropEffectDefault: "move",
        // Default dropEffect ('copy', 'link', or 'move') when no modifier is pressed (overide in dragDrag, dragOver).
        preventForeignNodes: false,
        // Prevent dropping nodes from different Fancytrees
        preventLazyParents: true,
        // Prevent dropping items on unloaded lazy Fancytree nodes
        preventNonNodes: false,
        // Prevent dropping items other than Fancytree nodes
        preventRecursion: true,
        // Prevent dropping nodes on own descendants
        preventSameParent: false,
        // Prevent dropping nodes under same direct parent
        preventVoidMoves: true,
        // Prevent dropping nodes 'before self', etc.
        scroll: true,
        // Enable auto-scrolling while dragging
        scrollSensitivity: 20,
        // Active top/bottom margin in pixel
        scrollSpeed: 5,
        // Pixel per event
        setTextTypeJson: false,
        // Allow dragging of nodes to different IE windows
        sourceCopyHook: null,
        // Optional callback passed to `toDict` on dragStart @since 2.38
        // Events (drag support)
        dragStart: null,
        // Callback(sourceNode, data), return true, to enable dnd drag
        dragDrag: $.noop,
        // Callback(sourceNode, data)
        dragEnd: $.noop,
        // Callback(sourceNode, data)
        // Events (drop support)
        dragEnter: null,
        // Callback(targetNode, data), return true, to enable dnd drop
        dragOver: $.noop,
        // Callback(targetNode, data)
        dragExpand: $.noop,
        // Callback(targetNode, data), return false to prevent autoExpand
        dragDrop: $.noop,
        // Callback(targetNode, data)
        dragLeave: $.noop // Callback(targetNode, data)
      },

      treeInit: function treeInit(ctx) {
        var $temp,
          tree = ctx.tree,
          opts = ctx.options,
          glyph = opts.glyph || null,
          dndOpts = opts.dnd5;
        if ($.inArray("dnd", opts.extensions) >= 0) {
          $.error("Extensions 'dnd' and 'dnd5' are mutually exclusive.");
        }
        if (dndOpts.dragStop) {
          $.error("dragStop is not used by ext-dnd5. Use dragEnd instead.");
        }
        if (dndOpts.preventRecursiveMoves != null) {
          $.error("preventRecursiveMoves was renamed to preventRecursion.");
        }

        // Implement `opts.createNode` event to add the 'draggable' attribute
        // #680: this must happen before calling super.treeInit()
        if (dndOpts.dragStart) {
          FT.overrideMethod(ctx.options, "createNode", function (event, data) {
            // Default processing if any
            this._super.apply(this, arguments);
            if (data.node.span) {
              data.node.span.draggable = true;
            } else {
              data.node.warn("Cannot add `draggable`: no span tag");
            }
          });
        }
        this._superApply(arguments);
        this.$container.addClass("fancytree-ext-dnd5");

        // Store the current scroll parent, which may be the tree
        // container, any enclosing div, or the document.
        // #761: scrollParent() always needs a container child
        $temp = $("<span>").appendTo(this.$container);
        this.$scrollParent = $temp.scrollParent();
        $temp.remove();
        $dropMarker = $("#fancytree-drop-marker");
        if (!$dropMarker.length) {
          $dropMarker = $("<div id='fancytree-drop-marker'></div>").hide().css({
            "z-index": 1000,
            // Drop marker should not steal dragenter/dragover events:
            "pointer-events": "none"
          }).prependTo(dndOpts.dropMarkerParent);
          if (glyph) {
            FT.setSpanIcon($dropMarker[0], glyph.map._addClass, glyph.map.dropMarker);
          }
        }
        $dropMarker.toggleClass("fancytree-rtl", !!opts.rtl);

        // Enable drag support if dragStart() is specified:
        if (dndOpts.dragStart) {
          // Bind drag event handlers
          tree.$container.on("dragstart drag dragend", onDragEvent.bind(tree));
        }
        // Enable drop support if dragEnter() is specified:
        if (dndOpts.dragEnter) {
          // Bind drop event handlers
          tree.$container.on("dragenter dragover dragleave drop", onDropEvent.bind(tree));
        }
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.edit.js' */ /*!
                                              * jquery.fancytree.edit.js
                                              *
                                              * Make node titles editable.
                                              * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                              *
                                              * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                              *
                                              * Released under the MIT license
                                              * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                              *
                                              * @version 2.38.2
                                              * @date 2022-06-30T18:24:06Z
                                              */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /*******************************************************************************
     * Private functions and variables
     */
    var isMac = /Mac/.test(navigator.platform),
      escapeHtml = $.ui.fancytree.escapeHtml,
      trim = $.ui.fancytree.trim,
      unescapeHtml = $.ui.fancytree.unescapeHtml;

    /**
     * [ext-edit] Start inline editing of current node title.
     *
     * @alias FancytreeNode#editStart
     * @requires Fancytree
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.editStart = function () {
      var $input,
        node = this,
        tree = this.tree,
        local = tree.ext.edit,
        instOpts = tree.options.edit,
        $title = $(".fancytree-title", node.span),
        eventData = {
          node: node,
          tree: tree,
          options: tree.options,
          isNew: $(node[tree.statusClassPropName]).hasClass("fancytree-edit-new"),
          orgTitle: node.title,
          input: null,
          dirty: false
        };

      // beforeEdit may want to modify the title before editing
      if (instOpts.beforeEdit.call(node, {
        type: "beforeEdit"
      }, eventData) === false) {
        return false;
      }
      $.ui.fancytree.assert(!local.currentNode, "recursive edit");
      local.currentNode = this;
      local.eventData = eventData;

      // Disable standard Fancytree mouse- and key handling
      tree.widget._unbind();
      local.lastDraggableAttrValue = node.span.draggable;
      if (local.lastDraggableAttrValue) {
        node.span.draggable = false;
      }

      // #116: ext-dnd prevents the blur event, so we have to catch outer clicks
      $(document).on("mousedown.fancytree-edit", function (event) {
        if (!$(event.target).hasClass("fancytree-edit-input")) {
          node.editEnd(true, event);
        }
      });

      // Replace node with <input>
      $input = $("<input />", {
        "class": "fancytree-edit-input",
        type: "text",
        value: tree.options.escapeTitles ? eventData.orgTitle : unescapeHtml(eventData.orgTitle)
      });
      local.eventData.input = $input;
      if (instOpts.adjustWidthOfs != null) {
        $input.width($title.width() + instOpts.adjustWidthOfs);
      }
      if (instOpts.inputCss != null) {
        $input.css(instOpts.inputCss);
      }
      $title.html($input);

      // Focus <input> and bind keyboard handler
      $input.focus().change(function (event) {
        $input.addClass("fancytree-edit-dirty");
      }).on("keydown", function (event) {
        switch (event.which) {
          case $.ui.keyCode.ESCAPE:
            node.editEnd(false, event);
            break;
          case $.ui.keyCode.ENTER:
            node.editEnd(true, event);
            return false;
          // so we don't start editmode on Mac
        }

        event.stopPropagation();
      }).blur(function (event) {
        return node.editEnd(true, event);
      });
      instOpts.edit.call(node, {
        type: "edit"
      }, eventData);
    };

    /**
     * [ext-edit] Stop inline editing.
     * @param {Boolean} [applyChanges=false] false: cancel edit, true: save (if modified)
     * @alias FancytreeNode#editEnd
     * @requires jquery.fancytree.edit.js
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.editEnd = function (applyChanges, _event) {
      var newVal,
        node = this,
        tree = this.tree,
        local = tree.ext.edit,
        eventData = local.eventData,
        instOpts = tree.options.edit,
        $title = $(".fancytree-title", node.span),
        $input = $title.find("input.fancytree-edit-input");
      if (instOpts.trim) {
        $input.val(trim($input.val()));
      }
      newVal = $input.val();
      eventData.dirty = newVal !== node.title;
      eventData.originalEvent = _event;

      // Find out, if saving is required
      if (applyChanges === false) {
        // If true/false was passed, honor this (except in rename mode, if unchanged)
        eventData.save = false;
      } else if (eventData.isNew) {
        // In create mode, we save everything, except for empty text
        eventData.save = newVal !== "";
      } else {
        // In rename mode, we save everyting, except for empty or unchanged text
        eventData.save = eventData.dirty && newVal !== "";
      }
      // Allow to break (keep editor open), modify input, or re-define data.save
      if (instOpts.beforeClose.call(node, {
        type: "beforeClose"
      }, eventData) === false) {
        return false;
      }
      if (eventData.save && instOpts.save.call(node, {
        type: "save"
      }, eventData) === false) {
        return false;
      }
      $input.removeClass("fancytree-edit-dirty").off();
      // Unbind outer-click handler
      $(document).off(".fancytree-edit");
      if (eventData.save) {
        // # 171: escape user input (not required if global escaping is on)
        node.setTitle(tree.options.escapeTitles ? newVal : escapeHtml(newVal));
        node.setFocus();
      } else {
        if (eventData.isNew) {
          node.remove();
          node = eventData.node = null;
          local.relatedNode.setFocus();
        } else {
          node.renderTitle();
          node.setFocus();
        }
      }
      local.eventData = null;
      local.currentNode = null;
      local.relatedNode = null;
      // Re-enable mouse and keyboard handling
      tree.widget._bind();
      if (node && local.lastDraggableAttrValue) {
        node.span.draggable = true;
      }

      // Set keyboard focus, even if setFocus() claims 'nothing to do'
      tree.$container.get(0).focus({
        preventScroll: true
      });
      eventData.input = null;
      instOpts.close.call(node, {
        type: "close"
      }, eventData);
      return true;
    };

    /**
     * [ext-edit] Create a new child or sibling node and start edit mode.
     *
     * @param {String} [mode='child'] 'before', 'after', or 'child'
     * @param {Object} [init] NodeData (or simple title string)
     * @alias FancytreeNode#editCreateNode
     * @requires jquery.fancytree.edit.js
     * @since 2.4
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.editCreateNode = function (mode, init) {
      var newNode,
        tree = this.tree,
        self = this;
      mode = mode || "child";
      if (init == null) {
        init = {
          title: ""
        };
      } else if (typeof init === "string") {
        init = {
          title: init
        };
      } else {
        $.ui.fancytree.assert($.isPlainObject(init));
      }
      // Make sure node is expanded (and loaded) in 'child' mode
      if (mode === "child" && !this.isExpanded() && this.hasChildren() !== false) {
        this.setExpanded().done(function () {
          self.editCreateNode(mode, init);
        });
        return;
      }
      newNode = this.addNode(init, mode);

      // #644: Don't filter new nodes.
      newNode.match = true;
      $(newNode[tree.statusClassPropName]).removeClass("fancytree-hide").addClass("fancytree-match");
      newNode.makeVisible().done(function () {
        $(newNode[tree.statusClassPropName]).addClass("fancytree-edit-new");
        self.tree.ext.edit.relatedNode = self;
        newNode.editStart();
      });
    };

    /**
     * [ext-edit] Check if any node in this tree  in edit mode.
     *
     * @returns {FancytreeNode | null}
     * @alias Fancytree#isEditing
     * @requires jquery.fancytree.edit.js
     */
    $.ui.fancytree._FancytreeClass.prototype.isEditing = function () {
      return this.ext.edit ? this.ext.edit.currentNode : null;
    };

    /**
     * [ext-edit] Check if this node is in edit mode.
     * @returns {Boolean} true if node is currently beeing edited
     * @alias FancytreeNode#isEditing
     * @requires jquery.fancytree.edit.js
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.isEditing = function () {
      return this.tree.ext.edit ? this.tree.ext.edit.currentNode === this : false;
    };

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "edit",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        adjustWidthOfs: 4,
        // null: don't adjust input size to content
        allowEmpty: false,
        // Prevent empty input
        inputCss: {
          minWidth: "3em"
        },
        // triggerCancel: ["esc", "tab", "click"],
        triggerStart: ["f2", "mac+enter", "shift+click"],
        trim: true,
        // Trim whitespace before save
        // Events:
        beforeClose: $.noop,
        // Return false to prevent cancel/save (data.input is available)
        beforeEdit: $.noop,
        // Return false to prevent edit mode
        close: $.noop,
        // Editor was removed
        edit: $.noop,
        // Editor was opened (available as data.input)
        //		keypress: $.noop,    // Not yet implemented
        save: $.noop // Save data.input.val() or return false to keep editor open
      },

      // Local attributes
      currentNode: null,
      treeInit: function treeInit(ctx) {
        var tree = ctx.tree;
        this._superApply(arguments);
        this.$container.addClass("fancytree-ext-edit").on("fancytreebeforeupdateviewport", function (event, data) {
          var editNode = tree.isEditing();
          // When scrolling, the TR may be re-used by another node, so the
          // active cell marker an
          if (editNode) {
            editNode.info("Cancel edit due to scroll event.");
            editNode.editEnd(false, event);
          }
        });
      },
      nodeClick: function nodeClick(ctx) {
        var eventStr = $.ui.fancytree.eventToString(ctx.originalEvent),
          triggerStart = ctx.options.edit.triggerStart;
        if (eventStr === "shift+click" && $.inArray("shift+click", triggerStart) >= 0) {
          if (ctx.originalEvent.shiftKey) {
            ctx.node.editStart();
            return false;
          }
        }
        if (eventStr === "click" && $.inArray("clickActive", triggerStart) >= 0) {
          // Only when click was inside title text (not aynwhere else in the row)
          if (ctx.node.isActive() && !ctx.node.isEditing() && $(ctx.originalEvent.target).hasClass("fancytree-title")) {
            ctx.node.editStart();
            return false;
          }
        }
        return this._superApply(arguments);
      },
      nodeDblclick: function nodeDblclick(ctx) {
        if ($.inArray("dblclick", ctx.options.edit.triggerStart) >= 0) {
          ctx.node.editStart();
          return false;
        }
        return this._superApply(arguments);
      },
      nodeKeydown: function nodeKeydown(ctx) {
        switch (ctx.originalEvent.which) {
          case 113:
            // [F2]
            if ($.inArray("f2", ctx.options.edit.triggerStart) >= 0) {
              ctx.node.editStart();
              return false;
            }
            break;
          case $.ui.keyCode.ENTER:
            if ($.inArray("mac+enter", ctx.options.edit.triggerStart) >= 0 && isMac) {
              ctx.node.editStart();
              return false;
            }
            break;
        }
        return this._superApply(arguments);
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.filter.js' */ /*!
                                                * jquery.fancytree.filter.js
                                                *
                                                * Remove or highlight tree nodes, based on a filter.
                                                * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                                *
                                                * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                                *
                                                * Released under the MIT license
                                                * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                                *
                                                * @version 2.38.2
                                                * @date 2022-06-30T18:24:06Z
                                                */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /*******************************************************************************
     * Private functions and variables
     */
    var KeyNoData = "__not_found__",
      escapeHtml = $.ui.fancytree.escapeHtml,
      exoticStartChar = "\uFFF7",
      exoticEndChar = "\uFFF8";
    function _escapeRegex(str) {
      return (str + "").replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    }
    function extractHtmlText(s) {
      if (s.indexOf(">") >= 0) {
        return $("<div/>").html(s).text();
      }
      return s;
    }

    /**
     * @description Marks the matching charecters of `text` either by `mark` or
     * by exotic*Chars (if `escapeTitles` is `true`) based on `regexMatchArray`
     * which is an array of matching groups.
     * @param {string} text
     * @param {RegExpMatchArray} regexMatchArray
     */
    function _markFuzzyMatchedChars(text, regexMatchArray, escapeTitles) {
      // It is extremely infuriating that we can not use `let` or `const` or arrow functions.
      // Damn you IE!!!
      var matchingIndices = [];
      // get the indices of matched characters (Iterate through `RegExpMatchArray`)
      for (var _matchingArrIdx = 1; _matchingArrIdx < regexMatchArray.length; _matchingArrIdx++) {
        var _mIdx =
        // get matching char index by cumulatively adding
        // the matched group length
        regexMatchArray[_matchingArrIdx].length + (_matchingArrIdx === 1 ? 0 : 1) + (matchingIndices[matchingIndices.length - 1] || 0);
        matchingIndices.push(_mIdx);
      }
      // Map each `text` char to its position and store in `textPoses`.
      var textPoses = text.split("");
      if (escapeTitles) {
        // If escaping the title, then wrap the matchng char within exotic chars
        matchingIndices.forEach(function (v) {
          textPoses[v] = exoticStartChar + textPoses[v] + exoticEndChar;
        });
      } else {
        // Otherwise, Wrap the matching chars within `mark`.
        matchingIndices.forEach(function (v) {
          textPoses[v] = "<mark>" + textPoses[v] + "</mark>";
        });
      }
      // Join back the modified `textPoses` to create final highlight markup.
      return textPoses.join("");
    }
    $.ui.fancytree._FancytreeClass.prototype._applyFilterImpl = function (filter, branchMode, _opts) {
      var match,
        statusNode,
        re,
        reHighlight,
        reExoticStartChar,
        reExoticEndChar,
        temp,
        prevEnableUpdate,
        count = 0,
        treeOpts = this.options,
        escapeTitles = treeOpts.escapeTitles,
        prevAutoCollapse = treeOpts.autoCollapse,
        opts = $.extend({}, treeOpts.filter, _opts),
        hideMode = opts.mode === "hide",
        leavesOnly = !!opts.leavesOnly && !branchMode;

      // Default to 'match title substring (not case sensitive)'
      if (typeof filter === "string") {
        if (filter === "") {
          this.warn("Fancytree passing an empty string as a filter is handled as clearFilter().");
          this.clearFilter();
          return;
        }
        if (opts.fuzzy) {
          // See https://codereview.stackexchange.com/questions/23899/faster-javascript-fuzzy-string-matching-function/23905#23905
          // and http://www.quora.com/How-is-the-fuzzy-search-algorithm-in-Sublime-Text-designed
          // and http://www.dustindiaz.com/autocomplete-fuzzy-matching
          match = filter.split("")
          // Escaping the `filter` will not work because,
          // it gets further split into individual characters. So,
          // escape each character after splitting
          .map(_escapeRegex).reduce(function (a, b) {
            // create capture groups for parts that comes before
            // the character
            return a + "([^" + b + "]*)" + b;
          }, "");
        } else {
          match = _escapeRegex(filter); // make sure a '.' is treated literally
        }

        re = new RegExp(match, "i");
        reHighlight = new RegExp(_escapeRegex(filter), "gi");
        if (escapeTitles) {
          reExoticStartChar = new RegExp(_escapeRegex(exoticStartChar), "g");
          reExoticEndChar = new RegExp(_escapeRegex(exoticEndChar), "g");
        }
        filter = function filter(node) {
          if (!node.title) {
            return false;
          }
          var text = escapeTitles ? node.title : extractHtmlText(node.title),
            // `.match` instead of `.test` to get the capture groups
            res = text.match(re);
          if (res && opts.highlight) {
            if (escapeTitles) {
              if (opts.fuzzy) {
                temp = _markFuzzyMatchedChars(text, res, escapeTitles);
              } else {
                // #740: we must not apply the marks to escaped entity names, e.g. `&quot;`
                // Use some exotic characters to mark matches:
                temp = text.replace(reHighlight, function (s) {
                  return exoticStartChar + s + exoticEndChar;
                });
              }
              // now we can escape the title...
              node.titleWithHighlight = escapeHtml(temp)
              // ... and finally insert the desired `<mark>` tags
              .replace(reExoticStartChar, "<mark>").replace(reExoticEndChar, "</mark>");
            } else {
              if (opts.fuzzy) {
                node.titleWithHighlight = _markFuzzyMatchedChars(text, res);
              } else {
                node.titleWithHighlight = text.replace(reHighlight, function (s) {
                  return "<mark>" + s + "</mark>";
                });
              }
            }
            // node.debug("filter", escapeTitles, text, node.titleWithHighlight);
          }

          return !!res;
        };
      }
      this.enableFilter = true;
      this.lastFilterArgs = arguments;
      prevEnableUpdate = this.enableUpdate(false);
      this.$div.addClass("fancytree-ext-filter");
      if (hideMode) {
        this.$div.addClass("fancytree-ext-filter-hide");
      } else {
        this.$div.addClass("fancytree-ext-filter-dimm");
      }
      this.$div.toggleClass("fancytree-ext-filter-hide-expanders", !!opts.hideExpanders);
      // Reset current filter
      this.rootNode.subMatchCount = 0;
      this.visit(function (node) {
        delete node.match;
        delete node.titleWithHighlight;
        node.subMatchCount = 0;
      });
      statusNode = this.getRootNode()._findDirectChild(KeyNoData);
      if (statusNode) {
        statusNode.remove();
      }

      // Adjust node.hide, .match, and .subMatchCount properties
      treeOpts.autoCollapse = false; // #528

      this.visit(function (node) {
        if (leavesOnly && node.children != null) {
          return;
        }
        var res = filter(node),
          matchedByBranch = false;
        if (res === "skip") {
          node.visit(function (c) {
            c.match = false;
          }, true);
          return "skip";
        }
        if (!res && (branchMode || res === "branch") && node.parent.match) {
          res = true;
          matchedByBranch = true;
        }
        if (res) {
          count++;
          node.match = true;
          node.visitParents(function (p) {
            if (p !== node) {
              p.subMatchCount += 1;
            }
            // Expand match (unless this is no real match, but only a node in a matched branch)
            if (opts.autoExpand && !matchedByBranch && !p.expanded) {
              p.setExpanded(true, {
                noAnimation: true,
                noEvents: true,
                scrollIntoView: false
              });
              p._filterAutoExpanded = true;
            }
          }, true);
        }
      });
      treeOpts.autoCollapse = prevAutoCollapse;
      if (count === 0 && opts.nodata && hideMode) {
        statusNode = opts.nodata;
        if (typeof statusNode === "function") {
          statusNode = statusNode();
        }
        if (statusNode === true) {
          statusNode = {};
        } else if (typeof statusNode === "string") {
          statusNode = {
            title: statusNode
          };
        }
        statusNode = $.extend({
          statusNodeType: "nodata",
          key: KeyNoData,
          title: this.options.strings.noData
        }, statusNode);
        this.getRootNode().addNode(statusNode).match = true;
      }
      // Redraw whole tree
      this._callHook("treeStructureChanged", this, "applyFilter");
      // this.render();
      this.enableUpdate(prevEnableUpdate);
      return count;
    };

    /**
     * [ext-filter] Dimm or hide nodes.
     *
     * @param {function | string} filter
     * @param {boolean} [opts={autoExpand: false, leavesOnly: false}]
     * @returns {integer} count
     * @alias Fancytree#filterNodes
     * @requires jquery.fancytree.filter.js
     */
    $.ui.fancytree._FancytreeClass.prototype.filterNodes = function (filter, opts) {
      if (typeof opts === "boolean") {
        opts = {
          leavesOnly: opts
        };
        this.warn("Fancytree.filterNodes() leavesOnly option is deprecated since 2.9.0 / 2015-04-19. Use opts.leavesOnly instead.");
      }
      return this._applyFilterImpl(filter, false, opts);
    };

    /**
     * [ext-filter] Dimm or hide whole branches.
     *
     * @param {function | string} filter
     * @param {boolean} [opts={autoExpand: false}]
     * @returns {integer} count
     * @alias Fancytree#filterBranches
     * @requires jquery.fancytree.filter.js
     */
    $.ui.fancytree._FancytreeClass.prototype.filterBranches = function (filter, opts) {
      return this._applyFilterImpl(filter, true, opts);
    };

    /**
     * [ext-filter] Re-apply current filter.
     *
     * @returns {integer} count
     * @alias Fancytree#updateFilter
     * @requires jquery.fancytree.filter.js
     * @since 2.38
     */
    $.ui.fancytree._FancytreeClass.prototype.updateFilter = function () {
      if (this.enableFilter && this.lastFilterArgs && this.options.filter.autoApply) {
        this._applyFilterImpl.apply(this, this.lastFilterArgs);
      } else {
        this.warn("updateFilter(): no filter active.");
      }
    };

    /**
     * [ext-filter] Reset the filter.
     *
     * @alias Fancytree#clearFilter
     * @requires jquery.fancytree.filter.js
     */
    $.ui.fancytree._FancytreeClass.prototype.clearFilter = function () {
      var $title,
        statusNode = this.getRootNode()._findDirectChild(KeyNoData),
        escapeTitles = this.options.escapeTitles,
        enhanceTitle = this.options.enhanceTitle,
        prevEnableUpdate = this.enableUpdate(false);
      if (statusNode) {
        statusNode.remove();
      }
      // we also counted root node's subMatchCount
      delete this.rootNode.match;
      delete this.rootNode.subMatchCount;
      this.visit(function (node) {
        if (node.match && node.span) {
          // #491, #601
          $title = $(node.span).find(">span.fancytree-title");
          if (escapeTitles) {
            $title.text(node.title);
          } else {
            $title.html(node.title);
          }
          if (enhanceTitle) {
            enhanceTitle({
              type: "enhanceTitle"
            }, {
              node: node,
              $title: $title
            });
          }
        }
        delete node.match;
        delete node.subMatchCount;
        delete node.titleWithHighlight;
        if (node.$subMatchBadge) {
          node.$subMatchBadge.remove();
          delete node.$subMatchBadge;
        }
        if (node._filterAutoExpanded && node.expanded) {
          node.setExpanded(false, {
            noAnimation: true,
            noEvents: true,
            scrollIntoView: false
          });
        }
        delete node._filterAutoExpanded;
      });
      this.enableFilter = false;
      this.lastFilterArgs = null;
      this.$div.removeClass("fancytree-ext-filter fancytree-ext-filter-dimm fancytree-ext-filter-hide");
      this._callHook("treeStructureChanged", this, "clearFilter");
      // this.render();
      this.enableUpdate(prevEnableUpdate);
    };

    /**
     * [ext-filter] Return true if a filter is currently applied.
     *
     * @returns {Boolean}
     * @alias Fancytree#isFilterActive
     * @requires jquery.fancytree.filter.js
     * @since 2.13
     */
    $.ui.fancytree._FancytreeClass.prototype.isFilterActive = function () {
      return !!this.enableFilter;
    };

    /**
     * [ext-filter] Return true if this node is matched by current filter (or no filter is active).
     *
     * @returns {Boolean}
     * @alias FancytreeNode#isMatched
     * @requires jquery.fancytree.filter.js
     * @since 2.13
     */
    $.ui.fancytree._FancytreeNodeClass.prototype.isMatched = function () {
      return !(this.tree.enableFilter && !this.match);
    };

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "filter",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        autoApply: true,
        // Re-apply last filter if lazy data is loaded
        autoExpand: false,
        // Expand all branches that contain matches while filtered
        counter: true,
        // Show a badge with number of matching child nodes near parent icons
        fuzzy: false,
        // Match single characters in order, e.g. 'fb' will match 'FooBar'
        hideExpandedCounter: true,
        // Hide counter badge if parent is expanded
        hideExpanders: false,
        // Hide expanders if all child nodes are hidden by filter
        highlight: true,
        // Highlight matches by wrapping inside <mark> tags
        leavesOnly: false,
        // Match end nodes only
        nodata: true,
        // Display a 'no data' status node if result is empty
        mode: "dimm" // Grayout unmatched nodes (pass "hide" to remove unmatched node instead)
      },

      nodeLoadChildren: function nodeLoadChildren(ctx, source) {
        var tree = ctx.tree;
        return this._superApply(arguments).done(function () {
          if (tree.enableFilter && tree.lastFilterArgs && ctx.options.filter.autoApply) {
            tree._applyFilterImpl.apply(tree, tree.lastFilterArgs);
          }
        });
      },
      nodeSetExpanded: function nodeSetExpanded(ctx, flag, callOpts) {
        var node = ctx.node;
        delete node._filterAutoExpanded;
        // Make sure counter badge is displayed again, when node is beeing collapsed
        if (!flag && ctx.options.filter.hideExpandedCounter && node.$subMatchBadge) {
          node.$subMatchBadge.show();
        }
        return this._superApply(arguments);
      },
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        // Set classes for current status
        var res,
          node = ctx.node,
          tree = ctx.tree,
          opts = ctx.options.filter,
          $title = $(node.span).find("span.fancytree-title"),
          $span = $(node[tree.statusClassPropName]),
          enhanceTitle = ctx.options.enhanceTitle,
          escapeTitles = ctx.options.escapeTitles;
        res = this._super(ctx);
        // nothing to do, if node was not yet rendered
        if (!$span.length || !tree.enableFilter) {
          return res;
        }
        $span.toggleClass("fancytree-match", !!node.match).toggleClass("fancytree-submatch", !!node.subMatchCount).toggleClass("fancytree-hide", !(node.match || node.subMatchCount));
        // Add/update counter badge
        if (opts.counter && node.subMatchCount && (!node.isExpanded() || !opts.hideExpandedCounter)) {
          if (!node.$subMatchBadge) {
            node.$subMatchBadge = $("<span class='fancytree-childcounter'/>");
            $("span.fancytree-icon, span.fancytree-custom-icon", node.span).append(node.$subMatchBadge);
          }
          node.$subMatchBadge.show().text(node.subMatchCount);
        } else if (node.$subMatchBadge) {
          node.$subMatchBadge.hide();
        }
        // node.debug("nodeRenderStatus", node.titleWithHighlight, node.title)
        // #601: also check for $title.length, because we don't need to render
        // if node.span is null (i.e. not rendered)
        if (node.span && (!node.isEditing || !node.isEditing.call(node))) {
          if (node.titleWithHighlight) {
            $title.html(node.titleWithHighlight);
          } else if (escapeTitles) {
            $title.text(node.title);
          } else {
            $title.html(node.title);
          }
          if (enhanceTitle) {
            enhanceTitle({
              type: "enhanceTitle"
            }, {
              node: node,
              $title: $title
            });
          }
        }
        return res;
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.glyph.js' */ /*!
                                               * jquery.fancytree.glyph.js
                                               *
                                               * Use glyph-fonts, ligature-fonts, or SVG icons instead of icon sprites.
                                               * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                               *
                                               * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                               *
                                               * Released under the MIT license
                                               * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                               *
                                               * @version 2.38.2
                                               * @date 2022-06-30T18:24:06Z
                                               */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /******************************************************************************
     * Private functions and variables
     */
    var FT = $.ui.fancytree,
      PRESETS = {
        awesome3: {
          // Outdated!
          _addClass: "",
          checkbox: "icon-check-empty",
          checkboxSelected: "icon-check",
          checkboxUnknown: "icon-check icon-muted",
          dragHelper: "icon-caret-right",
          dropMarker: "icon-caret-right",
          error: "icon-exclamation-sign",
          expanderClosed: "icon-caret-right",
          expanderLazy: "icon-angle-right",
          expanderOpen: "icon-caret-down",
          loading: "icon-refresh icon-spin",
          nodata: "icon-meh",
          noExpander: "",
          radio: "icon-circle-blank",
          radioSelected: "icon-circle",
          // radioUnknown: "icon-circle icon-muted",
          // Default node icons.
          // (Use tree.options.icon callback to define custom icons based on node data)
          doc: "icon-file-alt",
          docOpen: "icon-file-alt",
          folder: "icon-folder-close-alt",
          folderOpen: "icon-folder-open-alt"
        },
        awesome4: {
          _addClass: "fa",
          checkbox: "fa-square-o",
          checkboxSelected: "fa-check-square-o",
          checkboxUnknown: "fa-square fancytree-helper-indeterminate-cb",
          dragHelper: "fa-arrow-right",
          dropMarker: "fa-long-arrow-right",
          error: "fa-warning",
          expanderClosed: "fa-caret-right",
          expanderLazy: "fa-angle-right",
          expanderOpen: "fa-caret-down",
          // We may prevent wobbling rotations on FF by creating a separate sub element:
          loading: {
            html: "<span class='fa fa-spinner fa-pulse' />"
          },
          nodata: "fa-meh-o",
          noExpander: "",
          radio: "fa-circle-thin",
          // "fa-circle-o"
          radioSelected: "fa-circle",
          // radioUnknown: "fa-dot-circle-o",
          // Default node icons.
          // (Use tree.options.icon callback to define custom icons based on node data)
          doc: "fa-file-o",
          docOpen: "fa-file-o",
          folder: "fa-folder-o",
          folderOpen: "fa-folder-open-o"
        },
        awesome5: {
          // fontawesome 5 have several different base classes
          // "far, fas, fal and fab" The rendered svg puts that prefix
          // in a different location so we have to keep them separate here
          _addClass: "",
          checkbox: "far fa-square",
          checkboxSelected: "far fa-check-square",
          // checkboxUnknown: "far fa-window-close",
          checkboxUnknown: "fas fa-square fancytree-helper-indeterminate-cb",
          radio: "far fa-circle",
          radioSelected: "fas fa-circle",
          radioUnknown: "far fa-dot-circle",
          dragHelper: "fas fa-arrow-right",
          dropMarker: "fas fa-long-arrow-alt-right",
          error: "fas fa-exclamation-triangle",
          expanderClosed: "fas fa-caret-right",
          expanderLazy: "fas fa-angle-right",
          expanderOpen: "fas fa-caret-down",
          loading: "fas fa-spinner fa-pulse",
          nodata: "far fa-meh",
          noExpander: "",
          // Default node icons.
          // (Use tree.options.icon callback to define custom icons based on node data)
          doc: "far fa-file",
          docOpen: "far fa-file",
          folder: "far fa-folder",
          folderOpen: "far fa-folder-open"
        },
        bootstrap3: {
          _addClass: "glyphicon",
          checkbox: "glyphicon-unchecked",
          checkboxSelected: "glyphicon-check",
          checkboxUnknown: "glyphicon-expand fancytree-helper-indeterminate-cb",
          // "glyphicon-share",
          dragHelper: "glyphicon-play",
          dropMarker: "glyphicon-arrow-right",
          error: "glyphicon-warning-sign",
          expanderClosed: "glyphicon-menu-right",
          // glyphicon-plus-sign
          expanderLazy: "glyphicon-menu-right",
          // glyphicon-plus-sign
          expanderOpen: "glyphicon-menu-down",
          // glyphicon-minus-sign
          loading: "glyphicon-refresh fancytree-helper-spin",
          nodata: "glyphicon-info-sign",
          noExpander: "",
          radio: "glyphicon-remove-circle",
          // "glyphicon-unchecked",
          radioSelected: "glyphicon-ok-circle",
          // "glyphicon-check",
          // radioUnknown: "glyphicon-ban-circle",
          // Default node icons.
          // (Use tree.options.icon callback to define custom icons based on node data)
          doc: "glyphicon-file",
          docOpen: "glyphicon-file",
          folder: "glyphicon-folder-close",
          folderOpen: "glyphicon-folder-open"
        },
        material: {
          _addClass: "material-icons",
          checkbox: {
            text: "check_box_outline_blank"
          },
          checkboxSelected: {
            text: "check_box"
          },
          checkboxUnknown: {
            text: "indeterminate_check_box"
          },
          dragHelper: {
            text: "play_arrow"
          },
          dropMarker: {
            text: "arrow-forward"
          },
          error: {
            text: "warning"
          },
          expanderClosed: {
            text: "chevron_right"
          },
          expanderLazy: {
            text: "last_page"
          },
          expanderOpen: {
            text: "expand_more"
          },
          loading: {
            text: "autorenew",
            addClass: "fancytree-helper-spin"
          },
          nodata: {
            text: "info"
          },
          noExpander: {
            text: ""
          },
          radio: {
            text: "radio_button_unchecked"
          },
          radioSelected: {
            text: "radio_button_checked"
          },
          // Default node icons.
          // (Use tree.options.icon callback to define custom icons based on node data)
          doc: {
            text: "insert_drive_file"
          },
          docOpen: {
            text: "insert_drive_file"
          },
          folder: {
            text: "folder"
          },
          folderOpen: {
            text: "folder_open"
          }
        }
      };
    function setIcon(node, span, baseClass, opts, type) {
      var map = opts.map,
        icon = map[type],
        $span = $(span),
        $counter = $span.find(".fancytree-childcounter"),
        setClass = baseClass + " " + (map._addClass || "");

      // #871 Allow a callback
      if (typeof icon === "function") {
        icon = icon.call(this, node, span, type);
      }
      // node.debug( "setIcon(" + baseClass + ", " + type + "): " + "oldIcon" + " -> " + icon );
      // #871: propsed this, but I am not sure how robust this is, e.g.
      // the prefix (fas, far) class changes are not considered?
      // if (span.tagName === "svg" && opts.preset === "awesome5") {
      // 	// fa5 script converts <i> to <svg> so call a specific handler.
      // 	var oldIcon = "fa-" + $span.data("icon");
      // 	// node.debug( "setIcon(" + baseClass + ", " + type + "): " + oldIcon + " -> " + icon );
      // 	if (typeof oldIcon === "string") {
      // 		$span.removeClass(oldIcon);
      // 	}
      // 	if (typeof icon === "string") {
      // 		$span.addClass(icon);
      // 	}
      // 	return;
      // }
      if (typeof icon === "string") {
        // #883: remove inner html that may be added by prev. mode
        span.innerHTML = "";
        $span.attr("class", setClass + " " + icon).append($counter);
      } else if (icon) {
        if (icon.text) {
          span.textContent = "" + icon.text;
        } else if (icon.html) {
          span.innerHTML = icon.html;
        } else {
          span.innerHTML = "";
        }
        $span.attr("class", setClass + " " + (icon.addClass || "")).append($counter);
      }
    }
    $.ui.fancytree.registerExtension({
      name: "glyph",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        preset: null,
        // 'awesome3', 'awesome4', 'bootstrap3', 'material'
        map: {}
      },
      treeInit: function treeInit(ctx) {
        var tree = ctx.tree,
          opts = ctx.options.glyph;
        if (opts.preset) {
          FT.assert(!!PRESETS[opts.preset], "Invalid value for `options.glyph.preset`: " + opts.preset);
          opts.map = $.extend({}, PRESETS[opts.preset], opts.map);
        } else {
          tree.warn("ext-glyph: missing `preset` option.");
        }
        this._superApply(arguments);
        tree.$container.addClass("fancytree-ext-glyph");
      },
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        var checkbox,
          icon,
          res,
          span,
          node = ctx.node,
          $span = $(node.span),
          opts = ctx.options.glyph;
        res = this._super(ctx);
        if (node.isRootNode()) {
          return res;
        }
        span = $span.children(".fancytree-expander").get(0);
        if (span) {
          // if( node.isLoading() ){
          // icon = "loading";
          if (node.expanded && node.hasChildren()) {
            icon = "expanderOpen";
          } else if (node.isUndefined()) {
            icon = "expanderLazy";
          } else if (node.hasChildren()) {
            icon = "expanderClosed";
          } else {
            icon = "noExpander";
          }
          // span.className = "fancytree-expander " + map[icon];
          setIcon(node, span, "fancytree-expander", opts, icon);
        }
        if (node.tr) {
          span = $("td", node.tr).find(".fancytree-checkbox").get(0);
        } else {
          span = $span.children(".fancytree-checkbox").get(0);
        }
        if (span) {
          checkbox = FT.evalOption("checkbox", node, node, opts, false);
          if (node.parent && node.parent.radiogroup || checkbox === "radio") {
            icon = node.selected ? "radioSelected" : "radio";
            setIcon(node, span, "fancytree-checkbox fancytree-radio", opts, icon);
          } else {
            // eslint-disable-next-line no-nested-ternary
            icon = node.selected ? "checkboxSelected" : node.partsel ? "checkboxUnknown" : "checkbox";
            // span.className = "fancytree-checkbox " + map[icon];
            setIcon(node, span, "fancytree-checkbox", opts, icon);
          }
        }

        // Standard icon (note that this does not match .fancytree-custom-icon,
        // that might be set by opts.icon callbacks)
        span = $span.children(".fancytree-icon").get(0);
        if (span) {
          if (node.statusNodeType) {
            icon = node.statusNodeType; // loading, error
          } else if (node.folder) {
            icon = node.expanded && node.hasChildren() ? "folderOpen" : "folder";
          } else {
            icon = node.expanded ? "docOpen" : "doc";
          }
          setIcon(node, span, "fancytree-icon", opts, icon);
        }
        return res;
      },
      nodeSetStatus: function nodeSetStatus(ctx, status, message, details) {
        var res,
          span,
          opts = ctx.options.glyph,
          node = ctx.node;
        res = this._superApply(arguments);
        if (status === "error" || status === "loading" || status === "nodata") {
          if (node.parent) {
            span = $(".fancytree-expander", node.span).get(0);
            if (span) {
              setIcon(node, span, "fancytree-expander", opts, status);
            }
          } else {
            //
            span = $(".fancytree-statusnode-" + status, node[this.nodeContainerAttrName]).find(".fancytree-icon").get(0);
            if (span) {
              setIcon(node, span, "fancytree-icon", opts, status);
            }
          }
        }
        return res;
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.gridnav.js' */ /*!
                                                 * jquery.fancytree.gridnav.js
                                                 *
                                                 * Support keyboard navigation for trees with embedded input controls.
                                                 * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                                 *
                                                 * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                                 *
                                                 * Released under the MIT license
                                                 * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                                 *
                                                 * @version 2.38.2
                                                 * @date 2022-06-30T18:24:06Z
                                                 */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree", "./jquery.fancytree.table"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree.table"); // core + table
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /*******************************************************************************
     * Private functions and variables
     */

    // Allow these navigation keys even when input controls are focused
    var KC = $.ui.keyCode,
      // which keys are *not* handled by embedded control, but passed to tree
      // navigation handler:
      NAV_KEYS = {
        text: [KC.UP, KC.DOWN],
        checkbox: [KC.UP, KC.DOWN, KC.LEFT, KC.RIGHT],
        link: [KC.UP, KC.DOWN, KC.LEFT, KC.RIGHT],
        radiobutton: [KC.UP, KC.DOWN, KC.LEFT, KC.RIGHT],
        "select-one": [KC.LEFT, KC.RIGHT],
        "select-multiple": [KC.LEFT, KC.RIGHT]
      };

    /* Calculate TD column index (considering colspans).*/
    function getColIdx($tr, $td) {
      var colspan,
        td = $td.get(0),
        idx = 0;
      $tr.children().each(function () {
        if (this === td) {
          return false;
        }
        colspan = $(this).prop("colspan");
        idx += colspan ? colspan : 1;
      });
      return idx;
    }

    /* Find TD at given column index (considering colspans).*/
    function findTdAtColIdx($tr, colIdx) {
      var colspan,
        res = null,
        idx = 0;
      $tr.children().each(function () {
        if (idx >= colIdx) {
          res = $(this);
          return false;
        }
        colspan = $(this).prop("colspan");
        idx += colspan ? colspan : 1;
      });
      return res;
    }

    /* Find adjacent cell for a given direction. Skip empty cells and consider merged cells */
    function findNeighbourTd($target, keyCode) {
      var $tr,
        colIdx,
        $td = $target.closest("td"),
        $tdNext = null;
      switch (keyCode) {
        case KC.LEFT:
          $tdNext = $td.prev();
          break;
        case KC.RIGHT:
          $tdNext = $td.next();
          break;
        case KC.UP:
        case KC.DOWN:
          $tr = $td.parent();
          colIdx = getColIdx($tr, $td);
          while (true) {
            $tr = keyCode === KC.UP ? $tr.prev() : $tr.next();
            if (!$tr.length) {
              break;
            }
            // Skip hidden rows
            if ($tr.is(":hidden")) {
              continue;
            }
            // Find adjacent cell in the same column
            $tdNext = findTdAtColIdx($tr, colIdx);
            // Skip cells that don't conatain a focusable element
            if ($tdNext && $tdNext.find(":input,a").length) {
              break;
            }
          }
          break;
      }
      return $tdNext;
    }

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "gridnav",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        autofocusInput: false,
        // Focus first embedded input if node gets activated
        handleCursorKeys: true // Allow UP/DOWN in inputs to move to prev/next node
      },

      treeInit: function treeInit(ctx) {
        // gridnav requires the table extension to be loaded before itself
        this._requireExtension("table", true, true);
        this._superApply(arguments);
        this.$container.addClass("fancytree-ext-gridnav");

        // Activate node if embedded input gets focus (due to a click)
        this.$container.on("focusin", function (event) {
          var ctx2,
            node = $.ui.fancytree.getNode(event.target);
          if (node && !node.isActive()) {
            // Call node.setActive(), but also pass the event
            ctx2 = ctx.tree._makeHookContext(node, event);
            ctx.tree._callHook("nodeSetActive", ctx2, true);
          }
        });
      },
      nodeSetActive: function nodeSetActive(ctx, flag, callOpts) {
        var $outer,
          opts = ctx.options.gridnav,
          node = ctx.node,
          event = ctx.originalEvent || {},
          triggeredByInput = $(event.target).is(":input");
        flag = flag !== false;
        this._superApply(arguments);
        if (flag) {
          if (ctx.options.titlesTabbable) {
            if (!triggeredByInput) {
              $(node.span).find("span.fancytree-title").focus();
              node.setFocus();
            }
            // If one node is tabbable, the container no longer needs to be
            ctx.tree.$container.attr("tabindex", "-1");
            // ctx.tree.$container.removeAttr("tabindex");
          } else if (opts.autofocusInput && !triggeredByInput) {
            // Set focus to input sub input (if node was clicked, but not
            // when TAB was pressed )
            $outer = $(node.tr || node.span);
            $outer.find(":input:enabled").first().focus();
          }
        }
      },
      nodeKeydown: function nodeKeydown(ctx) {
        var inputType,
          handleKeys,
          $td,
          opts = ctx.options.gridnav,
          event = ctx.originalEvent,
          $target = $(event.target);
        if ($target.is(":input:enabled")) {
          inputType = $target.prop("type");
        } else if ($target.is("a")) {
          inputType = "link";
        }
        // ctx.tree.debug("ext-gridnav nodeKeydown", event, inputType);

        if (inputType && opts.handleCursorKeys) {
          handleKeys = NAV_KEYS[inputType];
          if (handleKeys && $.inArray(event.which, handleKeys) >= 0) {
            $td = findNeighbourTd($target, event.which);
            if ($td && $td.length) {
              // ctx.node.debug("ignore keydown in input", event.which, handleKeys);
              $td.find(":input:enabled,a").focus();
              // Prevent Fancytree default navigation
              return false;
            }
          }
          return true;
        }
        // ctx.tree.debug("ext-gridnav NOT HANDLED", event, inputType);
        return this._superApply(arguments);
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.multi.js' */ /*!
                                               * jquery.fancytree.multi.js
                                               *
                                               * Allow multiple selection of nodes  by mouse or keyboard.
                                               * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                               *
                                               * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                               *
                                               * Released under the MIT license
                                               * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                               *
                                               * @version 2.38.2
                                               * @date 2022-06-30T18:24:06Z
                                               */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /*******************************************************************************
     * Private functions and variables
     */

    // var isMac = /Mac/.test(navigator.platform);

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "multi",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        allowNoSelect: false,
        //
        mode: "sameParent" //
        // Events:
        // beforeSelect: $.noop  // Return false to prevent cancel/save (data.input is available)
      },

      treeInit: function treeInit(ctx) {
        this._superApply(arguments);
        this.$container.addClass("fancytree-ext-multi");
        if (ctx.options.selectMode === 1) {
          $.error("Fancytree ext-multi: selectMode: 1 (single) is not compatible.");
        }
      },
      nodeClick: function nodeClick(ctx) {
        var
          //pluginOpts = ctx.options.multi,
          tree = ctx.tree,
          node = ctx.node,
          activeNode = tree.getActiveNode() || tree.getFirstChild(),
          isCbClick = ctx.targetType === "checkbox",
          isExpanderClick = ctx.targetType === "expander",
          eventStr = $.ui.fancytree.eventToString(ctx.originalEvent);
        switch (eventStr) {
          case "click":
            if (isExpanderClick) {
              break;
            } // Default handler will expand/collapse
            if (!isCbClick) {
              tree.selectAll(false);
              // Select clicked node (radio-button  mode)
              node.setSelected();
            }
            // Default handler will toggle checkbox clicks and activate
            break;
          case "shift+click":
            // node.debug("click")
            tree.visitRows(function (n) {
              // n.debug("click2", n===node, node)
              n.setSelected();
              if (n === node) {
                return false;
              }
            }, {
              start: activeNode,
              reverse: activeNode.isBelowOf(node)
            });
            break;
          case "ctrl+click":
          case "meta+click":
            // Mac: [Command]
            node.toggleSelected();
            return;
        }
        return this._superApply(arguments);
      },
      nodeKeydown: function nodeKeydown(ctx) {
        var tree = ctx.tree,
          node = ctx.node,
          event = ctx.originalEvent,
          eventStr = $.ui.fancytree.eventToString(event);
        switch (eventStr) {
          case "up":
          case "down":
            tree.selectAll(false);
            node.navigate(event.which, true);
            tree.getActiveNode().setSelected();
            break;
          case "shift+up":
          case "shift+down":
            node.navigate(event.which, true);
            tree.getActiveNode().setSelected();
            break;
        }
        return this._superApply(arguments);
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.persist.js' */ /*!
                                                 * jquery.fancytree.persist.js
                                                 *
                                                 * Persist tree status in cookiesRemove or highlight tree nodes, based on a filter.
                                                 * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                                 *
                                                 * @depends: js-cookie or jquery-cookie
                                                 *
                                                 * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                                 *
                                                 * Released under the MIT license
                                                 * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                                 *
                                                 * @version 2.38.2
                                                 * @date 2022-06-30T18:24:06Z
                                                 */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /* global Cookies:false */

    /*******************************************************************************
     * Private functions and variables
     */
    var cookieStore = null,
      localStorageStore = null,
      sessionStorageStore = null,
      _assert = $.ui.fancytree.assert,
      ACTIVE = "active",
      EXPANDED = "expanded",
      FOCUS = "focus",
      SELECTED = "selected";

    // Accessing window.xxxStorage may raise security exceptions (see #1022)
    try {
      _assert(window.localStorage && window.localStorage.getItem);
      localStorageStore = {
        get: function get(key) {
          return window.localStorage.getItem(key);
        },
        set: function set(key, value) {
          window.localStorage.setItem(key, value);
        },
        remove: function remove(key) {
          window.localStorage.removeItem(key);
        }
      };
    } catch (e) {
      $.ui.fancytree.warn("Could not access window.localStorage", e);
    }
    try {
      _assert(window.sessionStorage && window.sessionStorage.getItem);
      sessionStorageStore = {
        get: function get(key) {
          return window.sessionStorage.getItem(key);
        },
        set: function set(key, value) {
          window.sessionStorage.setItem(key, value);
        },
        remove: function remove(key) {
          window.sessionStorage.removeItem(key);
        }
      };
    } catch (e) {
      $.ui.fancytree.warn("Could not access window.sessionStorage", e);
    }
    if (typeof Cookies === "function") {
      // Assume https://github.com/js-cookie/js-cookie
      cookieStore = {
        get: Cookies.get,
        set: function set(key, value) {
          Cookies.set(key, value, this.options.persist.cookie);
        },
        remove: Cookies.remove
      };
    } else if ($ && typeof $.cookie === "function") {
      // Fall back to https://github.com/carhartl/jquery-cookie
      cookieStore = {
        get: $.cookie,
        set: function set(key, value) {
          $.cookie(key, value, this.options.persist.cookie);
        },
        remove: $.removeCookie
      };
    }

    /* Recursively load lazy nodes
     * @param {string} mode 'load', 'expand', false
     */
    function _loadLazyNodes(tree, local, keyList, mode, dfd) {
      var i,
        key,
        l,
        node,
        foundOne = false,
        expandOpts = tree.options.persist.expandOpts,
        deferredList = [],
        missingKeyList = [];
      keyList = keyList || [];
      dfd = dfd || $.Deferred();
      for (i = 0, l = keyList.length; i < l; i++) {
        key = keyList[i];
        node = tree.getNodeByKey(key);
        if (node) {
          if (mode && node.isUndefined()) {
            foundOne = true;
            tree.debug("_loadLazyNodes: " + node + " is lazy: loading...");
            if (mode === "expand") {
              deferredList.push(node.setExpanded(true, expandOpts));
            } else {
              deferredList.push(node.load());
            }
          } else {
            tree.debug("_loadLazyNodes: " + node + " already loaded.");
            node.setExpanded(true, expandOpts);
          }
        } else {
          missingKeyList.push(key);
          tree.debug("_loadLazyNodes: " + node + " was not yet found.");
        }
      }
      $.when.apply($, deferredList).always(function () {
        // All lazy-expands have finished
        if (foundOne && missingKeyList.length > 0) {
          // If we read new nodes from server, try to resolve yet-missing keys
          _loadLazyNodes(tree, local, missingKeyList, mode, dfd);
        } else {
          if (missingKeyList.length) {
            tree.warn("_loadLazyNodes: could not load those keys: ", missingKeyList);
            for (i = 0, l = missingKeyList.length; i < l; i++) {
              key = keyList[i];
              local._appendKey(EXPANDED, keyList[i], false);
            }
          }
          dfd.resolve();
        }
      });
      return dfd;
    }

    /**
     * [ext-persist] Remove persistence data of the given type(s).
     * Called like
     *     $.ui.fancytree.getTree("#tree").clearCookies("active expanded focus selected");
     *
     * @alias Fancytree#clearPersistData
     * @requires jquery.fancytree.persist.js
     */
    $.ui.fancytree._FancytreeClass.prototype.clearPersistData = function (types) {
      var local = this.ext.persist,
        prefix = local.cookiePrefix;
      types = types || "active expanded focus selected";
      if (types.indexOf(ACTIVE) >= 0) {
        local._data(prefix + ACTIVE, null);
      }
      if (types.indexOf(EXPANDED) >= 0) {
        local._data(prefix + EXPANDED, null);
      }
      if (types.indexOf(FOCUS) >= 0) {
        local._data(prefix + FOCUS, null);
      }
      if (types.indexOf(SELECTED) >= 0) {
        local._data(prefix + SELECTED, null);
      }
    };
    $.ui.fancytree._FancytreeClass.prototype.clearCookies = function (types) {
      this.warn("'tree.clearCookies()' is deprecated since v2.27.0: use 'clearPersistData()' instead.");
      return this.clearPersistData(types);
    };

    /**
     * [ext-persist] Return persistence information from cookies
     *
     * Called like
     *     $.ui.fancytree.getTree("#tree").getPersistData();
     *
     * @alias Fancytree#getPersistData
     * @requires jquery.fancytree.persist.js
     */
    $.ui.fancytree._FancytreeClass.prototype.getPersistData = function () {
      var local = this.ext.persist,
        prefix = local.cookiePrefix,
        delim = local.cookieDelimiter,
        res = {};
      res[ACTIVE] = local._data(prefix + ACTIVE);
      res[EXPANDED] = (local._data(prefix + EXPANDED) || "").split(delim);
      res[SELECTED] = (local._data(prefix + SELECTED) || "").split(delim);
      res[FOCUS] = local._data(prefix + FOCUS);
      return res;
    };

    /******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "persist",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        cookieDelimiter: "~",
        cookiePrefix: undefined,
        // 'fancytree-<treeId>-' by default
        cookie: {
          raw: false,
          expires: "",
          path: "",
          domain: "",
          secure: false
        },
        expandLazy: false,
        // true: recursively expand and load lazy nodes
        expandOpts: undefined,
        // optional `opts` argument passed to setExpanded()
        fireActivate: true,
        // false: suppress `activate` event after active node was restored
        overrideSource: true,
        // true: cookie takes precedence over `source` data attributes.
        store: "auto",
        // 'cookie': force cookie, 'local': force localStore, 'session': force sessionStore
        types: "active expanded focus selected"
      },
      /* Generic read/write string data to cookie, sessionStorage or localStorage. */
      _data: function _data(key, value) {
        var store = this._local.store;
        if (value === undefined) {
          return store.get.call(this, key);
        } else if (value === null) {
          store.remove.call(this, key);
        } else {
          store.set.call(this, key, value);
        }
      },
      /* Append `key` to a cookie. */
      _appendKey: function _appendKey(type, key, flag) {
        key = "" + key; // #90
        var local = this._local,
          instOpts = this.options.persist,
          delim = instOpts.cookieDelimiter,
          cookieName = local.cookiePrefix + type,
          data = local._data(cookieName),
          keyList = data ? data.split(delim) : [],
          idx = $.inArray(key, keyList);
        // Remove, even if we add a key,  so the key is always the last entry
        if (idx >= 0) {
          keyList.splice(idx, 1);
        }
        // Append key to cookie
        if (flag) {
          keyList.push(key);
        }
        local._data(cookieName, keyList.join(delim));
      },
      treeInit: function treeInit(ctx) {
        var tree = ctx.tree,
          opts = ctx.options,
          local = this._local,
          instOpts = this.options.persist;

        // // For 'auto' or 'cookie' mode, the cookie plugin must be available
        // _assert((instOpts.store !== "auto" && instOpts.store !== "cookie") || cookieStore,
        // 	"Missing required plugin for 'persist' extension: js.cookie.js or jquery.cookie.js");

        local.cookiePrefix = instOpts.cookiePrefix || "fancytree-" + tree._id + "-";
        local.storeActive = instOpts.types.indexOf(ACTIVE) >= 0;
        local.storeExpanded = instOpts.types.indexOf(EXPANDED) >= 0;
        local.storeSelected = instOpts.types.indexOf(SELECTED) >= 0;
        local.storeFocus = instOpts.types.indexOf(FOCUS) >= 0;
        local.store = null;
        if (instOpts.store === "auto") {
          instOpts.store = localStorageStore ? "local" : "cookie";
        }
        if ($.isPlainObject(instOpts.store)) {
          local.store = instOpts.store;
        } else if (instOpts.store === "cookie") {
          local.store = cookieStore;
        } else if (instOpts.store === "local") {
          local.store = instOpts.store === "local" ? localStorageStore : sessionStorageStore;
        } else if (instOpts.store === "session") {
          local.store = instOpts.store === "local" ? localStorageStore : sessionStorageStore;
        }
        _assert(local.store, "Need a valid store.");

        // Bind init-handler to apply cookie state
        tree.$div.on("fancytreeinit", function (event) {
          if (tree._triggerTreeEvent("beforeRestore", null, {}) === false) {
            return;
          }
          var cookie,
            dfd,
            i,
            keyList,
            node,
            prevFocus = local._data(local.cookiePrefix + FOCUS),
            // record this before node.setActive() overrides it;
            noEvents = instOpts.fireActivate === false;

          // tree.debug("document.cookie:", document.cookie);

          cookie = local._data(local.cookiePrefix + EXPANDED);
          keyList = cookie && cookie.split(instOpts.cookieDelimiter);
          if (local.storeExpanded) {
            // Recursively load nested lazy nodes if expandLazy is 'expand' or 'load'
            // Also remove expand-cookies for unmatched nodes
            dfd = _loadLazyNodes(tree, local, keyList, instOpts.expandLazy ? "expand" : false, null);
          } else {
            // nothing to do
            dfd = new $.Deferred().resolve();
          }
          dfd.done(function () {
            if (local.storeSelected) {
              cookie = local._data(local.cookiePrefix + SELECTED);
              if (cookie) {
                keyList = cookie.split(instOpts.cookieDelimiter);
                for (i = 0; i < keyList.length; i++) {
                  node = tree.getNodeByKey(keyList[i]);
                  if (node) {
                    if (node.selected === undefined || instOpts.overrideSource && node.selected === false) {
                      //									node.setSelected();
                      node.selected = true;
                      node.renderStatus();
                    }
                  } else {
                    // node is no longer member of the tree: remove from cookie also
                    local._appendKey(SELECTED, keyList[i], false);
                  }
                }
              }
              // In selectMode 3 we have to fix the child nodes, since we
              // only stored the selected *top* nodes
              if (tree.options.selectMode === 3) {
                tree.visit(function (n) {
                  if (n.selected) {
                    n.fixSelection3AfterClick();
                    return "skip";
                  }
                });
              }
            }
            if (local.storeActive) {
              cookie = local._data(local.cookiePrefix + ACTIVE);
              if (cookie && (opts.persist.overrideSource || !tree.activeNode)) {
                node = tree.getNodeByKey(cookie);
                if (node) {
                  node.debug("persist: set active", cookie);
                  // We only want to set the focus if the container
                  // had the keyboard focus before
                  node.setActive(true, {
                    noFocus: true,
                    noEvents: noEvents
                  });
                }
              }
            }
            if (local.storeFocus && prevFocus) {
              node = tree.getNodeByKey(prevFocus);
              if (node) {
                // node.debug("persist: set focus", cookie);
                if (tree.options.titlesTabbable) {
                  $(node.span).find(".fancytree-title").focus();
                } else {
                  $(tree.$container).focus();
                }
                // node.setFocus();
              }
            }

            tree._triggerTreeEvent("restore", null, {});
          });
        });
        // Init the tree
        return this._superApply(arguments);
      },
      nodeSetActive: function nodeSetActive(ctx, flag, callOpts) {
        var res,
          local = this._local;
        flag = flag !== false;
        res = this._superApply(arguments);
        if (local.storeActive) {
          local._data(local.cookiePrefix + ACTIVE, this.activeNode ? this.activeNode.key : null);
        }
        return res;
      },
      nodeSetExpanded: function nodeSetExpanded(ctx, flag, callOpts) {
        var res,
          node = ctx.node,
          local = this._local;
        flag = flag !== false;
        res = this._superApply(arguments);
        if (local.storeExpanded) {
          local._appendKey(EXPANDED, node.key, flag);
        }
        return res;
      },
      nodeSetFocus: function nodeSetFocus(ctx, flag) {
        var res,
          local = this._local;
        flag = flag !== false;
        res = this._superApply(arguments);
        if (local.storeFocus) {
          local._data(local.cookiePrefix + FOCUS, this.focusNode ? this.focusNode.key : null);
        }
        return res;
      },
      nodeSetSelected: function nodeSetSelected(ctx, flag, callOpts) {
        var res,
          selNodes,
          tree = ctx.tree,
          node = ctx.node,
          local = this._local;
        flag = flag !== false;
        res = this._superApply(arguments);
        if (local.storeSelected) {
          if (tree.options.selectMode === 3) {
            // In selectMode 3 we only store the the selected *top* nodes.
            // De-selecting a node may also de-select some parents, so we
            // calculate the current status again
            selNodes = $.map(tree.getSelectedNodes(true), function (n) {
              return n.key;
            });
            selNodes = selNodes.join(ctx.options.persist.cookieDelimiter);
            local._data(local.cookiePrefix + SELECTED, selNodes);
          } else {
            // beforeSelect can prevent the change - flag doesn't reflect the node.selected state
            local._appendKey(SELECTED, node.key, node.selected);
          }
        }
        return res;
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.table.js' */ /*!
                                               * jquery.fancytree.table.js
                                               *
                                               * Render tree as table (aka 'tree grid', 'table tree').
                                               * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                               *
                                               * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                               *
                                               * Released under the MIT license
                                               * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                               *
                                               * @version 2.38.2
                                               * @date 2022-06-30T18:24:06Z
                                               */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /******************************************************************************
     * Private functions and variables
     */
    var _assert = $.ui.fancytree.assert;
    function insertFirstChild(referenceNode, newNode) {
      referenceNode.insertBefore(newNode, referenceNode.firstChild);
    }
    function insertSiblingAfter(referenceNode, newNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    /* Show/hide all rows that are structural descendants of `parent`. */
    function setChildRowVisibility(parent, flag) {
      parent.visit(function (node) {
        var tr = node.tr;
        // currentFlag = node.hide ? false : flag; // fix for ext-filter
        if (tr) {
          tr.style.display = node.hide || !flag ? "none" : "";
        }
        if (!node.expanded) {
          return "skip";
        }
      });
    }

    /* Find node that is rendered in previous row. */
    function findPrevRowNode(node) {
      var i,
        last,
        prev,
        parent = node.parent,
        siblings = parent ? parent.children : null;
      if (siblings && siblings.length > 1 && siblings[0] !== node) {
        // use the lowest descendant of the preceeding sibling
        i = $.inArray(node, siblings);
        prev = siblings[i - 1];
        _assert(prev.tr);
        // descend to lowest child (with a <tr> tag)
        while (prev.children && prev.children.length) {
          last = prev.children[prev.children.length - 1];
          if (!last.tr) {
            break;
          }
          prev = last;
        }
      } else {
        // if there is no preceding sibling, use the direct parent
        prev = parent;
      }
      return prev;
    }
    $.ui.fancytree.registerExtension({
      name: "table",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        checkboxColumnIdx: null,
        // render the checkboxes into the this column index (default: nodeColumnIdx)
        indentation: 16,
        // indent every node level by 16px
        mergeStatusColumns: true,
        // display 'nodata', 'loading', 'error' centered in a single, merged TR
        nodeColumnIdx: 0 // render node expander, icon, and title to this column (default: #0)
      },

      // Overide virtual methods for this extension.
      // `this`       : is this extension object
      // `this._super`: the virtual function that was overriden (member of prev. extension or Fancytree)
      treeInit: function treeInit(ctx) {
        var i,
          n,
          $row,
          $tbody,
          tree = ctx.tree,
          opts = ctx.options,
          tableOpts = opts.table,
          $table = tree.widget.element;
        if (tableOpts.customStatus != null) {
          if (opts.renderStatusColumns == null) {
            tree.warn("The 'customStatus' option is deprecated since v2.15.0. Use 'renderStatusColumns' instead.");
            opts.renderStatusColumns = tableOpts.customStatus;
          } else {
            $.error("The 'customStatus' option is deprecated since v2.15.0. Use 'renderStatusColumns' only instead.");
          }
        }
        if (opts.renderStatusColumns) {
          if (opts.renderStatusColumns === true) {
            opts.renderStatusColumns = opts.renderColumns;
            // } else if( opts.renderStatusColumns === "wide" ) {
            // 	opts.renderStatusColumns = _renderStatusNodeWide;
          }
        }

        $table.addClass("fancytree-container fancytree-ext-table");
        $tbody = $table.find(">tbody");
        if (!$tbody.length) {
          // TODO: not sure if we can rely on browsers to insert missing <tbody> before <tr>s:
          if ($table.find(">tr").length) {
            $.error("Expected table > tbody > tr. If you see this please open an issue.");
          }
          $tbody = $("<tbody>").appendTo($table);
        }
        tree.tbody = $tbody[0];

        // Prepare row templates:
        // Determine column count from table header if any
        tree.columnCount = $("thead >tr", $table).last().find(">th", $table).length;
        // Read TR templates from tbody if any
        $row = $tbody.children("tr").first();
        if ($row.length) {
          n = $row.children("td").length;
          if (tree.columnCount && n !== tree.columnCount) {
            tree.warn("Column count mismatch between thead (" + tree.columnCount + ") and tbody (" + n + "): using tbody.");
            tree.columnCount = n;
          }
          $row = $row.clone();
        } else {
          // Only thead is defined: create default row markup
          _assert(tree.columnCount >= 1, "Need either <thead> or <tbody> with <td> elements to determine column count.");
          $row = $("<tr />");
          for (i = 0; i < tree.columnCount; i++) {
            $row.append("<td />");
          }
        }
        $row.find(">td").eq(tableOpts.nodeColumnIdx).html("<span class='fancytree-node' />");
        if (opts.aria) {
          $row.attr("role", "row");
          $row.find("td").attr("role", "gridcell");
        }
        tree.rowFragment = document.createDocumentFragment();
        tree.rowFragment.appendChild($row.get(0));

        // // If tbody contains a second row, use this as status node template
        // $row = $tbody.children("tr").eq(1);
        // if( $row.length === 0 ) {
        // 	tree.statusRowFragment = tree.rowFragment;
        // } else {
        // 	$row = $row.clone();
        // 	tree.statusRowFragment = document.createDocumentFragment();
        // 	tree.statusRowFragment.appendChild($row.get(0));
        // }
        //
        $tbody.empty();

        // Make sure that status classes are set on the node's <tr> elements
        tree.statusClassPropName = "tr";
        tree.ariaPropName = "tr";
        this.nodeContainerAttrName = "tr";

        // #489: make sure $container is set to <table>, even if ext-dnd is listed before ext-table
        tree.$container = $table;
        this._superApply(arguments);

        // standard Fancytree created a root UL
        $(tree.rootNode.ul).remove();
        tree.rootNode.ul = null;

        // Add container to the TAB chain
        // #577: Allow to set tabindex to "0", "-1" and ""
        this.$container.attr("tabindex", opts.tabindex);
        // this.$container.attr("tabindex", opts.tabbable ? "0" : "-1");
        if (opts.aria) {
          tree.$container.attr("role", "treegrid").attr("aria-readonly", true);
        }
      },
      nodeRemoveChildMarkup: function nodeRemoveChildMarkup(ctx) {
        var node = ctx.node;
        //		node.debug("nodeRemoveChildMarkup()");
        node.visit(function (n) {
          if (n.tr) {
            $(n.tr).remove();
            n.tr = null;
          }
        });
      },
      nodeRemoveMarkup: function nodeRemoveMarkup(ctx) {
        var node = ctx.node;
        //		node.debug("nodeRemoveMarkup()");
        if (node.tr) {
          $(node.tr).remove();
          node.tr = null;
        }
        this.nodeRemoveChildMarkup(ctx);
      },
      /* Override standard render. */
      nodeRender: function nodeRender(ctx, force, deep, collapsed, _recursive) {
        var children,
          firstTr,
          i,
          l,
          newRow,
          prevNode,
          prevTr,
          subCtx,
          tree = ctx.tree,
          node = ctx.node,
          opts = ctx.options,
          isRootNode = !node.parent;
        if (tree._enableUpdate === false) {
          // $.ui.fancytree.debug("*** nodeRender _enableUpdate: false");
          return;
        }
        if (!_recursive) {
          ctx.hasCollapsedParents = node.parent && !node.parent.expanded;
        }
        // $.ui.fancytree.debug("*** nodeRender " + node + ", isRoot=" + isRootNode, "tr=" + node.tr, "hcp=" + ctx.hasCollapsedParents, "parent.tr=" + (node.parent && node.parent.tr));
        if (!isRootNode) {
          if (node.tr && force) {
            this.nodeRemoveMarkup(ctx);
          }
          if (node.tr) {
            if (force) {
              // Set icon, link, and title (normally this is only required on initial render)
              this.nodeRenderTitle(ctx); // triggers renderColumns()
            } else {
              // Update element classes according to node state
              this.nodeRenderStatus(ctx);
            }
          } else {
            if (ctx.hasCollapsedParents && !deep) {
              // #166: we assume that the parent will be (recursively) rendered
              // later anyway.
              // node.debug("nodeRender ignored due to unrendered parent");
              return;
            }
            // Create new <tr> after previous row
            // if( node.isStatusNode() ) {
            // 	newRow = tree.statusRowFragment.firstChild.cloneNode(true);
            // } else {
            newRow = tree.rowFragment.firstChild.cloneNode(true);
            // }
            prevNode = findPrevRowNode(node);
            // $.ui.fancytree.debug("*** nodeRender " + node + ": prev: " + prevNode.key);
            _assert(prevNode);
            if (collapsed === true && _recursive) {
              // hide all child rows, so we can use an animation to show it later
              newRow.style.display = "none";
            } else if (deep && ctx.hasCollapsedParents) {
              // also hide this row if deep === true but any parent is collapsed
              newRow.style.display = "none";
              //					newRow.style.color = "red";
            }

            if (prevNode.tr) {
              insertSiblingAfter(prevNode.tr, newRow);
            } else {
              _assert(!prevNode.parent, "prev. row must have a tr, or be system root");
              // tree.tbody.appendChild(newRow);
              insertFirstChild(tree.tbody, newRow); // #675
            }

            node.tr = newRow;
            if (node.key && opts.generateIds) {
              node.tr.id = opts.idPrefix + node.key;
            }
            node.tr.ftnode = node;
            // if(opts.aria){
            // 	$(node.tr).attr("aria-labelledby", "ftal_" + opts.idPrefix + node.key);
            // }
            node.span = $("span.fancytree-node", node.tr).get(0);
            // Set icon, link, and title (normally this is only required on initial render)
            this.nodeRenderTitle(ctx);
            // Allow tweaking, binding, after node was created for the first time
            //				tree._triggerNodeEvent("createNode", ctx);
            if (opts.createNode) {
              opts.createNode.call(tree, {
                type: "createNode"
              }, ctx);
            }
          }
        }
        // Allow tweaking after node state was rendered
        //		tree._triggerNodeEvent("renderNode", ctx);
        if (opts.renderNode) {
          opts.renderNode.call(tree, {
            type: "renderNode"
          }, ctx);
        }
        // Visit child nodes
        // Add child markup
        children = node.children;
        if (children && (isRootNode || deep || node.expanded)) {
          for (i = 0, l = children.length; i < l; i++) {
            subCtx = $.extend({}, ctx, {
              node: children[i]
            });
            subCtx.hasCollapsedParents = subCtx.hasCollapsedParents || !node.expanded;
            this.nodeRender(subCtx, force, deep, collapsed, true);
          }
        }
        // Make sure, that <tr> order matches node.children order.
        if (children && !_recursive) {
          // we only have to do it once, for the root branch
          prevTr = node.tr || null;
          firstTr = tree.tbody.firstChild;
          // Iterate over all descendants
          node.visit(function (n) {
            if (n.tr) {
              if (!n.parent.expanded && n.tr.style.display !== "none") {
                // fix after a node was dropped over a collapsed
                n.tr.style.display = "none";
                setChildRowVisibility(n, false);
              }
              if (n.tr.previousSibling !== prevTr) {
                node.debug("_fixOrder: mismatch at node: " + n);
                var nextTr = prevTr ? prevTr.nextSibling : firstTr;
                tree.tbody.insertBefore(n.tr, nextTr);
              }
              prevTr = n.tr;
            }
          });
        }
        // Update element classes according to node state
        // if(!isRootNode){
        // 	this.nodeRenderStatus(ctx);
        // }
      },

      nodeRenderTitle: function nodeRenderTitle(ctx, title) {
        var $cb,
          res,
          tree = ctx.tree,
          node = ctx.node,
          opts = ctx.options,
          isStatusNode = node.isStatusNode();
        res = this._super(ctx, title);
        if (node.isRootNode()) {
          return res;
        }
        // Move checkbox to custom column
        if (opts.checkbox && !isStatusNode && opts.table.checkboxColumnIdx != null) {
          $cb = $("span.fancytree-checkbox", node.span); //.detach();
          $(node.tr).find("td").eq(+opts.table.checkboxColumnIdx).html($cb);
        }
        // Update element classes according to node state
        this.nodeRenderStatus(ctx);
        if (isStatusNode) {
          if (opts.renderStatusColumns) {
            // Let user code write column content
            opts.renderStatusColumns.call(tree, {
              type: "renderStatusColumns"
            }, ctx);
          } else if (opts.table.mergeStatusColumns && node.isTopLevel()) {
            $(node.tr).find(">td").eq(0).prop("colspan", tree.columnCount).text(node.title).addClass("fancytree-status-merged").nextAll().remove();
          } // else: default rendering for status node: leave other cells empty
        } else if (opts.renderColumns) {
          opts.renderColumns.call(tree, {
            type: "renderColumns"
          }, ctx);
        }
        return res;
      },
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        var indent,
          node = ctx.node,
          opts = ctx.options;
        this._super(ctx);
        $(node.tr).removeClass("fancytree-node");
        // indent
        indent = (node.getLevel() - 1) * opts.table.indentation;
        if (opts.rtl) {
          $(node.span).css({
            paddingRight: indent + "px"
          });
        } else {
          $(node.span).css({
            paddingLeft: indent + "px"
          });
        }
      },
      /* Expand node, return Deferred.promise. */
      nodeSetExpanded: function nodeSetExpanded(ctx, flag, callOpts) {
        // flag defaults to true
        flag = flag !== false;
        if (ctx.node.expanded && flag || !ctx.node.expanded && !flag) {
          // Expanded state isn't changed - just call base implementation
          return this._superApply(arguments);
        }
        var dfd = new $.Deferred(),
          subOpts = $.extend({}, callOpts, {
            noEvents: true,
            noAnimation: true
          });
        callOpts = callOpts || {};
        function _afterExpand(ok, args) {
          // ctx.tree.info("ok:" + ok, args);
          if (ok) {
            // #1108 minExpandLevel: 2 together with table extension does not work
            // don't call when 'ok' is false:
            setChildRowVisibility(ctx.node, flag);
            if (flag && ctx.options.autoScroll && !callOpts.noAnimation && ctx.node.hasChildren()) {
              // Scroll down to last child, but keep current node visible
              ctx.node.getLastChild().scrollIntoView(true, {
                topNode: ctx.node
              }).always(function () {
                if (!callOpts.noEvents) {
                  ctx.tree._triggerNodeEvent(flag ? "expand" : "collapse", ctx);
                }
                dfd.resolveWith(ctx.node);
              });
            } else {
              if (!callOpts.noEvents) {
                ctx.tree._triggerNodeEvent(flag ? "expand" : "collapse", ctx);
              }
              dfd.resolveWith(ctx.node);
            }
          } else {
            if (!callOpts.noEvents) {
              ctx.tree._triggerNodeEvent(flag ? "expand" : "collapse", ctx);
            }
            dfd.rejectWith(ctx.node);
          }
        }
        // Call base-expand with disabled events and animation
        this._super(ctx, flag, subOpts).done(function () {
          _afterExpand(true, arguments);
        }).fail(function () {
          _afterExpand(false, arguments);
        });
        return dfd.promise();
      },
      nodeSetStatus: function nodeSetStatus(ctx, status, message, details) {
        if (status === "ok") {
          var node = ctx.node,
            firstChild = node.children ? node.children[0] : null;
          if (firstChild && firstChild.isStatusNode()) {
            $(firstChild.tr).remove();
          }
        }
        return this._superApply(arguments);
      },
      treeClear: function treeClear(ctx) {
        this.nodeRemoveChildMarkup(this._makeHookContext(this.rootNode));
        return this._superApply(arguments);
      },
      treeDestroy: function treeDestroy(ctx) {
        this.$container.find("tbody").empty();
        if (this.$source) {
          this.$source.removeClass("fancytree-helper-hidden");
        }
        return this._superApply(arguments);
      }
      /*,
      treeSetFocus: function(ctx, flag) {
      //	        alert("treeSetFocus" + ctx.tree.$container);
      ctx.tree.$container.focus();
      $.ui.fancytree.focusTree = ctx.tree;
      }*/
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.themeroller.js' */ /*!
                                                     * jquery.fancytree.themeroller.js
                                                     *
                                                     * Enable jQuery UI ThemeRoller styles.
                                                     * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                                     *
                                                     * @see http://jqueryui.com/themeroller/
                                                     *
                                                     * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                                     *
                                                     * Released under the MIT license
                                                     * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                                     *
                                                     * @version 2.38.2
                                                     * @date 2022-06-30T18:24:06Z
                                                     */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "themeroller",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        activeClass: "ui-state-active",
        // Class added to active node
        // activeClass: "ui-state-highlight",
        addClass: "ui-corner-all",
        // Class added to all nodes
        focusClass: "ui-state-focus",
        // Class added to focused node
        hoverClass: "ui-state-hover",
        // Class added to hovered node
        selectedClass: "ui-state-highlight" // Class added to selected nodes
        // selectedClass: "ui-state-active"
      },

      treeInit: function treeInit(ctx) {
        var $el = ctx.widget.element,
          opts = ctx.options.themeroller;
        this._superApply(arguments);
        if ($el[0].nodeName === "TABLE") {
          $el.addClass("ui-widget ui-corner-all");
          $el.find(">thead tr").addClass("ui-widget-header");
          $el.find(">tbody").addClass("ui-widget-conent");
        } else {
          $el.addClass("ui-widget ui-widget-content ui-corner-all");
        }
        $el.on("mouseenter mouseleave", ".fancytree-node", function (event) {
          var node = $.ui.fancytree.getNode(event.target),
            flag = event.type === "mouseenter";
          $(node.tr ? node.tr : node.span).toggleClass(opts.hoverClass + " " + opts.addClass, flag);
        });
      },
      treeDestroy: function treeDestroy(ctx) {
        this._superApply(arguments);
        ctx.widget.element.removeClass("ui-widget ui-widget-content ui-corner-all");
      },
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        var classes = {},
          node = ctx.node,
          $el = $(node.tr ? node.tr : node.span),
          opts = ctx.options.themeroller;
        this._super(ctx);
        /*
        .ui-state-highlight: Class to be applied to highlighted or selected elements. Applies "highlight" container styles to an element and its child text, links, and icons.
        .ui-state-error: Class to be applied to error messaging container elements. Applies "error" container styles to an element and its child text, links, and icons.
        .ui-state-error-text: An additional class that applies just the error text color without background. Can be used on form labels for instance. Also applies error icon color to child icons.
        .ui-state-default: Class to be applied to clickable button-like elements. Applies "clickable default" container styles to an element and its child text, links, and icons.
        .ui-state-hover: Class to be applied on mouseover to clickable button-like elements. Applies "clickable hover" container styles to an element and its child text, links, and icons.
        .ui-state-focus: Class to be applied on keyboard focus to clickable button-like elements. Applies "clickable hover" container styles to an element and its child text, links, and icons.
        .ui-state-active: Class to be applied on mousedown to clickable button-like elements. Applies "clickable active" container styles to an element and its child text, links, and icons.
        */
        // Set ui-state-* class (handle the case that the same class is assigned
        // to different states)
        classes[opts.activeClass] = false;
        classes[opts.focusClass] = false;
        classes[opts.selectedClass] = false;
        if (node.isActive()) {
          classes[opts.activeClass] = true;
        }
        if (node.hasFocus()) {
          classes[opts.focusClass] = true;
        }
        // activeClass takes precedence before selectedClass:
        if (node.isSelected() && !node.isActive()) {
          classes[opts.selectedClass] = true;
        }
        $el.toggleClass(opts.activeClass, classes[opts.activeClass]);
        $el.toggleClass(opts.focusClass, classes[opts.focusClass]);
        $el.toggleClass(opts.selectedClass, classes[opts.selectedClass]);
        // Additional classes (e.g. 'ui-corner-all')
        $el.addClass(opts.addClass);
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  /*! Extension 'jquery.fancytree.wide.js' */ /*!
                                              * jquery.fancytree.wide.js
                                              * Support for 100% wide selection bars.
                                              * (Extension module for jquery.fancytree.js: https://github.com/mar10/fancytree/)
                                              *
                                              * Copyright (c) 2008-2021, Martin Wendt (https://wwWendt.de)
                                              *
                                              * Released under the MIT license
                                              * https://github.com/mar10/fancytree/wiki/LicenseInfo
                                              *
                                              * @version 2.38.2
                                              * @date 2022-06-30T18:24:06Z
                                              */

  (function (factory) {
    if (typeof define === "function" && define.amd) {
      // AMD. Register as an anonymous module.
      define(["jquery", "./jquery.fancytree"], factory);
    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
      // Node/CommonJS
      require("./jquery.fancytree");
      module.exports = factory(require("jquery"));
    } else {
      // Browser globals
      factory(jQuery);
    }
  })(function ($) {
    "use strict";

    var reNumUnit = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/; // split "1.5em" to ["1.5", "em"]

    /*******************************************************************************
     * Private functions and variables
     */
    // var _assert = $.ui.fancytree.assert;

    /* Calculate inner width without scrollbar */
    // function realInnerWidth($el) {
    // 	// http://blog.jquery.com/2012/08/16/jquery-1-8-box-sizing-width-csswidth-and-outerwidth/
    // //	inst.contWidth = parseFloat(this.$container.css("width"), 10);
    // 	// 'Client width without scrollbar' - 'padding'
    // 	return $el[0].clientWidth - ($el.innerWidth() -  parseFloat($el.css("width"), 10));
    // }

    /* Create a global embedded CSS style for the tree. */
    function defineHeadStyleElement(id, cssText) {
      id = "fancytree-style-" + id;
      var $headStyle = $("#" + id);
      if (!cssText) {
        $headStyle.remove();
        return null;
      }
      if (!$headStyle.length) {
        $headStyle = $("<style />").attr("id", id).addClass("fancytree-style").prop("type", "text/css").appendTo("head");
      }
      try {
        $headStyle.html(cssText);
      } catch (e) {
        // fix for IE 6-8
        $headStyle[0].styleSheet.cssText = cssText;
      }
      return $headStyle;
    }

    /* Calculate the CSS rules that indent title spans. */
    function renderLevelCss(containerId, depth, levelOfs, lineOfs, labelOfs, measureUnit) {
      var i,
        prefix = "#" + containerId + " span.fancytree-level-",
        rules = [];
      for (i = 0; i < depth; i++) {
        rules.push(prefix + (i + 1) + " span.fancytree-title { padding-left: " + (i * levelOfs + lineOfs) + measureUnit + "; }");
      }
      // Some UI animations wrap the UL inside a DIV and set position:relative on both.
      // This breaks the left:0 and padding-left:nn settings of the title
      rules.push("#" + containerId + " div.ui-effects-wrapper ul li span.fancytree-title, " + "#" + containerId + " li.fancytree-animating span.fancytree-title " +
      // #716
      "{ padding-left: " + labelOfs + measureUnit + "; position: static; width: auto; }");
      return rules.join("\n");
    }

    // /**
    //  * [ext-wide] Recalculate the width of the selection bar after the tree container
    //  * was resized.<br>
    //  * May be called explicitly on container resize, since there is no resize event
    //  * for DIV tags.
    //  *
    //  * @alias Fancytree#wideUpdate
    //  * @requires jquery.fancytree.wide.js
    //  */
    // $.ui.fancytree._FancytreeClass.prototype.wideUpdate = function(){
    // 	var inst = this.ext.wide,
    // 		prevCw = inst.contWidth,
    // 		prevLo = inst.lineOfs;

    // 	inst.contWidth = realInnerWidth(this.$container);
    // 	// Each title is precceeded by 2 or 3 icons (16px + 3 margin)
    // 	//     + 1px title border and 3px title padding
    // 	// TODO: use code from treeInit() below
    // 	inst.lineOfs = (this.options.checkbox ? 3 : 2) * 19;
    // 	if( prevCw !== inst.contWidth || prevLo !== inst.lineOfs ) {
    // 		this.debug("wideUpdate: " + inst.contWidth);
    // 		this.visit(function(node){
    // 			node.tree._callHook("nodeRenderTitle", node);
    // 		});
    // 	}
    // };

    /*******************************************************************************
     * Extension code
     */
    $.ui.fancytree.registerExtension({
      name: "wide",
      version: "2.38.2",
      // Default options for this extension.
      options: {
        iconWidth: null,
        // Adjust this if @fancy-icon-width != "16px"
        iconSpacing: null,
        // Adjust this if @fancy-icon-spacing != "3px"
        labelSpacing: null,
        // Adjust this if padding between icon and label != "3px"
        levelOfs: null // Adjust this if ul padding != "16px"
      },

      treeCreate: function treeCreate(ctx) {
        this._superApply(arguments);
        this.$container.addClass("fancytree-ext-wide");
        var containerId,
          cssText,
          iconSpacingUnit,
          labelSpacingUnit,
          iconWidthUnit,
          levelOfsUnit,
          instOpts = ctx.options.wide,
          // css sniffing
          $dummyLI = $("<li id='fancytreeTemp'><span class='fancytree-node'><span class='fancytree-icon' /><span class='fancytree-title' /></span><ul />").appendTo(ctx.tree.$container),
          $dummyIcon = $dummyLI.find(".fancytree-icon"),
          $dummyUL = $dummyLI.find("ul"),
          // $dummyTitle = $dummyLI.find(".fancytree-title"),
          iconSpacing = instOpts.iconSpacing || $dummyIcon.css("margin-left"),
          iconWidth = instOpts.iconWidth || $dummyIcon.css("width"),
          labelSpacing = instOpts.labelSpacing || "3px",
          levelOfs = instOpts.levelOfs || $dummyUL.css("padding-left");
        $dummyLI.remove();
        iconSpacingUnit = iconSpacing.match(reNumUnit)[2];
        iconSpacing = parseFloat(iconSpacing, 10);
        labelSpacingUnit = labelSpacing.match(reNumUnit)[2];
        labelSpacing = parseFloat(labelSpacing, 10);
        iconWidthUnit = iconWidth.match(reNumUnit)[2];
        iconWidth = parseFloat(iconWidth, 10);
        levelOfsUnit = levelOfs.match(reNumUnit)[2];
        if (iconSpacingUnit !== iconWidthUnit || levelOfsUnit !== iconWidthUnit || labelSpacingUnit !== iconWidthUnit) {
          $.error("iconWidth, iconSpacing, and levelOfs must have the same css measure unit");
        }
        this._local.measureUnit = iconWidthUnit;
        this._local.levelOfs = parseFloat(levelOfs);
        this._local.lineOfs = (1 + (ctx.options.checkbox ? 1 : 0) + (ctx.options.icon === false ? 0 : 1)) * (iconWidth + iconSpacing) + iconSpacing;
        this._local.labelOfs = labelSpacing;
        this._local.maxDepth = 10;

        // Get/Set a unique Id on the container (if not already exists)
        containerId = this.$container.uniqueId().attr("id");
        // Generated css rules for some levels (extended on demand)
        cssText = renderLevelCss(containerId, this._local.maxDepth, this._local.levelOfs, this._local.lineOfs, this._local.labelOfs, this._local.measureUnit);
        defineHeadStyleElement(containerId, cssText);
      },
      treeDestroy: function treeDestroy(ctx) {
        // Remove generated css rules
        defineHeadStyleElement(this.$container.attr("id"), null);
        return this._superApply(arguments);
      },
      nodeRenderStatus: function nodeRenderStatus(ctx) {
        var containerId,
          cssText,
          res,
          node = ctx.node,
          level = node.getLevel();
        res = this._super(ctx);
        // Generate some more level-n rules if required
        if (level > this._local.maxDepth) {
          containerId = this.$container.attr("id");
          this._local.maxDepth *= 2;
          node.debug("Define global ext-wide css up to level " + this._local.maxDepth);
          cssText = renderLevelCss(containerId, this._local.maxDepth, this._local.levelOfs, this._local.lineOfs, this._local.labelSpacing, this._local.measureUnit);
          defineHeadStyleElement(containerId, cssText);
        }
        // Add level-n class to apply indentation padding.
        // (Setting element style would not work, since it cannot easily be
        // overriden while animations run)
        $(node.span).addClass("fancytree-level-" + level);
        return res;
      }
    });
    // Value returned by `require('jquery.fancytree..')`
    return $.ui.fancytree;
  }); // End of closure

  // Value returned by `require('jquery.fancytree')`
  return $.ui.fancytree;
}); // End of closure
/**
 * EtudesRu v.3.0.1
 *
 * Last Mod Date: 2020-10-16
 */

$(function () {
  var $html = $('html'),
    $window = $(window);
  $window.on('cardswiper:init', function (e, params) {
    if (!params.swiperRoot || !params.swiperRoot.get(0)) return false;

    //console.log( 'cardswiper:init' );

    initCardSwiper(params.swiperRoot);
  }).on('cardswiper:destroy', function (e, params) {
    //console.log( 'cardswiper:destroy' );

    //if ( !params.swiperRoot || !params.swiperRoot.get( 0 ) ) return false;

    destroyCardSwiper(params.swiperRoot);
  });
  var destroyCardSwiper = function destroyCardSwiper($swiperRoot) {
    //console.log( 'destroy', $swiperRoot.swiper );

    if ($swiperRoot.swiper) $swiperRoot.swiper.destroy();

    //$swiperRoot.swiper = null;
  };

  var initCardSwiper = function initCardSwiper($swiperRoot) {
    //$swiperRoot.swiper = null;

    var arrInputs = ['input', 'textarea', 'button'];
    var arrStopKeys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', /*'Space', ' ',*/'Home', 'End'];
    var arrStopInputKeys = ['PageDown', 'PageUp'];
    var arrClosetKeys = ['Escape'];
    var $imgXlinks = $swiperRoot.find('[data-xlink="img"]'),
      $zoomSwiper = $swiperRoot.find('[data-zoom-viewer-popup]'),
      $elSwiper = $swiperRoot.find('[data-swiper-block="object"]'),
      urlTemplate = $zoomSwiper.data('url'),
      $elCards = $swiperRoot.parent(),
      autoCard = $elCards.data('auto');
    var $btnRotate = $swiperRoot.find('[data-rotate]'),
      $btnClose = $swiperRoot.find('[data-close-swiper]');
    var tAnimation = 250,
      tLazyInit = 1000,
      bSwiperInitialized = false;
    if (!$zoomSwiper.length || !$elSwiper || !urlTemplate) return false;

    //try { tAnimation = 50 + Math.max.apply( null, $( '[data-global-fader]' ).getAnimationDuration()[ 'transition-duration' ] ); } catch ( E ) { }

    //console.log(tAnimation)

    // LAZY INIT IMG SWIPER -- we don't need it immediately
    var timerInitSwiper = setTimeout(function () {
      initImgSwipers();
    }, tLazyInit);
    $elCards.data('auto', null);
    $elCards.attr('data-auto', null);

    // ADD HANDLERS TO TEXT
    $imgXlinks.on('click', function (e) {
      jQuery.powerTip.hide(null, true);

      //if ( $zoomSwiper ) return;

      var $this = $(e.delegateTarget),
        imgRel = $this.data('rel'),
        imgXref = $this.data('xref'),
        imgID = imgRel ? imgRel : imgXref;
      if (!bSwiperInitialized) {
        clearTimeout(timerInitSwiper);
        initImgSwipers();
      }
      try {
        $swiperRoot.swiper.slideTo(imgID - 1, 0);
        $swiperRoot.swiper.keyboard.enable();
      } catch (e) {}
      requestAnimationFrame(function () {
        if (window._isMobile || window._isTablet) $html.addClass('is-scroll-disabled');
        $html.addClass('global-fader-visible');
        $zoomSwiper.addClass('is-visible');
      });
      requestAnimationFrame(function () {
        $html.addClass('global-fader-active');
        $zoomSwiper.addClass('is-active');
        changeHistoryState($swiperRoot.swiper);
      });
      setTimeout(function () {
        $zoomSwiper.addClass('is-conrollable');
      }, tAnimation);
      e.preventDefault();
      e.stopPropagation();
      return false;
    }).on('mousedown', function (e) {});
    $btnClose.on('click', function () {
      if (!$zoomSwiper) return false;
      if ($zoomSwiper && $zoomSwiper['trackurlbyid']) {}
      $swiperRoot.swiper.keyboard.disable();
      $zoomSwiper.removeClass('is-conrollable');
      requestAnimationFrame(function () {
        $html.removeClass('global-fader-active');
        $zoomSwiper.removeClass('is-active');
        changeHistoryState($swiperRoot.swiper, true);
      });
      setTimeout(function () {
        requestAnimationFrame(function () {
          $html.removeClass('global-fader-visible');
          $zoomSwiper.removeClass('is-visible');
          $html.removeClass('is-scroll-disabled');
        });
      }, tAnimation);
    });
    $btnRotate.on('click', function () {
      if (!$swiperRoot.swiper || $btnRotate.hasClass('is-disabled')) return false;
      var $figure = $($swiperRoot.swiper.slides[$swiperRoot.swiper.realIndex]).find('figure');
      if (!$figure.get(0) || !$figure.hasClass('flippable')) return false;
      $figure.toggleClass('is-flipped');
    });

    // CLOSE BTN + SWIPE UP TO CLOSE
    $zoomSwiper.on('click', function (e) {
      if (e.target !== e.delegateTarget) return;
      $btnClose.trigger('click');
    }).on('swipeup', function (e) {
      $btnClose.trigger('click');
    });

    // --- KBD ---
    $html.on('keydown', function (e) {
      var $this = $(e.target);
      if (!$zoomSwiper || !$this.get(0)) return;
      if ($.inArray(e.key, arrClosetKeys) !== -1) return $btnClose.trigger('click') && e.preventDefault() && false;
      if ($.inArray($this.tagNameLC(), arrInputs) !== -1 && $.inArray(e.key, arrStopInputKeys) === -1) return;

      // HOME/END SUPPORT FOR SLIDER
      switch (e.key) {
        case 'PageUp':
          break;
        case 'PageDown':
          break;
        case 'Home':
          //console.log( 'home', $swiperRoot.attr( 'id' ) )
          $swiperRoot.swiper.slideTo(0);
          break;
        case 'End':
          $swiperRoot.swiper.slideTo($swiperRoot.swiper.slides.length);
          break;
        case ' ':
          return $btnRotate.trigger('click') && e.preventDefault() && false;
          break;
      }
      if ($.inArray(e.key, arrStopKeys) !== -1) return e.preventDefault() && false;
    });

    // --- DISABLE WHEEL ---
    $html.get(0).addEventListener('wheel', function (e) {
      //if ( !$zoomSwiper ) return;

      if (!$html.hasClass('global-fader-active')) return;
      e.preventDefault();
      return false;
    }, {
      passive: false
    });

    // INIT IMG SWIPERS ROUTINE
    var initImgSwipers = function initImgSwipers() {
      var numSlides = $elSwiper.find('[data-slide]').length,
        swiper = $elSwiper.find('[data-swiper]').get(0),
        btnPrev = $elSwiper.find('.btn-prev').get(0),
        btnNext = $elSwiper.find('.btn-next').get(0),
        paginator = $elSwiper.find('[data-paginator]').get(0),
        scrollbar = $elSwiper.find('.swiper-scrollbar').get(0);
      $swiperRoot.swiper = new Swiper(swiper, {
        //slidesPerView        : 'auto',
        slidesPerView: !window._isMobile && !window._isTablet ? 1.8 : 1,
        centeredSlides: true,
        spaceBetween: !window._isMobile && !window._isTablet ? 10 : 0,
        //effect         : ( !window._isMobile && !window._isTablet ) ? 'coverflow' : 'slide',
        effect: 'slide',
        //coverflowEffect: {
        //	slideShadows: false,
        //	rotate      : 30,
        //	stretch     : window.innerWidth / 3
        //},
        //freeMode : true,
        //freeModeSticky : true,
        //loop          : true,
        grabCursor: true,
        mousewheel: true,
        keyboard: {
          enabled: false,
          onlyInViewport: true,
          pageUpDown: true
        },
        preloadImages: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          elementClass: 'lazy-load',
          loadingClass: 'lazy-loading',
          loadedClass: 'lazy-loaded',
          preloaderClass: 'lazy-preloader'
        },
        //autoHeight: true,
        pagination: {
          el: paginator,
          clickable: false,
          type: 'fraction'
          //dynamicBullets : true,
          //dynamicMainBullets : 1,
          //fixWidth : 5
        },

        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
          disabledClass: 'is-disabled',
          hiddenClass: 'is-hidden',
          lockClass: 'is-hidden'
        },
        scrollbar: {
          el: scrollbar,
          draggable: true,
          dragSize: 50
        },
        watchSlidesVisibility: true,
        on: {
          init: function init(swiper) {
            $elSwiper.addClass('is-loaded');
            flippableState(swiper);
            changeHistoryState(swiper);
          },
          slideChange: function slideChange(swiper, slideEl) {
            flippableState(swiper);
            changeHistoryState(swiper);
          },
          lazyImageLoad: function lazyImageLoad(swiper, slideEl, imageEl) {},
          lazyImageReady: function lazyImageReady(swiper, slideEl, imageEl) {
            $(slideEl).find('[data-img] img');
            var $el = $(slideEl).find('[data-img]');
            $($el).addClass('is-just-loaded');
            setTimeout(function () {
              $($el).addClass('is-loaded');
            }, 250);
          }
        },
        a11y: false,
        breakpoints: {
          //568: {
          //	slidesPerView: 1,
          //spaceBetween : 20,
          //},
          //768: {
          //	slidesPerView: 1.2,
          //	spaceBetween : 20,
          //},
        }
      });

      //console.log('create ', $swiperRoot, $swiperRoot.swiper);
      //$swiperRoot.swiper.destroy();

      setTimeout(function () {
        bSwiperInitialized = true;
      }, 0);
    }; // initImgSwipers

    // --- MAKE FLIPPABLE ---
    var flippableState = function flippableState(swiper) {
      var $figure = $(swiper.slides[swiper.realIndex]).find('figure');
      if (!$figure.get(0) || !$figure.hasClass('flippable')) return $btnRotate.addClass('is-disabled');
      $btnRotate.removeClass('is-disabled');
    };

    // --- CHANGE URL STATE ---
    var changeHistoryState = function changeHistoryState(swiper) {
      var cleanState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!$html.hasClass('global-fader-visible')) return;
      var data = {
          img: ''
        },
        title = document.title,
        url = urlTemplate;
      if (cleanState) {
        url = url.replace('&card=%IMG%', '');
      } else {
        url = url.replace('%IMG%', swiper.realIndex + 1 || 1);
      }
      history.replaceState(data, title, url);
    };

    // --- AUTOLOAD ---
    if (autoCard) {
      //console.log(autoCard);
      jQuery.powerTip.hide(null, true);
      setTimeout(function () {
        var $autoXref = $swiperRoot.find('[data-rel=' + autoCard + ']');
        if ($autoXref.get(0)) {
          $elCards.data('card', null);
          $autoXref.trigger('click');
        } else {
          changeHistoryState(null, true);
        }
      }, 1);
    }
  };
});
/**
 * jMiniCore System Core / ImgCat / Cards v 0.9
 *
 * Last Mod Date: 2022-11-15
 */

$(function () {
  // on page load

  var $window = $(window),
    $document = $(document);
  var PH_CAT = $('#ph-cat');
  if (!PH_CAT.get(0) || !(dataRPC = PH_CAT.data('rpc')) || !(dataIdCat = PH_CAT.data('idcat'))) return false;
  var TREE_RPC = "/".concat(dataRPC, "/");
  var ID_CAT = dataIdCat;
  var METHOD_RPC = 'GET';
  var xhrImages = null;
  $window.on('cards:load', function (e, params) {
    loadCards(params.key, params.el, params.query, params.count);
  }).on('cards:abort', function (e, params) {
    if (xhrImages) xhrImages.abort();
    params.el.parent().removeClass('is-loading');
  }).on('cards:clear', function (e, params) {
    if (xhrImages) xhrImages.abort();
    params.el.html('');
  }).on('search:loadtree', function (e, params) {
    $($EL_SRCH.cards).addClass('is-loading').html('');
  });
  function loadCards() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var $el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$el || key === null || $el.curLoaded === key) return false;
    if (xhrImages) xhrImages.abort();
    $($EL_BRWS.treepath).parent().addClass('is-loading');
    $el.parent().addClass('is-loading');
    $el.html('');
    xhrImages = $.ajax({
      type: METHOD_RPC,
      url: TREE_RPC,
      data: {
        rpc: 'get-images',
        sep: key,
        query: query,
        count: count,
        idcat: ID_CAT
      }
    }).always(function () {
      setTimeout(function (_) {
        $($EL_BRWS.treepath).parent().removeClass('is-loading');
        $el.parent().removeClass('is-loading');
      }, 50);
    }).done(function (msg) {
      $el.curLoaded = key;
      requestAnimationFrame(function (_) {
        $el.html(msg.cards);
        $($EL_BRWS.treepath).html(msg.treepath + '<div>&zwj;</div>');
        if (!query) window.htmlTreePath = $($EL_BRWS.treepath).html();
        setTimeout(function (_) {
          //console.log($el.attr('id'));

          $window.trigger('image:preload');
          $window.trigger('cardswiper:destroy', {
            swiperRoot: $el
          });
          $window.trigger('cardswiper:init', {
            swiperRoot: $el
          });
          initTips($el);
        }, 10);
      });
    });
  }
  function initTips($el) {
    var $imgTips = $el.find('[data-xlink="img"][data-rel]');
    $imgTips.powerTip({
      openDelay: 1000,
      popupClass: 'object-img w600',
      followMouse: true,
      offset: 0,
      openEvents: ['mouseenter']
      //smartPlacement: false,
      //placement     : 'n'
    }).on({
      powerTipPreRender: function powerTipPreRender(e) {
        if (window._isMobile || window._isTablet) return false;
        var $this = $(this),
          $imgEl = $el.find('[data-xlink="img"][data-rel="' + $this.data('rel') + '"]');

        //console.log( $imgEl );

        //<a data-xlink="img" data-xref="1"
        //console.log( 'powerTipPreRender', this, $imgEl );

        $(this).data('powertipjq', $imgEl);
      },
      powerTipRender: function powerTipRender() {
        //$( '#powerTip' ).find( '.title' ).text( 'This is a dynamic title.' );
      },
      powerTipOpen: function powerTipOpen() {
        //$( '#powerTip' ).find( '.title' ).animate( { opacity: .1 }, 1000 ).animate( { opacity: 1 }, 1000 );
      },
      powerTipClose: function powerTipClose() {
        //$( '#powerTip' ).find( '.title' ).stop( true, true );
        //$( '#powerTip figure' ).fade( 0 );
        $('#powerTip figure').css('opacity', 0);
      }
    });
  }
});
$(function () {
  $('.scroll-top').on('click', function (_) {
    $('.ph-app').get(0).scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  });
  var minLen = 1;
  var $window = $(window),
    $document = $(document),
    $html = $('html');
  var $searchBox = $('.box-tree-search'),
    $searchForm = $searchBox.find('form'),
    $boxQuery = $searchBox.find('[data-input]'),
    $txtQuery = $searchBox.find('#input--query'),
    $elTable = $('.data-table'),
    $elRows = $('.data-table tr');
  var prevQuery = [],
    curQuery = [],
    tDeb = null;
  if (!$searchForm.length || !$elTable.length) return;
  var srchTitle = $elRows.map(function () {
    return [$(this).data('text')];
  }).toArray();
  var srchYears = $elRows.map(function () {
    return [$(this).data('years')];
  }).toArray();
  $searchBox.on('propertychange change click keyup input paste', '[data-input]', function (e) {
    clearTimeout(tDeb);
    setTimeout(function (_) {
      var inpQuery = $txtQuery.val();
      if (inpQuery.length >= minLen) {
        doSearch(inpQuery);
      } else {
        doSearch('');
      }
    }, 200);
  });
  var doSearch = function doSearch(query) {
    clearTimeout(tDeb);
    var bFound;
    query = $.trim(query).replace(/ +/g, ' ').toLowerCase().split(' ');
    if (query.toString() === curQuery.toString() && query.length) return;
    if (query.length && query[0] !== '') {
      $searchBox.addClass('is-clearable');
      $(srchTitle).each(function (idxTitle, elTitle) {
        bFound = true;
        if (!elTitle) return null;
        $(query).each(function (idxChunk, elChunk) {
          if (/[12]\d{3}/.test(elChunk.toString())) {
            var elYear = srchYears[idxTitle],
              year = parseInt(elChunk.toString());
            $(elYear).each(function (idxYrChunk, elYrChunk) {
              bFound = !bFound ? false : year >= elYrChunk.from && year <= elYrChunk.to;
            });
          } else {
            if (elTitle && elTitle.includes) bFound = !bFound ? false : elTitle.includes(elChunk);
          }
        });
        $($elRows.get(idxTitle))[!bFound ? 'addClass' : 'removeClass']('is-hidden');
      });
    } else {
      $searchBox.removeClass('is-clearable');
      $txtQuery.val('');
      $elRows.removeClass('is-hidden');
    }
    curQuery = query;
  };
  $html.on('click', '[data-action="clear"]', function (e) {
    doSearch('');
  });
  $window.on('keyup', '', function (e) {
    if (e.keyCode === 27 && curQuery.length) doSearch('');
  });
});
/**
 * jMiniCore System Core / Search v 0.9
 *
 * Last Mod Date: 2022-11-25
 */
$(function () {
  var $window = $(window);
  var minLen = 1;
  var $html = $('html'),
    $searchBox = $('.box-tree-search'),
    $elLayout = $('.imgcat-layout'),
    $searchForm = $searchBox.find('form'),
    $boxQuery = $searchBox.find('[data-input]'),
    $txtQuery = $searchBox.find('#input--query'),
    tAnimation = 250;
  if (!$searchForm.length) return;
  window.htmlTreePath = $($EL_BRWS.treepath).html();

  //console.log($txtQuery);

  var prevQuery = null,
    curQuery = null;
  var $xhrSearch = null,
    searchState = null;

  /**
   * SEARCH FORM ON SUBMIT
   */
  $searchForm.on('submit', function (e) {
    $window.trigger('search:do');
    e.originalEvent.preventDefault();
    return true;
  });

  /**
   * WINDOW MESSAGING
   */
  $window.on('search:init', function (_) {
    searchState = 'init';
    setStateURL();

    //$window.trigger( 'search:do' );
  }).on('search:do', function (_) {
    var strQuery = String($txtQuery.val());
    if (prevQuery === strQuery || strQuery.length < minLen) return false;
    $elLayout.addClass('search-state-void mode-search').removeClass('mode-browse');
    $searchBox.addClass('is-loading ');
    $window.trigger('search:loadtree', {
      query: strQuery,
      state: searchState
    });
    $txtQuery.attr('readonly', '1').blur();
    inputControlState('inv');
  }).on('search:done', function (_) {
    var strQuery = String($txtQuery.val());
    prevQuery = strQuery;
    $searchBox.removeClass('is-loading');
    $txtQuery.attr('readonly', null).focus();
    inputControlState(strQuery.length ? 'clr' : 'inv');
    $window.trigger('image:preload');
  }).on('search:clear', function (_) {
    $elLayout.addClass('search-state-void mode-browse').removeClass('mode-search');
    $searchBox.removeClass('is-loading');
    prevQuery = null;
    curQuery = null;
    $txtQuery.val('');
    inputControlState('inv');
  });

  /**
   * INPUT CONTROLS (CLEAR/SEARCH) HANDLERS
   */
  $searchBox.on('click', '[data-action="go"]', function (e) {
    $window.trigger('search:do');
    //$searchForm.trigger('submit');
    e.originalEvent.preventDefault();
    return false;
  });
  $html.on('click', '[data-action="clear"]', function (e) {
    $window.trigger('search:clear');
  });

  /**
   * MONITOR INPUT CHANGE
   */
  $searchBox.on('propertychange change click keyup input paste', '[data-input]', function (e) {
    var inpQuery = $txtQuery.val();
    if (prevQuery !== inpQuery && inpQuery.length >= minLen) inputControlState('srch');else if (prevQuery === curQuery && inpQuery.length >= minLen || prevQuery) inputControlState('clr');else inputControlState('inv');
  });

  /**
   * REWRITE URL HASH
   */
  var setStateURL = function setStateURL() {
    return;

    /*let hashURL = '';
    let cleanQuery = cleanQueryString( curQuery ? curQuery : '' );
    let txtQuery = cleanQueryString( $txtQuery.val() );
    		switch ( searchState ) {
    	case 'init':
    		if ( !txtQuery.length ) history.replaceState( null, null, ' ' );
    		break;
    			case 'closed':
    		history.replaceState( null, null, ' ' );
    		break;
    			default:
    		if ( cleanQuery.length ) {
    			hashURL += '#query=' + cleanQuery;
    			if ( curPage > 1 ) hashURL += '&p=' + curPage
    		}
    		history.replaceState( null, null, hashURL );
    		break;
    }*/
  };

  /**
   * CHECK IF WE NEED TO AUTOOPEN SEARCH
   */
  var launchSearch = function launchSearch() {
    return false;

    /*
    		let reqURL = location
    			.hash.substr( 1 )
    			.split( '&' )
    			.map( v => v.split( '=' ) )
    			.reduce( ( pre, [ key, value ] ) => ( { ...pre, [ key ]: value } ), {} );
    				let reqQuery = cleanQueryString( decodeURI( reqURL[ 'query' ] ? reqURL[ 'query' ] : '' ) );
    				if ( reqQuery.length ) {
    			prevQuery = reqQuery;
    			$txtQuery.val( reqQuery );
    			$( '[data-open-search].do-open' ).trigger( 'click' );
    		}
    */
  };

  setTimeout(function (_) {
    launchSearch();
  }, tAnimation);

  /**
   * HELPERS
   */
  var inputControlState = function inputControlState(state) {
    switch (state) {
      case 'inv':
        $searchBox.removeClass('is-searchable').removeClass('is-clearable');
        break;
      case 'clr':
        $searchBox.removeClass('is-searchable').addClass('is-clearable');
        break;
      case 'srch':
        $searchBox.addClass('is-searchable').addClass('is-clearable');
        break;
    }
  };

  /**
   *
   */
  var cleanQueryString = function cleanQueryString(str) {
    if (!str || !str.length) return '';
    return str.replace(/[~`@#$%^&*={}\[\];:\'<>.,\/\\\?_]/g, '');
  };
});
/** * jMiniCore System Core / ImgCat / Tree / Browse v 0.9 * * Last Mod Date: 2022-11-15 */

$(function () {
  // on page load

  var $window = $(window),
    $document = $(document);
  var PH_CAT = $('#ph-cat');
  if (!PH_CAT.get(0) || !(dataRPC = PH_CAT.data('rpc')) || !(dataIdCat = PH_CAT.data('idcat'))) return false;
  var TREE_RPC = "/".concat(dataRPC, "/");
  var ID_CAT = dataIdCat;
  var $elLayout = $('.imgcat-layout'),
    $elTree = $($EL_BRWS.tree),
    $elCards = $($EL_BRWS.cards);
  if (!$elTree.get(0)) return false;
  window.treeLoaded = false;
  window.timerLoad = null;
  $window.on('search:clear', function (e, data) {
    setTimeout(function (_) {
      window.history.replaceState({
        url: TREE_RPC
      }, '', "".concat(TREE_RPC).concat(ID_CAT, "/") + $elTree.curLoaded ? '?sep=' + $elTree.curLoaded : '');
    }, 10);
  });
  $elTree.fancytree($.extend({}, TREE_OPTS, {
    source: {
      url: TREE_RPC,
      data: {
        key: '',
        rpc: 'get-tree',
        idcat: ID_CAT
      }
    },
    activate: function activate(event, data) {
      var node = data.node;
      $elTree.curLoaded = node.key;
      window.history.replaceState({
        url: TREE_RPC
      }, '', "".concat(TREE_RPC).concat(ID_CAT, "/") + $elTree.curLoaded ? '?sep=' + $elTree.curLoaded : '');

      //loadCards( node.key );
      clearTimeout(window.timerLoad);
      $window.trigger('cards:abort', {
        el: $elCards
      });
      if (data.node.hasChildren()) {
        setTimeout(function (_) {
          data.node.children[0].setExpanded(true);
          data.node.children[0].setActive();
        }, 1);
      } else {
        window.timerLoad = setTimeout(function (_) {
          //console.log( "LOAD CARDS " + node.key )
          $window.trigger('cards:load', {
            key: node.key,
            el: $elCards
          });
        }, 10);
      }
    },
    loadChildren: function loadChildren(event, data) {
      if (data.node.hasChildren() && window.treeLoaded) {
        //console.log( 'has children' );
        //console.log( data.node.children[ 0 ] );

        try {
          clearTimeout(window.timerLoad);
          $window.trigger('cards:abort', {
            el: $elCards
          });
          setTimeout(function (_) {
            //console.log("ACTIVATE NODE " + data.node.children[ 0 ]);
            data.node.children[0].setExpanded(true);
            data.node.children[0].setActive();
          }, 1);
        } catch (e) {}
      }
    },
    init: function init(event, data) {
      try {
        var expKey;
        var expKeyPath;
        if ((expKey = data.tree.$div.data('tree-expand-key')) && (expKeyPath = data.tree.$div.data('tree-expand-keypath'))) {
          var expandTree = function expandTree($elTree, hierarchy) {
            var activateNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            $elTree.fancyTree.loadKeyPath(hierarchy).progress(function (data) {
              if (data.status === "loaded") {
                //$elTree.fancyTree.activateKey( data.node.key );
              } else if (data.status === "ok") {}
            }).done(function () {
              if (activateNode) {
                setTimeout(function () {
                  $elTree.fancyTree.getNodeByKey(activateNode).setActive();
                  $elTree.fancyTree.getNodeByKey(activateNode).setExpanded(true);
                  window.treeLoaded = true;
                }, 1);
              }
            });
          };
          expandTree($elTree, expKeyPath, expKey);
        } else {
          //$window.trigger( 'cards:abort', { el: $elCards } );
          setTimeout(function (_) {
            var item2act = $elTree.fancyTree.getRootNode().getChildren();
            if (item2act.length) {
              item2act[0].setActive();
              item2act[0].setExpanded(true);
            }
          }, 1);
          window.treeLoaded = true;
        }
      } catch (e) {}
      $elTree.parent().removeClass('is-loading');
    },
    lazyLoad: function lazyLoad(event, data) {
      var node = data.node;
      data.result = {
        url: TREE_RPC,
        data: {
          key: node.key,
          rpc: 'get-tree',
          idcat: ID_CAT
        }
      };
    }
  }));
  $elTree.fancyTree = $.ui.fancytree.getTree($elTree);

  /**	 * TREE-PATH NAVIGATOR	 */
  $document.on('click', '[data-sep]', function (e) {
    var $el = $(e.currentTarget),
      key = $el.get(0) ? $el.data('sep') : null;
    if (key) {
      if (key === '/') {
        if (!$elLayout.hasClass('mode-search')) {
          //let anode = $elTree.fancyTree.getActiveNode();
          //
          //if ( anode ) {
          //	anode.setFocus( false );
          //	anode.setActive( false );
          //}
          //console.log($elTree.fancyTree.getFirstChild());

          //$elTree.fancyTree.expandAll( false );
          //window.history.replaceState( { url: TREE_RPC }, '', `${TREE_RPC}${ID_CAT}/` );

          //$window.trigger( 'cards:load', { key: $elTree.fancyTree.getFirstChild()['key'], el: $elCards } );

          setTimeout(function (_) {
            var anode = $elTree.fancyTree.getActiveNode();
            var item2act = $elTree.fancyTree.getRootNode().getChildren();
            if (anode !== item2act) {
              //$elTree.fancyTree.expandAll( false );
            }
            if (item2act.length) {
              console.log("!!!!!!!!!!!!!!");
              item2act[0].setActive();
              item2act[0].setExpanded(true);
            }
          }, 10);
        } else {
          $window.trigger('search:clear');
        }
      } else {
        $elTree.fancyTree.getNodeByKey(key).setActive();
      }
      e.preventDefault();
      return false;
    }
  });

  /*		$document.on( 'click', '.expand-hier', function ( e ) {			expandTree( $elTree, '/8iWEMr/54kfkH/5Lmtn9/7QABaK/' );			//$( ".fancytree-container" ).addClass( "fancytree-connectors" );		} );		$document.on( 'click', '.expand-all-nested', function ( e ) {			expandNodes();			function expandNodes () {				$elTree.fancyTree.visit( function ( node ) {					if ( node.isLazy() && !node.isExpanded() && !node.isLoading() )						node.setExpanded( true ).done( () => { expandNodes(); } );				} );			}		} );	*/
});
/** * jMiniCore System Core / ImgCat / Tree / Browse v 0.9 * * Last Mod Date: 2022-11-15 */

$(function () {
  // on page load

  var $window = $(window),
    $document = $(document);
  var PH_CAT = $('#ph-cat');
  if (!PH_CAT.get(0) || !(dataRPC = PH_CAT.data('rpc')) || !(dataIdCat = PH_CAT.data('idcat'))) return false;
  var TREE_RPC = "/".concat(dataRPC, "/");
  var ID_CAT = dataIdCat;
  var METHOD_RPC = 'GET';
  var $elTree = $($EL_SRCH.tree),
    $elCards = $($EL_SRCH.cards),
    $elLayout = $('.imgcat-layout');
  var xhrSearch = null;
  if (!$elTree.get(0)) return false;
  $window.on('search:loadtree', function (e, data) {
    if (xhrSearch) xhrSearch.abort();
    $elTree.parent().addClass('is-loading');
    $elCards.parent().addClass('is-loading');
    $($EL_BRWS.treepath).parent().addClass('is-loading');
    $elCards.curLoaded = null;
    $window.trigger('treetoggle', {
      action: 'show'
    });
    $elTree.searchState = data.state;
    $elTree.searchQuery = data.query;
    $elTree.countFound = null;
    xhrSearch = $.ajax({
      type: METHOD_RPC,
      url: TREE_RPC,
      data: {
        rpc: 'do-search',
        state: data.state,
        query: data.query,
        idcat: ID_CAT
      }
    }).always(function () {
      setTimeout(function (_) {
        $($EL_BRWS.treepath).parent().removeClass('is-loading');
        $elTree.parent().removeClass('is-loading');
        $elCards.parent().removeClass('is-loading');
        $window.trigger('search:done');
      }, 50);
    }).done(function (msg) {
      requestAnimationFrame(function (_) {
        $elTree.countFound = msg.count;
        $elCards.html(msg.cards);
        $($EL_BRWS.treepath).html(msg.treepath + '<div>&zwj;</div>');
        $elTree.fancytree('getTree').reload(msg.tree);
        if ($elTree.countFound) $elLayout.removeClass('search-state-void');
      });
    });
  }).on('search:clear', function (e, data) {
    //console.log('clear')
    if (xhrSearch) xhrSearch.abort();
    $elTree.parent().addClass('is-loading');
    $elCards.parent().addClass('is-loading');
    $($EL_BRWS.treepath).html(window.htmlTreePath);
    $elCards.curLoaded = null;
    $elTree.curLoaded = null;
    $elTree.countFound = null;
    $elTree.searchQuery = null;
    $window.trigger('cardswiper:destroy', {
      swiperRoot: $($EL_SRCH.cards)
    });
    setTimeout(function (_) {
      $elTree.fancytree('getTree').reload([]);
    }, 50);
  });
  $elTree.fancytree($.extend({}, TREE_OPTS, {
    source: [],
    activate: function activate(event, data) {
      if (!$elTree.searchQuery) return false;
      var node = data.node;
      $elTree.curLoaded = node.key;
      window.history.replaceState({
        url: TREE_RPC
      }, '', "".concat(TREE_RPC).concat(ID_CAT, "/") + '?sep=' + node.key);
      $window.trigger('cards:load', {
        key: node.key,
        el: $elCards,
        query: $elTree.searchQuery,
        count: $elTree.countFound
      });
    },
    init: function init(event, data) {},
    postProcess: function postProcess(event, data) {
      if (!$elTree.searchQuery) return false;
      setTimeout(function (_) {
        var item2act = $elTree.fancyTree.getRootNode().getChildren().filter(function (item) {
          return item.extraClasses !== 'sibling';
        });
        if ($elTree.countFound && item2act.length) item2act[0].setActive();
      }, 1);
    }
  }));
  $elTree.fancyTree = $.ui.fancytree.getTree($elTree);
});
/**
 * jMiniCore System Core / ImgCat / View Switcher v 0.9
 *
 * Last Mod Date: 2022-11-15
 */

$(function () {
  // on page load
  // go-tree
  var $window = $(window),
    $document = $(document),
    $html = $('html');
  var $elLayout = $('.imgcat-layout'),
    $elTree = $($EL_BRWS.tree),
    $elTreeToggle = $('.tree-toggler');
  if (!$elTree.get(0) || !$elTreeToggle.get(0) || !$elLayout.get(0)) return false;
  $elTreeToggle.on('click', function (e) {
    if ($elLayout.hasClass('mode-search')) {
      $window.trigger('search:clear');
      return false;
    }
    var goActive = !$elTreeToggle.hasClass('active');
    $elTreeToggle[goActive ? 'addClass' : 'removeClass']('active');
    $elLayout[!goActive ? 'addClass' : 'removeClass']('is-tree-hidden');
    return false;
  });
  $window.on('keyup', '', function (e) {
    if ($html.hasClass('global-fader-visible')) return;
    var inpFocused = e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input';
    if (e.keyCode === 192 && !inpFocused) $elTreeToggle.trigger('click');
    if (e.keyCode === 27 && $elLayout.hasClass('mode-search') && !$html.hasClass('global-fader-visible')) $window.trigger('search:clear');
  });
  $window.on('treetoggle', function (e, data) {
    var goActive = data.action === 'switch' ? !$elTreeToggle.hasClass('active') : data.action === 'show';
    $elTreeToggle[goActive ? 'addClass' : 'removeClass']('active');
    $elLayout[!goActive ? 'addClass' : 'removeClass']('is-tree-hidden');
  });
  setTimeout(function () {
    if (window.isMobile) {
      $elTreeToggle.removeClass('active');
    } else {
      $elTreeToggle.addClass('active');
    }
  }, 10);
});
/**
 * jMiniCore System Core / ImgCat v 0.9
 * Definitions and Constants
 *
 * Last Mod Date: 2022-11-15
 */

var $EL_BRWS = {
  tree: '#cards-tree',
  cards: '#cards-images',
  treepath: '#treepath .ph'
};
var $EL_SRCH = {
  tree: '#search-cards-tree',
  cards: '#search-cards-images'
};
var I18_FANCY = {
  loading: "Загрузка...",
  loadError: "Ошибка!",
  moreData: "Ещё....",
  noData: "Данные отсутствуют."
};
var TREE_OPTS = {
  aria: false,
  activeVisible: true,
  autoScroll: true,
  debugLevel: 0,
  focusOnSelect: true,
  quicksearch: true,
  clickFolderMode: 3,
  // 1:activate, 2:expand, 3:activate and expand, 4:activate (dblclick expands)
  strings: I18_FANCY
};
/**
 * jMiniCore System Core v 2.0 -- SCROLLERS
 *
 * Last Mod Date: 2019-09-15
 */

/*
	jQuery.fn.scrollIntoViewCentered = function ( objContainer, objDoc, smooth, gapY ) {
		if ( !this || !$( this )[ 0 ] ) return null;

		if ( typeof objContainer === 'undefined' ) objContainer = window;
		if ( typeof objDoc === 'undefined' ) objDoc = document;
		if ( typeof smooth === 'undefined' ) smooth = 0;
		if ( typeof gapY === 'undefined' ) gapY = 0;

		var $parentElement = this.getScrollParent( false, objDoc );
		var viewportHeight = Math.ceil( $parentElement[ 0 ].offsetHeight || 0 );
		var targetElement = this[ 0 ];

		var scrollY = ( targetElement.offsetHeight < viewportHeight )
			? ( ( targetElement.offsetTop + ( targetElement.offsetHeight >> 1 ) - ( viewportHeight >> 1 ) ) || 0 )
			: ( targetElement.offsetTop - gapY || 0 );

		objContainer[ 0 ].deflectScrollEvent = true;

		if ( !smooth ) $parentElement.scrollTop( scrollY ); else $parentElement.animate( { scrollTop: scrollY }, smooth );

		window.setTimeout( function () { objContainer[ 0 ].deflectScrollEvent = false; }, smooth * 2 );
	};
	*/

function scrollToView(element, parent) {
  element = $(element);
  parent = $(parent);
  if (!element.get(0)) return false;
  var timeAnim = 50,
    elOffset = (element && element.offset() ? element.offset().top : 0) + (parent && parent.scrollTop() ? parent.scrollTop() : 0),
    elHeight = element.innerHeight(),
    elOffsetEnd = elOffset + elHeight,
    vpStart = parent.scrollTop(),
    vpEnd = vpStart + parent.innerHeight();
  if (!element.is(':visible')) {
    element.css({
      'visibility': 'hidden'
    }).show();
    elOffset = element.offset() ? element.offset().top : 0;
    element.css({
      'visibility': '',
      'display': ''
    });
  }
  if (elOffset - elHeight < vpStart) {
    parent.animate({
      scrollTop: elOffset - elHeight
    }, timeAnim);
    return false;
  } else if (elOffsetEnd > vpEnd) {
    parent.animate({
      scrollTop: parent.scrollTop() + elOffsetEnd - vpEnd
    }, timeAnim);
    return false;
  }
  return true;
}
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (root, factory) {
  // support loading the plugin via common patterns
  if (typeof define === 'function' && define.amd) {
    // load the plugin as an amd module
    define(['jquery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // load the plugin as a commonjs module
    module.exports = factory(require('jquery'));
  } else {
    // load the plugin as a global
    factory(root.jQuery);
  }
})(this, function ($) {
  // useful private variables
  var $document = $(document),
    $window = $(window),
    $body = $('body');

  // constants
  var DATA_DISPLAYCONTROLLER = 'displayController',
    DATA_HASACTIVEHOVER = 'hasActiveHover',
    DATA_FORCEDOPEN = 'forcedOpen',
    DATA_HASMOUSEMOVE = 'hasMouseMove',
    DATA_MOUSEONTOTIP = 'mouseOnToPopup',
    DATA_ORIGINALTITLE = 'originalTitle',
    DATA_POWERTIP = 'powertip',
    DATA_POWERTIPJQ = 'powertipjq',
    DATA_POWERTIPTARGET = 'powertiptarget',
    EVENT_NAMESPACE = '.powertip',
    RAD2DEG = 180 / Math.PI,
    MOUSE_EVENTS = ['click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'mouseout', 'mouseenter', 'mouseleave', 'contextmenu'];

  /**
   * Session data
   * Private properties global to all powerTip instances
   */
  var session = {
    elements: null,
    tooltips: null,
    isTipOpen: false,
    isFixedTipOpen: false,
    isClosing: false,
    tipOpenImminent: false,
    activeHover: null,
    currentX: 0,
    currentY: 0,
    previousX: 0,
    previousY: 0,
    desyncTimeout: null,
    openDelayTimeout: null,
    closeDelayTimeout: null,
    mouseTrackingActive: false,
    delayInProgress: false,
    windowWidth: 0,
    windowHeight: 0,
    scrollTop: 0,
    scrollLeft: 0
  };

  /**
   * Collision enumeration
   * @enum {number}
   */
  var Collision = {
    none: 0,
    top: 1,
    bottom: 2,
    left: 4,
    right: 8
  };

  /**
   * Display hover tooltips on the matched elements.
   * @param {(Object|string)=} opts The options object to use for the plugin, or
   *     the name of a method to invoke on the first matched element.
   * @param {*=} [arg] Argument for an invoked method (optional).
   * @return {jQuery} jQuery object for the matched selectors.
   */
  $.fn.powerTip = function (opts, arg) {
    var targetElements = this,
      options,
      tipController;

    // don't do any work if there were no matched elements
    if (!targetElements.length) {
      return targetElements;
    }

    // handle api method calls on the plugin, e.g. powerTip('hide')
    if ($.type(opts) === 'string' && $.powerTip[opts]) {
      return $.powerTip[opts].call(targetElements, targetElements, arg);
    }

    // extend options
    options = $.extend({}, $.fn.powerTip.defaults, opts);

    // handle repeated powerTip calls on the same element by destroying any
    // original instance hooked to it and replacing it with this call
    $.powerTip.destroy(targetElements);

    // instantiate the TooltipController for this instance
    tipController = new TooltipController(options);

    // hook mouse and viewport dimension tracking
    initTracking();

    // setup the elements
    targetElements.each(function elementSetup() {
      var $this = $(this),
        dataPowertip = $this.data(DATA_POWERTIP),
        dataElem = $this.data(DATA_POWERTIPJQ),
        dataTarget = $this.data(DATA_POWERTIPTARGET),
        title = $this.attr('title');

      // attempt to use title attribute text if there is no data-powertip,
      // data-powertipjq or data-powertiptarget. If we do use the title
      // attribute, delete the attribute so the browser will not show it
      if (!dataPowertip && !dataTarget && !dataElem && title) {
        $this.data(DATA_POWERTIP, title);
        $this.data(DATA_ORIGINALTITLE, title);
        $this.removeAttr('title');
      }

      // create hover controllers for each element
      $this.data(DATA_DISPLAYCONTROLLER, new DisplayController($this, options, tipController));
    });

    // attach events to matched elements if the manual option is not enabled
    if (!options.manual) {
      // attach open events
      $.each(options.openEvents, function (idx, evt) {
        if ($.inArray(evt, options.closeEvents) > -1) {
          // event is in both openEvents and closeEvents, so toggle it
          targetElements.on(evt + EVENT_NAMESPACE, function elementToggle(event) {
            $.powerTip.toggle(this, event);
          });
        } else {
          targetElements.on(evt + EVENT_NAMESPACE, function elementOpen(event) {
            //$.powerTip.show(this, event);
            $.powerTip.show(this, event, false);
          });
        }
      });

      // attach close events
      $.each(options.closeEvents, function (idx, evt) {
        if ($.inArray(evt, options.openEvents) < 0) {
          targetElements.on(evt + EVENT_NAMESPACE, function elementClose(event) {
            // set immediate to true for any event without mouse info
            $.powerTip.hide(this, !isMouseEvent(event));
          });
        }
      });

      // attach escape key close event
      targetElements.on('keydown' + EVENT_NAMESPACE, function elementKeyDown(event) {
        // always close tooltip when the escape key is pressed
        if (event.keyCode === 27) {
          $.powerTip.hide(this, true);
        }
      });
    }

    // remember elements that the plugin is attached to
    session.elements = session.elements ? session.elements.add(targetElements) : targetElements;
    return targetElements;
  };

  /**
   * Default options for the powerTip plugin.
   */
  $.fn.powerTip.defaults = {
    fadeInTime: 200,
    fadeOutTime: 100,
    followMouse: false,
    popupId: 'powerTip',
    popupClass: null,
    intentSensitivity: 7,
    intentPollInterval: 100,
    openDelay: 100,
    closeDelay: 100,
    placement: 'n',
    smartPlacement: false,
    offset: 10,
    mouseOnToPopup: false,
    manual: false,
    noDesyncCheck: false,
    openEvents: ['mouseenter', 'focus'],
    closeEvents: ['mouseleave', 'blur']
  };

  /**
   * Default smart placement priority lists.
   * The first item in the array is the highest priority, the last is the lowest.
   * The last item is also the default, which will be used if all previous options
   * do not fit.
   */
  $.fn.powerTip.smartPlacementLists = {
    n: ['n', 'ne', 'nw', 's'],
    e: ['e', 'ne', 'se', 'w', 'nw', 'sw', 'n', 's', 'e'],
    s: ['s', 'se', 'sw', 'n'],
    w: ['w', 'nw', 'sw', 'e', 'ne', 'se', 'n', 's', 'w'],
    nw: ['nw', 'w', 'sw', 'n', 's', 'se', 'nw'],
    ne: ['ne', 'e', 'se', 'n', 's', 'sw', 'ne'],
    sw: ['sw', 'w', 'nw', 's', 'n', 'ne', 'sw'],
    se: ['se', 'e', 'ne', 's', 'n', 'nw', 'se'],
    'nw-alt': ['nw-alt', 'n', 'ne-alt', 'sw-alt', 's', 'se-alt', 'w', 'e'],
    'ne-alt': ['ne-alt', 'n', 'nw-alt', 'se-alt', 's', 'sw-alt', 'e', 'w'],
    'sw-alt': ['sw-alt', 's', 'se-alt', 'nw-alt', 'n', 'ne-alt', 'w', 'e'],
    'se-alt': ['se-alt', 's', 'sw-alt', 'ne-alt', 'n', 'nw-alt', 'e', 'w']
  };

  /**
   * Public API
   */
  $.powerTip = {
    /**
     * Attempts to show the tooltip for the specified element.
     * @param {jQuery|Element} element The element to open the tooltip for.
     * @param {jQuery.Event=} event jQuery event for hover intent and mouse
     *     tracking (optional).
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    show: function apiShowTip(element, event, disableDelay) {
      // if we were given a mouse event then run the hover intent testing,
      // otherwise, simply show the tooltip asap
      if (isMouseEvent(event)) {
        trackMouse(event);
        session.previousX = event.pageX;
        session.previousY = event.pageY;
        //$(element).data(DATA_DISPLAYCONTROLLER).show();
        $(element).data(DATA_DISPLAYCONTROLLER).show(element, undefined, disableDelay);
      } else {
        //$(element).first().data(DATA_DISPLAYCONTROLLER).show(true, true);
        $(element).first().data(DATA_DISPLAYCONTROLLER).show(true, true, disableDelay);
      }
      return element;
    },
    /**
     * Repositions the tooltip on the element.
     * @param {jQuery|Element} element The element the tooltip is shown for.
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    reposition: function apiResetPosition(element) {
      $(element).first().data(DATA_DISPLAYCONTROLLER).resetPosition();
      return element;
    },
    /**
     * Attempts to close any open tooltips.
     * @param {(jQuery|Element)=} element The element with the tooltip that
     *     should be closed (optional).
     * @param {boolean=} immediate Disable close delay (optional).
     * @return {jQuery|Element|undefined} The original jQuery object or DOM
     *     Element, if one was specified.
     */
    hide: function apiCloseTip(element, immediate) {
      var displayController;

      // set immediate to true when no element is specified
      immediate = element ? immediate : true;

      // find the relevant display controller
      if (element) {
        displayController = $(element).first().data(DATA_DISPLAYCONTROLLER);
      } else if (session.activeHover) {
        displayController = session.activeHover.data(DATA_DISPLAYCONTROLLER);
      }

      // if found, hide the tip
      if (displayController) {
        displayController.hide(immediate);
      }
      return element;
    },
    /**
     * Toggles the tooltip for the specified element. This will open a closed
     * tooltip, or close an open tooltip.
     * @param {jQuery|Element} element The element with the tooltip that
     *     should be toggled.
     * @param {jQuery.Event=} event jQuery event for hover intent and mouse
     *     tracking (optional).
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    toggle: function apiToggle(element, event) {
      if (session.activeHover && session.activeHover.is(element)) {
        // tooltip for element is active, so close it
        $.powerTip.hide(element, !isMouseEvent(event));
      } else {
        // tooltip for element is not active, so open it
        //$.powerTip.show(element, event);
        $.powerTip.show(element, event, true);
      }
      return element;
    },
    /**
     * Destroy and roll back any powerTip() instance on the specified elements.
     * If no elements are specified then all elements that the plugin is
     * currently attached to will be rolled back.
     * @param {(jQuery|Element)=} element The element with the powerTip instance.
     * @return {jQuery|Element|undefined} The original jQuery object or DOM
     *     Element, if one was specified.
     */
    destroy: function apiDestroy(element) {
      var $element = element ? $(element) : session.elements;

      // if the plugin is not hooked to any elements then there is no point
      // trying to destroy anything, or dealing with the possible errors
      if (!session.elements || session.elements.length === 0) {
        return element;
      }

      // if a tooltip is currently open for an element we are being asked to
      // destroy then it should be forced to close
      if (session.isTipOpen && !session.isClosing && $element.filter(session.activeHover).length > 0) {
        // if the tooltip is waiting to close then cancel that delay timer
        if (session.delayInProgress) {
          session.activeHover.data(DATA_DISPLAYCONTROLLER).cancel();
        }
        // hide the tooltip, immediately
        $.powerTip.hide(session.activeHover, true);
      }

      // unhook events and destroy plugin changes to each element
      $element.off(EVENT_NAMESPACE).each(function destroy() {
        var $this = $(this),
          dataAttributes = [DATA_ORIGINALTITLE, DATA_DISPLAYCONTROLLER, DATA_HASACTIVEHOVER, DATA_FORCEDOPEN];

        // revert title attribute
        if ($this.data(DATA_ORIGINALTITLE)) {
          $this.attr('title', $this.data(DATA_ORIGINALTITLE));
          dataAttributes.push(DATA_POWERTIP);
        }

        // remove data attributes
        $this.removeData(dataAttributes);
      });

      // remove destroyed element from active elements collection
      session.elements = session.elements.not($element);

      // if there are no active elements left then we will unhook all of the
      // events that we've bound code to and remove the tooltip elements
      if (session.elements.length === 0) {
        $window.off(EVENT_NAMESPACE);
        $document.off(EVENT_NAMESPACE);
        session.mouseTrackingActive = false;
        session.tooltips.remove();
        session.tooltips = null;
      }
      return element;
    }
  };

  // API aliasing
  $.powerTip.showTip = $.powerTip.show;
  $.powerTip.closeTip = $.powerTip.hide;

  /**
   * Creates a new CSSCoordinates object.
   * @private
   * @constructor
   */
  function CSSCoordinates() {
    var me = this;

    // initialize object properties
    me.top = 'auto';
    me.left = 'auto';
    me.right = 'auto';
    me.bottom = 'auto';

    /**
     * Set a property to a value.
     * @private
     * @param {string} property The name of the property.
     * @param {number} value The value of the property.
     */
    me.set = function (property, value) {
      if ($.isNumeric(value)) {
        me[property] = Math.round(value);
      }
    };
  }

  /**
   * Creates a new tooltip display controller.
   * @private
   * @constructor
   * @param {jQuery} element The element that this controller will handle.
   * @param {Object} options Options object containing settings.
   * @param {TooltipController} tipController The TooltipController object for
   *     this instance.
   */
  function DisplayController(element, options, tipController) {
    var hoverTimer = null,
      myCloseDelay = null,
      myOpenDelay = null;

    /**
     * Begins the process of showing a tooltip.
     * @private
     * @param {boolean=} immediate Skip intent testing (optional).
     * @param {boolean=} forceOpen Ignore cursor position and force tooltip to
     *     open (optional).
     */
    function openTooltip(immediate, forceOpen, disableDelay) {
      // if this instance already has an open delay in progress then halt it
      if (myOpenDelay) {
        myOpenDelay = session.openDelayTimeout = clearTimeout(myOpenDelay);
        session.delayInProgress = false;
      }
      cancelTimer();
      if (!element.data(DATA_HASACTIVEHOVER)) {
        if (!immediate) {
          session.tipOpenImminent = true;
          hoverTimer = setTimeout(function intentDelay() {
            hoverTimer = null;
            checkForIntent();
          }, options.intentPollInterval);
        } else {
          if (forceOpen) {
            element.data(DATA_FORCEDOPEN, true);
          }
          closeAnyDelayed();
          //tipController.showTip(element);
          if (!disableDelay) {
            session.delayInProgress = true;
            session.openDelayTimeout = setTimeout(function openDelay() {
              session.openDelayTimeout = null;
              tipController.showTip(element);
              session.delayInProgress = false;
              myOpenDelay = null;
            }, options.openDelay);
            // save internal reference open delay id so we can check if the
            // active open delay belongs to this instance
            myOpenDelay = session.openDelayTimeout;
          } else {
            tipController.showTip(element);
          }
        }
      } else {
        // cursor left and returned to this element, cancel close
        cancelClose();
      }
    }

    /**
     * Begins the process of closing a tooltip.
     * @private
     * @param {boolean=} disableDelay Disable close delay (optional).
     */
    function closeTooltip(disableDelay) {
      // if this instance already has a close delay in progress then halt it
      //console.log(myCloseDelay);

      if (myCloseDelay) {
        myCloseDelay = session.closeDelayTimeout = clearTimeout(myCloseDelay);
        session.delayInProgress = false;
      }
      cancelTimer();
      session.tipOpenImminent = false;
      if (element.data(DATA_HASACTIVEHOVER)) {
        element.data(DATA_FORCEDOPEN, false);
        if (!disableDelay) {
          session.delayInProgress = true;
          session.closeDelayTimeout = setTimeout(function closeDelay() {
            session.closeDelayTimeout = null;
            tipController.hideTip(element);
            session.delayInProgress = false;
            myCloseDelay = null;
          }, options.closeDelay);
          // save internal reference close delay id so we can check if the
          // active close delay belongs to this instance
          myCloseDelay = session.closeDelayTimeout;
        } else {
          tipController.hideTip(element);
        }
      }
    }

    /**
     * Checks mouse position to make sure that the user intended to hover on the
     * specified element before showing the tooltip.
     * @private
     */
    function checkForIntent() {
      // calculate mouse position difference
      var xDifference = Math.abs(session.previousX - session.currentX),
        yDifference = Math.abs(session.previousY - session.currentY),
        totalDifference = xDifference + yDifference;

      // check if difference has passed the sensitivity threshold
      if (totalDifference < options.intentSensitivity) {
        cancelClose();
        closeAnyDelayed();
        tipController.showTip(element);
      } else {
        // try again
        session.previousX = session.currentX;
        session.previousY = session.currentY;
        openTooltip();
      }
    }

    /**
     * Cancels active hover timer.
     * @private
     * @param {boolean=} stopClose Cancel any active close delay timer.
     */
    function cancelTimer(stopClose) {
      hoverTimer = clearTimeout(hoverTimer);
      // cancel the current close delay if the active close delay is for this
      // element or the stopClose argument is true
      if (session.closeDelayTimeout && myCloseDelay === session.closeDelayTimeout || stopClose) {
        cancelClose();
      }
      if (myOpenDelay === session.openDelayTimeout) {
        cancelOpen();
      }
    }

    /**
     * Cancels any active close delay timer.
     * @private
     */
    function cancelClose() {
      session.closeDelayTimeout = clearTimeout(session.closeDelayTimeout);
      session.delayInProgress = false;
    }
    /**
     * Cancels any active open delay timer.
     * @private
     */
    function cancelOpen() {
      session.openDelayTimeout = clearTimeout(session.openDelayTimeout);
      session.delayInProgress = false;
    }

    /**
     * Asks any tooltips waiting on their close delay to close now.
     * @private
     */
    function closeAnyDelayed() {
      // if another element is waiting for its close delay then we should ask
      // it to close immediately so we can proceed without unexpected timeout
      // code being run during this tooltip's lifecycle
      if (session.delayInProgress && session.activeHover && !session.activeHover.is(element)) {
        session.activeHover.data(DATA_DISPLAYCONTROLLER).hide(true);
      }
    }

    /**
     * Repositions the tooltip on this element.
     * @private
     */
    function repositionTooltip() {
      tipController.resetPosition(element);
    }

    // expose the methods
    this.show = openTooltip;
    this.hide = closeTooltip;
    this.cancel = cancelTimer;
    this.resetPosition = repositionTooltip;
  }

  /**
   * Creates a new Placement Calculator.
   * @private
   * @constructor
   */
  function PlacementCalculator() {
    /**
     * Compute the CSS position to display a tooltip at the specified placement
     * relative to the specified element.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @param {number} tipWidth Width of the tooltip element in pixels.
     * @param {number} tipHeight Height of the tooltip element in pixels.
     * @param {number} offset Distance to offset tooltips in pixels.
     * @return {CSSCoordinates} A CSSCoordinates object with the position.
     */
    function computePlacementCoords(element, placement, tipWidth, tipHeight, offset) {
      var placementBase = placement.split('-')[0],
        // ignore 'alt' for corners
        coords = new CSSCoordinates(),
        position;
      if (isSvgElement(element)) {
        position = getSvgPlacement(element, placementBase);
      } else {
        position = getHtmlPlacement(element, placementBase);
      }

      // calculate the appropriate x and y position in the document
      switch (placement) {
        case 'n':
          coords.set('left', position.left - tipWidth / 2);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;
        case 'e':
          coords.set('left', position.left + offset);
          coords.set('top', position.top - tipHeight / 2);
          break;
        case 's':
          coords.set('left', position.left - tipWidth / 2);
          coords.set('top', position.top + offset);
          break;
        case 'w':
          coords.set('top', position.top - tipHeight / 2);
          coords.set('right', session.windowWidth - position.left + offset);
          break;
        case 'nw':
          coords.set('bottom', session.windowHeight - position.top + offset);
          coords.set('right', session.windowWidth - position.left - 20);
          break;
        case 'nw-alt':
          coords.set('left', position.left);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;
        case 'ne':
          coords.set('left', position.left - 20);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;
        case 'ne-alt':
          coords.set('bottom', session.windowHeight - position.top + offset);
          coords.set('right', session.windowWidth - position.left);
          break;
        case 'sw':
          coords.set('top', position.top + offset);
          coords.set('right', session.windowWidth - position.left - 20);
          break;
        case 'sw-alt':
          coords.set('left', position.left);
          coords.set('top', position.top + offset);
          break;
        case 'se':
          coords.set('left', position.left - 20);
          coords.set('top', position.top + offset);
          break;
        case 'se-alt':
          coords.set('top', position.top + offset);
          coords.set('right', session.windowWidth - position.left);
          break;
      }
      return coords;
    }

    /**
     * Finds the tooltip attachment point in the document for a HTML DOM element
     * for the specified placement.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {Object} An object with the top,left position values.
     */
    function getHtmlPlacement(element, placement) {
      var objectOffset = element.offset(),
        objectWidth = element.outerWidth(),
        objectHeight = element.outerHeight(),
        left,
        top;

      // calculate the appropriate x and y position in the document
      switch (placement) {
        case 'n':
          left = objectOffset.left + objectWidth / 2;
          top = objectOffset.top;
          break;
        case 'e':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top + objectHeight / 2;
          break;
        case 's':
          left = objectOffset.left + objectWidth / 2;
          top = objectOffset.top + objectHeight;
          break;
        case 'w':
          left = objectOffset.left;
          top = objectOffset.top + objectHeight / 2;
          break;
        case 'nw':
          left = objectOffset.left;
          top = objectOffset.top;
          break;
        case 'ne':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top;
          break;
        case 'sw':
          left = objectOffset.left;
          top = objectOffset.top + objectHeight;
          break;
        case 'se':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top + objectHeight;
          break;
      }
      return {
        top: top,
        left: left
      };
    }

    /**
     * Finds the tooltip attachment point in the document for a SVG element for
     * the specified placement.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {Object} An object with the top,left position values.
     */
    function getSvgPlacement(element, placement) {
      var svgElement = element.closest('svg')[0],
        domElement = element[0],
        point = svgElement.createSVGPoint(),
        boundingBox = domElement.getBBox(),
        matrix = domElement.getScreenCTM(),
        halfWidth = boundingBox.width / 2,
        halfHeight = boundingBox.height / 2,
        placements = [],
        placementKeys = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
        coords,
        rotation,
        steps,
        x;

      /**
       * Transform and append the current points to the placements list.
       * @private
       */
      function pushPlacement() {
        placements.push(point.matrixTransform(matrix));
      }

      // get bounding box corners and midpoints
      point.x = boundingBox.x;
      point.y = boundingBox.y;
      pushPlacement();
      point.x += halfWidth;
      pushPlacement();
      point.x += halfWidth;
      pushPlacement();
      point.y += halfHeight;
      pushPlacement();
      point.y += halfHeight;
      pushPlacement();
      point.x -= halfWidth;
      pushPlacement();
      point.x -= halfWidth;
      pushPlacement();
      point.y -= halfHeight;
      pushPlacement();

      // determine rotation
      if (placements[0].y !== placements[1].y || placements[0].x !== placements[7].x) {
        rotation = Math.atan2(matrix.b, matrix.a) * RAD2DEG;
        steps = Math.ceil((rotation % 360 - 22.5) / 45);
        if (steps < 1) {
          steps += 8;
        }
        while (steps--) {
          placementKeys.push(placementKeys.shift());
        }
      }

      // find placement
      for (x = 0; x < placements.length; x++) {
        if (placementKeys[x] === placement) {
          coords = placements[x];
          break;
        }
      }
      return {
        top: coords.y + session.scrollTop,
        left: coords.x + session.scrollLeft
      };
    }

    // expose methods
    this.compute = computePlacementCoords;
  }

  /**
   * Creates a new tooltip controller.
   * @private
   * @constructor
   * @param {Object} options Options object containing settings.
   */
  function TooltipController(options) {
    var placementCalculator = new PlacementCalculator(),
      tipElement = $('#' + options.popupId);

    // build and append tooltip div if it does not already exist
    if (tipElement.length === 0) {
      tipElement = $('<div/>', {
        id: options.popupId
      });
      // grab body element if it was not populated when the script loaded
      // note: this hack exists solely for jsfiddle support
      if ($body.length === 0) {
        $body = $('body');
      }
      $body.append(tipElement);
      // remember the tooltip elements that the plugin has created
      session.tooltips = session.tooltips ? session.tooltips.add(tipElement) : tipElement;
    }

    // hook mousemove for cursor follow tooltips
    if (options.followMouse) {
      // only one positionTipOnCursor hook per tooltip element, please
      if (!tipElement.data(DATA_HASMOUSEMOVE)) {
        $document.on('mousemove' + EVENT_NAMESPACE, positionTipOnCursor);
        $window.on('scroll' + EVENT_NAMESPACE, positionTipOnCursor);
        tipElement.data(DATA_HASMOUSEMOVE, true);
      }
    }

    /**
     * Gives the specified element the active-hover state and queues up the
     * showTip function.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */
    function beginShowTip(element) {
      element.data(DATA_HASACTIVEHOVER, true);
      // show tooltip, asap
      tipElement.queue(function queueTipInit(next) {
        showTip(element);
        next();
      });
    }

    /**
     * Shows the tooltip, as soon as possible.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */
    function showTip(element) {
      var tipContent;

      // it is possible, especially with keyboard navigation, to move on to
      // another element with a tooltip during the queue to get to this point
      // in the code. if that happens then we need to not proceed or we may
      // have the fadeout callback for the last tooltip execute immediately
      // after this code runs, causing bugs.
      if (!element.data(DATA_HASACTIVEHOVER)) {
        return;
      }

      // if the tooltip is open and we got asked to open another one then the
      // old one is still in its fadeOut cycle, so wait and try again
      if (session.isTipOpen) {
        if (!session.isClosing) {
          hideTip(session.activeHover);
        }
        tipElement.delay(100).queue(function queueTipAgain(next) {
          showTip(element);
          next();
        });
        return;
      }

      // trigger powerTipPreRender event
      element.trigger('powerTipPreRender');

      // set tooltip content
      tipContent = getTooltipContent(element);
      if (tipContent) {
        tipElement.empty().append(tipContent);
      } else {
        // we have no content to display, give up
        return;
      }

      // trigger powerTipRender event
      element.trigger('powerTipRender');
      session.activeHover = element;
      session.isTipOpen = true;
      tipElement.data(DATA_MOUSEONTOTIP, options.mouseOnToPopup);

      // add custom class to tooltip element
      tipElement.addClass(options.popupClass);

      // set tooltip position
      // revert to static placement when the "force open" flag was set because
      // that flag means that we do not have accurate mouse position info
      if (!options.followMouse || element.data(DATA_FORCEDOPEN)) {
        positionTipOnElement(element);
        session.isFixedTipOpen = true;
      } else {
        positionTipOnCursor();
      }

      // close tooltip when clicking anywhere on the page, with the exception
      // of the tooltip's trigger element and any elements that are within a
      // tooltip that has 'mouseOnToPopup' option enabled
      // always enable this feature when the "force open" flag is set on a
      // followMouse tooltip because we reverted to static placement above
      if (!element.data(DATA_FORCEDOPEN) && !options.followMouse) {
        $document.on('click' + EVENT_NAMESPACE, function documentClick(event) {
          var target = event.target;
          if (target !== element[0]) {
            if (options.mouseOnToPopup) {
              if (target !== tipElement[0] && !$.contains(tipElement[0], target)) {
                $.powerTip.hide();
              }
            } else {
              $.powerTip.hide();
            }
          }
        });
      }

      // if we want to be able to mouse on to the tooltip then we need to
      // attach hover events to the tooltip that will cancel a close request
      // on mouseenter and start a new close request on mouseleave
      // only hook these listeners if we're not in manual mode
      if (options.mouseOnToPopup && !options.manual) {
        tipElement.on('mouseenter' + EVENT_NAMESPACE, function tipMouseEnter() {
          // check activeHover in case the mouse cursor entered the
          // tooltip during the fadeOut and close cycle
          if (session.activeHover) {
            session.activeHover.data(DATA_DISPLAYCONTROLLER).cancel();
          }
        });
        tipElement.on('mouseleave' + EVENT_NAMESPACE, function tipMouseLeave() {
          // check activeHover in case the mouse cursor left the tooltip
          // during the fadeOut and close cycle
          if (session.activeHover) {
            session.activeHover.data(DATA_DISPLAYCONTROLLER).hide();
          }
        });
      }

      // fadein
      tipElement.fadeIn(options.fadeInTime, function fadeInCallback() {
        // start desync polling
        if (!session.desyncTimeout && !options.noDesyncCheck) {
          session.desyncTimeout = setInterval(closeDesyncedTip, 500);
        }

        // trigger powerTipOpen event
        element.trigger('powerTipOpen');
      });
    }

    /**
     * Hides the tooltip.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */
    function hideTip(element) {
      // reset session
      session.isClosing = true;
      session.isTipOpen = false;

      // stop desync polling
      session.desyncTimeout = clearInterval(session.desyncTimeout);

      // reset element state
      element.data(DATA_HASACTIVEHOVER, false);
      element.data(DATA_FORCEDOPEN, false);

      // remove document click handler
      $document.off('click' + EVENT_NAMESPACE);

      // unbind the mouseOnToPopup events if they were set
      tipElement.off(EVENT_NAMESPACE);

      // fade out
      tipElement.fadeOut(options.fadeOutTime, function fadeOutCallback() {
        var coords = new CSSCoordinates();

        // reset session and tooltip element
        session.activeHover = null;
        session.isClosing = false;
        session.isFixedTipOpen = false;
        tipElement.removeClass();

        // support mouse-follow and fixed position tips at the same time by
        // moving the tooltip to the last cursor location after it is hidden
        coords.set('top', session.currentY + options.offset);
        coords.set('left', session.currentX + options.offset);
        tipElement.css(coords);

        // trigger powerTipClose event
        element.trigger('powerTipClose');
      });
    }

    /**
     * Moves the tooltip to the users mouse cursor.
     * @private
     */
    function positionTipOnCursor() {
      var tipWidth, tipHeight, coords, collisions, collisionCount;

      // to support having fixed tooltips on the same page as cursor tooltips,
      // where both instances are referencing the same tooltip element, we
      // need to keep track of the mouse position constantly, but we should
      // only set the tip location if a fixed tip is not currently open, a tip
      // open is imminent or active, and the tooltip element in question does
      // have a mouse-follow using it.
      if (!session.isFixedTipOpen && (session.isTipOpen || session.tipOpenImminent && tipElement.data(DATA_HASMOUSEMOVE))) {
        // grab measurements
        tipWidth = tipElement.outerWidth();
        tipHeight = tipElement.outerHeight();
        coords = new CSSCoordinates();

        // grab collisions
        coords.set('top', session.currentY + options.offset);
        coords.set('left', session.currentX + options.offset);
        collisions = getViewportCollisions(coords, tipWidth, tipHeight);

        // handle tooltip view port collisions
        if (collisions !== Collision.none) {
          collisionCount = countFlags(collisions);
          if (collisionCount === 1) {
            // if there is only one collision (bottom or right) then
            // simply constrain the tooltip to the view port
            if (collisions === Collision.right) {
              coords.set('left', session.scrollLeft + session.windowWidth - tipWidth);
            } else if (collisions === Collision.bottom) {
              coords.set('top', session.scrollTop + session.windowHeight - tipHeight);
            }
          } else {
            // if the tooltip has more than one collision then it is
            // trapped in the corner and should be flipped to get it out
            // of the users way
            coords.set('left', session.currentX - tipWidth - options.offset);
            coords.set('top', session.currentY - tipHeight - options.offset);
          }
        }

        // position the tooltip
        tipElement.css(coords);
      }
    }

    /**
     * Sets the tooltip to the correct position relative to the specified target
     * element. Based on options settings.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */
    function positionTipOnElement(element) {
      var priorityList, finalPlacement;

      // when the followMouse option is enabled and the "force open" flag is
      // set we revert to static positioning. since the developer may not have
      // considered this scenario we should use smart placement
      if (options.smartPlacement || options.followMouse && element.data(DATA_FORCEDOPEN)) {
        priorityList = $.fn.powerTip.smartPlacementLists[options.placement];

        // iterate over the priority list and use the first placement option
        // that does not collide with the view port. if they all collide
        // then the last placement in the list will be used.
        $.each(priorityList, function (idx, pos) {
          // place tooltip and find collisions
          var collisions = getViewportCollisions(placeTooltip(element, pos), tipElement.outerWidth(), tipElement.outerHeight());

          // update the final placement variable
          finalPlacement = pos;

          // break if there were no collisions
          return collisions !== Collision.none;
        });
      } else {
        // if we're not going to use the smart placement feature then just
        // compute the coordinates and do it
        placeTooltip(element, options.placement);
        finalPlacement = options.placement;
      }

      // add placement as class for CSS arrows
      tipElement.removeClass('w nw sw e ne se n s w se-alt sw-alt ne-alt nw-alt');
      tipElement.addClass(finalPlacement);
    }

    /**
     * Sets the tooltip position to the appropriate values to show the tip at
     * the specified placement. This function will iterate and test the tooltip
     * to support elastic tooltips.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {CSSCoordinates} A CSSCoordinates object with the top, left, and
     *     right position values.
     */
    function placeTooltip(element, placement) {
      var iterationCount = 0,
        tipWidth,
        tipHeight,
        coords = new CSSCoordinates();

      // set the tip to 0,0 to get the full expanded width
      coords.set('top', 0);
      coords.set('left', 0);
      tipElement.css(coords);

      // to support elastic tooltips we need to check for a change in the
      // rendered dimensions after the tooltip has been positioned
      do {
        // grab the current tip dimensions
        tipWidth = tipElement.outerWidth();
        tipHeight = tipElement.outerHeight();

        // get placement coordinates
        coords = placementCalculator.compute(element, placement, tipWidth, tipHeight, options.offset);

        // place the tooltip
        tipElement.css(coords);
      } while (
      // sanity check: limit to 5 iterations, and...
      ++iterationCount <= 5 && (
      // try again if the dimensions changed after placement
      tipWidth !== tipElement.outerWidth() || tipHeight !== tipElement.outerHeight()));
      return coords;
    }

    /**
     * Checks for a tooltip desync and closes the tooltip if one occurs.
     * @private
     */
    function closeDesyncedTip() {
      var isDesynced = false,
        hasDesyncableCloseEvent = $.grep(['mouseleave', 'mouseout', 'blur', 'focusout'], function (eventType) {
          return $.inArray(eventType, options.closeEvents) !== -1;
        }).length > 0;

      // It is possible for the mouse cursor to leave an element without
      // firing the mouseleave or blur event. This most commonly happens when
      // the element is disabled under mouse cursor. If this happens it will
      // result in a desynced tooltip because the tooltip was never asked to
      // close. So we should periodically check for a desync situation and
      // close the tip if such a situation arises.
      if (session.isTipOpen && !session.isClosing && !session.delayInProgress && hasDesyncableCloseEvent) {
        if (session.activeHover.data(DATA_HASACTIVEHOVER) === false || session.activeHover.is(':disabled')) {
          // user moused onto another tip or active hover is disabled
          isDesynced = true;
        } else if (!isMouseOver(session.activeHover) && !session.activeHover.is(':focus') && !session.activeHover.data(DATA_FORCEDOPEN)) {
          // hanging tip - have to test if mouse position is not over the
          // active hover and not over a tooltip set to let the user
          // interact with it.
          // for keyboard navigation: this only counts if the element does
          // not have focus.
          // for tooltips opened via the api: we need to check if it has
          // the forcedOpen flag.
          if (tipElement.data(DATA_MOUSEONTOTIP)) {
            if (!isMouseOver(tipElement)) {
              isDesynced = true;
            }
          } else {
            isDesynced = true;
          }
        }
        if (isDesynced) {
          // close the desynced tip
          hideTip(session.activeHover);
        }
      }
    }

    // expose methods
    this.showTip = beginShowTip;
    this.hideTip = hideTip;
    this.resetPosition = positionTipOnElement;
  }

  /**
   * Determine whether a jQuery object is an SVG element
   * @private
   * @param {jQuery} element The element to check
   * @return {boolean} Whether this is an SVG element
   */
  function isSvgElement(element) {
    return Boolean(window.SVGElement && element[0] instanceof SVGElement);
  }

  /**
   * Determines if the specified jQuery.Event object has mouse data.
   * @private
   * @param {jQuery.Event=} event The jQuery.Event object to test.
   * @return {boolean} True if there is mouse data, otherwise false.
   */
  function isMouseEvent(event) {
    return Boolean(event && $.inArray(event.type, MOUSE_EVENTS) > -1 && typeof event.pageX === 'number');
  }

  /**
   * Initializes the viewport dimension cache and hooks up the mouse position
   * tracking and viewport dimension tracking events.
   * Prevents attaching the events more than once.
   * @private
   */
  function initTracking() {
    if (!session.mouseTrackingActive) {
      session.mouseTrackingActive = true;

      // grab the current viewport dimensions on load
      getViewportDimensions();
      $(getViewportDimensions);

      // hook mouse move tracking
      $document.on('mousemove' + EVENT_NAMESPACE, trackMouse);

      // hook viewport dimensions tracking
      $window.on('resize' + EVENT_NAMESPACE, trackResize);
      $window.on('scroll' + EVENT_NAMESPACE, trackScroll);
    }
  }

  /**
   * Updates the viewport dimensions cache.
   * @private
   */
  function getViewportDimensions() {
    session.scrollLeft = $window.scrollLeft();
    session.scrollTop = $window.scrollTop();
    session.windowWidth = $window.width();
    session.windowHeight = $window.height();
  }

  /**
   * Updates the window size info in the viewport dimensions cache.
   * @private
   */
  function trackResize() {
    session.windowWidth = $window.width();
    session.windowHeight = $window.height();
  }

  /**
   * Updates the scroll offset info in the viewport dimensions cache.
   * @private
   */
  function trackScroll() {
    var x = $window.scrollLeft(),
      y = $window.scrollTop();
    if (x !== session.scrollLeft) {
      session.currentX += x - session.scrollLeft;
      session.scrollLeft = x;
    }
    if (y !== session.scrollTop) {
      session.currentY += y - session.scrollTop;
      session.scrollTop = y;
    }
  }

  /**
   * Saves the current mouse coordinates to the session object.
   * @private
   * @param {jQuery.Event} event The mousemove event for the document.
   */
  function trackMouse(event) {
    session.currentX = event.pageX;
    session.currentY = event.pageY;
  }

  /**
   * Tests if the mouse is currently over the specified element.
   * @private
   * @param {jQuery} element The element to check for hover.
   * @return {boolean} True if the mouse is over the element, otherwise false.
   */
  function isMouseOver(element) {
    // use getBoundingClientRect() because jQuery's width() and height()
    // methods do not work with SVG elements
    // compute width/height because those properties do not exist on the object
    // returned by getBoundingClientRect() in older versions of IE
    var elementPosition = element.offset(),
      elementBox = element[0].getBoundingClientRect(),
      elementWidth = elementBox.right - elementBox.left,
      elementHeight = elementBox.bottom - elementBox.top;
    return session.currentX >= elementPosition.left && session.currentX <= elementPosition.left + elementWidth && session.currentY >= elementPosition.top && session.currentY <= elementPosition.top + elementHeight;
  }

  /**
   * Fetches the tooltip content from the specified element's data attributes.
   * @private
   * @param {jQuery} element The element to get the tooltip content for.
   * @return {(string|jQuery|undefined)} The text/HTML string, jQuery object, or
   *     undefined if there was no tooltip content for the element.
   */
  function getTooltipContent(element) {
    var tipText = element.data(DATA_POWERTIP),
      tipObject = element.data(DATA_POWERTIPJQ),
      tipTarget = element.data(DATA_POWERTIPTARGET),
      targetElement,
      content;
    if (tipText) {
      if ($.isFunction(tipText)) {
        tipText = tipText.call(element[0]);
      }
      content = tipText;
    } else if (tipObject) {
      if ($.isFunction(tipObject)) {
        tipObject = tipObject.call(element[0]);
      }
      if (tipObject.length > 0) {
        content = tipObject.clone(true, true);
      }
    } else if (tipTarget) {
      targetElement = $(tipTarget);
      if (targetElement.length > 0) {
        content = targetElement.html();
      } else {
        targetElement = $('#' + tipTarget);
        if (targetElement.length > 0) {
          content = targetElement.html();
        }
      }
    }
    return content;
  }

  /**
   * Finds any viewport collisions that an element (the tooltip) would have if it
   * were absolutely positioned at the specified coordinates.
   * @private
   * @param {CSSCoordinates} coords Coordinates for the element.
   * @param {number} elementWidth Width of the element in pixels.
   * @param {number} elementHeight Height of the element in pixels.
   * @return {number} Value with the collision flags.
   */
  function getViewportCollisions(coords, elementWidth, elementHeight) {
    var margin = 0,
      viewportTop = session.scrollTop + margin,
      viewportLeft = session.scrollLeft + margin,
      viewportBottom = viewportTop + session.windowHeight - margin * 2,
      viewportRight = viewportLeft + session.windowWidth - margin * 2,
      collisions = Collision.none;
    if (coords.top < viewportTop || Math.abs(coords.bottom - session.windowHeight) - elementHeight < viewportTop) {
      collisions |= Collision.top;
    }
    if (coords.top + elementHeight > viewportBottom || Math.abs(coords.bottom - session.windowHeight) > viewportBottom) {
      collisions |= Collision.bottom;
    }
    if (coords.left < viewportLeft || coords.right + elementWidth > viewportRight) {
      collisions |= Collision.left;
    }
    if (coords.left + elementWidth > viewportRight || coords.right < viewportLeft) {
      collisions |= Collision.right;
    }
    return collisions;
  }

  /**
   * Counts the number of bits set on a flags value.
   * @param {number} value The flags value.
   * @return {number} The number of bits that have been set.
   */
  function countFlags(value) {
    var count = 0;
    while (value) {
      value &= value - 1;
      count++;
    }
    return count;
  }

  // return api for commonjs and amd environments
  return $.powerTip;
});
/**
 * jQuery Mobile Events
 * by Ben Major
 *
 * Copyright 2011-2019, Ben Major
 * Licensed under the MIT License:
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * https://github.com/benmajor/jQuery-Touch-Events
 *
 */

"use strict";

(function ($) {
  $.attrFn = $.attrFn || {};
  var touchCapable = ('ontouchstart' in window),
    settings = {
      tap_pixel_range: 5,
      swipe_h_threshold: 50,
      swipe_v_threshold: 50,
      taphold_threshold: 750,
      doubletap_int: 500,
      shake_threshold: 15,
      touch_capable: touchCapable,
      orientation_support: 'orientation' in window && 'onorientationchange' in window,
      startevent: touchCapable ? 'touchstart' : 'mousedown',
      endevent: touchCapable ? 'touchend' : 'mouseup',
      moveevent: touchCapable ? 'touchmove' : 'mousemove',
      tapevent: touchCapable ? 'tap' : 'click',
      scrollevent: touchCapable ? 'touchmove' : 'scroll',
      hold_timer: null,
      tap_timer: null
    };

  // Declare touch namespace:
  $.touch = {};

  // Convenience functions:
  $.isTouchCapable = function () {
    return settings.touch_capable;
  };
  $.getStartEvent = function () {
    return settings.startevent;
  };
  $.getEndEvent = function () {
    return settings.endevent;
  };
  $.getMoveEvent = function () {
    return settings.moveevent;
  };
  $.getTapEvent = function () {
    return settings.tapevent;
  };
  $.getScrollEvent = function () {
    return settings.scrollevent;
  };

  // SETTERS:
  // Set the X threshold of swipe events:
  $.touch.setSwipeThresholdX = function (threshold) {
    if (typeof threshold !== 'number') {
      throw new Error('Threshold parameter must be a type of number');
    }
    settings.swipe_h_threshold = threshold;
  };

  // Set the Y threshold of swipe events:
  $.touch.setSwipeThresholdY = function (threshold) {
    if (typeof threshold !== 'number') {
      throw new Error('Threshold parameter must be a type of number');
    }
    settings.swipe_v_threshold = threshold;
  };

  // Set the double tap interval:
  $.touch.setDoubleTapInt = function (interval) {
    if (typeof interval !== 'number') {
      throw new Error('Interval parameter must be a type of number');
    }
    settings.doubletap_int = interval;
  };

  // Set the taphold threshold:
  $.touch.setTapHoldThreshold = function (threshold) {
    if (typeof threshold !== 'number') {
      throw new Error('Threshold parameter must be a type of number');
    }
    settings.taphold_threshold = threshold;
  };

  // Set the pixel range for tapas:
  $.touch.setTapRange = function (range) {
    if (typeof range !== 'number') {
      throw new Error('Ranger parameter must be a type of number');
    }
    settings.tap_pixel_range = threshold;
  };

  // Add Event shortcuts:
  $.each(['tapstart', 'tapend', 'tapmove', 'tap', 'singletap', 'doubletap', 'taphold', 'swipe', 'swipeup', 'swiperight', 'swipedown', 'swipeleft', 'swipeend', 'scrollstart', 'scrollend', 'orientationchange', 'tap2', 'taphold2'], function (i, name) {
    $.fn[name] = function (fn) {
      return fn ? this.on(name, fn) : this.trigger(name);
    };
    $.attrFn[name] = true;
  });

  // tapstart Event:
  $.event.special.tapstart = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject);
      $this.on(settings.startevent, function tapStartFunc(e) {
        $this.data('callee', tapStartFunc);
        if (e.which && e.which !== 1) {
          return false;
        }
        var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
          left: 0,
          top: 0
        };
        var origEvent = e.originalEvent,
          touchData = {
            'position': {
              'x': settings.touch_capable ? origEvent.touches[0].pageX : e.pageX,
              'y': settings.touch_capable ? origEvent.touches[0].pageY : e.pageY
            },
            'offset': {
              'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
              'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
            },
            'time': Date.now(),
            'target': e.target
          };
        triggerCustomEvent(thisObject, 'tapstart', e, touchData);
        return true;
      });
    },
    remove: function remove() {
      $(this).off(settings.startevent, $(this).data.callee);
    }
  };

  // tapmove Event:
  $.event.special.tapmove = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject);
      $this.on(settings.moveevent, function tapMoveFunc(e) {
        $this.data('callee', tapMoveFunc);
        var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
          left: 0,
          top: 0
        };
        var origEvent = e.originalEvent,
          touchData = {
            'position': {
              'x': settings.touch_capable ? origEvent.touches[0].pageX : e.pageX,
              'y': settings.touch_capable ? origEvent.touches[0].pageY : e.pageY
            },
            'offset': {
              'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
              'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
            },
            'time': Date.now(),
            'target': e.target
          };
        triggerCustomEvent(thisObject, 'tapmove', e, touchData);
        return true;
      });
    },
    remove: function remove() {
      $(this).off(settings.moveevent, $(this).data.callee);
    }
  };

  // tapend Event:
  $.event.special.tapend = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject);
      $this.on(settings.endevent, function tapEndFunc(e) {
        // Touch event data:
        $this.data('callee', tapEndFunc);
        var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
          left: 0,
          top: 0
        };
        var origEvent = e.originalEvent;
        var touchData = {
          'position': {
            'x': settings.touch_capable ? origEvent.changedTouches[0].pageX : e.pageX,
            'y': settings.touch_capable ? origEvent.changedTouches[0].pageY : e.pageY
          },
          'offset': {
            'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
            'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
          },
          'time': Date.now(),
          'target': e.target
        };
        triggerCustomEvent(thisObject, 'tapend', e, touchData);
        return true;
      });
    },
    remove: function remove() {
      $(this).off(settings.endevent, $(this).data.callee);
    }
  };

  // taphold Event:
  $.event.special.taphold = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject),
        origTarget,
        start_pos = {
          x: 0,
          y: 0
        },
        end_x = 0,
        end_y = 0;
      $this.on(settings.startevent, function tapHoldFunc1(e) {
        if (e.which && e.which !== 1) {
          return false;
        } else {
          $this.data('tapheld', false);
          origTarget = e.target;
          var origEvent = e.originalEvent;
          var start_time = Date.now(),
            startPosition = {
              'x': settings.touch_capable ? origEvent.touches[0].pageX : e.pageX,
              'y': settings.touch_capable ? origEvent.touches[0].pageY : e.pageY
            },
            startOffset = {
              'x': settings.touch_capable ? origEvent.touches[0].pageX - origEvent.touches[0].target.offsetLeft : e.offsetX,
              'y': settings.touch_capable ? origEvent.touches[0].pageY - origEvent.touches[0].target.offsetTop : e.offsetY
            };
          start_pos.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX;
          start_pos.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY;
          end_x = start_pos.x;
          end_y = start_pos.y;

          // Get the element's threshold:
          var ele_threshold = $this.parent().data('threshold') ? $this.parent().data('threshold') : $this.data('threshold'),
            threshold = typeof ele_threshold !== 'undefined' && ele_threshold !== false && parseInt(ele_threshold) ? parseInt(ele_threshold) : settings.taphold_threshold;
          $this.data('hold_timer', window.setTimeout(function () {
            var diff_x = start_pos.x - end_x,
              diff_y = start_pos.y - end_y;
            if (e.target == origTarget && (start_pos.x == end_x && start_pos.y == end_y || diff_x >= -settings.tap_pixel_range && diff_x <= settings.tap_pixel_range && diff_y >= -settings.tap_pixel_range && diff_y <= settings.tap_pixel_range)) {
              $this.data('tapheld', true);
              var end_time = Date.now();
              var duration = end_time - start_time,
                touches = e.originalEvent.targetTouches ? e.originalEvent.targetTouches : [e],
                touchData = [];
              var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
                left: 0,
                top: 0
              };
              for (var i = 0; i < touches.length; i++) {
                var touch = {
                  'position': {
                    'x': settings.touch_capable ? origEvent.changedTouches[i].pageX : e.pageX,
                    'y': settings.touch_capable ? origEvent.changedTouches[i].pageY : e.pageY
                  },
                  'offset': {
                    'x': settings.touch_capable ? Math.round(origEvent.changedTouches[i].pageX - offset.left) : Math.round(e.pageX - offset.left),
                    'y': settings.touch_capable ? Math.round(origEvent.changedTouches[i].pageY - offset.top) : Math.round(e.pageY - offset.top)
                  },
                  'time': Date.now(),
                  'target': e.target,
                  'duration': duration
                };
                touchData.push(touch);
              }
              var evt_name = touches.length == 2 ? 'taphold2' : 'taphold';
              $this.data('callee1', tapHoldFunc1);
              triggerCustomEvent(thisObject, evt_name, e, touchData);
            }
          }, threshold));
          return true;
        }
      }).on(settings.endevent, function tapHoldFunc2() {
        $this.data('callee2', tapHoldFunc2);
        $this.data('tapheld', false);
        window.clearTimeout($this.data('hold_timer'));
      }).on(settings.moveevent, function tapHoldFunc3(e) {
        $this.data('callee3', tapHoldFunc3);
        end_x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX;
        end_y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY;
      });
    },
    remove: function remove() {
      $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2).off(settings.moveevent, $(this).data.callee3);
    }
  };

  // doubletap Event:
  $.event.special.doubletap = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject),
        origTarget,
        action,
        firstTap = null,
        origEvent,
        cooloff,
        cooling = false;
      $this.on(settings.startevent, function doubleTapFunc1(e) {
        if (e.which && e.which !== 1) {
          return false;
        }
        $this.data('doubletapped', false);
        origTarget = e.target;
        $this.data('callee1', doubleTapFunc1);
        origEvent = e.originalEvent;
        if (!firstTap) {
          var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
            left: 0,
            top: 0
          };
          firstTap = {
            'position': {
              'x': settings.touch_capable ? origEvent.touches[0].pageX : e.pageX,
              'y': settings.touch_capable ? origEvent.touches[0].pageY : e.pageY
            },
            'offset': {
              'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
              'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
            },
            'time': Date.now(),
            'target': e.target,
            'element': e.originalEvent.srcElement,
            'index': $(e.target).index()
          };
        }
        return true;
      }).on(settings.endevent, function doubleTapFunc2(e) {
        var now = Date.now();
        var lastTouch = $this.data('lastTouch') || now + 1;
        var delta = now - lastTouch;
        window.clearTimeout(action);
        $this.data('callee2', doubleTapFunc2);
        if (delta < settings.doubletap_int && $(e.target).index() == firstTap.index && delta > 100) {
          $this.data('doubletapped', true);
          window.clearTimeout(settings.tap_timer);

          // Now get the current event:
          var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
            left: 0,
            top: 0
          };
          var lastTap = {
            'position': {
              'x': settings.touch_capable ? e.originalEvent.changedTouches[0].pageX : e.pageX,
              'y': settings.touch_capable ? e.originalEvent.changedTouches[0].pageY : e.pageY
            },
            'offset': {
              'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
              'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
            },
            'time': Date.now(),
            'target': e.target,
            'element': e.originalEvent.srcElement,
            'index': $(e.target).index()
          };
          var touchData = {
            'firstTap': firstTap,
            'secondTap': lastTap,
            'interval': lastTap.time - firstTap.time
          };
          if (!cooling) {
            triggerCustomEvent(thisObject, 'doubletap', e, touchData);
            firstTap = null;
          }
          cooling = true;
          cooloff = window.setTimeout(function () {
            cooling = false;
          }, settings.doubletap_int);
        } else {
          $this.data('lastTouch', now);
          action = window.setTimeout(function () {
            firstTap = null;
            window.clearTimeout(action);
          }, settings.doubletap_int, [e]);
        }
        $this.data('lastTouch', now);
      });
    },
    remove: function remove() {
      $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2);
    }
  };

  // singletap Event:
  // This is used in conjuction with doubletap when both events are needed on the same element
  $.event.special.singletap = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject),
        origTarget = null,
        startTime = null,
        start_pos = {
          x: 0,
          y: 0
        };
      $this.on(settings.startevent, function singleTapFunc1(e) {
        if (e.which && e.which !== 1) {
          return false;
        } else {
          startTime = Date.now();
          origTarget = e.target;
          $this.data('callee1', singleTapFunc1);

          // Get the start x and y position:
          start_pos.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX;
          start_pos.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY;
          return true;
        }
      }).on(settings.endevent, function singleTapFunc2(e) {
        $this.data('callee2', singleTapFunc2);
        if (e.target == origTarget) {
          // Get the end point:
          var end_pos_x = e.originalEvent.changedTouches ? e.originalEvent.changedTouches[0].pageX : e.pageX,
            end_pos_y = e.originalEvent.changedTouches ? e.originalEvent.changedTouches[0].pageY : e.pageY;

          // We need to check if it was a taphold:

          settings.tap_timer = window.setTimeout(function () {
            var diff_x = start_pos.x - end_pos_x,
              diff_y = start_pos.y - end_pos_y;
            if (!$this.data('doubletapped') && !$this.data('tapheld') && (start_pos.x == end_pos_x && start_pos.y == end_pos_y || diff_x >= -settings.tap_pixel_range && diff_x <= settings.tap_pixel_range && diff_y >= -settings.tap_pixel_range && diff_y <= settings.tap_pixel_range)) {
              var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
                left: 0,
                top: 0
              };
              var origEvent = e.originalEvent;
              var touchData = {
                'position': {
                  'x': settings.touch_capable ? origEvent.changedTouches[0].pageX : e.pageX,
                  'y': settings.touch_capable ? origEvent.changedTouches[0].pageY : e.pageY
                },
                'offset': {
                  'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
                  'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
                },
                'time': Date.now(),
                'target': e.target
              };

              // Was it a taphold?
              if (touchData.time - startTime < settings.taphold_threshold) {
                triggerCustomEvent(thisObject, 'singletap', e, touchData);
              }
            }
          }, settings.doubletap_int);
        }
      });
    },
    remove: function remove() {
      $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2);
    }
  };

  // tap Event:
  $.event.special.tap = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject),
        started = false,
        origTarget = null,
        start_time,
        start_pos = {
          x: 0,
          y: 0
        },
        touches;
      $this.on(settings.startevent, function tapFunc1(e) {
        $this.data('callee1', tapFunc1);
        if (e.which && e.which !== 1) {
          return false;
        } else {
          started = true;
          start_pos.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX;
          start_pos.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY;
          start_time = Date.now();
          origTarget = e.target;
          touches = e.originalEvent.targetTouches ? e.originalEvent.targetTouches : [e];
          return true;
        }
      }).on(settings.endevent, function tapFunc2(e) {
        $this.data('callee2', tapFunc2);

        // Only trigger if they've started, and the target matches:
        var end_x = e.originalEvent.targetTouches ? e.originalEvent.changedTouches[0].pageX : e.pageX,
          end_y = e.originalEvent.targetTouches ? e.originalEvent.changedTouches[0].pageY : e.pageY,
          diff_x = start_pos.x - end_x,
          diff_y = start_pos.y - end_y,
          eventName;
        if (origTarget == e.target && started && Date.now() - start_time < settings.taphold_threshold && (start_pos.x == end_x && start_pos.y == end_y || diff_x >= -settings.tap_pixel_range && diff_x <= settings.tap_pixel_range && diff_y >= -settings.tap_pixel_range && diff_y <= settings.tap_pixel_range)) {
          var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
            left: 0,
            top: 0
          };
          var origEvent = e.originalEvent;
          var touchData = [];
          for (var i = 0; i < touches.length; i++) {
            var touch = {
              'position': {
                'x': settings.touch_capable ? origEvent.changedTouches[i].pageX : e.pageX,
                'y': settings.touch_capable ? origEvent.changedTouches[i].pageY : e.pageY
              },
              'offset': {
                'x': settings.touch_capable ? Math.round(origEvent.changedTouches[i].pageX - offset.left) : Math.round(e.pageX - offset.left),
                'y': settings.touch_capable ? Math.round(origEvent.changedTouches[i].pageY - offset.top) : Math.round(e.pageY - offset.top)
              },
              'time': Date.now(),
              'target': e.target
            };
            touchData.push(touch);
          }
          var evt_name = touches.length == 2 ? 'tap2' : 'tap';
          triggerCustomEvent(thisObject, evt_name, e, touchData);
        }
      });
    },
    remove: function remove() {
      $(this).off(settings.startevent, $(this).data.callee1).off(settings.endevent, $(this).data.callee2);
    }
  };

  // swipe Event (also handles swipeup, swiperight, swipedown and swipeleft):
  $.event.special.swipe = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject),
        started = false,
        hasSwiped = false,
        originalCoord = {
          x: 0,
          y: 0
        },
        finalCoord = {
          x: 0,
          y: 0
        },
        startEvnt;

      // Screen touched, store the original coordinate

      function touchStart(e) {
        $this = $(e.currentTarget);
        $this.data('callee1', touchStart);
        originalCoord.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX;
        originalCoord.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY;
        finalCoord.x = originalCoord.x;
        finalCoord.y = originalCoord.y;
        started = true;
        var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
          left: 0,
          top: 0
        };
        var origEvent = e.originalEvent;
        // Read event data into our startEvt:
        startEvnt = {
          'position': {
            'x': settings.touch_capable ? origEvent.touches[0].pageX : e.pageX,
            'y': settings.touch_capable ? origEvent.touches[0].pageY : e.pageY
          },
          'offset': {
            'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
            'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
          },
          'time': Date.now(),
          'target': e.target
        };
      }

      // Store coordinates as finger is swiping

      function touchMove(e) {
        $this = $(e.currentTarget);
        $this.data('callee2', touchMove);
        finalCoord.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX;
        finalCoord.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY;
        var swipedir;

        // We need to check if the element to which the event was bound contains a data-xthreshold | data-vthreshold:
        var ele_x_threshold = $this.parent().data('xthreshold') ? $this.parent().data('xthreshold') : $this.data('xthreshold'),
          ele_y_threshold = $this.parent().data('ythreshold') ? $this.parent().data('ythreshold') : $this.data('ythreshold'),
          h_threshold = typeof ele_x_threshold !== 'undefined' && ele_x_threshold !== false && parseInt(ele_x_threshold) ? parseInt(ele_x_threshold) : settings.swipe_h_threshold,
          v_threshold = typeof ele_y_threshold !== 'undefined' && ele_y_threshold !== false && parseInt(ele_y_threshold) ? parseInt(ele_y_threshold) : settings.swipe_v_threshold;
        if (Math.abs(finalCoord.x - originalCoord.x) > Math.abs(finalCoord.y - originalCoord.y)) {
          if (originalCoord.x < finalCoord.x && finalCoord.x - originalCoord.x > h_threshold) {
            swipedir = 'swiperight';
          }
          if (originalCoord.x > finalCoord.x && originalCoord.x - finalCoord.x > h_threshold) {
            swipedir = 'swipeleft';
          }
        } else {
          if (originalCoord.y > finalCoord.y && originalCoord.y - finalCoord.y > v_threshold) {
            swipedir = 'swipeup';
          }
          if (originalCoord.y < finalCoord.y && finalCoord.y - originalCoord.y > v_threshold) {
            swipedir = 'swipedown';
          }
        }
        if (swipedir != undefined && started) {
          originalCoord.x = 0;
          originalCoord.y = 0;
          finalCoord.x = 0;
          finalCoord.y = 0;
          started = false;

          // Read event data into our endEvnt:
          var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
            left: 0,
            top: 0
          };
          var origEvent = e.originalEvent;
          var endEvnt = {
            'position': {
              'x': settings.touch_capable ? origEvent.touches[0].pageX : e.pageX,
              'y': settings.touch_capable ? origEvent.touches[0].pageY : e.pageY
            },
            'offset': {
              'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
              'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
            },
            'time': Date.now(),
            'target': e.target
          };

          // Calculate the swipe amount (normalized):
          var xAmount = Math.abs(startEvnt.position.x - endEvnt.position.x),
            yAmount = Math.abs(startEvnt.position.y - endEvnt.position.y);
          var touchData = {
            'startEvnt': startEvnt,
            'endEvnt': endEvnt,
            'direction': swipedir.replace('swipe', ''),
            'xAmount': xAmount,
            'yAmount': yAmount,
            'duration': endEvnt.time - startEvnt.time
          };
          hasSwiped = true;
          $this.trigger('swipe', touchData).trigger(swipedir, touchData);
        }
      }
      function touchEnd(e) {
        $this = $(e.currentTarget);
        var swipedir = "";
        $this.data('callee3', touchEnd);
        if (hasSwiped) {
          // We need to check if the element to which the event was bound contains a data-xthreshold | data-vthreshold:
          var ele_x_threshold = $this.data('xthreshold'),
            ele_y_threshold = $this.data('ythreshold'),
            h_threshold = typeof ele_x_threshold !== 'undefined' && ele_x_threshold !== false && parseInt(ele_x_threshold) ? parseInt(ele_x_threshold) : settings.swipe_h_threshold,
            v_threshold = typeof ele_y_threshold !== 'undefined' && ele_y_threshold !== false && parseInt(ele_y_threshold) ? parseInt(ele_y_threshold) : settings.swipe_v_threshold;
          var offset = $this.get(0) !== window && $this.get(0) !== document ? $this.offset() : {
            left: 0,
            top: 0
          };
          var origEvent = e.originalEvent;
          var endEvnt = {
            'position': {
              'x': settings.touch_capable ? origEvent.changedTouches[0].pageX : e.pageX,
              'y': settings.touch_capable ? origEvent.changedTouches[0].pageY : e.pageY
            },
            'offset': {
              'x': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageX - offset.left) : Math.round(e.pageX - offset.left),
              'y': settings.touch_capable ? Math.round(origEvent.changedTouches[0].pageY - offset.top) : Math.round(e.pageY - offset.top)
            },
            'time': Date.now(),
            'target': e.target
          };

          // Calculate the swipe amount (normalized):
          var xAmount = Math.abs(startEvnt.position.x - endEvnt.position.x),
            yAmount = Math.abs(startEvnt.position.y - endEvnt.position.y);

          // Read event data into our endEvnt:
          if (xAmount > yAmount) {
            if (startEvnt.position.x < endEvnt.position.x && endEvnt.position.x - startEvnt.position.x > h_threshold) {
              swipedir = 'swiperight';
            }
            if (startEvnt.position.x > endEvnt.position.x && startEvnt.position.x - endEvnt.position.x > h_threshold) {
              swipedir = 'swipeleft';
            }
          } else {
            if (startEvnt.position.y > endEvnt.position.y && startEvnt.position.y - endEvnt.position.y > v_threshold) {
              swipedir = 'swipeup';
            }
            if (startEvnt.position.y < endEvnt.position.y && endEvnt.position.y - startEvnt.position.y > v_threshold) {
              swipedir = 'swipedown';
            }
          }
          var touchData = {
            'startEvnt': startEvnt,
            'endEvnt': endEvnt,
            'direction': swipedir.replace('swipe', ''),
            'xAmount': xAmount,
            'yAmount': yAmount,
            'duration': endEvnt.time - startEvnt.time
          };
          $this.trigger('swipeend', touchData);
        }
        started = false;
        hasSwiped = false;
      }
      $this.on(settings.startevent, touchStart);
      $this.on(settings.moveevent, touchMove);
      $this.on(settings.endevent, touchEnd);
    },
    remove: function remove() {
      $(this).off(settings.startevent, $(this).data.callee1).off(settings.moveevent, $(this).data.callee2).off(settings.endevent, $(this).data.callee3);
    }
  };

  // scrollstart Event (also handles scrollend):
  $.event.special.scrollstart = {
    setup: function setup() {
      var thisObject = this,
        $this = $(thisObject),
        scrolling,
        timer;
      function trigger(event, state) {
        scrolling = state;
        triggerCustomEvent(thisObject, scrolling ? 'scrollstart' : 'scrollend', event);
      }

      // iPhone triggers scroll after a small delay; use touchmove instead
      $this.on(settings.scrollevent, function scrollFunc(event) {
        $this.data('callee', scrollFunc);
        if (!scrolling) {
          trigger(event, true);
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
          trigger(event, false);
        }, 50);
      });
    },
    remove: function remove() {
      $(this).off(settings.scrollevent, $(this).data.callee);
    }
  };

  // This is the orientation change (largely borrowed from jQuery Mobile):
  var win = $(window),
    special_event,
    get_orientation,
    last_orientation,
    initial_orientation_is_landscape,
    initial_orientation_is_default,
    portrait_map = {
      '0': true,
      '180': true
    };
  if (settings.orientation_support) {
    var ww = window.innerWidth || win.width(),
      wh = window.innerHeight || win.height(),
      landscape_threshold = 50;
    initial_orientation_is_landscape = ww > wh && ww - wh > landscape_threshold;
    initial_orientation_is_default = portrait_map[window.orientation];
    if (initial_orientation_is_landscape && initial_orientation_is_default || !initial_orientation_is_landscape && !initial_orientation_is_default) {
      portrait_map = {
        '-90': true,
        '90': true
      };
    }
  }
  $.event.special.orientationchange = special_event = {
    setup: function setup() {
      // If the event is supported natively, return false so that jQuery
      // will on to the event using DOM methods.
      if (settings.orientation_support) {
        return false;
      }

      // Get the current orientation to avoid initial double-triggering.
      last_orientation = get_orientation();
      win.on('throttledresize', handler);
      return true;
    },
    teardown: function teardown() {
      if (settings.orientation_support) {
        return false;
      }
      win.off('throttledresize', handler);
      return true;
    },
    add: function add(handleObj) {
      // Save a reference to the bound event handler.
      var old_handler = handleObj.handler;
      handleObj.handler = function (event) {
        event.orientation = get_orientation();
        return old_handler.apply(this, arguments);
      };
    }
  };

  // If the event is not supported natively, this handler will be bound to
  // the window resize event to simulate the orientationchange event.

  function handler() {
    // Get the current orientation.
    var orientation = get_orientation();
    if (orientation !== last_orientation) {
      // The orientation has changed, so trigger the orientationchange event.
      last_orientation = orientation;
      win.trigger("orientationchange");
    }
  }
  $.event.special.orientationchange.orientation = get_orientation = function get_orientation() {
    var isPortrait = true,
      elem = document.documentElement;
    if (settings.orientation_support) {
      isPortrait = portrait_map[window.orientation];
    } else {
      isPortrait = elem && elem.clientWidth / elem.clientHeight < 1.1;
    }
    return isPortrait ? 'portrait' : 'landscape';
  };

  // throttle Handler:
  $.event.special.throttledresize = {
    setup: function setup() {
      $(this).on('resize', throttle_handler);
    },
    teardown: function teardown() {
      $(this).off('resize', throttle_handler);
    }
  };
  var throttle = 250,
    throttle_handler = function throttle_handler() {
      curr = Date.now();
      diff = curr - lastCall;
      if (diff >= throttle) {
        lastCall = curr;
        $(this).trigger('throttledresize');
      } else {
        if (heldCall) {
          window.clearTimeout(heldCall);
        }

        // Promise a held call will still execute
        heldCall = window.setTimeout(handler, throttle - diff);
      }
    },
    lastCall = 0,
    heldCall,
    curr,
    diff;

  // Trigger a custom event:

  function triggerCustomEvent(obj, eventType, event, touchData) {
    var originalType = event.type;
    event.type = eventType;
    $.event.dispatch.call(obj, event, touchData);
    event.type = originalType;
  }

  // Correctly on anything we've overloaded:
  $.each({
    scrollend: 'scrollstart',
    swipeup: 'swipe',
    swiperight: 'swipe',
    swipedown: 'swipe',
    swipeleft: 'swipe',
    swipeend: 'swipe',
    tap2: 'tap',
    taphold2: 'taphold'
  }, function (e, srcE) {
    $.event.special[e] = {
      setup: function setup() {
        $(this).on(srcE, $.noop);
      }
    };
  });
})(jQuery);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Swiper 6.3.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 20, 2020
 */

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.Swiper = factory());
})(this, function () {
  'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }

  /**
   * SSR Window 3.0.0-alpha.4
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2020, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: May 20, 2020
   */

  /* eslint-disable no-param-reassign */
  function isObject(obj) {
    return obj !== null && _typeof(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
  }
  function extend(target, src) {
    if (target === void 0) {
      target = {};
    }
    if (src === void 0) {
      src = {};
    }
    Object.keys(src).forEach(function (key) {
      if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }
  var ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS: function createElementNS() {
      return {};
    },
    importNode: function importNode() {
      return null;
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    }
  };
  function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ''
    },
    location: {
      hash: '',
      host: '',
      hostname: '',
      href: '',
      origin: '',
      pathname: '',
      protocol: '',
      search: ''
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
      if (typeof setTimeout === 'undefined') {
        callback();
        return null;
      }
      return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
      if (typeof setTimeout === 'undefined') {
        return;
      }
      clearTimeout(id);
    }
  };
  function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  /**
   * Dom7 3.0.0-alpha.7
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * https://framework7.io/docs/dom7.html
   *
   * Copyright 2020, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 14, 2020
   */

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  /* eslint-disable no-proto */

  function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
      get: function get() {
        return proto;
      },
      set: function set(value) {
        proto.__proto__ = value;
      }
    });
  }
  var Dom7 = /*#__PURE__*/function (_Array) {
    _inheritsLoose(Dom7, _Array);
    function Dom7(items) {
      var _this;
      _this = _Array.call.apply(_Array, [this].concat(items)) || this;
      makeReactive(_assertThisInitialized(_this));
      return _this;
    }
    return Dom7;
  }( /*#__PURE__*/_wrapNativeSuper(Array));
  function arrayFlat(arr) {
    if (arr === void 0) {
      arr = [];
    }
    var res = [];
    arr.forEach(function (el) {
      if (Array.isArray(el)) {
        res.push.apply(res, arrayFlat(el));
      } else {
        res.push(el);
      }
    });
    return res;
  }
  function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
  }
  function arrayUnique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    }
    return uniqueArray;
  }
  function qsa(selector, context) {
    if (typeof selector !== 'string') {
      return [selector];
    }
    var a = [];
    var res = context.querySelectorAll(selector);
    for (var i = 0; i < res.length; i += 1) {
      a.push(res[i]);
    }
    return a;
  }
  function $(selector, context) {
    var window = getWindow();
    var document = getDocument();
    var arr = [];
    if (!context && selector instanceof Dom7) {
      return selector;
    }
    if (!selector) {
      return new Dom7(arr);
    }
    if (typeof selector === 'string') {
      var html = selector.trim();
      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (html.indexOf('<li') === 0) toCreate = 'ul';
        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
        if (html.indexOf('<tbody') === 0) toCreate = 'table';
        if (html.indexOf('<option') === 0) toCreate = 'select';
        var tempParent = document.createElement(toCreate);
        tempParent.innerHTML = html;
        for (var i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        arr = qsa(selector.trim(), context || document);
      } // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) {
      arr.push(selector);
    } else if (Array.isArray(selector)) {
      if (selector instanceof Dom7) return selector;
      arr = selector;
    }
    return new Dom7(arrayUnique(arr));
  }
  $.fn = Dom7.prototype;
  function addClass() {
    for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
      classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    this.forEach(function (el) {
      var _el$classList;
      (_el$classList = el.classList).add.apply(_el$classList, classNames);
    });
    return this;
  }
  function removeClass() {
    for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classes[_key2] = arguments[_key2];
    }
    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    this.forEach(function (el) {
      var _el$classList2;
      (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
    });
    return this;
  }
  function toggleClass() {
    for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      classes[_key3] = arguments[_key3];
    }
    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    this.forEach(function (el) {
      classNames.forEach(function (className) {
        el.classList.toggle(className);
      });
    });
  }
  function hasClass() {
    for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      classes[_key4] = arguments[_key4];
    }
    var classNames = arrayFlat(classes.map(function (c) {
      return c.split(' ');
    }));
    return arrayFilter(this, function (el) {
      return classNames.filter(function (className) {
        return el.classList.contains(className);
      }).length > 0;
    }).length > 0;
  }
  function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) return this[0].getAttribute(attrs);
      return undefined;
    } // Set attrs

    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].style.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].style.transition = typeof duration !== 'string' ? duration + "ms" : duration;
    }
    return this;
  }
  function on() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];
    if (typeof args[1] === 'function') {
      eventType = args[0];
      listener = args[1];
      capture = args[2];
      targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) return;
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
        var _parents = $(target).parents(); // eslint-disable-line

        for (var k = 0; k < _parents.length; k += 1) {
          if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) el.dom7Listeners = {};
          if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var _event = events[j];
          if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
          if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
          el.dom7LiveListeners[_event].push({
            listener: listener,
            proxyListener: handleLiveEvent
          });
          el.addEventListener(_event, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];
    if (typeof args[1] === 'function') {
      eventType = args[0];
      listener = args[1];
      capture = args[2];
      targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = void 0;
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var window = getWindow();
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        if (window.CustomEvent) {
          var evt = new window.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true
          });
          el.dom7EventData = args.filter(function (data, dataIndex) {
            return dataIndex > 0;
          });
          el.dispatchEvent(evt);
          el.dom7EventData = [];
          delete el.dom7EventData;
        }
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
      if (e.target !== this) return;
      callback.call(this, e);
      dom.off('transitionend', fireCallBack);
    }
    if (callback) {
      dom.on('transitionend', fireCallBack);
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        var _styles = this.styles();
        return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        var _styles2 = this.styles();
        return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var window = getWindow();
      var document = getDocument();
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = document.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === window ? window.scrollY : el.scrollTop;
      var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
      return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
      };
    }
    return null;
  }
  function styles() {
    var window = getWindow();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
  }
  function css(props, value) {
    var window = getWindow();
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        // .css('width')
        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
      } else {
        // .css({ width: '100px' })
        for (i = 0; i < this.length; i += 1) {
          for (var _prop in props) {
            this[i].style[_prop] = props[_prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      // .css('width', '100px')
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  function each(callback) {
    if (!callback) return this;
    this.forEach(function (el, index) {
      callback.apply(el, [el, index]);
    });
    return this;
  }
  function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
  }
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : null;
    }
    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  function text(text) {
    if (typeof text === 'undefined') {
      return this[0] ? this[0].textContent.trim() : null;
    }
    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
      if (el.matches) return el.matches(selector);
      if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
      if (el.msMatchesSelector) return el.msMatchesSelector(selector);
      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) return true;
      }
      return false;
    }
    if (selector === document) {
      return el === document;
    }
    if (selector === window) {
      return el === window;
    }
    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) return true;
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0; // eslint-disable-next-line

      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) i += 1;
      }
      return i;
    }
    return undefined;
  }
  function eq(index) {
    if (typeof index === 'undefined') return this;
    var length = this.length;
    if (index > length - 1) {
      return $([]);
    }
    if (index < 0) {
      var returnIndex = length + index;
      if (returnIndex < 0) return $([]);
      return $([this[returnIndex]]);
    }
    return $([this[index]]);
  }
  function append() {
    var newChild;
    var document = getDocument();
    for (var k = 0; k < arguments.length; k += 1) {
      newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }
    return this;
  }
  function prepend(newChild) {
    var document = getDocument();
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return $([this[0].nextElementSibling]);
        }
        return $([]);
      }
      if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
      return $([]);
    }
    return $([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);
    while (el.nextElementSibling) {
      var _next = el.nextElementSibling; // eslint-disable-line

      if (selector) {
        if ($(_next).is(selector)) nextEls.push(_next);
      } else nextEls.push(_next);
      el = _next;
    }
    return $(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return $([el.previousElementSibling]);
        }
        return $([]);
      }
      if (el.previousElementSibling) return $([el.previousElementSibling]);
      return $([]);
    }
    return $([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);
    while (el.previousElementSibling) {
      var _prev = el.previousElementSibling; // eslint-disable-line

      if (selector) {
        if ($(_prev).is(selector)) prevEls.push(_prev);
      } else prevEls.push(_prev);
      el = _prev;
    }
    return $(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(parents);
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      var _parent = this[i].parentNode; // eslint-disable-line

      while (_parent) {
        if (selector) {
          if ($(_parent).is(selector)) parents.push(_parent);
        } else {
          parents.push(_parent);
        }
        _parent = _parent.parentNode;
      }
    }
    return $(parents);
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line

    if (typeof selector === 'undefined') {
      return $([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return $(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line

    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].children;
      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector || $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return $(children);
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    }
    return this;
  }
  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    styles: styles,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    filter: filter,
    remove: remove
  };
  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = Methods[methodName];
  });
  function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {// no getter for object
      }
      try {
        delete object[key];
      } catch (e) {// something got wrong
      }
    });
  }
  function nextTick(callback, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return setTimeout(callback, delay);
  }
  function now() {
    return Date.now();
  }
  function getTranslate(el, axis) {
    if (axis === void 0) {
      axis = 'x';
    }
    var window = getWindow();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = window.getComputedStyle(el, null);
    if (window.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) {
          return a.replace(',', '.');
        }).join(', ');
      } // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case

      transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  }
  function isObject$1(o) {
    return _typeof(o) === 'object' && o !== null && o.constructor && o.constructor === Object;
  }
  function extend$1() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    for (var i = 1; i < arguments.length; i += 1) {
      var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
      if (nextSource !== undefined && nextSource !== null) {
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
              extend$1(to[nextKey], nextSource[nextKey]);
            } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
              to[nextKey] = {};
              extend$1(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
  function bindModuleMethods(instance, obj) {
    Object.keys(obj).forEach(function (key) {
      if (isObject$1(obj[key])) {
        Object.keys(obj[key]).forEach(function (subKey) {
          if (typeof obj[key][subKey] === 'function') {
            obj[key][subKey] = obj[key][subKey].bind(instance);
          }
        });
      }
      instance[key] = obj[key];
    });
  }
  var support;
  function calcSupport() {
    var window = getWindow();
    var document = getDocument();
    return {
      touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
      pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
      observer: function checkObserver() {
        return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
      }(),
      passiveListener: function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            }
          });
          window.addEventListener('testPassiveListener', null, opts);
        } catch (e) {// No support
        }
        return supportsPassive;
      }(),
      gestures: function checkGestures() {
        return 'ongesturestart' in window;
      }()
    };
  }
  function getSupport() {
    if (!support) {
      support = calcSupport();
    }
    return support;
  }
  var device;
  function calcDevice(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;
    var support = getSupport();
    var window = getWindow();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
      ios: false,
      android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel'; // iPadOs 13 fix

    var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      if (!ipad) ipad = [0, 1, '13_0_0'];
      macos = false;
    } // Android

    if (android && !windows) {
      device.os = 'android';
      device.android = true;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    } // Export object

    return device;
  }
  function getDevice(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }
    if (!device) {
      device = calcDevice(overrides);
    }
    return device;
  }
  var browser;
  function calcBrowser() {
    var window = getWindow();
    function isSafari() {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
      isEdge: !!window.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
  }
  function getBrowser() {
    if (!browser) {
      browser = calcBrowser();
    }
    return browser;
  }
  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      extend$1(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) return;
            swiper.emit('orientationchange');
          }
        }
      });
    },
    on: {
      init: function init(swiper) {
        var window = getWindow(); // Emit resize

        window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

        window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy(swiper) {
        var window = getWindow();
        window.removeEventListener('resize', swiper.resize.resizeHandler);
        window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      }
    }
  };
  var Observer = {
    attach: function attach(target, options) {
      if (options === void 0) {
        options = {};
      }
      var window = getWindow();
      var swiper = this;
      var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(observerUpdate);
        } else {
          window.setTimeout(observerUpdate, 0);
        }
      });
      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData
      });
      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!swiper.support.observer || !swiper.params.observer) return;
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      } // Observe container

      swiper.observer.attach(swiper.$el[0], {
        childList: swiper.params.observeSlideChildren
      }); // Observe wrapper

      swiper.observer.attach(swiper.$wrapperEl[0], {
        attributes: false
      });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    }
  };
  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        observer: _extends(_extends({}, Observer), {}, {
          observers: []
        })
      });
    },
    on: {
      init: function init(swiper) {
        swiper.observer.init();
      },
      destroy: function destroy(swiper) {
        swiper.observer.destroy();
      }
    }
  };
  var modular = {
    useParams: function useParams(instanceParams) {
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName]; // Extend params

        if (module.params) {
          extend$1(instanceParams, module.params);
        }
      });
    },
    useModules: function useModules(modulesParams) {
      if (modulesParams === void 0) {
        modulesParams = {};
      }
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        } // Module create callback

        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    }
  };

  /* eslint-disable no-underscore-dangle */
  var eventsEmitter = {
    on: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    },
    once: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      function onceHandler() {
        self.off(events, onceHandler);
        if (onceHandler.__emitterProxy) {
          delete onceHandler.__emitterProxy;
        }
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        handler.apply(self, args);
      }
      onceHandler.__emitterProxy = handler;
      return self.on(events, onceHandler, priority);
    },
    onAny: function onAny(handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      if (self.eventsAnyListeners.indexOf(handler) < 0) {
        self.eventsAnyListeners[method](handler);
      }
      return self;
    },
    offAny: function offAny(handler) {
      var self = this;
      if (!self.eventsAnyListeners) return self;
      var index = self.eventsAnyListeners.indexOf(handler);
      if (index >= 0) {
        self.eventsAnyListeners.splice(index, 1);
      }
      return self;
    },
    off: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event]) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    },
    emit: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events;
      var data;
      var context;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }
      data.unshift(context);
      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
          self.eventsAnyListeners.forEach(function (eventHandler) {
            eventHandler.apply(context, [event].concat(data));
          });
        }
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  };
  function updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined' && swiper.params.width !== null) {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    } // Subtract paddings

    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    extend$1(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height
    });
  }
  function updateSlides() {
    var swiper = this;
    var window = getWindow();
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children("." + swiper.params.slideClass);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    function slidesForMargin(slideEl, slideIndex) {
      if (!params.cssMode) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    }
    swiper.virtualSize = -spaceBetween; // reset margins

    if (rtl) slides.css({
      marginLeft: '',
      marginTop: ''
    });else slides.css({
      marginRight: '',
      marginBottom: ''
    });
    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    } // Calc slides

    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = void 0;
        var column = void 0;
        var row = void 0;
        if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
          var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
          var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
          var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
          row = Math.floor(slideIndexInGroup / columnsInGroup);
          column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
          newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
          slide.css({
            '-webkit-box-ordinal-group': newSlideOrderIndex,
            '-moz-box-ordinal-group': newSlideOrderIndex,
            '-ms-flex-order': newSlideOrderIndex,
            '-webkit-order': newSlideOrderIndex,
            order: newSlideOrderIndex
          });
        } else if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - column * slidesPerColumn;
          if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
            row += 1;
            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - row * slidesPerRow;
        }
        slide.css("margin-" + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + "px");
      }
      if (slide.css('display') === 'none') continue; // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = window.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width') || 0);
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left') || 0);
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right') || 0);
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left') || 0);
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right') || 0);
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box') {
              slideSize = width + marginLeft + marginRight;
            } else {
              var _slide$ = slide[0],
                clientWidth = _slide$.clientWidth,
                offsetWidth = _slide$.offsetWidth;
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height') || 0);
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top') || 0);
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom') || 0);
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top') || 0);
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom') || 0);
            var _boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (_boxSizing && _boxSizing === 'border-box') {
              slideSize = height + marginTop + marginBottom;
            } else {
              var _slide$2 = slide[0],
                clientHeight = _slide$2.clientHeight,
                offsetHeight = _slide$2.offsetHeight;
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom + (offsetHeight - clientHeight);
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);
      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }
      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
      });
    }
    if (params.setWrapperSize) {
      if (swiper.isHorizontal()) $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
      });else $wrapperEl.css({
        height: swiper.virtualSize + params.spaceBetween + "px"
      });
    }
    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
      });else $wrapperEl.css({
        height: swiper.virtualSize + params.spaceBetween + "px"
      });
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var _i = 0; _i < snapGrid.length; _i += 1) {
          var slidesGridItem = snapGrid[_i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
      }
    } // Remove last grid elements depending on width

    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
        var _slidesGridItem = snapGrid[_i2];
        if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
        if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(_slidesGridItem);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) snapGrid = [0];
    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) slides.filter(slidesForMargin).css({
          marginLeft: spaceBetween + "px"
        });else slides.filter(slidesForMargin).css({
          marginRight: spaceBetween + "px"
        });
      } else slides.filter(slidesForMargin).css({
        marginBottom: spaceBetween + "px"
      });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      var maxSnap = allSlidesSize - swiperSize;
      snapGrid = snapGrid.map(function (snap) {
        if (snap < 0) return -offsetBefore;
        if (snap > maxSnap) return maxSnap + offsetAfter;
        return snap;
      });
    }
    if (params.centerInsufficientSlides) {
      var _allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      _allSlidesSize -= params.spaceBetween;
      if (_allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }
    extend$1(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid
    });
    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) swiper.checkOverflow();
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }
    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }
  function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    } // Find slides currently in view

    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        swiper.visibleSlides.each(function (slide) {
          activeSlides.push(slide);
        });
      } else {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          var index = swiper.activeIndex + i;
          if (index > swiper.slides.length) break;
          activeSlides.push(swiper.slides.eq(index)[0]);
        }
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    } // Find new height from highest slide in view

    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    } // Update Height

    if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
  }
  function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }
  function updateSlidesProgress(translate) {
    if (translate === void 0) {
      translate = this && this.translate || 0;
    }
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides

    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }
  function updateProgress(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
      var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

      translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / translatesDiff;
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    extend$1(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit('fromEdge');
    }
    swiper.emit('progress', progress);
  }
  function updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
    } else {
      activeSlide = slides.eq(activeIndex);
    } // Active classes

    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
      }
    } // Next Slide

    var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    } // Prev Slide

    var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
      }
    }
    swiper.emitSlidesClasses();
  }
  function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      } // Normalize slideIndex

      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    } // Get real index

    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    extend$1(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }
  function updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest("." + params.slideClass)[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) slideFound = true;
      }
    }
    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }
  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide
  };
  function getSwiperTranslate(axis) {
    if (axis === void 0) {
      axis = this.isHorizontal() ? 'x' : 'y';
    }
    var swiper = this;
    var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }
    if (params.cssMode) {
      return translate;
    }
    var currentTranslate = getTranslate($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }
  function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }
    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }
    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }
    swiper.emit('setTranslate', swiper.translate, byController);
  }
  function minTranslate() {
    return -this.snapGrid[0];
  }
  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) {
      translate = 0;
    }
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    if (translateBounds === void 0) {
      translateBounds = true;
    }
    var swiper = this;
    var params = swiper.params,
      wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          var _wrapperEl$scrollTo;
          wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        }
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionEnd');
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.emit('transitionStart');
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            if (runCallbacks) {
              swiper.emit('transitionEnd');
            }
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
      }
    }
    return true;
  }
  var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo
  };
  function setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) {
      swiper.$wrapperEl.transition(duration);
    }
    swiper.emit('setTransition', duration, byController);
  }
  function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
    if (params.cssMode) return;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
    }
    swiper.emit('transitionStart');
    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }
  function transitionEnd$1(runCallbacks, direction) {
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
    }
    swiper.emit('transitionEnd');
    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }
  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1
  };
  function slideTo(index, speed, runCallbacks, internal) {
    if (index === void 0) {
      index = 0;
    }
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }
    var translate = -snapGrid[snapIndex]; // Update progress

    swiper.updateProgress(translate); // Normalize slideIndex

    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    } // Directions locks

    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) return false;
      }
    }
    var direction;
    if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
      swiper.updateActiveIndex(slideIndex); // Update Height

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      var isH = swiper.isHorizontal();
      var t = -translate;
      if (rtl) {
        t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
      }
      if (speed === 0) {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      } else {
        // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
          var _wrapperEl$scrollTo;
          wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        }
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }
    return true;
  }
  function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) {
      index = 0;
    }
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    var params = swiper.params,
      animating = swiper.animating;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
    if (params.loop) {
      if (animating && params.loopPreventsSlide) return false;
      swiper.loopFix(); // eslint-disable-next-line

      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate;
    if (params.loop) {
      if (animating && params.loopPreventsSlide) return false;
      swiper.loopFix(); // eslint-disable-next-line

      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) {
      return normalize(val);
    });
    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
      snapGrid.forEach(function (snap) {
        if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
      });
    }
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) {
      speed = this.params.speed;
    }
    if (runCallbacks === void 0) {
      runCallbacks = true;
    }
    if (threshold === void 0) {
      threshold = 0.5;
    }
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
      // The current translate is on or after the current snap index, so the choice
      // is between the current index and the one after it.
      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];
      if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      // The current translate is before the current snap index, so the choice
      // is between the current index and the one before it.
      var prevSnap = swiper.snapGrid[snapIndex - 1];
      var _currentSnap = swiper.snapGrid[snapIndex];
      if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
  }
  function slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) return;
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
          nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide
  };
  function loopCreate() {
    var swiper = this;
    var document = getDocument();
    var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
    var slides = $wrapperEl.children("." + params.slideClass);
    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children("." + params.slideClass);
      }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (el, index) {
      var slide = $(el);
      if (index < swiper.loopedSlides) {
        appendSlides.push(el);
      }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
        prependSlides.push(el);
      }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var _i = 0; _i < appendSlides.length; _i += 1) {
      $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
      $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }
  function loopFix() {
    var swiper = this;
    swiper.emit('beforeLoopFix');
    var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

    if (activeIndex < loopedSlides) {
      newIndex = slides.length - loopedSlides * 3 + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (activeIndex >= slides.length - loopedSlides) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (_slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
  }
  function loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
    slides.removeAttr('data-swiper-slide-index');
  }
  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy
  };
  function setGrabCursor(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }
  function unsetGrabCursor() {
    var swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
      return;
    }
    swiper.el.style.cursor = '';
  }
  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor
  };
  function appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) $wrapperEl.append(slides[i]);
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }
  }
  function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) $wrapperEl.prepend(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }
  function addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }
    if (_typeof(slides) === 'object' && 'length' in slides) {
      for (var _i = 0; _i < slides.length; _i += 1) {
        if (slides[_i]) $wrapperEl.append(slides[_i]);
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }
    for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
      $wrapperEl.append(slidesBuffer[_i2]);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }
  function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (_typeof(slidesIndexes) === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
      newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && swiper.support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }
  function removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }
  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides
  };
  function onTouchStart(event) {
    var swiper = this;
    var document = getDocument();
    var window = getWindow();
    var data = swiper.touchEventsData;
    var params = swiper.params,
      touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = $(e.target);
    if (params.touchEventsTarget === 'wrapper') {
      if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.screen.width - edgeSwipeThreshold)) {
      return;
    }
    extend$1(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($targetEl.is(data.formElements)) preventDefault = false;
      if (document.activeElement && $(document.activeElement).is(data.formElements) && document.activeElement !== $targetEl[0]) {
        document.activeElement.blur();
      }
      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }
  function onTouchMove(event) {
    var document = getDocument();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        extend$1(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
        return;
      }
    }
    if (data.isTouchEvent && document.activeElement) {
      if (e.target === document.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) {
      e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }
    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false; // Grab Cursor

      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    } // Directions locks

    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    } // Threshold

    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode

    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: now()
      });
    } // Update progress

    swiper.updateProgress(data.currentTranslate); // Update translate

    swiper.setTranslate(data.currentTranslate);
  }
  function onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    } // Return Grab Cursor

    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    } // Time diff

    var touchEndTime = now();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap click', e);
      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        swiper.emit('doubleTap doubleClick', e);
      }
    }
    data.lastClickTime = now();
    nextTick(function () {
      if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }
    if (params.cssMode) {
      return;
    }
    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }
      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();
          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          } // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.

          if (time > 150 || now() - lastMoveEvent.time > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;
        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;
        var newPosition = swiper.translate + momentumDistance;
        if (rtl) newPosition = -newPosition;
        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }
          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        } // Fix duration

        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
          if (params.freeModeSticky) {
            // If freeModeSticky is active and the user ends a swipe with a slow-velocity
            // event, then durations can be 20+ seconds to slide one (or zero!) slides.
            // It's easy to see this when simulating touch with mouse events. To fix this,
            // limit single-slide swipes to the default slide duration. This also has the
            // nice side effect of matching slide speed if the user stopped moving before
            // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
            // For faster swipes, also apply limits (albeit higher ones).
            var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
            var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
            if (moveDistance < currentSlideSize) {
              momentumDuration = params.speed;
            } else if (moveDistance < 2 * currentSlideSize) {
              momentumDuration = params.speed * 1.5;
            } else {
              momentumDuration = params.speed * 2.5;
            }
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }
        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
            swiper.emit('momentumBounce');
            swiper.setTransition(params.speed);
            setTimeout(function () {
              swiper.setTranslate(afterBouncePosition);
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }, 0);
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }
      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    } // Find current slide

    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (typeof slidesGrid[i + _increment] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
          stopIndex = i;
          groupSize = slidesGrid[i + _increment] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    } // Find current slide size

    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + increment);
        }
        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }
  function onResize() {
    var swiper = this;
    var params = swiper.params,
      el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    } // Save locks

    var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    } // Return locks after resize

    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }
  function onClick(e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) e.preventDefault();
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }
  function onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
      if (rtlTranslate) {
        swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
      } else {
        swiper.translate = -wrapperEl.scrollLeft;
      }
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    } // eslint-disable-next-line

    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit('setTranslate', swiper.translate, false);
  }
  var dummyEventAttached = false;
  function dummyEventListener() {}
  function attachEvents() {
    var swiper = this;
    var document = getDocument();
    var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    var capture = !!params.nested; // Touch Events

    if (!support.touch && support.pointerEvents) {
      el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
          passive: false,
          capture: capture
        } : capture);
        el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
        if (!dummyEventAttached) {
          document.addEventListener('touchstart', dummyEventListener);
          dummyEventAttached = true;
        }
      }
      if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
        el.addEventListener('mousedown', swiper.onTouchStart, false);
        document.addEventListener('mousemove', swiper.onTouchMove, capture);
        document.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    } // Prevent Links Clicks

    if (params.preventClicks || params.preventClicksPropagation) {
      el.addEventListener('click', swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl.addEventListener('scroll', swiper.onScroll);
    } // Resize handler

    if (params.updateOnWindowResize) {
      swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
    } else {
      swiper.on('observerUpdate', onResize, true);
    }
  }
  function detachEvents() {
    var swiper = this;
    var document = getDocument();
    var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
    var capture = !!params.nested; // Touch Events

    if (!support.touch && support.pointerEvents) {
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      }
      if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
        el.removeEventListener('mousedown', swiper.onTouchStart, false);
        document.removeEventListener('mousemove', swiper.onTouchMove, capture);
        document.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    } // Prevent Links Clicks

    if (params.preventClicks || params.preventClicksPropagation) {
      el.removeEventListener('click', swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl.removeEventListener('scroll', swiper.onScroll);
    } // Resize handler

    swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
  }
  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
  };
  function setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

    var breakpoint = swiper.getBreakpoint(breakpoints);
    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') return;
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }
      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var wasMultiRow = params.slidesPerColumn > 1;
      var isMultiRow = breakpointParams.slidesPerColumn > 1;
      if (wasMultiRow && !isMultiRow) {
        $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
      } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(params.containerModifierClass + "multirow");
        if (breakpointParams.slidesPerColumnFill === 'column') {
          $el.addClass(params.containerModifierClass + "multirow-column");
        }
        swiper.emitContainerClasses();
      }
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
      if (directionChanged && initialized) {
        swiper.changeDirection();
      }
      extend$1(swiper.params, breakpointParams);
      extend$1(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
      });
      swiper.currentBreakpoint = breakpoint;
      swiper.emit('_beforeBreakpoint', breakpointParams);
      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
      }
      swiper.emit('breakpoint', breakpointParams);
    }
  }
  function getBreakpoints(breakpoints) {
    var window = getWindow(); // Get breakpoint for window width

    if (!breakpoints) return undefined;
    var breakpoint = false;
    var points = Object.keys(breakpoints).map(function (point) {
      if (typeof point === 'string' && point.indexOf('@') === 0) {
        var minRatio = parseFloat(point.substr(1));
        var value = window.innerHeight * minRatio;
        return {
          value: value,
          point: point
        };
      }
      return {
        value: point,
        point: point
      };
    });
    points.sort(function (a, b) {
      return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for (var i = 0; i < points.length; i += 1) {
      var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;
      if (value <= window.innerWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }
  var breakpoints = {
    setBreakpoint: setBreakpoint,
    getBreakpoint: getBreakpoints
  };
  function addClasses() {
    var swiper = this;
    var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device;
    var suffixes = [];
    suffixes.push('initialized');
    suffixes.push(params.direction);
    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
      if (params.slidesPerColumnFill === 'column') {
        suffixes.push('multirow-column');
      }
    }
    if (device.android) {
      suffixes.push('android');
    }
    if (device.ios) {
      suffixes.push('ios');
    }
    if (params.cssMode) {
      suffixes.push('css-mode');
    }
    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });
    $el.addClass(classNames.join(' '));
    swiper.emitContainerClasses();
  }
  function removeClasses() {
    var swiper = this;
    var $el = swiper.$el,
      classNames = swiper.classNames;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
  }
  var classes = {
    addClasses: addClasses,
    removeClasses: removeClasses
  };
  function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var window = getWindow();
    var image;
    function onReady() {
      if (callback) callback();
    }
    var isPicture = $(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
      if (src) {
        image = new window.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }
  function preloadImages() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
      if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) swiper.update();
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
  }
  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages
  };
  function checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
      swiper.isLocked = lastSlidePosition <= swiper.size;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked; // events

    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      if (swiper.navigation) swiper.navigation.update();
    }
  }
  var checkOverflow$1 = {
    checkOverflow: checkOverflow
  };
  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    nested: false,
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-container-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
  };
  var prototypes = {
    modular: modular,
    eventsEmitter: eventsEmitter,
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images
  };
  var extendedDefaults = {};
  var Swiper = /*#__PURE__*/function () {
    function Swiper() {
      var el;
      var params;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        el = args[0];
        params = args[1];
      }
      if (!params) params = {};
      params = extend$1({}, params);
      if (el && !params.el) params.el = el; // Swiper Instance

      var swiper = this;
      swiper.support = getSupport();
      swiper.device = getDevice({
        userAgent: params.userAgent
      });
      swiper.browser = getBrowser();
      swiper.eventsListeners = {};
      swiper.eventsAnyListeners = [];
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (_typeof(moduleParams) !== 'object' || moduleParams === null) return;
          if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
          if (params[moduleParamName] === true) {
            params[moduleParamName] = {
              enabled: true
            };
          }
          if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
          };
        }
      }); // Extend defaults with modules params

      var swiperParams = extend$1({}, defaults);
      swiper.useParams(swiperParams); // Extend defaults with passed params

      swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = extend$1({}, swiper.params);
      swiper.passedParams = extend$1({}, params); // add event listeners

      if (swiper.params && swiper.params.on) {
        Object.keys(swiper.params.on).forEach(function (eventName) {
          swiper.on(eventName, swiper.params.on[eventName]);
        });
      }
      if (swiper.params && swiper.params.onAny) {
        swiper.onAny(swiper.params.onAny);
      } // Save Dom lib

      swiper.$ = $; // Find el

      var $el = $(swiper.params.el);
      el = $el[0];
      if (!el) {
        return undefined;
      }
      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (containerEl) {
          var newParams = extend$1({}, params, {
            el: containerEl
          });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }
      el.swiper = swiper; // Find Wrapper

      var $wrapperEl;
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        $wrapperEl = $(el.shadowRoot.querySelector("." + swiper.params.wrapperClass)); // Children needs to return slot items

        $wrapperEl.children = function (options) {
          return $el.children(options);
        };
      } else {
        $wrapperEl = $el.children("." + swiper.params.wrapperClass);
      } // Extend Swiper

      extend$1(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],
        // Classes
        classNames: [],
        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',
        // Indexes
        activeIndex: 0,
        realIndex: 0,
        //
        isBeginning: true,
        isEnd: false,
        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        // Touch Events
        touchEvents: function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (swiper.support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
            cancel: touch[3]
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2]
          };
          return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }(),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video, label',
          // Last click time
          lastClickTime: now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined
        },
        // Clicks
        allowClick: true,
        // Touches
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        // Images
        imagesToLoad: [],
        imagesLoaded: 0
      }); // Install Modules

      swiper.useModules();
      swiper.emit('_swiper'); // Init

      if (swiper.params.init) {
        swiper.init();
      } // Return app instance

      return swiper;
    }
    var _proto = Swiper.prototype;
    _proto.emitContainerClasses = function emitContainerClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var classes = swiper.el.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit('_containerClasses', classes.join(' '));
    };
    _proto.getSlideClasses = function getSlideClasses(slideEl) {
      var swiper = this;
      return slideEl.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(' ');
    };
    _proto.emitSlidesClasses = function emitSlidesClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      swiper.slides.each(function (slideEl) {
        var classNames = swiper.getSlideClasses(slideEl);
        swiper.emit('_slideClass', slideEl, classNames);
      });
    };
    _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
          if (slides[_i] && !breakLoop) {
            slideSize += slides[_i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
          if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };
    _proto.update = function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };
    _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) {
        needUpdate = true;
      }
      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }
      swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.each(function (slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    };
    _proto.init = function init() {
      var swiper = this;
      if (swiper.initialized) return;
      swiper.emit('beforeInit'); // Set breakpoint

      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      } // Add Classes

      swiper.addClasses(); // Create loop

      if (swiper.params.loop) {
        swiper.loopCreate();
      } // Update size

      swiper.updateSize(); // Update slides

      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      } // Set Grab Cursor

      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      } // Slide To Initial Slide

      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      } // Attach events

      swiper.attachEvents(); // Init Flag

      swiper.initialized = true; // Emit

      swiper.emit('init');
      swiper.emit('afterInit');
    };
    _proto.destroy = function destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) {
        deleteInstance = true;
      }
      if (cleanStyles === void 0) {
        cleanStyles = true;
      }
      var swiper = this;
      var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;
      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }
      swiper.emit('beforeDestroy'); // Init Flag

      swiper.initialized = false; // Detach events

      swiper.detachEvents(); // Destroy loop

      if (params.loop) {
        swiper.loopDestroy();
      } // Cleanup styles

      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
      }
      swiper.emit('destroy'); // Detach emitter events

      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        deleteProps(swiper);
      }
      swiper.destroyed = true;
      return null;
    };
    Swiper.extendDefaults = function extendDefaults(newDefaults) {
      extend$1(extendedDefaults, newDefaults);
    };
    Swiper.installModule = function installModule(module) {
      if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
      var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
      Swiper.prototype.modules[name] = module;
    };
    Swiper.use = function use(module) {
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Swiper.installModule(m);
        });
        return Swiper;
      }
      Swiper.installModule(module);
      return Swiper;
    };
    _createClass(Swiper, null, [{
      key: "extendedDefaults",
      get: function get() {
        return extendedDefaults;
      }
    }, {
      key: "defaults",
      get: function get() {
        return defaults;
      }
    }]);
    return Swiper;
  }();
  Object.keys(prototypes).forEach(function (prototypeGroup) {
    Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
      Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
  });
  Swiper.use([Resize, Observer$1]);
  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
      var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
      var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;
      var offsetProp;
      if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
        slidesBefore = slidesPerGroup + addSlidesBefore;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
      extend$1(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid
      });
      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }
      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, offset + "px");
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()
        });
        if (swiper.params.virtual.renderExternalUpdate) {
          onRendered();
        }
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
          }
        }
      }
      for (var _i = 0; _i < slides.length; _i += 1) {
        if (_i >= from && _i <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(_i);
          } else {
            if (_i > previousTo) appendIndexes.push(_i);
            if (_i < previousFrom) prependIndexes.push(_i);
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) {
        return b - a;
      }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
      if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
      if (params.cache) swiper.virtual.cache[index] = $slideEl;
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) swiper.virtual.slides.push(slides[i]);
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;
      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          var $cachedEl = cache[cachedIndex];
          var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
          if (cachedElIndex) {
            $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
          }
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    }
  };
  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        renderExternalUpdate: true,
        addSlidesBefore: 0,
        addSlidesAfter: 0
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        virtual: _extends(_extends({}, Virtual), {}, {
          slides: swiper.params.virtual.slides,
          cache: {}
        })
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (!swiper.params.virtual.enabled) return;
        swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
        var overwriteParams = {
          watchSlidesProgress: true
        };
        extend$1(swiper.params, overwriteParams);
        extend$1(swiper.originalParams, overwriteParams);
        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate(swiper) {
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.update();
      }
    }
  };
  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var window = getWindow();
      var document = getDocument();
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) e = e.originalEvent; // jquery fix

      var kc = e.keyCode || e.charCode;
      var pageUpDown = swiper.params.keyboard.pageUpDown;
      var isPageUp = pageUpDown && kc === 33;
      var isPageDown = pageUpDown && kc === 34;
      var isArrowLeft = kc === 37;
      var isArrowRight = kc === 39;
      var isArrowUp = kc === 38;
      var isArrowDown = kc === 40; // Directions locks

      if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
        return false;
      }
      if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
        var inView = false; // Check that swiper should be inside of visible area of window

        if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
          return undefined;
        }
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
            inView = true;
          }
        }
        if (!inView) return undefined;
      }
      if (swiper.isHorizontal()) {
        if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
          if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        }
        if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
        if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
      } else {
        if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
          if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        }
        if (isPageDown || isArrowDown) swiper.slideNext();
        if (isPageUp || isArrowUp) swiper.slidePrev();
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      var document = getDocument();
      if (swiper.keyboard.enabled) return;
      $(document).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      var document = getDocument();
      if (!swiper.keyboard.enabled) return;
      $(document).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    }
  };
  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
        pageUpDown: true
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        keyboard: _extends({
          enabled: false
        }, Keyboard)
      });
    },
    on: {
      init: function init(swiper) {
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy(swiper) {
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      }
    }
  };
  function isEventSupported() {
    var document = getDocument();
    var eventName = 'onwheel';
    var isSupported = (eventName in document);
    if (!isSupported) {
      var element = document.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }
    if (!isSupported && document.implementation && document.implementation.hasFeature &&
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature('', '') !== true) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
    }
    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: now(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
      var window = getWindow();
      if (window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
      return isEventSupported() ? 'wheel' : 'mousewheel';
    },
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;
      var sX = 0;
      var sY = 0; // spinX, spinY

      var pX = 0;
      var pY = 0; // pixelX, pixelY
      // Legacy

      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      } // side scrolling on FF with DOMMouseScroll

      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }
      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;
      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }
      if (e.shiftKey && !pX) {
        // if user scrolls with shift he wants horizontal scroll
        pX = pY;
        pY = 0;
      }
      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) {
          // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else {
          // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      } // Fall-back if spin cannot be determined

      if (pX && !sX) {
        sX = pX < 1 ? -1 : 1;
      }
      if (pY && !sY) {
        sY = pY < 1 ? -1 : 1;
      }
      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;
      if (swiper.params.cssMode) {
        e.preventDefault();
      }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarget !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarget);
      }
      if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
      if (e.originalEvent) e = e.originalEvent; // jquery fix

      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;
      var data = Mousewheel.normalize(e);
      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }
      if (delta === 0) return true;
      if (params.invert) delta = -delta;
      if (!swiper.params.freeMode) {
        // Register the new event in a variable which stores the relevant data
        var newEvent = {
          time: now(),
          delta: Math.abs(delta),
          direction: Math.sign(delta),
          raw: event
        }; // Keep the most recent events

        var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
        if (recentWheelEvents.length >= 2) {
          recentWheelEvents.shift(); // only store the last N events
        }

        var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
        recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
        //   If direction has changed or
        //   if the scroll is quicker than the previous one:
        //     Animate the slider.
        // Else (this is the first time the wheel is moved):
        //     Animate the slider.

        if (prevEvent) {
          if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
            swiper.mousewheel.animateSlider(newEvent);
          }
        } else {
          swiper.mousewheel.animateSlider(newEvent);
        } // If it's time to release the scroll:
        //   Return now so you don't hit the preventDefault.

        if (swiper.mousewheel.releaseScroll(newEvent)) {
          return true;
        }
      } else {
        // Freemode or scrollContainer:
        // If we recently snapped after a momentum scroll, then ignore wheel events
        // to give time for the deceleration to finish. Stop ignoring after 500 msecs
        // or if it's a new scroll (larger delta or inverse sign as last event before
        // an end-of-momentum snap).
        var _newEvent = {
          time: now(),
          delta: Math.abs(delta),
          direction: Math.sign(delta)
        };
        var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
        var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;
        if (!ignoreWheelEvents) {
          swiper.mousewheel.lastEventBeforeSnap = undefined;
          if (swiper.params.loop) {
            swiper.loopFix();
          }
          var position = swiper.getTranslate() + delta * params.sensitivity;
          var wasBeginning = swiper.isBeginning;
          var wasEnd = swiper.isEnd;
          if (position >= swiper.minTranslate()) position = swiper.minTranslate();
          if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
          swiper.setTransition(0);
          swiper.setTranslate(position);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
          if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
            swiper.updateSlidesClasses();
          }
          if (swiper.params.freeModeSticky) {
            // When wheel scrolling starts with sticky (aka snap) enabled, then detect
            // the end of a momentum scroll by storing recent (N=15?) wheel events.
            // 1. do all N events have decreasing or same (absolute value) delta?
            // 2. did all N events arrive in the last M (M=500?) msecs?
            // 3. does the earliest event have an (absolute value) delta that's
            //    at least P (P=1?) larger than the most recent event's delta?
            // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
            // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
            // Snap immediately and ignore remaining wheel events in this scroll.
            // See comment above for "remaining wheel events in this scroll" determination.
            // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = undefined;
            var _recentWheelEvents = swiper.mousewheel.recentWheelEvents;
            if (_recentWheelEvents.length >= 15) {
              _recentWheelEvents.shift(); // only store the last N events
            }

            var _prevEvent = _recentWheelEvents.length ? _recentWheelEvents[_recentWheelEvents.length - 1] : undefined;
            var firstEvent = _recentWheelEvents[0];
            _recentWheelEvents.push(_newEvent);
            if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
              // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
              _recentWheelEvents.splice(0);
            } else if (_recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
              // We're at the end of the deceleration of a momentum scroll, so there's no need
              // to wait for more events. Snap ASAP on the next tick.
              // Also, because there's some remaining momentum we'll bias the snap in the
              // direction of the ongoing scroll because it's better UX for the scroll to snap
              // in the same direction as the scroll instead of reversing to snap.  Therefore,
              // if it's already scrolled more than 20% in the current direction, keep going.
              var snapToThreshold = delta > 0 ? 0.8 : 0.2;
              swiper.mousewheel.lastEventBeforeSnap = _newEvent;
              _recentWheelEvents.splice(0);
              swiper.mousewheel.timeout = nextTick(function () {
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 0); // no delay; move on next tick
            }

            if (!swiper.mousewheel.timeout) {
              // if we get here, then we haven't detected the end of a momentum scroll, so
              // we'll consider a scroll "complete" when there haven't been any wheel events
              // for 500ms.
              swiper.mousewheel.timeout = nextTick(function () {
                var snapToThreshold = 0.5;
                swiper.mousewheel.lastEventBeforeSnap = _newEvent;
                _recentWheelEvents.splice(0);
                swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
              }, 500);
            }
          } // Emit event

          if (!ignoreWheelEvents) swiper.emit('scroll', e); // Stop autoplay

          if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

          if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
        }
      }
      if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      return false;
    },
    animateSlider: function animateSlider(newEvent) {
      var swiper = this;
      var window = getWindow();
      if (this.params.mousewheel.thresholdDelta && newEvent.delta < this.params.mousewheel.thresholdDelta) {
        // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
      }
      if (this.params.mousewheel.thresholdTime && now() - swiper.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) {
        // Prevent if time between scrolls is below configured threshold
        return false;
      } // If the movement is NOT big enough and
      // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
      //   Don't go any further (avoid insignificant scroll movement).

      if (newEvent.delta >= 6 && now() - swiper.mousewheel.lastScrollTime < 60) {
        // Return false as a default
        return true;
      } // If user is scrolling towards the end:
      //   If the slider hasn't hit the latest slide or
      //   if the slider is a loop and
      //   if the slider isn't moving right now:
      //     Go to next slide and
      //     emit a scroll event.
      // Else (the user is scrolling towards the beginning) and
      // if the slider hasn't hit the first slide or
      // if the slider is a loop and
      // if the slider isn't moving right now:
      //   Go to prev slide and
      //   emit a scroll event.

      if (newEvent.direction < 0) {
        if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
          swiper.slideNext();
          swiper.emit('scroll', newEvent.raw);
        }
      } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
        swiper.slidePrev();
        swiper.emit('scroll', newEvent.raw);
      } // If you got here is because an animation has been triggered so store the current time

      swiper.mousewheel.lastScrollTime = new window.Date().getTime(); // Return false as a default

      return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
      var swiper = this;
      var params = swiper.params.mousewheel;
      if (newEvent.direction < 0) {
        if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
          // Return true to animate scroll on edges
          return true;
        }
      } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      var event = Mousewheel.event();
      if (swiper.params.cssMode) {
        swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
        return true;
      }
      if (!event) return false;
      if (swiper.mousewheel.enabled) return false;
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarget !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarget);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      var event = Mousewheel.event();
      if (swiper.params.cssMode) {
        swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
        return true;
      }
      if (!event) return false;
      if (!swiper.mousewheel.enabled) return false;
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarget !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarget);
      }
      target.off(event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    }
  };
  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarget: 'container',
        thresholdDelta: null,
        thresholdTime: null
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        mousewheel: {
          enabled: false,
          lastScrollTime: now(),
          lastEventBeforeSnap: undefined,
          recentWheelEvents: [],
          enable: Mousewheel.enable,
          disable: Mousewheel.disable,
          handle: Mousewheel.handle,
          handleMouseEnter: Mousewheel.handleMouseEnter,
          handleMouseLeave: Mousewheel.handleMouseLeave,
          animateSlider: Mousewheel.animateSlider,
          releaseScroll: Mousewheel.releaseScroll
        }
      });
    },
    on: {
      init: function init(swiper) {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
          swiper.mousewheel.disable();
        }
        if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
      },
      destroy: function destroy(swiper) {
        if (swiper.params.cssMode) {
          swiper.mousewheel.enable();
        }
        if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
      }
    }
  };
  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;
      if (swiper.params.loop) return;
      var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;
      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) return;
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) return;
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) return;
      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }
      extend$1(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0]
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    }
  };
  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        navigation: _extends({}, Navigation)
      });
    },
    on: {
      init: function init(swiper) {
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge(swiper) {
        swiper.navigation.update();
      },
      fromEdge: function fromEdge(swiper) {
        swiper.navigation.update();
      },
      destroy: function destroy(swiper) {
        swiper.navigation.destroy();
      },
      click: function click(swiper, e) {
        var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;
        if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow');
          } else {
            swiper.emit('navigationHide');
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      }
    }
  };
  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el; // Current/Total

      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
          current -= slidesLength - swiper.loopedSlides * 2;
        }
        if (current > total - 1) current -= total;
        if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      } // Types

      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + (params.fixWidth ? params.fixWidth : 4)) + "px");
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
            if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
        if ($el.length > 1) {
          bullets.each(function (bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(params.bulletActiveClass + "-main");
              }
              if (bulletIndex === firstIndex) {
                $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              }
              if (bulletIndex === lastIndex) {
                $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          var bulletIndex = $bullet.index();
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(params.bulletActiveClass + "-main");
            }
            if (swiper.params.loop) {
              if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                  bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                }
                bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
              } else {
                $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
              }
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
        }
      }
      if (params.type === 'fraction') {
        $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
        $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', $el[0]);
      } else {
        swiper.emit('paginationUpdate', $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find("." + params.bulletClass);
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) return;
      var $el = $(params.el);
      if ($el.length === 0) return;
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
        $el = swiper.$el.find(params.el);
      }
      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }
      $el.addClass(params.modifierClass + params.type);
      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass("" + params.modifierClass + params.type + "-dynamic");
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        $el.on('click', "." + params.bulletClass, function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) index += swiper.loopedSlides;
          swiper.slideTo(index);
        });
      }
      extend$1(swiper.pagination, {
        $el: $el,
        el: $el[0]
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
      var $el = swiper.pagination.$el;
      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
      if (params.clickable) {
        $el.off('click', "." + params.bulletClass);
      }
    }
  };
  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets',
        // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(number) {
          return number;
        },
        formatFractionTotal: function formatFractionTotal(number) {
          return number;
        },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-',
        // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable',
        // NEW
        lockClass: 'swiper-pagination-lock'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        pagination: _extends({
          dynamicBulletIndex: 0
        }, Pagination)
      });
    },
    on: {
      init: function init(swiper) {
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange(swiper) {
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange(swiper) {
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange(swiper) {
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange(swiper) {
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy(swiper) {
        swiper.pagination.destroy();
      },
      click: function click(swiper, e) {
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow');
          } else {
            swiper.emit('paginationHide');
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      }
    }
  };
  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
      var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
      var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
      var params = swiper.params.scrollbar;
      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
        $dragEl[0].style.width = newSize + "px";
      } else {
        $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }
      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }
      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      extend$1(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
      }
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;
      var positionRatio;
      positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }
      var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();
      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);
      clearTimeout(swiper.scrollbar.dragTimeout);
      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', 'none');
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
      if (!swiper.scrollbar.isTouched) return;
      if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      if (!swiper.scrollbar.isTouched) return;
      swiper.scrollbar.isTouched = false;
      if (swiper.params.cssMode) {
        swiper.$wrapperEl.css('scroll-snap-type', '');
        $wrapperEl.transition('');
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) return;
      var document = getDocument();
      var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = support.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
      } : false;
      var passiveListener = support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      if (!support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) return;
      var document = getDocument();
      var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = support.passiveListener && params.passiveListeners ? {
        passive: false,
        capture: false
      } : false;
      var passiveListener = support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      if (!support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) return;
      var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;
      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }
      var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
      if ($dragEl.length === 0) {
        $dragEl = $("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
        $el.append($dragEl);
      }
      extend$1(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0]
      });
      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    }
  };
  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        scrollbar: _extends({
          isTouched: false,
          timeout: null,
          dragTimeout: null
        }, Scrollbar)
      });
    },
    on: {
      init: function init(swiper) {
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update(swiper) {
        swiper.scrollbar.updateSize();
      },
      resize: function resize(swiper) {
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate(swiper) {
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate(swiper) {
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(swiper, duration) {
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy(swiper) {
        swiper.scrollbar.destroy();
      }
    }
  };
  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;
      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;
      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');
      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }
      if (x.indexOf('%') >= 0) {
        x = parseInt(x, 10) * progress * rtlFactor + "%";
      } else {
        x = x * progress * rtlFactor + "px";
      }
      if (y.indexOf('%') >= 0) {
        y = parseInt(y, 10) * progress + "%";
      } else {
        y = y * progress + "px";
      }
      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform("translate3d(" + x + ", " + y + ", 0px)");
      } else {
        var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
        $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el,
        slides = swiper.slides,
        progress = swiper.progress,
        snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
        swiper.parallax.setTransform(el, progress);
      });
      slides.each(function (slideEl, slideIndex) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (el) {
          swiper.parallax.setTransform(el, slideProgress);
        });
      });
    },
    setTransition: function setTransition(duration) {
      if (duration === void 0) {
        duration = this.params.speed;
      }
      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (parallaxEl) {
        var $parallaxEl = $(parallaxEl);
        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
        if (duration === 0) parallaxDuration = 0;
        $parallaxEl.transition(parallaxDuration);
      });
    }
  };
  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        parallax: _extends({}, Parallax)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init(swiper) {
        if (!swiper.params.parallax.enabled) return;
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate(swiper) {
        if (!swiper.params.parallax.enabled) return;
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        swiper.parallax.setTransition(duration);
      }
    }
  };
  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) return 1;
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var support = swiper.support;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!support.gestures) {
        if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest("." + swiper.params.slideClass);
        if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
        gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      if (gesture.$imageEl) {
        gesture.$imageEl.transition(0);
      }
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var support = swiper.support;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!support.gestures) {
        if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        if (e.type === 'gesturechange') zoom.onGestureStart(e);
        return;
      }
      if (support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
      }
      gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var device = swiper.device;
      var support = swiper.support;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) gesture.$slideEl = undefined;
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var device = swiper.device;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture,
        image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      if (image.isTouched) return;
      if (device.android && e.cancelable) e.preventDefault();
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) return;
      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      } // Define if we need image drag

      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
      image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
      image.maxX = -image.minX;
      image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
      image.maxY = -image.minY;
      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
      if (!image.isMoved && !zoom.isScaling) {
        if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
          image.isTouched = false;
          return;
        }
        if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
          image.isTouched = false;
          return;
        }
      }
      if (e.cancelable) {
        e.preventDefault();
      }
      e.stopPropagation();
      image.isMoved = true;
      image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
      image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
      if (image.currentX < image.minX) {
        image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
      }
      if (image.currentX > image.maxX) {
        image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
      }
      if (image.currentY < image.minY) {
        image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
      }
      if (image.currentY > image.maxY) {
        image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
      } // Velocity

      if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
      if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
      if (!velocity.prevTime) velocity.prevTime = Date.now();
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();
      gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY; // Fix duration

      if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
      if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
      image.currentX = newPositionX;
      image.currentY = newPositionY; // Define if we need image drag

      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
      image.maxX = -image.minX;
      image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
      gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        if (gesture.$imageEl) {
          gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        }
        if (gesture.$imageWrapEl) {
          gesture.$imageWrapEl.transform('translate3d(0,0,0)');
        }
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom["in"](e);
      }
    },
    "in": function _in(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture,
        image = zoom.image;
      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
        gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      gesture.$slideEl.addClass("" + params.zoomedSlideClass);
      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;
      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }
      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = offsetX + slideWidth / 2 - touchX;
        diffY = offsetY + slideHeight / 2 - touchY;
        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;
        translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;
        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;
        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }
        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
      gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    out: function out() {
      var swiper = this;
      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children("." + swiper.params.slideActiveClass);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
        gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
      gesture.$slideEl = undefined;
    },
    toggleGestures: function toggleGestures(method) {
      var swiper = this;
      var zoom = swiper.zoom;
      var selector = zoom.slideSelector,
        passive = zoom.passiveListener;
      swiper.$wrapperEl[method]('gesturestart', selector, zoom.onGestureStart, passive);
      swiper.$wrapperEl[method]('gesturechange', selector, zoom.onGestureChange, passive);
      swiper.$wrapperEl[method]('gestureend', selector, zoom.onGestureEnd, passive);
    },
    enableGestures: function enableGestures() {
      if (this.zoom.gesturesEnabled) return;
      this.zoom.gesturesEnabled = true;
      this.zoom.toggleGestures('on');
    },
    disableGestures: function disableGestures() {
      if (!this.zoom.gesturesEnabled) return;
      this.zoom.gesturesEnabled = false;
      this.zoom.toggleGestures('off');
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var support = swiper.support;
      var zoom = swiper.zoom;
      if (zoom.enabled) return;
      zoom.enabled = true;
      var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      var activeListenerWithCapture = support.passiveListener ? {
        passive: false,
        capture: true
      } : true;
      var slideSelector = "." + swiper.params.slideClass;
      swiper.zoom.passiveListener = passiveListener;
      swiper.zoom.slideSelector = slideSelector; // Scale image

      if (support.gestures) {
        swiper.$wrapperEl.on(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        }
      } // Move image

      swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) return;
      var support = swiper.support;
      swiper.zoom.enabled = false;
      var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      var activeListenerWithCapture = support.passiveListener ? {
        passive: false,
        capture: true
      } : true;
      var slideSelector = "." + swiper.params.slideClass; // Scale image

      if (support.gestures) {
        swiper.$wrapperEl.off(swiper.touchEvents.start, swiper.zoom.enableGestures, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, swiper.zoom.disableGestures, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
        swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
        if (swiper.touchEvents.cancel) {
          swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
        }
      } // Move image

      swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove, activeListenerWithCapture);
    }
  };
  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        zoom: _extends({
          enabled: false,
          scale: 1,
          currentScale: 1,
          isScaling: false,
          gesture: {
            $slideEl: undefined,
            slideWidth: undefined,
            slideHeight: undefined,
            $imageEl: undefined,
            $imageWrapEl: undefined,
            maxRatio: 3
          },
          image: {
            isTouched: undefined,
            isMoved: undefined,
            currentX: undefined,
            currentY: undefined,
            minX: undefined,
            minY: undefined,
            maxX: undefined,
            maxY: undefined,
            width: undefined,
            height: undefined,
            startX: undefined,
            startY: undefined,
            touchesStart: {},
            touchesCurrent: {}
          },
          velocity: {
            x: undefined,
            y: undefined,
            prevPositionX: undefined,
            prevPositionY: undefined,
            prevTime: undefined
          }
        }, Zoom)
      });
      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        }
      });
    },
    on: {
      init: function init(swiper) {
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy(swiper) {
        swiper.zoom.disable();
      },
      touchStart: function touchStart(swiper, e) {
        if (!swiper.zoom.enabled) return;
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(swiper, e) {
        if (!swiper.zoom.enabled) return;
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(swiper, e) {
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd(swiper) {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
      slideChange: function slideChange(swiper) {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
          swiper.zoom.onTransitionEnd();
        }
      }
    }
  };
  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if (loadInDuplicate === void 0) {
        loadInDuplicate = true;
      }
      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') return;
      if (swiper.slides.length === 0) return;
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
      var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images.push($slideEl[0]);
      }
      if ($images.length === 0) return;
      $images.each(function (imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);
        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');
        var $pictureEl = $imageEl.parent('picture');
        swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
          if (background) {
            $imageEl.css('background-image', "url(\"" + background + "\")");
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if ($pictureEl.length) {
              $pictureEl.children('source').each(function (sourceEl) {
                var $source = $(sourceEl);
                if ($source.attr('data-srcset')) {
                  $source.attr('srcset', $source.attr('data-srcset'));
                  $source.removeAttr('data-srcset');
                }
              });
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }
          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find("." + params.preloaderClass).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        });
        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl,
        swiperParams = swiper.params,
        slides = swiper.slides,
        activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;
      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }
      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
            return true;
          }
        } else if (slides[index]) return true;
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }
      if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) swiper.lazy.loadInSlide(i);
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
          var amount = params.loadPrevNextAmount;
          var spv = Math.ceil(slidesPerView);
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

          for (var _i = activeIndex + spv; _i < maxIndex; _i += 1) {
            if (slideExist(_i)) swiper.lazy.loadInSlide(_i);
          } // Prev Slides

          for (var _i2 = minIndex; _i2 < activeIndex; _i2 += 1) {
            if (slideExist(_i2)) swiper.lazy.loadInSlide(_i2);
          }
        } else {
          var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
          if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
          var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
          if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
        }
      }
    }
  };
  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,
        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        lazy: _extends({
          initialImageLoaded: false
        }, Lazy)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init(swiper) {
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll(swiper) {
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize(swiper) {
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove(swiper) {
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart(swiper) {
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd(swiper) {
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
      slideChange: function slideChange(swiper) {
        if (swiper.params.lazy.enabled && swiper.params.cssMode) {
          swiper.lazy.load();
        }
      }
    }
  };
  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }();
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.

      var i1;
      var i3;
      this.interpolate = function interpolate(x2) {
        if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

        return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(_setTranslate, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      var Swiper = swiper.constructor;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out

          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }
        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
        }
        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var Swiper = swiper.constructor;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) return;
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    }
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide' // or 'container'
      }
    },

    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        controller: _extends({
          control: swiper.params.controller.control
        }, Controller)
      });
    },
    on: {
      update: function update(swiper) {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize(swiper) {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate(swiper) {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(swiper, translate, byController) {
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(swiper, duration, byController) {
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
      }
    }
  };
  var A11y = {
    getRandomNumber: function getRandomNumber(size) {
      if (size === void 0) {
        size = 16;
      }
      var randomChar = function randomChar() {
        return Math.round(16 * Math.random()).toString(16);
      };
      return 'x'.repeat(size).replace(/x/g, randomChar);
    },
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    makeElNotFocusable: function makeElNotFocusable($el) {
      $el.attr('tabIndex', '-1');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElRoleDescription: function addElRoleDescription($el, description) {
      $el.attr('aria-role-description', description);
      return $el;
    },
    addElControls: function addElControls($el, controls) {
      $el.attr('aria-controls', controls);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    addElId: function addElId($el, id) {
      $el.attr('id', id);
      return $el;
    },
    addElLive: function addElLive($el, live) {
      $el.attr('aria-live', live);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) return;
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass)) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) return;
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;
      if (swiper.params.loop || !swiper.navigation) return;
      var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;
      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
          swiper.a11y.makeElNotFocusable($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
          swiper.a11y.makeElFocusable($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
          swiper.a11y.makeElNotFocusable($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
          swiper.a11y.makeElFocusable($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          if (!swiper.params.pagination.renderBullet) {
            swiper.a11y.addElRole($bulletEl, 'button');
            swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
          }
        });
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.a11y;
      swiper.$el.append(swiper.a11y.liveRegion); // Container

      var $containerEl = swiper.$el;
      if (params.containerRoleDescriptionMessage) {
        swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
      }
      if (params.containerMessage) {
        swiper.a11y.addElLabel($containerEl, params.containerMessage);
      } // Wrapper

      var $wrapperEl = swiper.$wrapperEl;
      var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
      var live;
      swiper.a11y.addElId($wrapperEl, wrapperId);
      if (swiper.params.autoplay && swiper.params.autoplay.enabled) {
        live = 'off';
      } else {
        live = 'polite';
      }
      swiper.a11y.addElLive($wrapperEl, live); // Slide

      if (params.itemRoleDescriptionMessage) {
        swiper.a11y.addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
      }
      swiper.a11y.addElRole($(swiper.slides), 'group');
      swiper.slides.each(function (slideEl) {
        var $slideEl = $(slideEl);
        swiper.a11y.addElLabel($slideEl, $slideEl.index() + 1 + " / " + swiper.slides.length);
      }); // Navigation

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl && $nextEl.length) {
        swiper.a11y.makeElFocusable($nextEl);
        if ($nextEl[0].tagName !== 'BUTTON') {
          swiper.a11y.addElRole($nextEl, 'button');
          $nextEl.on('keydown', swiper.a11y.onEnterKey);
        }
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        swiper.a11y.addElControls($nextEl, wrapperId);
      }
      if ($prevEl && $prevEl.length) {
        swiper.a11y.makeElFocusable($prevEl);
        if ($prevEl[0].tagName !== 'BUTTON') {
          swiper.a11y.addElRole($prevEl, 'button');
          $prevEl.on('keydown', swiper.a11y.onEnterKey);
        }
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        swiper.a11y.addElControls($prevEl, wrapperId);
      } // Pagination

      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      } // Pagination

      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
      }
    }
  };
  var A11y$1 = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        containerMessage: null,
        containerRoleDescriptionMessage: null,
        itemRoleDescriptionMessage: null
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        a11y: _extends(_extends({}, A11y), {}, {
          liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
        })
      });
    },
    on: {
      afterInit: function afterInit(swiper) {
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge(swiper) {
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge(swiper) {
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate(swiper) {
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.updatePagination();
      },
      destroy: function destroy(swiper) {
        if (!swiper.params.a11y.enabled) return;
        swiper.a11y.destroy();
      }
    }
  };
  var History = {
    init: function init() {
      var swiper = this;
      var window = getWindow();
      if (!swiper.params.history) return;
      if (!window.history || !window.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues(swiper.params.url);
      if (!history.paths.key && !history.paths.value) return;
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        window.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      var window = getWindow();
      if (!swiper.params.history.replaceState) {
        window.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues(swiper.params.url);
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues(urlOverride) {
      var window = getWindow();
      var location;
      if (urlOverride) {
        location = new URL(urlOverride);
      } else {
        location = window.location;
      }
      var pathArray = location.pathname.slice(1).split('/').filter(function (part) {
        return part !== '';
      });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return {
        key: key,
        value: value
      };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      var window = getWindow();
      if (!swiper.history.initialized || !swiper.params.history.enabled) return;
      var location;
      if (swiper.params.url) {
        location = new URL(swiper.params.url);
      } else {
        location = window.location;
      }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = window.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        window.history.replaceState({
          value: value
        }, null, value);
      } else {
        window.history.pushState({
          value: value
        }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    }
  };
  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        history: _extends({}, History)
      });
    },
    on: {
      init: function init(swiper) {
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy(swiper) {
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd(swiper) {
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
      slideChange: function slideChange(swiper) {
        if (swiper.history.initialized && swiper.params.cssMode) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      }
    }
  };
  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var document = getDocument();
      swiper.emit('hashChange');
      var newHash = document.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
        if (typeof newIndex === 'undefined') return;
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      var window = getWindow();
      var document = getDocument();
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
      if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
        window.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
        swiper.emit('hashSet');
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        document.location.hash = hash || '';
        swiper.emit('hashSet');
      }
    },
    init: function init() {
      var swiper = this;
      var document = getDocument();
      var window = getWindow();
      if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
      swiper.hashNavigation.initialized = true;
      var hash = document.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(window).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      var window = getWindow();
      if (swiper.params.hashNavigation.watchState) {
        $(window).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    }
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        hashNavigation: _extends({
          initialized: false
        }, HashNavigation)
      });
    },
    on: {
      init: function init(swiper) {
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy(swiper) {
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd(swiper) {
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
      slideChange: function slideChange(swiper) {
        if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
          swiper.hashNavigation.setHash();
        }
      }
    }
  };
  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = nextTick(function () {
        var autoplayResult;
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
        if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
          swiper.autoplay.run();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') return false;
      if (swiper.autoplay.running) return false;
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) return false;
      if (typeof swiper.autoplay.timeout === 'undefined') return false;
      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) return;
      if (swiper.autoplay.paused) return;
      if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
    onVisibilityChange: function onVisibilityChange() {
      var swiper = this;
      var document = getDocument();
      if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
        swiper.autoplay.pause();
      }
      if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
        swiper.autoplay.run();
        swiper.autoplay.paused = false;
      }
    },
    onTransitionEnd: function onTransitionEnd(e) {
      var swiper = this;
      if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
      if (e.target !== swiper.$wrapperEl[0]) return;
      swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
      swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      swiper.autoplay.paused = false;
      if (!swiper.autoplay.running) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.run();
      }
    }
  };
  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        autoplay: _extends(_extends({}, Autoplay), {}, {
          running: false,
          paused: false
        })
      });
    },
    on: {
      init: function init(swiper) {
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
          var document = getDocument();
          document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
      },
      beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove(swiper) {
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      touchEnd: function touchEnd(swiper) {
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.run();
        }
      },
      destroy: function destroy(swiper) {
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
        var document = getDocument();
        document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
      }
    }
  };
  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) tx -= swiper.translate;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl.css({
          opacity: slideOpacity
        }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) return;
          if (!swiper || swiper.destroyed) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    }
  };
  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        fadeEffect: _extends({}, Fade)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (swiper.params.effect !== 'fade') return;
        swiper.classNames.push(swiper.params.containerModifierClass + "fade");
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true
        };
        extend$1(swiper.params, overwriteParams);
        extend$1(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate(swiper) {
        if (swiper.params.effect !== 'fade') return;
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(swiper, duration) {
        if (swiper.params.effect !== 'fade') return;
        swiper.fadeEffect.setTransition(duration);
      }
    }
  };
  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides,
        swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        rtl = swiper.rtlTranslate,
        swiperSize = swiper.size,
        browser = swiper.browser;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({
            height: swiperWidth + "px"
          });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + round * 4 * swiperSize;
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = 3 * swiperSize + swiperSize * 4 * round;
        }
        if (rtl) {
          tx = -tx;
        }
        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }
        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = slideIndex * 90 + progress * 90;
          if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
          if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
        '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
        '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
        'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
      });
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
          var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
        }
      }
      var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
      $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el,
        slides = swiper.slides;
      slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    }
  };
  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        cubeEffect: _extends({}, Cube)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (swiper.params.effect !== 'cube') return;
        swiper.classNames.push(swiper.params.containerModifierClass + "cube");
        swiper.classNames.push(swiper.params.containerModifierClass + "3d");
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true
        };
        extend$1(swiper.params, overwriteParams);
        extend$1(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate(swiper) {
        if (swiper.params.effect !== 'cube') return;
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(swiper, duration) {
        if (swiper.params.effect !== 'cube') return;
        swiper.cubeEffect.setTransition(duration);
      }
    }
  };
  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides,
        rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }
        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
          if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
        }
        $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides,
        activeIndex = swiper.activeIndex,
        $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false; // eslint-disable-next-line

        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) return;
          if (!swiper || swiper.destroyed) return; // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;

          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    }
  };
  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        flipEffect: _extends({}, Flip)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (swiper.params.effect !== 'flip') return;
        swiper.classNames.push(swiper.params.containerModifierClass + "flip");
        swiper.classNames.push(swiper.params.containerModifierClass + "3d");
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true
        };
        extend$1(swiper.params, overwriteParams);
        extend$1(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate(swiper) {
        if (swiper.params.effect !== 'flip') return;
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(swiper, duration) {
        if (swiper.params.effect !== 'flip') return;
        swiper.flipEffect.setTransition(duration);
      }
    }
  };
  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        slides = swiper.slides,
        slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth; // Each slide offset from center

      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

        var translateZ = -translate * Math.abs(offsetMultiplier);
        var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

        if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
          stretch = parseFloat(params.stretch) / 100 * slideSize;
        }
        var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
        var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
        var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

        if (Math.abs(translateX) < 0.001) translateX = 0;
        if (Math.abs(translateY) < 0.001) translateY = 0;
        if (Math.abs(translateZ) < 0.001) translateZ = 0;
        if (Math.abs(rotateY) < 0.001) rotateY = 0;
        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        if (Math.abs(scale) < 0.001) scale = 0;
        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg) scale(" + scale + ")";
        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
          if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
        }
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    }
  };
  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        scale: 1,
        modifier: 1,
        slideShadows: true
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        coverflowEffect: _extends({}, Coverflow)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        if (swiper.params.effect !== 'coverflow') return;
        swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
        swiper.classNames.push(swiper.params.containerModifierClass + "3d");
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate(swiper) {
        if (swiper.params.effect !== 'coverflow') return;
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(swiper, duration) {
        if (swiper.params.effect !== 'coverflow') return;
        swiper.coverflowEffect.setTransition(duration);
      }
    }
  };
  var Thumbs = {
    init: function init() {
      var swiper = this;
      var thumbsParams = swiper.params.thumbs;
      if (swiper.thumbs.initialized) return false;
      swiper.thumbs.initialized = true;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        extend$1(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        extend$1(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
      } else if (isObject$1(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(extend$1({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
      return true;
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix(); // eslint-disable-next-line

          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
        if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
      var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
      var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
      if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        var direction;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix(); // eslint-disable-next-line

            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          } // Find actual thumbs index to slide to

          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
          direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
        } else {
          newThumbsIndex = swiper.realIndex;
          direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
        }
        if (useOffset) {
          newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      } // Activate thumbs

      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }
      if (!swiper.params.thumbs.multipleActiveThumbs) {
        thumbsToActivate = 1;
      }
      thumbsToActivate = Math.floor(thumbsToActivate);
      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
        }
      } else {
        for (var _i = 0; _i < thumbsToActivate; _i += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
        }
      }
    }
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        multipleActiveThumbs: true,
        autoScrollOffset: 0,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs'
      }
    },
    create: function create() {
      var swiper = this;
      bindModuleMethods(swiper, {
        thumbs: _extends({
          swiper: null,
          initialized: false
        }, Thumbs)
      });
    },
    on: {
      beforeInit: function beforeInit(swiper) {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange(swiper) {
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      update: function update(swiper) {
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      resize: function resize(swiper) {
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate(swiper) {
        if (!swiper.thumbs.swiper) return;
        swiper.thumbs.update();
      },
      setTransition: function setTransition(swiper, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy(swiper) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      }
    }
  };

  // Swiper Class
  var components = [Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y$1, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];
  Swiper.use(components);
  return Swiper;
});
/**
 * Check if we entered mobile mode by querying border width of element that is being modified by CSS @media-queries
 *
 * @returns {boolean}
 * @private
 */
$(function () {

  /*
  	const markDesktop = "rgb(255,0,0)";
  	const markTablet = "rgb(0,255,0)";
  	const markMobile = "rgb(0,0,255)";
  
  	const throttleDelay = 50;
  	let throttleTimer;
  
  	window._isInMobileMode = function () {
  		let markerState = $( '[data-mobile-marker]' ).css( 'backgroundColor' ).replace(/\s/g, ''),
  		    isMobile    = markerState === markMobile,
  		    isTablet    = markerState === markTablet,
  		    isDesktop   = markerState === markDesktop;
  
  		window._isMobile = isMobile;
  		window._isTablet = isTablet;
  		window._isDesktop = isDesktop;
  
  		return !isDesktop;
  	}
  
  	$( window )
  		.on( 'resize' + NS, function () {
  			clearTimeout( throttleTimer );
  			throttleTimer = setTimeout( function () { window._isInMobileMode(); }, throttleDelay );
  		} )
  		.on( 'orientationchange' + NS, function () {
  			window.dispatchEvent( new Event( "resize" ) );
  		} );
  
  	window._isInMobileMode();
  */
});
/*const */
var jMiniCoreVersion = 'ImgCat.Mathedu.Ru / Core / 202011.2';
jQuery.fn.cssInt = function (prop) {
  return parseInt(this.css(prop), 10) || 0;
};
jQuery.fn.cssFloat = function (prop) {
  return parseFloat(this.css(prop)) || 0;
};
jQuery.fn.getWidthInPercent = function () {
  var width = parseFloat($(this).css('width')) / parseFloat($(this).parent().css('width'));
  return Math.ceil(100 * width);
};
jQuery.fn.tagNameLC = function () {
  return $(this).prop('tagName').toLowerCase();
};
String.prototype.trimChars = function (chars) {
  var l = 0;
  var r = this.length - 1;
  while (chars.indexOf(this[l]) >= 0 && l < r) {
    l++;
  }
  while (chars.indexOf(this[r]) >= 0 && r >= l) {
    r--;
  }
  return this.substring(l, r + 1);
};
function jisNumber(val) {
  var str = ('' + val).trim();
  if (str.length === 0) return false;
  return !isNaN(+str);
}
function jBool(val) {
  var num = +val;
  return !isNaN(num) ? !!num : !!String(val).toLowerCase().replace(!!0, '');
}
function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Get the CSS animation/transition duration for a DOM element
 * Useful for matching CSS animations and JS events
 *
 * Sources:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
 * https://developer.mozilla.org/en-US/docs/Web/CSS/time
 *
 * @param DOM node
 * @returns {array}
 */
jQuery.fn.getAnimationDuration = function () {
  //'use strict';

  var el = $(this);
  var cssTimingProps = ['animation-duration', 'transition-duration'],
    durations = {};
  if (!el.get(0)) return 0;
  for (var i = 0, len = cssTimingProps.length; i < len; i++) {
    var key = String(cssTimingProps[i]),
      compStyle = window.getComputedStyle(el.get(0), null),
      trans = compStyle.getPropertyValue(key);

    // Safari returns null and typeof object, but Chrome returns 0s
    if (trans && trans !== '0s') {
      // create new group using timing prop as index
      durations[key] = [];
      var transItems = trans.toLowerCase().split(',');

      // loop through transition values
      for (var j = 0, lenJ = transItems.length; j < lenJ; j++) {
        var duration = transItems[j];
        if (duration.indexOf('ms') !== -1) {
          // time value in milliseconds
          duration = duration.replace('ms', '');
          durations[key][j] = parseFloat(duration);
        } else {
          // time value in seconds, convert to milliseconds
          duration = duration.replace('s', '');
          durations[key][j] = parseFloat(duration) * 1000;
        }
      }
    }
  }
  return durations;
};
$(function () {
  var $window = $(window);
  var pollPeriod = 100;
  var imagePreloader = function imagePreloader(_) {
    var $imgPreload = $('[data-img]:not(".is-loaded"):not(".ext-lazy-load")'),
      pollTimer;

    // 1. Check if some images already loaded while script was loading

    var checkLoadedImages = function checkLoadedImages() {
      $imgPreload.each(function (idx, el) {
        var img = $(el).find('img').get(0);
        if (img && (img.naturalWidth && img.naturalHeight && img.complete || img.src.indexOf('.svg') && img.complete)) {
          $(el).addClass('is-just-loaded');
          setTimeout(function () {
            $(el).addClass('is-loaded');
          }, 250);
        }
      });
    };
    pollTimer = setInterval(function () {
      $imgPreload = $('[data-img]:not(".is-loaded"):not(".ext-lazy-load")');
      if (!$imgPreload.length) clearInterval(pollTimer);
      checkLoadedImages();
    }, pollPeriod);
  };
  $window.on('image:preload', function (_) {
    imagePreloader();
  });
  $window.trigger('image:preload');
});